/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */ ! function(e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(e, t) {
    function n(e) {
        var t = "length" in e && e.length,
            n = J.type(e);
        return "function" !== n && !J.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
    }

    function i(e, t, n) {
        if (J.isFunction(t)) return J.grep(e, function(e, i) {
            return !!t.call(e, i, e) !== n
        });
        if (t.nodeType) return J.grep(e, function(e) {
            return e === t !== n
        });
        if ("string" == typeof t) {
            if (ae.test(t)) return J.filter(t, e, n);
            t = J.filter(t, e)
        }
        return J.grep(e, function(e) {
            return U.call(t, e) >= 0 !== n
        })
    }

    function r(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }

    function o(e) {
        var t = fe[e] = {};
        return J.each(e.match(he) || [], function(e, n) {
            t[n] = !0
        }), t
    }

    function s() {
        Z.removeEventListener("DOMContentLoaded", s, !1), e.removeEventListener("load", s, !1), J.ready()
    }

    function a() {
        Object.defineProperty(this.cache = {}, 0, {
            get: function() {
                return {}
            }
        }), this.expando = J.expando + a.uid++
    }

    function l(e, t, n) {
        var i;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(we, "-$1").toLowerCase(), n = e.getAttribute(i), "string" == typeof n) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : be.test(n) ? J.parseJSON(n) : n)
                } catch (r) {}
                ye.set(e, t, n)
            } else n = void 0;
        return n
    }

    function u() {
        return !0
    }

    function c() {
        return !1
    }

    function d() {
        try {
            return Z.activeElement
        } catch (e) {}
    }

    function p(e, t) {
        return J.nodeName(e, "table") && J.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function h(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function f(e) {
        var t = De.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function g(e, t) {
        for (var n = 0, i = e.length; i > n; n++) ve.set(e[n], "globalEval", !t || ve.get(t[n], "globalEval"))
    }

    function m(e, t) {
        var n, i, r, o, s, a, l, u;
        if (1 === t.nodeType) {
            if (ve.hasData(e) && (o = ve.access(e), s = ve.set(t, o), u = o.events)) {
                delete s.handle, s.events = {};
                for (r in u)
                    for (n = 0, i = u[r].length; i > n; n++) J.event.add(t, r, u[r][n])
            }
            ye.hasData(e) && (a = ye.access(e), l = J.extend({}, a), ye.set(t, l))
        }
    }

    function v(e, t) {
        var n = e.getElementsByTagName ? e.getElementsByTagName(t || "*") : e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || t && J.nodeName(e, t) ? J.merge([e], n) : n
    }

    function y(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && _e.test(e.type) ? t.checked = e.checked : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue)
    }

    function b(t, n) {
        var i, r = J(n.createElement(t)).appendTo(n.body),
            o = e.getDefaultComputedStyle && (i = e.getDefaultComputedStyle(r[0])) ? i.display : J.css(r[0], "display");
        return r.detach(), o
    }

    function w(e) {
        var t = Z,
            n = Re[e];
        return n || (n = b(e, t), "none" !== n && n || (Le = (Le || J("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = Le[0].contentDocument, t.write(), t.close(), n = b(e, t), Le.detach()), Re[e] = n), n
    }

    function x(e, t, n) {
        var i, r, o, s, a = e.style;
        return n = n || Me(e), n && (s = n.getPropertyValue(t) || n[t]), n && ("" !== s || J.contains(e.ownerDocument, e) || (s = J.style(e, t)), Ve.test(s) && He.test(t) && (i = a.width, r = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = r, a.maxWidth = o)), void 0 !== s ? s + "" : s
    }

    function C(e, t) {
        return {
            get: function() {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments)
            }
        }
    }

    function S(e, t) {
        if (t in e) return t;
        for (var n = t[0].toUpperCase() + t.slice(1), i = t, r = Ye.length; r--;)
            if (t = Ye[r] + n, t in e) return t;
        return i
    }

    function _(e, t, n) {
        var i = Be.exec(t);
        return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t
    }

    function T(e, t, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > o; o += 2) "margin" === n && (s += J.css(e, n + Ce[o], !0, r)), i ? ("content" === n && (s -= J.css(e, "padding" + Ce[o], !0, r)), "margin" !== n && (s -= J.css(e, "border" + Ce[o] + "Width", !0, r))) : (s += J.css(e, "padding" + Ce[o], !0, r), "padding" !== n && (s += J.css(e, "border" + Ce[o] + "Width", !0, r)));
        return s
    }

    function A(e, t, n) {
        var i = !0,
            r = "width" === t ? e.offsetWidth : e.offsetHeight,
            o = Me(e),
            s = "border-box" === J.css(e, "boxSizing", !1, o);
        if (0 >= r || null == r) {
            if (r = x(e, t, o), (0 > r || null == r) && (r = e.style[t]), Ve.test(r)) return r;
            i = s && (G.boxSizingReliable() || r === e.style[t]), r = parseFloat(r) || 0
        }
        return r + T(e, t, n || (s ? "border" : "content"), i, o) + "px"
    }

    function k(e, t) {
        for (var n, i, r, o = [], s = 0, a = e.length; a > s; s++) i = e[s], i.style && (o[s] = ve.get(i, "olddisplay"), n = i.style.display, t ? (o[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && Se(i) && (o[s] = ve.access(i, "olddisplay", w(i.nodeName)))) : (r = Se(i), "none" === n && r || ve.set(i, "olddisplay", r ? n : J.css(i, "display"))));
        for (s = 0; a > s; s++) i = e[s], i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? o[s] || "" : "none"));
        return e
    }

    function P(e, t, n, i, r) {
        return new P.prototype.init(e, t, n, i, r)
    }

    function E() {
        return setTimeout(function() {
            Ge = void 0
        }), Ge = J.now()
    }

    function I(e, t) {
        var n, i = 0,
            r = {
                height: e
            };
        for (t = t ? 1 : 0; 4 > i; i += 2 - t) n = Ce[i], r["margin" + n] = r["padding" + n] = e;
        return t && (r.opacity = r.width = e), r
    }

    function O(e, t, n) {
        for (var i, r = (nt[t] || []).concat(nt["*"]), o = 0, s = r.length; s > o; o++)
            if (i = r[o].call(n, t, e)) return i
    }

    function z(e, t, n) {
        var i, r, o, s, a, l, u, c, d = this,
            p = {},
            h = e.style,
            f = e.nodeType && Se(e),
            g = ve.get(e, "fxshow");
        n.queue || (a = J._queueHooks(e, "fx"), null == a.unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
            a.unqueued || l()
        }), a.unqueued++, d.always(function() {
            d.always(function() {
                a.unqueued--, J.queue(e, "fx").length || a.empty.fire()
            })
        })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [h.overflow, h.overflowX, h.overflowY], u = J.css(e, "display"), c = "none" === u ? ve.get(e, "olddisplay") || w(e.nodeName) : u, "inline" === c && "none" === J.css(e, "float") && (h.display = "inline-block")), n.overflow && (h.overflow = "hidden", d.always(function() {
            h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
        }));
        for (i in t)
            if (r = t[i], Ke.exec(r)) {
                if (delete t[i], o = o || "toggle" === r, r === (f ? "hide" : "show")) {
                    if ("show" !== r || !g || void 0 === g[i]) continue;
                    f = !0
                }
                p[i] = g && g[i] || J.style(e, i)
            } else u = void 0;
        if (J.isEmptyObject(p)) "inline" === ("none" === u ? w(e.nodeName) : u) && (h.display = u);
        else {
            g ? "hidden" in g && (f = g.hidden) : g = ve.access(e, "fxshow", {}), o && (g.hidden = !f), f ? J(e).show() : d.done(function() {
                J(e).hide()
            }), d.done(function() {
                var t;
                ve.remove(e, "fxshow");
                for (t in p) J.style(e, t, p[t])
            });
            for (i in p) s = O(f ? g[i] : 0, i, d), i in g || (g[i] = s.start, f && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0))
        }
    }

    function N(e, t) {
        var n, i, r, o, s;
        for (n in e)
            if (i = J.camelCase(n), r = t[i], o = e[n], J.isArray(o) && (r = o[1], o = e[n] = o[0]), n !== i && (e[i] = o, delete e[n]), s = J.cssHooks[i], s && "expand" in s) {
                o = s.expand(o), delete e[i];
                for (n in o) n in e || (e[n] = o[n], t[n] = r)
            } else t[i] = r
    }

    function j(e, t, n) {
        var i, r, o = 0,
            s = tt.length,
            a = J.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (r) return !1;
                for (var t = Ge || E(), n = Math.max(0, u.startTime + u.duration - t), i = n / u.duration || 0, o = 1 - i, s = 0, l = u.tweens.length; l > s; s++) u.tweens[s].run(o);
                return a.notifyWith(e, [u, o, n]), 1 > o && l ? n : (a.resolveWith(e, [u]), !1)
            },
            u = a.promise({
                elem: e,
                props: J.extend({}, t),
                opts: J.extend(!0, {
                    specialEasing: {}
                }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: Ge || E(),
                duration: n.duration,
                tweens: [],
                createTween: function(t, n) {
                    var i = J.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                    return u.tweens.push(i), i
                },
                stop: function(t) {
                    var n = 0,
                        i = t ? u.tweens.length : 0;
                    if (r) return this;
                    for (r = !0; i > n; n++) u.tweens[n].run(1);
                    return t ? a.resolveWith(e, [u, t]) : a.rejectWith(e, [u, t]), this
                }
            }),
            c = u.props;
        for (N(c, u.opts.specialEasing); s > o; o++)
            if (i = tt[o].call(u, e, c, u.opts)) return i;
        return J.map(c, O, u), J.isFunction(u.opts.start) && u.opts.start.call(e, u), J.fx.timer(J.extend(l, {
            elem: e,
            anim: u,
            queue: u.opts.queue
        })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
    }

    function $(e) {
        return function(t, n) {
            "string" != typeof t && (n = t, t = "*");
            var i, r = 0,
                o = t.toLowerCase().match(he) || [];
            if (J.isFunction(n))
                for (; i = o[r++];) "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
        }
    }

    function D(e, t, n, i) {
        function r(a) {
            var l;
            return o[a] = !0, J.each(e[a] || [], function(e, a) {
                var u = a(t, n, i);
                return "string" != typeof u || s || o[u] ? s ? !(l = u) : void 0 : (t.dataTypes.unshift(u), r(u), !1)
            }), l
        }
        var o = {},
            s = e === bt;
        return r(t.dataTypes[0]) || !o["*"] && r("*")
    }

    function F(e, t) {
        var n, i, r = J.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
        return i && J.extend(!0, e, i), e
    }

    function q(e, t, n) {
        for (var i, r, o, s, a = e.contents, l = e.dataTypes;
            "*" === l[0];) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
        if (i)
            for (r in a)
                if (a[r] && a[r].test(i)) {
                    l.unshift(r);
                    break
                } if (l[0] in n) o = l[0];
        else {
            for (r in n) {
                if (!l[0] || e.converters[r + " " + l[0]]) {
                    o = r;
                    break
                }
                s || (s = r)
            }
            o = o || s
        }
        return o ? (o !== l[0] && l.unshift(o), n[o]) : void 0
    }

    function L(e, t, n, i) {
        var r, o, s, a, l, u = {},
            c = e.dataTypes.slice();
        if (c[1])
            for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
        for (o = c.shift(); o;)
            if (e.responseFields[o] && (n[e.responseFields[o]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = o, o = c.shift())
                if ("*" === o) o = l;
                else if ("*" !== l && l !== o) {
            if (s = u[l + " " + o] || u["* " + o], !s)
                for (r in u)
                    if (a = r.split(" "), a[1] === o && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                        s === !0 ? s = u[r] : u[r] !== !0 && (o = a[0], c.unshift(a[1]));
                        break
                    } if (s !== !0)
                if (s && e["throws"]) t = s(t);
                else try {
                    t = s(t)
                } catch (d) {
                    return {
                        state: "parsererror",
                        error: s ? d : "No conversion from " + l + " to " + o
                    }
                }
        }
        return {
            state: "success",
            data: t
        }
    }

    function R(e, t, n, i) {
        var r;
        if (J.isArray(t)) J.each(t, function(t, r) {
            n || _t.test(e) ? i(e, r) : R(e + "[" + ("object" == typeof r ? t : "") + "]", r, n, i)
        });
        else if (n || "object" !== J.type(t)) i(e, t);
        else
            for (r in t) R(e + "[" + r + "]", t[r], n, i)
    }

    function H(e) {
        return J.isWindow(e) ? e : 9 === e.nodeType && e.defaultView
    }
    var V = [],
        M = V.slice,
        W = V.concat,
        B = V.push,
        U = V.indexOf,
        Q = {},
        X = Q.toString,
        Y = Q.hasOwnProperty,
        G = {},
        Z = e.document,
        K = "2.1.4",
        J = function(e, t) {
            return new J.fn.init(e, t)
        },
        ee = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        te = /^-ms-/,
        ne = /-([\da-z])/gi,
        ie = function(e, t) {
            return t.toUpperCase()
        };
    J.fn = J.prototype = {
        jquery: K,
        constructor: J,
        selector: "",
        length: 0,
        toArray: function() {
            return M.call(this)
        },
        get: function(e) {
            return null != e ? 0 > e ? this[e + this.length] : this[e] : M.call(this)
        },
        pushStack: function(e) {
            var t = J.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t
        },
        each: function(e, t) {
            return J.each(this, e, t)
        },
        map: function(e) {
            return this.pushStack(J.map(this, function(t, n) {
                return e.call(t, n, t)
            }))
        },
        slice: function() {
            return this.pushStack(M.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(e) {
            var t = this.length,
                n = +e + (0 > e ? t : 0);
            return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor(null)
        },
        push: B,
        sort: V.sort,
        splice: V.splice
    }, J.extend = J.fn.extend = function() {
        var e, t, n, i, r, o, s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            u = !1;
        for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || J.isFunction(s) || (s = {}), a === l && (s = this, a--); l > a; a++)
            if (null != (e = arguments[a]))
                for (t in e) n = s[t], i = e[t], s !== i && (u && i && (J.isPlainObject(i) || (r = J.isArray(i))) ? (r ? (r = !1, o = n && J.isArray(n) ? n : []) : o = n && J.isPlainObject(n) ? n : {}, s[t] = J.extend(u, o, i)) : void 0 !== i && (s[t] = i));
        return s
    }, J.extend({
        expando: "jQuery" + (K + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isFunction: function(e) {
            return "function" === J.type(e)
        },
        isArray: Array.isArray,
        isWindow: function(e) {
            return null != e && e === e.window
        },
        isNumeric: function(e) {
            return !J.isArray(e) && e - parseFloat(e) + 1 >= 0
        },
        isPlainObject: function(e) {
            return "object" === J.type(e) && !e.nodeType && !J.isWindow(e) && !(e.constructor && !Y.call(e.constructor.prototype, "isPrototypeOf"))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        type: function(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? Q[X.call(e)] || "object" : typeof e
        },
        globalEval: function(e) {
            var t, n = eval;
            e = J.trim(e), e && (1 === e.indexOf("use strict") ? (t = Z.createElement("script"), t.text = e, Z.head.appendChild(t).parentNode.removeChild(t)) : n(e))
        },
        camelCase: function(e) {
            return e.replace(te, "ms-").replace(ne, ie)
        },
        nodeName: function(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        },
        each: function(e, t, i) {
            var r, o = 0,
                s = e.length,
                a = n(e);
            if (i) {
                if (a)
                    for (; s > o && (r = t.apply(e[o], i), r !== !1); o++);
                else
                    for (o in e)
                        if (r = t.apply(e[o], i), r === !1) break
            } else if (a)
                for (; s > o && (r = t.call(e[o], o, e[o]), r !== !1); o++);
            else
                for (o in e)
                    if (r = t.call(e[o], o, e[o]), r === !1) break;
            return e
        },
        trim: function(e) {
            return null == e ? "" : (e + "").replace(ee, "")
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (n(Object(e)) ? J.merge(i, "string" == typeof e ? [e] : e) : B.call(i, e)), i
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : U.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, r = e.length; n > i; i++) e[r++] = t[i];
            return e.length = r, e
        },
        grep: function(e, t, n) {
            for (var i, r = [], o = 0, s = e.length, a = !n; s > o; o++) i = !t(e[o], o), i !== a && r.push(e[o]);
            return r
        },
        map: function(e, t, i) {
            var r, o = 0,
                s = e.length,
                a = n(e),
                l = [];
            if (a)
                for (; s > o; o++) r = t(e[o], o, i), null != r && l.push(r);
            else
                for (o in e) r = t(e[o], o, i), null != r && l.push(r);
            return W.apply([], l)
        },
        guid: 1,
        proxy: function(e, t) {
            var n, i, r;
            return "string" == typeof t && (n = e[t], t = e, e = n), J.isFunction(e) ? (i = M.call(arguments, 2), r = function() {
                return e.apply(t || this, i.concat(M.call(arguments)))
            }, r.guid = e.guid = e.guid || J.guid++, r) : void 0
        },
        now: Date.now,
        support: G
    }), J.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(e, t) {
        Q["[object " + t + "]"] = t.toLowerCase()
    });
    var re = function(e) {
        function t(e, t, n, i) {
            var r, o, s, a, l, u, d, h, f, g;
            if ((t ? t.ownerDocument || t : R) !== z && O(t), t = t || z, n = n || [], a = t.nodeType, "string" != typeof e || !e || 1 !== a && 9 !== a && 11 !== a) return n;
            if (!i && j) {
                if (11 !== a && (r = ye.exec(e)))
                    if (s = r[1]) {
                        if (9 === a) {
                            if (o = t.getElementById(s), !o || !o.parentNode) return n;
                            if (o.id === s) return n.push(o), n
                        } else if (t.ownerDocument && (o = t.ownerDocument.getElementById(s)) && q(t, o) && o.id === s) return n.push(o), n
                    } else {
                        if (r[2]) return K.apply(n, t.getElementsByTagName(e)), n;
                        if ((s = r[3]) && x.getElementsByClassName) return K.apply(n, t.getElementsByClassName(s)), n
                    } if (x.qsa && (!$ || !$.test(e))) {
                    if (h = d = L, f = t, g = 1 !== a && e, 1 === a && "object" !== t.nodeName.toLowerCase()) {
                        for (u = T(e), (d = t.getAttribute("id")) ? h = d.replace(we, "\\$&") : t.setAttribute("id", h), h = "[id='" + h + "'] ", l = u.length; l--;) u[l] = h + p(u[l]);
                        f = be.test(e) && c(t.parentNode) || t, g = u.join(",")
                    }
                    if (g) try {
                        return K.apply(n, f.querySelectorAll(g)), n
                    } catch (m) {} finally {
                        d || t.removeAttribute("id")
                    }
                }
            }
            return k(e.replace(le, "$1"), t, n, i)
        }

        function n() {
            function e(n, i) {
                return t.push(n + " ") > C.cacheLength && delete e[t.shift()], e[n + " "] = i
            }
            var t = [];
            return e
        }

        function i(e) {
            return e[L] = !0, e
        }

        function r(e) {
            var t = z.createElement("div");
            try {
                return !!e(t)
            } catch (n) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function o(e, t) {
            for (var n = e.split("|"), i = e.length; i--;) C.attrHandle[n[i]] = t
        }

        function s(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || Q) - (~e.sourceIndex || Q);
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t) return -1;
            return e ? 1 : -1
        }

        function a(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return "input" === n && t.type === e
            }
        }

        function l(e) {
            return function(t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }

        function u(e) {
            return i(function(t) {
                return t = +t, i(function(n, i) {
                    for (var r, o = e([], n.length, t), s = o.length; s--;) n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }

        function c(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e
        }

        function d() {}

        function p(e) {
            for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
            return i
        }

        function h(e, t, n) {
            var i = t.dir,
                r = n && "parentNode" === i,
                o = V++;
            return t.first ? function(t, n, o) {
                for (; t = t[i];)
                    if (1 === t.nodeType || r) return e(t, n, o)
            } : function(t, n, s) {
                var a, l, u = [H, o];
                if (s) {
                    for (; t = t[i];)
                        if ((1 === t.nodeType || r) && e(t, n, s)) return !0
                } else
                    for (; t = t[i];)
                        if (1 === t.nodeType || r) {
                            if (l = t[L] || (t[L] = {}), (a = l[i]) && a[0] === H && a[1] === o) return u[2] = a[2];
                            if (l[i] = u, u[2] = e(t, n, s)) return !0
                        }
            }
        }

        function f(e) {
            return e.length > 1 ? function(t, n, i) {
                for (var r = e.length; r--;)
                    if (!e[r](t, n, i)) return !1;
                return !0
            } : e[0]
        }

        function g(e, n, i) {
            for (var r = 0, o = n.length; o > r; r++) t(e, n[r], i);
            return i
        }

        function m(e, t, n, i, r) {
            for (var o, s = [], a = 0, l = e.length, u = null != t; l > a; a++)(o = e[a]) && (!n || n(o, i, r)) && (s.push(o), u && t.push(a));
            return s
        }

        function v(e, t, n, r, o, s) {
            return r && !r[L] && (r = v(r)), o && !o[L] && (o = v(o, s)), i(function(i, s, a, l) {
                var u, c, d, p = [],
                    h = [],
                    f = s.length,
                    v = i || g(t || "*", a.nodeType ? [a] : a, []),
                    y = !e || !i && t ? v : m(v, p, e, a, l),
                    b = n ? o || (i ? e : f || r) ? [] : s : y;
                if (n && n(y, b, a, l), r)
                    for (u = m(b, h), r(u, [], a, l), c = u.length; c--;)(d = u[c]) && (b[h[c]] = !(y[h[c]] = d));
                if (i) {
                    if (o || e) {
                        if (o) {
                            for (u = [], c = b.length; c--;)(d = b[c]) && u.push(y[c] = d);
                            o(null, b = [], u, l)
                        }
                        for (c = b.length; c--;)(d = b[c]) && (u = o ? ee(i, d) : p[c]) > -1 && (i[u] = !(s[u] = d))
                    }
                } else b = m(b === s ? b.splice(f, b.length) : b), o ? o(null, s, b, l) : K.apply(s, b)
            })
        }

        function y(e) {
            for (var t, n, i, r = e.length, o = C.relative[e[0].type], s = o || C.relative[" "], a = o ? 1 : 0, l = h(function(e) {
                    return e === t
                }, s, !0), u = h(function(e) {
                    return ee(t, e) > -1
                }, s, !0), c = [function(e, n, i) {
                    var r = !o && (i || n !== P) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                    return t = null, r
                }]; r > a; a++)
                if (n = C.relative[e[a].type]) c = [h(f(c), n)];
                else {
                    if (n = C.filter[e[a].type].apply(null, e[a].matches), n[L]) {
                        for (i = ++a; r > i && !C.relative[e[i].type]; i++);
                        return v(a > 1 && f(c), a > 1 && p(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(le, "$1"), n, i > a && y(e.slice(a, i)), r > i && y(e = e.slice(i)), r > i && p(e))
                    }
                    c.push(n)
                } return f(c)
        }

        function b(e, n) {
            var r = n.length > 0,
                o = e.length > 0,
                s = function(i, s, a, l, u) {
                    var c, d, p, h = 0,
                        f = "0",
                        g = i && [],
                        v = [],
                        y = P,
                        b = i || o && C.find.TAG("*", u),
                        w = H += null == y ? 1 : Math.random() || .1,
                        x = b.length;
                    for (u && (P = s !== z && s); f !== x && null != (c = b[f]); f++) {
                        if (o && c) {
                            for (d = 0; p = e[d++];)
                                if (p(c, s, a)) {
                                    l.push(c);
                                    break
                                } u && (H = w)
                        }
                        r && ((c = !p && c) && h--, i && g.push(c))
                    }
                    if (h += f, r && f !== h) {
                        for (d = 0; p = n[d++];) p(g, v, s, a);
                        if (i) {
                            if (h > 0)
                                for (; f--;) g[f] || v[f] || (v[f] = G.call(l));
                            v = m(v)
                        }
                        K.apply(l, v), u && !i && v.length > 0 && h + n.length > 1 && t.uniqueSort(l)
                    }
                    return u && (H = w, P = y), g
                };
            return r ? i(s) : s
        }
        var w, x, C, S, _, T, A, k, P, E, I, O, z, N, j, $, D, F, q, L = "sizzle" + 1 * new Date,
            R = e.document,
            H = 0,
            V = 0,
            M = n(),
            W = n(),
            B = n(),
            U = function(e, t) {
                return e === t && (I = !0), 0
            },
            Q = 1 << 31,
            X = {}.hasOwnProperty,
            Y = [],
            G = Y.pop,
            Z = Y.push,
            K = Y.push,
            J = Y.slice,
            ee = function(e, t) {
                for (var n = 0, i = e.length; i > n; n++)
                    if (e[n] === t) return n;
                return -1
            },
            te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            ne = "[\\x20\\t\\r\\n\\f]",
            ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            re = ie.replace("w", "w#"),
            oe = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + re + "))|)" + ne + "*\\]",
            se = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + oe + ")*)|.*)\\)|)",
            ae = new RegExp(ne + "+", "g"),
            le = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"),
            ue = new RegExp("^" + ne + "*," + ne + "*"),
            ce = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
            de = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
            pe = new RegExp(se),
            he = new RegExp("^" + re + "$"),
            fe = {
                ID: new RegExp("^#(" + ie + ")"),
                CLASS: new RegExp("^\\.(" + ie + ")"),
                TAG: new RegExp("^(" + ie.replace("w", "w*") + ")"),
                ATTR: new RegExp("^" + oe),
                PSEUDO: new RegExp("^" + se),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + te + ")$", "i"),
                needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)", "i")
            },
            ge = /^(?:input|select|textarea|button)$/i,
            me = /^h\d$/i,
            ve = /^[^{]+\{\s*\[native \w/,
            ye = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            be = /[+~]/,
            we = /'|\\/g,
            xe = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
            Ce = function(e, t, n) {
                var i = "0x" + t - 65536;
                return i !== i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
            },
            Se = function() {
                O()
            };
        try {
            K.apply(Y = J.call(R.childNodes), R.childNodes), Y[R.childNodes.length].nodeType
        } catch (_e) {
            K = {
                apply: Y.length ? function(e, t) {
                    Z.apply(e, J.call(t))
                } : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++];);
                    e.length = n - 1
                }
            }
        }
        x = t.support = {}, _ = t.isXML = function(e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }, O = t.setDocument = function(e) {
            var t, n, i = e ? e.ownerDocument || e : R;
            return i !== z && 9 === i.nodeType && i.documentElement ? (z = i, N = i.documentElement, n = i.defaultView, n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", Se, !1) : n.attachEvent && n.attachEvent("onunload", Se)), j = !_(i), x.attributes = r(function(e) {
                return e.className = "i", !e.getAttribute("className")
            }), x.getElementsByTagName = r(function(e) {
                return e.appendChild(i.createComment("")), !e.getElementsByTagName("*").length
            }), x.getElementsByClassName = ve.test(i.getElementsByClassName), x.getById = r(function(e) {
                return N.appendChild(e).id = L, !i.getElementsByName || !i.getElementsByName(L).length
            }), x.getById ? (C.find.ID = function(e, t) {
                if ("undefined" != typeof t.getElementById && j) {
                    var n = t.getElementById(e);
                    return n && n.parentNode ? [n] : []
                }
            }, C.filter.ID = function(e) {
                var t = e.replace(xe, Ce);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }) : (delete C.find.ID, C.filter.ID = function(e) {
                var t = e.replace(xe, Ce);
                return function(e) {
                    var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }), C.find.TAG = x.getElementsByTagName ? function(e, t) {
                return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : x.qsa ? t.querySelectorAll(e) : void 0
            } : function(e, t) {
                var n, i = [],
                    r = 0,
                    o = t.getElementsByTagName(e);
                if ("*" === e) {
                    for (; n = o[r++];) 1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }, C.find.CLASS = x.getElementsByClassName && function(e, t) {
                return j ? t.getElementsByClassName(e) : void 0
            }, D = [], $ = [], (x.qsa = ve.test(i.querySelectorAll)) && (r(function(e) {
                N.appendChild(e).innerHTML = "<a id='" + L + "'></a><select id='" + L + "-\f]' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && $.push("[*^$]=" + ne + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || $.push("\\[" + ne + "*(?:value|" + te + ")"), e.querySelectorAll("[id~=" + L + "-]").length || $.push("~="), e.querySelectorAll(":checked").length || $.push(":checked"), e.querySelectorAll("a#" + L + "+*").length || $.push(".#.+[+~]")
            }), r(function(e) {
                var t = i.createElement("input");
                t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && $.push("name" + ne + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || $.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), $.push(",.*:")
            })), (x.matchesSelector = ve.test(F = N.matches || N.webkitMatchesSelector || N.mozMatchesSelector || N.oMatchesSelector || N.msMatchesSelector)) && r(function(e) {
                x.disconnectedMatch = F.call(e, "div"), F.call(e, "[s!='']:x"), D.push("!=", se)
            }), $ = $.length && new RegExp($.join("|")), D = D.length && new RegExp(D.join("|")), t = ve.test(N.compareDocumentPosition), q = t || ve.test(N.contains) ? function(e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e,
                    i = t && t.parentNode;
                return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
            } : function(e, t) {
                if (t)
                    for (; t = t.parentNode;)
                        if (t === e) return !0;
                return !1
            }, U = t ? function(e, t) {
                if (e === t) return I = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n ? n : (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & n || !x.sortDetached && t.compareDocumentPosition(e) === n ? e === i || e.ownerDocument === R && q(R, e) ? -1 : t === i || t.ownerDocument === R && q(R, t) ? 1 : E ? ee(E, e) - ee(E, t) : 0 : 4 & n ? -1 : 1)
            } : function(e, t) {
                if (e === t) return I = !0, 0;
                var n, r = 0,
                    o = e.parentNode,
                    a = t.parentNode,
                    l = [e],
                    u = [t];
                if (!o || !a) return e === i ? -1 : t === i ? 1 : o ? -1 : a ? 1 : E ? ee(E, e) - ee(E, t) : 0;
                if (o === a) return s(e, t);
                for (n = e; n = n.parentNode;) l.unshift(n);
                for (n = t; n = n.parentNode;) u.unshift(n);
                for (; l[r] === u[r];) r++;
                return r ? s(l[r], u[r]) : l[r] === R ? -1 : u[r] === R ? 1 : 0
            }, i) : z
        }, t.matches = function(e, n) {
            return t(e, null, null, n)
        }, t.matchesSelector = function(e, n) {
            if ((e.ownerDocument || e) !== z && O(e), n = n.replace(de, "='$1']"), !(!x.matchesSelector || !j || D && D.test(n) || $ && $.test(n))) try {
                var i = F.call(e, n);
                if (i || x.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
            } catch (r) {}
            return t(n, z, null, [e]).length > 0
        }, t.contains = function(e, t) {
            return (e.ownerDocument || e) !== z && O(e), q(e, t)
        }, t.attr = function(e, t) {
            (e.ownerDocument || e) !== z && O(e);
            var n = C.attrHandle[t.toLowerCase()],
                i = n && X.call(C.attrHandle, t.toLowerCase()) ? n(e, t, !j) : void 0;
            return void 0 !== i ? i : x.attributes || !j ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }, t.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }, t.uniqueSort = function(e) {
            var t, n = [],
                i = 0,
                r = 0;
            if (I = !x.detectDuplicates, E = !x.sortStable && e.slice(0), e.sort(U), I) {
                for (; t = e[r++];) t === e[r] && (i = n.push(r));
                for (; i--;) e.splice(n[i], 1)
            }
            return E = null, e
        }, S = t.getText = function(e) {
            var t, n = "",
                i = 0,
                r = e.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += S(e)
                } else if (3 === r || 4 === r) return e.nodeValue
            } else
                for (; t = e[i++];) n += S(t);
            return n
        }, C = t.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: fe,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(xe, Ce), e[3] = (e[3] || e[4] || e[5] || "").replace(xe, Ce), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
                },
                PSEUDO: function(e) {
                    var t, n = !e[6] && e[2];
                    return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && pe.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(xe, Ce).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    } : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = M[e + " "];
                    return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && M(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(e, n, i) {
                    return function(r) {
                        var o = t.attr(r, e);
                        return null == o ? "!=" === n : !n || (o += "", "=" === n ? o === i : "!=" === n ? o !== i : "^=" === n ? i && 0 === o.indexOf(i) : "*=" === n ? i && o.indexOf(i) > -1 : "$=" === n ? i && o.slice(-i.length) === i : "~=" === n ? (" " + o.replace(ae, " ") + " ").indexOf(i) > -1 : "|=" === n && (o === i || o.slice(0, i.length + 1) === i + "-"))
                    }
                },
                CHILD: function(e, t, n, i, r) {
                    var o = "nth" !== e.slice(0, 3),
                        s = "last" !== e.slice(-4),
                        a = "of-type" === t;
                    return 1 === i && 0 === r ? function(e) {
                        return !!e.parentNode
                    } : function(t, n, l) {
                        var u, c, d, p, h, f, g = o !== s ? "nextSibling" : "previousSibling",
                            m = t.parentNode,
                            v = a && t.nodeName.toLowerCase(),
                            y = !l && !a;
                        if (m) {
                            if (o) {
                                for (; g;) {
                                    for (d = t; d = d[g];)
                                        if (a ? d.nodeName.toLowerCase() === v : 1 === d.nodeType) return !1;
                                    f = g = "only" === e && !f && "nextSibling"
                                }
                                return !0
                            }
                            if (f = [s ? m.firstChild : m.lastChild], s && y) {
                                for (c = m[L] || (m[L] = {}), u = c[e] || [], h = u[0] === H && u[1], p = u[0] === H && u[2], d = h && m.childNodes[h]; d = ++h && d && d[g] || (p = h = 0) || f.pop();)
                                    if (1 === d.nodeType && ++p && d === t) {
                                        c[e] = [H, h, p];
                                        break
                                    }
                            } else if (y && (u = (t[L] || (t[L] = {}))[e]) && u[0] === H) p = u[1];
                            else
                                for (;
                                    (d = ++h && d && d[g] || (p = h = 0) || f.pop()) && ((a ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++p || (y && ((d[L] || (d[L] = {}))[e] = [H, p]), d !== t)););
                            return p -= r, p === i || p % i === 0 && p / i >= 0
                        }
                    }
                },
                PSEUDO: function(e, n) {
                    var r, o = C.pseudos[e] || C.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return o[L] ? o(n) : o.length > 1 ? (r = [e, e, "", n], C.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
                        for (var i, r = o(e, n), s = r.length; s--;) i = ee(e, r[s]), e[i] = !(t[i] = r[s])
                    }) : function(e) {
                        return o(e, 0, r)
                    }) : o
                }
            },
            pseudos: {
                not: i(function(e) {
                    var t = [],
                        n = [],
                        r = A(e.replace(le, "$1"));
                    return r[L] ? i(function(e, t, n, i) {
                        for (var o, s = r(e, null, i, []), a = e.length; a--;)(o = s[a]) && (e[a] = !(t[a] = o))
                    }) : function(e, i, o) {
                        return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop()
                    }
                }),
                has: i(function(e) {
                    return function(n) {
                        return t(e, n).length > 0
                    }
                }),
                contains: i(function(e) {
                    return e = e.replace(xe, Ce),
                        function(t) {
                            return (t.textContent || t.innerText || S(t)).indexOf(e) > -1
                        }
                }),
                lang: i(function(e) {
                    return he.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(xe, Ce).toLowerCase(),
                        function(t) {
                            var n;
                            do
                                if (n = j ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return n = n.toLowerCase(), n === e || 0 === n.indexOf(e + "-"); while ((t = t.parentNode) && 1 === t.nodeType);
                            return !1
                        }
                }),
                target: function(t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                },
                root: function(e) {
                    return e === N
                },
                focus: function(e) {
                    return e === z.activeElement && (!z.hasFocus || z.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: function(e) {
                    return e.disabled === !1
                },
                disabled: function(e) {
                    return e.disabled === !0
                },
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex, e.selected === !0
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6) return !1;
                    return !0
                },
                parent: function(e) {
                    return !C.pseudos.empty(e)
                },
                header: function(e) {
                    return me.test(e.nodeName)
                },
                input: function(e) {
                    return ge.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: u(function() {
                    return [0]
                }),
                last: u(function(e, t) {
                    return [t - 1]
                }),
                eq: u(function(e, t, n) {
                    return [0 > n ? n + t : n]
                }),
                even: u(function(e, t) {
                    for (var n = 0; t > n; n += 2) e.push(n);
                    return e
                }),
                odd: u(function(e, t) {
                    for (var n = 1; t > n; n += 2) e.push(n);
                    return e
                }),
                lt: u(function(e, t, n) {
                    for (var i = 0 > n ? n + t : n; --i >= 0;) e.push(i);
                    return e
                }),
                gt: u(function(e, t, n) {
                    for (var i = 0 > n ? n + t : n; ++i < t;) e.push(i);
                    return e
                })
            }
        }, C.pseudos.nth = C.pseudos.eq;
        for (w in {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) C.pseudos[w] = a(w);
        for (w in {
                submit: !0,
                reset: !0
            }) C.pseudos[w] = l(w);
        return d.prototype = C.filters = C.pseudos, C.setFilters = new d, T = t.tokenize = function(e, n) {
            var i, r, o, s, a, l, u, c = W[e + " "];
            if (c) return n ? 0 : c.slice(0);
            for (a = e, l = [], u = C.preFilter; a;) {
                (!i || (r = ue.exec(a))) && (r && (a = a.slice(r[0].length) || a), l.push(o = [])), i = !1, (r = ce.exec(a)) && (i = r.shift(), o.push({
                    value: i,
                    type: r[0].replace(le, " ")
                }), a = a.slice(i.length));
                for (s in C.filter) !(r = fe[s].exec(a)) || u[s] && !(r = u[s](r)) || (i = r.shift(), o.push({
                    value: i,
                    type: s,
                    matches: r
                }), a = a.slice(i.length));
                if (!i) break
            }
            return n ? a.length : a ? t.error(e) : W(e, l).slice(0)
        }, A = t.compile = function(e, t) {
            var n, i = [],
                r = [],
                o = B[e + " "];
            if (!o) {
                for (t || (t = T(e)), n = t.length; n--;) o = y(t[n]), o[L] ? i.push(o) : r.push(o);
                o = B(e, b(r, i)), o.selector = e
            }
            return o
        }, k = t.select = function(e, t, n, i) {
            var r, o, s, a, l, u = "function" == typeof e && e,
                d = !i && T(e = u.selector || e);
            if (n = n || [], 1 === d.length) {
                if (o = d[0] = d[0].slice(0), o.length > 2 && "ID" === (s = o[0]).type && x.getById && 9 === t.nodeType && j && C.relative[o[1].type]) {
                    if (t = (C.find.ID(s.matches[0].replace(xe, Ce), t) || [])[0], !t) return n;
                    u && (t = t.parentNode), e = e.slice(o.shift().value.length)
                }
                for (r = fe.needsContext.test(e) ? 0 : o.length; r-- && (s = o[r], !C.relative[a = s.type]);)
                    if ((l = C.find[a]) && (i = l(s.matches[0].replace(xe, Ce), be.test(o[0].type) && c(t.parentNode) || t))) {
                        if (o.splice(r, 1), e = i.length && p(o), !e) return K.apply(n, i), n;
                        break
                    }
            }
            return (u || A(e, d))(i, t, !j, n, be.test(e) && c(t.parentNode) || t), n
        }, x.sortStable = L.split("").sort(U).join("") === L, x.detectDuplicates = !!I, O(), x.sortDetached = r(function(e) {
            return 1 & e.compareDocumentPosition(z.createElement("div"))
        }), r(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function(e, t, n) {
            return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), x.attributes && r(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || o("value", function(e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
        }), r(function(e) {
            return null == e.getAttribute("disabled")
        }) || o(te, function(e, t, n) {
            var i;
            return n ? void 0 : e[t] === !0 ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }), t
    }(e);
    J.find = re, J.expr = re.selectors, J.expr[":"] = J.expr.pseudos, J.unique = re.uniqueSort, J.text = re.getText, J.isXMLDoc = re.isXML, J.contains = re.contains;
    var oe = J.expr.match.needsContext,
        se = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
        ae = /^.[^:#\[\.,]*$/;
    J.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? J.find.matchesSelector(i, e) ? [i] : [] : J.find.matches(e, J.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, J.fn.extend({
        find: function(e) {
            var t, n = this.length,
                i = [],
                r = this;
            if ("string" != typeof e) return this.pushStack(J(e).filter(function() {
                for (t = 0; n > t; t++)
                    if (J.contains(r[t], this)) return !0
            }));
            for (t = 0; n > t; t++) J.find(e, r[t], i);
            return i = this.pushStack(n > 1 ? J.unique(i) : i), i.selector = this.selector ? this.selector + " " + e : e, i
        },
        filter: function(e) {
            return this.pushStack(i(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(i(this, e || [], !0))
        },
        is: function(e) {
            return !!i(this, "string" == typeof e && oe.test(e) ? J(e) : e || [], !1).length
        }
    });
    var le, ue = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
        ce = J.fn.init = function(e, t) {
            var n, i;
            if (!e) return this;
            if ("string" == typeof e) {
                if (n = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : ue.exec(e), !n || !n[1] && t) return !t || t.jquery ? (t || le).find(e) : this.constructor(t).find(e);
                if (n[1]) {
                    if (t = t instanceof J ? t[0] : t, J.merge(this, J.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : Z, !0)), se.test(n[1]) && J.isPlainObject(t))
                        for (n in t) J.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                    return this
                }
                return i = Z.getElementById(n[2]), i && i.parentNode && (this.length = 1, this[0] = i), this.context = Z, this.selector = e, this
            }
            return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : J.isFunction(e) ? "undefined" != typeof le.ready ? le.ready(e) : e(J) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), J.makeArray(e, this))
        };
    ce.prototype = J.fn, le = J(Z);
    var de = /^(?:parents|prev(?:Until|All))/,
        pe = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    J.extend({
        dir: function(e, t, n) {
            for (var i = [], r = void 0 !== n;
                (e = e[t]) && 9 !== e.nodeType;)
                if (1 === e.nodeType) {
                    if (r && J(e).is(n)) break;
                    i.push(e)
                } return i
        },
        sibling: function(e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n
        }
    }), J.fn.extend({
        has: function(e) {
            var t = J(e, this),
                n = t.length;
            return this.filter(function() {
                for (var e = 0; n > e; e++)
                    if (J.contains(this, t[e])) return !0
            })
        },
        closest: function(e, t) {
            for (var n, i = 0, r = this.length, o = [], s = oe.test(e) || "string" != typeof e ? J(e, t || this.context) : 0; r > i; i++)
                for (n = this[i]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && J.find.matchesSelector(n, e))) {
                        o.push(n);
                        break
                    } return this.pushStack(o.length > 1 ? J.unique(o) : o)
        },
        index: function(e) {
            return e ? "string" == typeof e ? U.call(J(e), this[0]) : U.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(J.unique(J.merge(this.get(), J(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), J.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return J.dir(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return J.dir(e, "parentNode", n)
        },
        next: function(e) {
            return r(e, "nextSibling")
        },
        prev: function(e) {
            return r(e, "previousSibling")
        },
        nextAll: function(e) {
            return J.dir(e, "nextSibling")
        },
        prevAll: function(e) {
            return J.dir(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return J.dir(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return J.dir(e, "previousSibling", n)
        },
        siblings: function(e) {
            return J.sibling((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return J.sibling(e.firstChild)
        },
        contents: function(e) {
            return e.contentDocument || J.merge([], e.childNodes)
        }
    }, function(e, t) {
        J.fn[e] = function(n, i) {
            var r = J.map(this, t, n);
            return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (r = J.filter(i, r)), this.length > 1 && (pe[e] || J.unique(r), de.test(e) && r.reverse()), this.pushStack(r)
        }
    });
    var he = /\S+/g,
        fe = {};
    J.Callbacks = function(e) {
        e = "string" == typeof e ? fe[e] || o(e) : J.extend({}, e);
        var t, n, i, r, s, a, l = [],
            u = !e.once && [],
            c = function(o) {
                for (t = e.memory && o, n = !0, a = r || 0, r = 0, s = l.length, i = !0; l && s > a; a++)
                    if (l[a].apply(o[0], o[1]) === !1 && e.stopOnFalse) {
                        t = !1;
                        break
                    } i = !1, l && (u ? u.length && c(u.shift()) : t ? l = [] : d.disable())
            },
            d = {
                add: function() {
                    if (l) {
                        var n = l.length;
                        ! function o(t) {
                            J.each(t, function(t, n) {
                                var i = J.type(n);
                                "function" === i ? e.unique && d.has(n) || l.push(n) : n && n.length && "string" !== i && o(n)
                            })
                        }(arguments), i ? s = l.length : t && (r = n, c(t))
                    }
                    return this
                },
                remove: function() {
                    return l && J.each(arguments, function(e, t) {
                        for (var n;
                            (n = J.inArray(t, l, n)) > -1;) l.splice(n, 1), i && (s >= n && s--, a >= n && a--)
                    }), this
                },
                has: function(e) {
                    return e ? J.inArray(e, l) > -1 : !(!l || !l.length)
                },
                empty: function() {
                    return l = [], s = 0, this
                },
                disable: function() {
                    return l = u = t = void 0, this
                },
                disabled: function() {
                    return !l
                },
                lock: function() {
                    return u = void 0, t || d.disable(), this
                },
                locked: function() {
                    return !u
                },
                fireWith: function(e, t) {
                    return !l || n && !u || (t = t || [], t = [e, t.slice ? t.slice() : t], i ? u.push(t) : c(t)), this
                },
                fire: function() {
                    return d.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!n
                }
            };
        return d
    }, J.extend({
        Deferred: function(e) {
            var t = [
                    ["resolve", "done", J.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", J.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", J.Callbacks("memory")]
                ],
                n = "pending",
                i = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return r.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var e = arguments;
                        return J.Deferred(function(n) {
                            J.each(t, function(t, o) {
                                var s = J.isFunction(e[t]) && e[t];
                                r[o[1]](function() {
                                    var e = s && s.apply(this, arguments);
                                    e && J.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[o[0] + "With"](this === i ? n.promise() : this, s ? [e] : arguments)
                                })
                            }), e = null
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? J.extend(e, i) : i
                    }
                },
                r = {};
            return i.pipe = i.then, J.each(t, function(e, o) {
                var s = o[2],
                    a = o[3];
                i[o[1]] = s.add, a && s.add(function() {
                    n = a
                }, t[1 ^ e][2].disable, t[2][2].lock), r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? i : this, arguments), this
                }, r[o[0] + "With"] = s.fireWith
            }), i.promise(r), e && e.call(r, r), r
        },
        when: function(e) {
            var t, n, i, r = 0,
                o = M.call(arguments),
                s = o.length,
                a = 1 !== s || e && J.isFunction(e.promise) ? s : 0,
                l = 1 === a ? e : J.Deferred(),
                u = function(e, n, i) {
                    return function(r) {
                        n[e] = this, i[e] = arguments.length > 1 ? M.call(arguments) : r, i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i)
                    }
                };
            if (s > 1)
                for (t = new Array(s), n = new Array(s), i = new Array(s); s > r; r++) o[r] && J.isFunction(o[r].promise) ? o[r].promise().done(u(r, i, o)).fail(l.reject).progress(u(r, n, t)) : --a;
            return a || l.resolveWith(i, o), l.promise()
        }
    });
    var ge;
    J.fn.ready = function(e) {
        return J.ready.promise().done(e), this
    }, J.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(e) {
            e ? J.readyWait++ : J.ready(!0)
        },
        ready: function(e) {
            (e === !0 ? --J.readyWait : J.isReady) || (J.isReady = !0, e !== !0 && --J.readyWait > 0 || (ge.resolveWith(Z, [J]), J.fn.triggerHandler && (J(Z).triggerHandler("ready"), J(Z).off("ready"))))
        }
    }), J.ready.promise = function(t) {
        return ge || (ge = J.Deferred(), "complete" === Z.readyState ? setTimeout(J.ready) : (Z.addEventListener("DOMContentLoaded", s, !1), e.addEventListener("load", s, !1))), ge.promise(t)
    }, J.ready.promise();
    var me = J.access = function(e, t, n, i, r, o, s) {
        var a = 0,
            l = e.length,
            u = null == n;
        if ("object" === J.type(n)) {
            r = !0;
            for (a in n) J.access(e, t, a, n[a], !0, o, s)
        } else if (void 0 !== i && (r = !0, J.isFunction(i) || (s = !0), u && (s ? (t.call(e, i), t = null) : (u = t, t = function(e, t, n) {
                return u.call(J(e), n)
            })), t))
            for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return r ? e : u ? t.call(e) : l ? t(e[0], n) : o
    };
    J.acceptData = function(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    }, a.uid = 1, a.accepts = J.acceptData, a.prototype = {
        key: function(e) {
            if (!a.accepts(e)) return 0;
            var t = {},
                n = e[this.expando];
            if (!n) {
                n = a.uid++;
                try {
                    t[this.expando] = {
                        value: n
                    }, Object.defineProperties(e, t)
                } catch (i) {
                    t[this.expando] = n, J.extend(e, t)
                }
            }
            return this.cache[n] || (this.cache[n] = {}), n
        },
        set: function(e, t, n) {
            var i, r = this.key(e),
                o = this.cache[r];
            if ("string" == typeof t) o[t] = n;
            else if (J.isEmptyObject(o)) J.extend(this.cache[r], t);
            else
                for (i in t) o[i] = t[i];
            return o
        },
        get: function(e, t) {
            var n = this.cache[this.key(e)];
            return void 0 === t ? n : n[t]
        },
        access: function(e, t, n) {
            var i;
            return void 0 === t || t && "string" == typeof t && void 0 === n ? (i = this.get(e, t), void 0 !== i ? i : this.get(e, J.camelCase(t))) : (this.set(e, t, n), void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i, r, o = this.key(e),
                s = this.cache[o];
            if (void 0 === t) this.cache[o] = {};
            else {
                J.isArray(t) ? i = t.concat(t.map(J.camelCase)) : (r = J.camelCase(t), t in s ? i = [t, r] : (i = r, i = i in s ? [i] : i.match(he) || [])), n = i.length;
                for (; n--;) delete s[i[n]]
            }
        },
        hasData: function(e) {
            return !J.isEmptyObject(this.cache[e[this.expando]] || {})
        },
        discard: function(e) {
            e[this.expando] && delete this.cache[e[this.expando]]
        }
    };
    var ve = new a,
        ye = new a,
        be = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        we = /([A-Z])/g;
    J.extend({
        hasData: function(e) {
            return ye.hasData(e) || ve.hasData(e)
        },
        data: function(e, t, n) {
            return ye.access(e, t, n)
        },
        removeData: function(e, t) {
            ye.remove(e, t)
        },
        _data: function(e, t, n) {
            return ve.access(e, t, n)
        },
        _removeData: function(e, t) {
            ve.remove(e, t)
        }
    }), J.fn.extend({
        data: function(e, t) {
            var n, i, r, o = this[0],
                s = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (r = ye.get(o), 1 === o.nodeType && !ve.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--;) s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = J.camelCase(i.slice(5)), l(o, i, r[i])));
                    ve.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof e ? this.each(function() {
                ye.set(this, e)
            }) : me(this, function(t) {
                var n, i = J.camelCase(e);
                if (o && void 0 === t) {
                    if (n = ye.get(o, e), void 0 !== n) return n;
                    if (n = ye.get(o, i), void 0 !== n) return n;
                    if (n = l(o, i, void 0), void 0 !== n) return n
                } else this.each(function() {
                    var n = ye.get(this, i);
                    ye.set(this, i, t), -1 !== e.indexOf("-") && void 0 !== n && ye.set(this, e, t)
                })
            }, null, t, arguments.length > 1, null, !0)
        },
        removeData: function(e) {
            return this.each(function() {
                ye.remove(this, e)
            })
        }
    }), J.extend({
        queue: function(e, t, n) {
            var i;
            return e ? (t = (t || "fx") + "queue", i = ve.get(e, t), n && (!i || J.isArray(n) ? i = ve.access(e, t, J.makeArray(n)) : i.push(n)), i || []) : void 0
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = J.queue(e, t),
                i = n.length,
                r = n.shift(),
                o = J._queueHooks(e, t),
                s = function() {
                    J.dequeue(e, t)
                };
            "inprogress" === r && (r = n.shift(), i--), r && ("fx" === t && n.unshift("inprogress"), delete o.stop, r.call(e, s, o)), !i && o && o.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return ve.get(e, n) || ve.access(e, n, {
                empty: J.Callbacks("once memory").add(function() {
                    ve.remove(e, [t + "queue", n])
                })
            })
        }
    }), J.fn.extend({
        queue: function(e, t) {
            var n = 2;
            return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? J.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                var n = J.queue(this, e, t);
                J._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && J.dequeue(this, e)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                J.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            var n, i = 1,
                r = J.Deferred(),
                o = this,
                s = this.length,
                a = function() {
                    --i || r.resolveWith(o, [o])
                };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;) n = ve.get(o[s], e + "queueHooks"), n && n.empty && (i++, n.empty.add(a));
            return a(), r.promise(t)
        }
    });
    var xe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        Ce = ["Top", "Right", "Bottom", "Left"],
        Se = function(e, t) {
            return e = t || e, "none" === J.css(e, "display") || !J.contains(e.ownerDocument, e)
        },
        _e = /^(?:checkbox|radio)$/i;
    ! function() {
        var e = Z.createDocumentFragment(),
            t = e.appendChild(Z.createElement("div")),
            n = Z.createElement("input");
        n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), t.appendChild(n), G.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, t.innerHTML = "<textarea>x</textarea>", G.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
    }();
    var Te = "undefined";
    G.focusinBubbles = "onfocusin" in e;
    var Ae = /^key/,
        ke = /^(?:mouse|pointer|contextmenu)|click/,
        Pe = /^(?:focusinfocus|focusoutblur)$/,
        Ee = /^([^.]*)(?:\.(.+)|)$/;
    J.event = {
        global: {},
        add: function(e, t, n, i, r) {
            var o, s, a, l, u, c, d, p, h, f, g, m = ve.get(e);
            if (m)
                for (n.handler && (o = n, n = o.handler, r = o.selector), n.guid || (n.guid = J.guid++), (l = m.events) || (l = m.events = {}), (s = m.handle) || (s = m.handle = function(t) {
                        return typeof J !== Te && J.event.triggered !== t.type ? J.event.dispatch.apply(e, arguments) : void 0
                    }), t = (t || "").match(he) || [""], u = t.length; u--;) a = Ee.exec(t[u]) || [], h = g = a[1], f = (a[2] || "").split(".").sort(), h && (d = J.event.special[h] || {}, h = (r ? d.delegateType : d.bindType) || h, d = J.event.special[h] || {}, c = J.extend({
                    type: h,
                    origType: g,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: r,
                    needsContext: r && J.expr.match.needsContext.test(r),
                    namespace: f.join(".")
                }, o), (p = l[h]) || (p = l[h] = [], p.delegateCount = 0, d.setup && d.setup.call(e, i, f, s) !== !1 || e.addEventListener && e.addEventListener(h, s, !1)), d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), r ? p.splice(p.delegateCount++, 0, c) : p.push(c), J.event.global[h] = !0)
        },
        remove: function(e, t, n, i, r) {
            var o, s, a, l, u, c, d, p, h, f, g, m = ve.hasData(e) && ve.get(e);
            if (m && (l = m.events)) {
                for (t = (t || "").match(he) || [""], u = t.length; u--;)
                    if (a = Ee.exec(t[u]) || [], h = g = a[1], f = (a[2] || "").split(".").sort(), h) {
                        for (d = J.event.special[h] || {}, h = (i ? d.delegateType : d.bindType) || h, p = l[h] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = p.length; o--;) c = p[o], !r && g !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, d.remove && d.remove.call(e, c));
                        s && !p.length && (d.teardown && d.teardown.call(e, f, m.handle) !== !1 || J.removeEvent(e, h, m.handle), delete l[h])
                    } else
                        for (h in l) J.event.remove(e, h + t[u], n, i, !0);
                J.isEmptyObject(l) && (delete m.handle, ve.remove(e, "events"))
            }
        },
        trigger: function(t, n, i, r) {
            var o, s, a, l, u, c, d, p = [i || Z],
                h = Y.call(t, "type") ? t.type : t,
                f = Y.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = a = i = i || Z, 3 !== i.nodeType && 8 !== i.nodeType && !Pe.test(h + J.event.triggered) && (h.indexOf(".") >= 0 && (f = h.split("."), h = f.shift(), f.sort()), u = h.indexOf(":") < 0 && "on" + h, t = t[J.expando] ? t : new J.Event(h, "object" == typeof t && t), t.isTrigger = r ? 2 : 3, t.namespace = f.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : J.makeArray(n, [t]), d = J.event.special[h] || {}, r || !d.trigger || d.trigger.apply(i, n) !== !1)) {
                if (!r && !d.noBubble && !J.isWindow(i)) {
                    for (l = d.delegateType || h, Pe.test(l + h) || (s = s.parentNode); s; s = s.parentNode) p.push(s), a = s;
                    a === (i.ownerDocument || Z) && p.push(a.defaultView || a.parentWindow || e)
                }
                for (o = 0;
                    (s = p[o++]) && !t.isPropagationStopped();) t.type = o > 1 ? l : d.bindType || h, c = (ve.get(s, "events") || {})[t.type] && ve.get(s, "handle"), c && c.apply(s, n), c = u && s[u], c && c.apply && J.acceptData(s) && (t.result = c.apply(s, n), t.result === !1 && t.preventDefault());
                return t.type = h, r || t.isDefaultPrevented() || d._default && d._default.apply(p.pop(), n) !== !1 || !J.acceptData(i) || u && J.isFunction(i[h]) && !J.isWindow(i) && (a = i[u], a && (i[u] = null), J.event.triggered = h, i[h](), J.event.triggered = void 0, a && (i[u] = a)), t.result
            }
        },
        dispatch: function(e) {
            e = J.event.fix(e);
            var t, n, i, r, o, s = [],
                a = M.call(arguments),
                l = (ve.get(this, "events") || {})[e.type] || [],
                u = J.event.special[e.type] || {};
            if (a[0] = e, e.delegateTarget = this, !u.preDispatch || u.preDispatch.call(this, e) !== !1) {
                for (s = J.event.handlers.call(this, e, l), t = 0;
                    (r = s[t++]) && !e.isPropagationStopped();)
                    for (e.currentTarget = r.elem, n = 0;
                        (o = r.handlers[n++]) && !e.isImmediatePropagationStopped();)(!e.namespace_re || e.namespace_re.test(o.namespace)) && (e.handleObj = o, e.data = o.data, i = ((J.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, a), void 0 !== i && (e.result = i) === !1 && (e.preventDefault(), e.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, e), e.result
            }
        },
        handlers: function(e, t) {
            var n, i, r, o, s = [],
                a = t.delegateCount,
                l = e.target;
            if (a && l.nodeType && (!e.button || "click" !== e.type))
                for (; l !== this; l = l.parentNode || this)
                    if (l.disabled !== !0 || "click" !== e.type) {
                        for (i = [], n = 0; a > n; n++) o = t[n], r = o.selector + " ", void 0 === i[r] && (i[r] = o.needsContext ? J(r, this).index(l) >= 0 : J.find(r, this, null, [l]).length), i[r] && i.push(o);
                        i.length && s.push({
                            elem: l,
                            handlers: i
                        })
                    } return a < t.length && s.push({
                elem: this,
                handlers: t.slice(a)
            }), s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(e, t) {
                var n, i, r, o = t.button;
                return null == e.pageX && null != t.clientX && (n = e.target.ownerDocument || Z, i = n.documentElement, r = n.body, e.pageX = t.clientX + (i && i.scrollLeft || r && r.scrollLeft || 0) - (i && i.clientLeft || r && r.clientLeft || 0), e.pageY = t.clientY + (i && i.scrollTop || r && r.scrollTop || 0) - (i && i.clientTop || r && r.clientTop || 0)), e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), e
            }
        },
        fix: function(e) {
            if (e[J.expando]) return e;
            var t, n, i, r = e.type,
                o = e,
                s = this.fixHooks[r];
            for (s || (this.fixHooks[r] = s = ke.test(r) ? this.mouseHooks : Ae.test(r) ? this.keyHooks : {}), i = s.props ? this.props.concat(s.props) : this.props, e = new J.Event(o), t = i.length; t--;) n = i[t], e[n] = o[n];
            return e.target || (e.target = Z), 3 === e.target.nodeType && (e.target = e.target.parentNode), s.filter ? s.filter(e, o) : e
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== d() && this.focus ? (this.focus(), !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === d() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && J.nodeName(this, "input") ? (this.click(), !1) : void 0
                },
                _default: function(e) {
                    return J.nodeName(e.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        },
        simulate: function(e, t, n, i) {
            var r = J.extend(new J.Event, n, {
                type: e,
                isSimulated: !0,
                originalEvent: {}
            });
            i ? J.event.trigger(r, null, t) : J.event.dispatch.call(t, r), r.isDefaultPrevented() && n.preventDefault()
        }
    }, J.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n, !1)
    }, J.Event = function(e, t) {
        return this instanceof J.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? u : c) : this.type = e, t && J.extend(this, t), this.timeStamp = e && e.timeStamp || J.now(), void(this[J.expando] = !0)) : new J.Event(e, t)
    }, J.Event.prototype = {
        isDefaultPrevented: c,
        isPropagationStopped: c,
        isImmediatePropagationStopped: c,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = u, e && e.preventDefault && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = u, e && e.stopPropagation && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = u, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, J.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, t) {
        J.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function(e) {
                var n, i = this,
                    r = e.relatedTarget,
                    o = e.handleObj;
                return (!r || r !== i && !J.contains(i, r)) && (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n
            }
        }
    }), G.focusinBubbles || J.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        var n = function(e) {
            J.event.simulate(t, e.target, J.event.fix(e), !0)
        };
        J.event.special[t] = {
            setup: function() {
                var i = this.ownerDocument || this,
                    r = ve.access(i, t);
                r || i.addEventListener(e, n, !0), ve.access(i, t, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this,
                    r = ve.access(i, t) - 1;
                r ? ve.access(i, t, r) : (i.removeEventListener(e, n, !0), ve.remove(i, t))
            }
        }
    }), J.fn.extend({
        on: function(e, t, n, i, r) {
            var o, s;
            if ("object" == typeof e) {
                "string" != typeof t && (n = n || t, t = void 0);
                for (s in e) this.on(s, t, n, e[s], r);
                return this
            }
            if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, n = void 0) : (i = n, n = t, t = void 0)), i === !1) i = c;
            else if (!i) return this;
            return 1 === r && (o = i, i = function(e) {
                return J().off(e), o.apply(this, arguments)
            }, i.guid = o.guid || (o.guid = J.guid++)), this.each(function() {
                J.event.add(this, e, i, n, t)
            })
        },
        one: function(e, t, n, i) {
            return this.on(e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, r;
            if (e && e.preventDefault && e.handleObj) return i = e.handleObj, J(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" == typeof e) {
                for (r in e) this.off(r, t, e[r]);
                return this
            }
            return (t === !1 || "function" == typeof t) && (n = t, t = void 0), n === !1 && (n = c), this.each(function() {
                J.event.remove(this, e, n, t)
            })
        },
        trigger: function(e, t) {
            return this.each(function() {
                J.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            return n ? J.event.trigger(e, t, n, !0) : void 0
        }
    });
    var Ie = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
        Oe = /<([\w:]+)/,
        ze = /<|&#?\w+;/,
        Ne = /<(?:script|style|link)/i,
        je = /checked\s*(?:[^=]|=\s*.checked.)/i,
        $e = /^$|\/(?:java|ecma)script/i,
        De = /^true\/(.*)/,
        Fe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
        qe = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
    qe.optgroup = qe.option, qe.tbody = qe.tfoot = qe.colgroup = qe.caption = qe.thead, qe.th = qe.td, J.extend({
        clone: function(e, t, n) {
            var i, r, o, s, a = e.cloneNode(!0),
                l = J.contains(e.ownerDocument, e);
            if (!(G.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || J.isXMLDoc(e)))
                for (s = v(a), o = v(e), i = 0, r = o.length; r > i; i++) y(o[i], s[i]);
            if (t)
                if (n)
                    for (o = o || v(e), s = s || v(a), i = 0, r = o.length; r > i; i++) m(o[i], s[i]);
                else m(e, a);
            return s = v(a, "script"), s.length > 0 && g(s, !l && v(e, "script")), a
        },
        buildFragment: function(e, t, n, i) {
            for (var r, o, s, a, l, u, c = t.createDocumentFragment(), d = [], p = 0, h = e.length; h > p; p++)
                if (r = e[p], r || 0 === r)
                    if ("object" === J.type(r)) J.merge(d, r.nodeType ? [r] : r);
                    else if (ze.test(r)) {
                for (o = o || c.appendChild(t.createElement("div")), s = (Oe.exec(r) || ["", ""])[1].toLowerCase(), a = qe[s] || qe._default, o.innerHTML = a[1] + r.replace(Ie, "<$1></$2>") + a[2], u = a[0]; u--;) o = o.lastChild;
                J.merge(d, o.childNodes), o = c.firstChild, o.textContent = ""
            } else d.push(t.createTextNode(r));
            for (c.textContent = "", p = 0; r = d[p++];)
                if ((!i || -1 === J.inArray(r, i)) && (l = J.contains(r.ownerDocument, r), o = v(c.appendChild(r), "script"), l && g(o), n))
                    for (u = 0; r = o[u++];) $e.test(r.type || "") && n.push(r);
            return c
        },
        cleanData: function(e) {
            for (var t, n, i, r, o = J.event.special, s = 0; void 0 !== (n = e[s]); s++) {
                if (J.acceptData(n) && (r = n[ve.expando], r && (t = ve.cache[r]))) {
                    if (t.events)
                        for (i in t.events) o[i] ? J.event.remove(n, i) : J.removeEvent(n, i, t.handle);
                    ve.cache[r] && delete ve.cache[r]
                }
                delete ye.cache[n[ye.expando]]
            }
        }
    }), J.fn.extend({
        text: function(e) {
            return me(this, function(e) {
                return void 0 === e ? J.text(this) : this.empty().each(function() {
                    (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = p(this, e);
                    t.appendChild(e)
                }
            })
        },
        prepend: function() {
            return this.domManip(arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = p(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return this.domManip(arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        remove: function(e, t) {
            for (var n, i = e ? J.filter(e, this) : this, r = 0; null != (n = i[r]); r++) t || 1 !== n.nodeType || J.cleanData(v(n)), n.parentNode && (t && J.contains(n.ownerDocument, n) && g(v(n, "script")), n.parentNode.removeChild(n));
            return this
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (J.cleanData(v(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return J.clone(this, e, t)
            })
        },
        html: function(e) {
            return me(this, function(e) {
                var t = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Ne.test(e) && !qe[(Oe.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = e.replace(Ie, "<$1></$2>");
                    try {
                        for (; i > n; n++) t = this[n] || {}, 1 === t.nodeType && (J.cleanData(v(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (r) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var e = arguments[0];
            return this.domManip(arguments, function(t) {
                e = this.parentNode, J.cleanData(v(this)), e && e.replaceChild(t, this)
            }), e && (e.length || e.nodeType) ? this : this.remove()
        },
        detach: function(e) {
            return this.remove(e, !0)
        },
        domManip: function(e, t) {
            e = W.apply([], e);
            var n, i, r, o, s, a, l = 0,
                u = this.length,
                c = this,
                d = u - 1,
                p = e[0],
                g = J.isFunction(p);
            if (g || u > 1 && "string" == typeof p && !G.checkClone && je.test(p)) return this.each(function(n) {
                var i = c.eq(n);
                g && (e[0] = p.call(this, n, i.html())), i.domManip(e, t)
            });
            if (u && (n = J.buildFragment(e, this[0].ownerDocument, !1, this), i = n.firstChild, 1 === n.childNodes.length && (n = i), i)) {
                for (r = J.map(v(n, "script"), h), o = r.length; u > l; l++) s = n, l !== d && (s = J.clone(s, !0, !0), o && J.merge(r, v(s, "script"))), t.call(this[l], s, l);
                if (o)
                    for (a = r[r.length - 1].ownerDocument, J.map(r, f), l = 0; o > l; l++) s = r[l], $e.test(s.type || "") && !ve.access(s, "globalEval") && J.contains(a, s) && (s.src ? J._evalUrl && J._evalUrl(s.src) : J.globalEval(s.textContent.replace(Fe, "")))
            }
            return this
        }
    }), J.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, t) {
        J.fn[e] = function(e) {
            for (var n, i = [], r = J(e), o = r.length - 1, s = 0; o >= s; s++) n = s === o ? this : this.clone(!0), J(r[s])[t](n), B.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Le, Re = {},
        He = /^margin/,
        Ve = new RegExp("^(" + xe + ")(?!px)[a-z%]+$", "i"),
        Me = function(t) {
            return t.ownerDocument.defaultView.opener ? t.ownerDocument.defaultView.getComputedStyle(t, null) : e.getComputedStyle(t, null)
        };
    ! function() {
        function t() {
            s.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", s.innerHTML = "", r.appendChild(o);
            var t = e.getComputedStyle(s, null);
            n = "1%" !== t.top, i = "4px" === t.width, r.removeChild(o)
        }
        var n, i, r = Z.documentElement,
            o = Z.createElement("div"),
            s = Z.createElement("div");
        s.style && (s.style.backgroundClip = "content-box", s.cloneNode(!0).style.backgroundClip = "", G.clearCloneStyle = "content-box" === s.style.backgroundClip, o.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute", o.appendChild(s), e.getComputedStyle && J.extend(G, {
            pixelPosition: function() {
                return t(), n
            },
            boxSizingReliable: function() {
                return null == i && t(), i
            },
            reliableMarginRight: function() {
                var t, n = s.appendChild(Z.createElement("div"));
                return n.style.cssText = s.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", s.style.width = "1px", r.appendChild(o), t = !parseFloat(e.getComputedStyle(n, null).marginRight), r.removeChild(o), s.removeChild(n), t
            }
        }))
    }(), J.swap = function(e, t, n, i) {
        var r, o, s = {};
        for (o in t) s[o] = e.style[o], e.style[o] = t[o];
        r = n.apply(e, i || []);
        for (o in t) e.style[o] = s[o];
        return r
    };
    var We = /^(none|table(?!-c[ea]).+)/,
        Be = new RegExp("^(" + xe + ")(.*)$", "i"),
        Ue = new RegExp("^([+-])=(" + xe + ")", "i"),
        Qe = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        Xe = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        Ye = ["Webkit", "O", "Moz", "ms"];
    J.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = x(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            "float": "cssFloat"
        },
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var r, o, s, a = J.camelCase(t),
                    l = e.style;
                return t = J.cssProps[a] || (J.cssProps[a] = S(l, a)), s = J.cssHooks[t] || J.cssHooks[a], void 0 === n ? s && "get" in s && void 0 !== (r = s.get(e, !1, i)) ? r : l[t] : (o = typeof n, "string" === o && (r = Ue.exec(n)) && (n = (r[1] + 1) * r[2] + parseFloat(J.css(e, t)), o = "number"), void(null != n && n === n && ("number" !== o || J.cssNumber[a] || (n += "px"), G.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, i)) || (l[t] = n))))
            }
        },
        css: function(e, t, n, i) {
            var r, o, s, a = J.camelCase(t);
            return t = J.cssProps[a] || (J.cssProps[a] = S(e.style, a)), s = J.cssHooks[t] || J.cssHooks[a], s && "get" in s && (r = s.get(e, !0, n)), void 0 === r && (r = x(e, t, i)), "normal" === r && t in Xe && (r = Xe[t]), "" === n || n ? (o = parseFloat(r), n === !0 || J.isNumeric(o) ? o || 0 : r) : r
        }
    }), J.each(["height", "width"], function(e, t) {
        J.cssHooks[t] = {
            get: function(e, n, i) {
                return n ? We.test(J.css(e, "display")) && 0 === e.offsetWidth ? J.swap(e, Qe, function() {
                    return A(e, t, i)
                }) : A(e, t, i) : void 0
            },
            set: function(e, n, i) {
                var r = i && Me(e);
                return _(e, n, i ? T(e, t, i, "border-box" === J.css(e, "boxSizing", !1, r), r) : 0)
            }
        }
    }), J.cssHooks.marginRight = C(G.reliableMarginRight, function(e, t) {
        return t ? J.swap(e, {
            display: "inline-block"
        }, x, [e, "marginRight"]) : void 0
    }), J.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(e, t) {
        J.cssHooks[e + t] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) r[e + Ce[i] + t] = o[i] || o[i - 2] || o[0];
                return r
            }
        }, He.test(e) || (J.cssHooks[e + t].set = _)
    }), J.fn.extend({
        css: function(e, t) {
            return me(this, function(e, t, n) {
                var i, r, o = {},
                    s = 0;
                if (J.isArray(t)) {
                    for (i = Me(e), r = t.length; r > s; s++) o[t[s]] = J.css(e, t[s], !1, i);
                    return o
                }
                return void 0 !== n ? J.style(e, t, n) : J.css(e, t)
            }, e, t, arguments.length > 1)
        },
        show: function() {
            return k(this, !0)
        },
        hide: function() {
            return k(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                Se(this) ? J(this).show() : J(this).hide()
            })
        }
    }), J.Tween = P, P.prototype = {
        constructor: P,
        init: function(e, t, n, i, r, o) {
            this.elem = e, this.prop = n, this.easing = r || "swing", this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = o || (J.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = P.propHooks[this.prop];
            return e && e.get ? e.get(this) : P.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = P.propHooks[this.prop];
            return this.options.duration ? this.pos = t = J.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : P.propHooks._default.set(this), this
        }
    }, P.prototype.init.prototype = P.prototype, P.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = J.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop]
            },
            set: function(e) {
                J.fx.step[e.prop] ? J.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[J.cssProps[e.prop]] || J.cssHooks[e.prop]) ? J.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
            }
        }
    }, P.propHooks.scrollTop = P.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, J.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        }
    }, J.fx = P.prototype.init, J.fx.step = {};
    var Ge, Ze, Ke = /^(?:toggle|show|hide)$/,
        Je = new RegExp("^(?:([+-])=|)(" + xe + ")([a-z%]*)$", "i"),
        et = /queueHooks$/,
        tt = [z],
        nt = {
            "*": [function(e, t) {
                var n = this.createTween(e, t),
                    i = n.cur(),
                    r = Je.exec(t),
                    o = r && r[3] || (J.cssNumber[e] ? "" : "px"),
                    s = (J.cssNumber[e] || "px" !== o && +i) && Je.exec(J.css(n.elem, e)),
                    a = 1,
                    l = 20;
                if (s && s[3] !== o) {
                    o = o || s[3], r = r || [], s = +i || 1;
                    do a = a || ".5", s /= a, J.style(n.elem, e, s + o); while (a !== (a = n.cur() / i) && 1 !== a && --l)
                }
                return r && (s = n.start = +s || +i || 0, n.unit = o, n.end = r[1] ? s + (r[1] + 1) * r[2] : +r[2]), n
            }]
        };
    J.Animation = J.extend(j, {
            tweener: function(e, t) {
                J.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
                for (var n, i = 0, r = e.length; r > i; i++) n = e[i], nt[n] = nt[n] || [], nt[n].unshift(t)
            },
            prefilter: function(e, t) {
                t ? tt.unshift(e) : tt.push(e)
            }
        }), J.speed = function(e, t, n) {
            var i = e && "object" == typeof e ? J.extend({}, e) : {
                complete: n || !n && t || J.isFunction(e) && e,
                duration: e,
                easing: n && t || t && !J.isFunction(t) && t
            };
            return i.duration = J.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in J.fx.speeds ? J.fx.speeds[i.duration] : J.fx.speeds._default, (null == i.queue || i.queue === !0) && (i.queue = "fx"), i.old = i.complete, i.complete = function() {
                J.isFunction(i.old) && i.old.call(this), i.queue && J.dequeue(this, i.queue)
            }, i
        }, J.fn.extend({
            fadeTo: function(e, t, n, i) {
                return this.filter(Se).css("opacity", 0).show().end().animate({
                    opacity: t
                }, e, n, i)
            },
            animate: function(e, t, n, i) {
                var r = J.isEmptyObject(e),
                    o = J.speed(t, n, i),
                    s = function() {
                        var t = j(this, J.extend({}, e), o);
                        (r || ve.get(this, "finish")) && t.stop(!0)
                    };
                return s.finish = s, r || o.queue === !1 ? this.each(s) : this.queue(o.queue, s)
            },
            stop: function(e, t, n) {
                var i = function(e) {
                    var t = e.stop;
                    delete e.stop, t(n)
                };
                return "string" != typeof e && (n = t, t = e, e = void 0), t && e !== !1 && this.queue(e || "fx", []), this.each(function() {
                    var t = !0,
                        r = null != e && e + "queueHooks",
                        o = J.timers,
                        s = ve.get(this);
                    if (r) s[r] && s[r].stop && i(s[r]);
                    else
                        for (r in s) s[r] && s[r].stop && et.test(r) && i(s[r]);
                    for (r = o.length; r--;) o[r].elem !== this || null != e && o[r].queue !== e || (o[r].anim.stop(n), t = !1, o.splice(r, 1));
                    (t || !n) && J.dequeue(this, e)
                })
            },
            finish: function(e) {
                return e !== !1 && (e = e || "fx"), this.each(function() {
                    var t, n = ve.get(this),
                        i = n[e + "queue"],
                        r = n[e + "queueHooks"],
                        o = J.timers,
                        s = i ? i.length : 0;
                    for (n.finish = !0, J.queue(this, e, []), r && r.stop && r.stop.call(this, !0),
                        t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                    for (t = 0; s > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
                    delete n.finish
                })
            }
        }), J.each(["toggle", "show", "hide"], function(e, t) {
            var n = J.fn[t];
            J.fn[t] = function(e, i, r) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(I(t, !0), e, i, r)
            }
        }), J.each({
            slideDown: I("show"),
            slideUp: I("hide"),
            slideToggle: I("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(e, t) {
            J.fn[e] = function(e, n, i) {
                return this.animate(t, e, n, i)
            }
        }), J.timers = [], J.fx.tick = function() {
            var e, t = 0,
                n = J.timers;
            for (Ge = J.now(); t < n.length; t++) e = n[t], e() || n[t] !== e || n.splice(t--, 1);
            n.length || J.fx.stop(), Ge = void 0
        }, J.fx.timer = function(e) {
            J.timers.push(e), e() ? J.fx.start() : J.timers.pop()
        }, J.fx.interval = 13, J.fx.start = function() {
            Ze || (Ze = setInterval(J.fx.tick, J.fx.interval))
        }, J.fx.stop = function() {
            clearInterval(Ze), Ze = null
        }, J.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, J.fn.delay = function(e, t) {
            return e = J.fx ? J.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function(t, n) {
                var i = setTimeout(t, e);
                n.stop = function() {
                    clearTimeout(i)
                }
            })
        },
        function() {
            var e = Z.createElement("input"),
                t = Z.createElement("select"),
                n = t.appendChild(Z.createElement("option"));
            e.type = "checkbox", G.checkOn = "" !== e.value, G.optSelected = n.selected, t.disabled = !0, G.optDisabled = !n.disabled, e = Z.createElement("input"), e.value = "t", e.type = "radio", G.radioValue = "t" === e.value
        }();
    var it, rt, ot = J.expr.attrHandle;
    J.fn.extend({
        attr: function(e, t) {
            return me(this, J.attr, e, t, arguments.length > 1)
        },
        removeAttr: function(e) {
            return this.each(function() {
                J.removeAttr(this, e)
            })
        }
    }), J.extend({
        attr: function(e, t, n) {
            var i, r, o = e.nodeType;
            if (e && 3 !== o && 8 !== o && 2 !== o) return typeof e.getAttribute === Te ? J.prop(e, t, n) : (1 === o && J.isXMLDoc(e) || (t = t.toLowerCase(), i = J.attrHooks[t] || (J.expr.match.bool.test(t) ? rt : it)), void 0 === n ? i && "get" in i && null !== (r = i.get(e, t)) ? r : (r = J.find.attr(e, t), null == r ? void 0 : r) : null !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : void J.removeAttr(e, t))
        },
        removeAttr: function(e, t) {
            var n, i, r = 0,
                o = t && t.match(he);
            if (o && 1 === e.nodeType)
                for (; n = o[r++];) i = J.propFix[n] || n, J.expr.match.bool.test(n) && (e[i] = !1), e.removeAttribute(n)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!G.radioValue && "radio" === t && J.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        }
    }), rt = {
        set: function(e, t, n) {
            return t === !1 ? J.removeAttr(e, n) : e.setAttribute(n, n), n
        }
    }, J.each(J.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var n = ot[t] || J.find.attr;
        ot[t] = function(e, t, i) {
            var r, o;
            return i || (o = ot[t], ot[t] = r, r = null != n(e, t, i) ? t.toLowerCase() : null, ot[t] = o), r
        }
    });
    var st = /^(?:input|select|textarea|button)$/i;
    J.fn.extend({
        prop: function(e, t) {
            return me(this, J.prop, e, t, arguments.length > 1)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[J.propFix[e] || e]
            })
        }
    }), J.extend({
        propFix: {
            "for": "htmlFor",
            "class": "className"
        },
        prop: function(e, t, n) {
            var i, r, o, s = e.nodeType;
            if (e && 3 !== s && 8 !== s && 2 !== s) return o = 1 !== s || !J.isXMLDoc(e), o && (t = J.propFix[t] || t, r = J.propHooks[t]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : e[t] = n : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    return e.hasAttribute("tabindex") || st.test(e.nodeName) || e.href ? e.tabIndex : -1
                }
            }
        }
    }), G.optSelected || (J.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        }
    }), J.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        J.propFix[this.toLowerCase()] = this
    });
    var at = /[\t\r\n\f]/g;
    J.fn.extend({
        addClass: function(e) {
            var t, n, i, r, o, s, a = "string" == typeof e && e,
                l = 0,
                u = this.length;
            if (J.isFunction(e)) return this.each(function(t) {
                J(this).addClass(e.call(this, t, this.className))
            });
            if (a)
                for (t = (e || "").match(he) || []; u > l; l++)
                    if (n = this[l], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(at, " ") : " ")) {
                        for (o = 0; r = t[o++];) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        s = J.trim(i), n.className !== s && (n.className = s)
                    } return this
        },
        removeClass: function(e) {
            var t, n, i, r, o, s, a = 0 === arguments.length || "string" == typeof e && e,
                l = 0,
                u = this.length;
            if (J.isFunction(e)) return this.each(function(t) {
                J(this).removeClass(e.call(this, t, this.className))
            });
            if (a)
                for (t = (e || "").match(he) || []; u > l; l++)
                    if (n = this[l], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(at, " ") : "")) {
                        for (o = 0; r = t[o++];)
                            for (; i.indexOf(" " + r + " ") >= 0;) i = i.replace(" " + r + " ", " ");
                        s = e ? J.trim(i) : "", n.className !== s && (n.className = s)
                    } return this
        },
        toggleClass: function(e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : this.each(J.isFunction(e) ? function(n) {
                J(this).toggleClass(e.call(this, n, this.className, t), t)
            } : function() {
                if ("string" === n)
                    for (var t, i = 0, r = J(this), o = e.match(he) || []; t = o[i++];) r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                else(n === Te || "boolean" === n) && (this.className && ve.set(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : ve.get(this, "__className__") || "")
            })
        },
        hasClass: function(e) {
            for (var t = " " + e + " ", n = 0, i = this.length; i > n; n++)
                if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(at, " ").indexOf(t) >= 0) return !0;
            return !1
        }
    });
    var lt = /\r/g;
    J.fn.extend({
        val: function(e) {
            var t, n, i, r = this[0];
            return arguments.length ? (i = J.isFunction(e), this.each(function(n) {
                var r;
                1 === this.nodeType && (r = i ? e.call(this, n, J(this).val()) : e, null == r ? r = "" : "number" == typeof r ? r += "" : J.isArray(r) && (r = J.map(r, function(e) {
                    return null == e ? "" : e + ""
                })), t = J.valHooks[this.type] || J.valHooks[this.nodeName.toLowerCase()], t && "set" in t && void 0 !== t.set(this, r, "value") || (this.value = r))
            })) : r ? (t = J.valHooks[r.type] || J.valHooks[r.nodeName.toLowerCase()], t && "get" in t && void 0 !== (n = t.get(r, "value")) ? n : (n = r.value, "string" == typeof n ? n.replace(lt, "") : null == n ? "" : n)) : void 0
        }
    }), J.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = J.find.attr(e, "value");
                    return null != t ? t : J.trim(J.text(e))
                }
            },
            select: {
                get: function(e) {
                    for (var t, n, i = e.options, r = e.selectedIndex, o = "select-one" === e.type || 0 > r, s = o ? null : [], a = o ? r + 1 : i.length, l = 0 > r ? a : o ? r : 0; a > l; l++)
                        if (n = i[l], !(!n.selected && l !== r || (G.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && J.nodeName(n.parentNode, "optgroup"))) {
                            if (t = J(n).val(), o) return t;
                            s.push(t)
                        } return s
                },
                set: function(e, t) {
                    for (var n, i, r = e.options, o = J.makeArray(t), s = r.length; s--;) i = r[s], (i.selected = J.inArray(i.value, o) >= 0) && (n = !0);
                    return n || (e.selectedIndex = -1), o
                }
            }
        }
    }), J.each(["radio", "checkbox"], function() {
        J.valHooks[this] = {
            set: function(e, t) {
                return J.isArray(t) ? e.checked = J.inArray(J(e).val(), t) >= 0 : void 0
            }
        }, G.checkOn || (J.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    }), J.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(e, t) {
        J.fn[t] = function(e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }), J.fn.extend({
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        },
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }
    });
    var ut = J.now(),
        ct = /\?/;
    J.parseJSON = function(e) {
        return JSON.parse(e + "")
    }, J.parseXML = function(e) {
        var t, n;
        if (!e || "string" != typeof e) return null;
        try {
            n = new DOMParser, t = n.parseFromString(e, "text/xml")
        } catch (i) {
            t = void 0
        }
        return (!t || t.getElementsByTagName("parsererror").length) && J.error("Invalid XML: " + e), t
    };
    var dt = /#.*$/,
        pt = /([?&])_=[^&]*/,
        ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        ft = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        gt = /^(?:GET|HEAD)$/,
        mt = /^\/\//,
        vt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
        yt = {},
        bt = {},
        wt = "*/".concat("*"),
        xt = e.location.href,
        Ct = vt.exec(xt.toLowerCase()) || [];
    J.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: xt,
            type: "GET",
            isLocal: ft.test(Ct[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": wt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": J.parseJSON,
                "text xml": J.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? F(F(e, J.ajaxSettings), t) : F(J.ajaxSettings, e)
        },
        ajaxPrefilter: $(yt),
        ajaxTransport: $(bt),
        ajax: function(e, t) {
            function n(e, t, n, s) {
                var l, c, v, y, w, C = t;
                2 !== b && (b = 2, a && clearTimeout(a), i = void 0, o = s || "", x.readyState = e > 0 ? 4 : 0, l = e >= 200 && 300 > e || 304 === e, n && (y = q(d, x, n)), y = L(d, y, x, l), l ? (d.ifModified && (w = x.getResponseHeader("Last-Modified"), w && (J.lastModified[r] = w), w = x.getResponseHeader("etag"), w && (J.etag[r] = w)), 204 === e || "HEAD" === d.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = y.state, c = y.data, v = y.error, l = !v)) : (v = C, (e || !C) && (C = "error", 0 > e && (e = 0))), x.status = e, x.statusText = (t || C) + "", l ? f.resolveWith(p, [c, C, x]) : f.rejectWith(p, [x, C, v]), x.statusCode(m), m = void 0, u && h.trigger(l ? "ajaxSuccess" : "ajaxError", [x, d, l ? c : v]), g.fireWith(p, [x, C]), u && (h.trigger("ajaxComplete", [x, d]), --J.active || J.event.trigger("ajaxStop")))
            }
            "object" == typeof e && (t = e, e = void 0), t = t || {};
            var i, r, o, s, a, l, u, c, d = J.ajaxSetup({}, t),
                p = d.context || d,
                h = d.context && (p.nodeType || p.jquery) ? J(p) : J.event,
                f = J.Deferred(),
                g = J.Callbacks("once memory"),
                m = d.statusCode || {},
                v = {},
                y = {},
                b = 0,
                w = "canceled",
                x = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (2 === b) {
                            if (!s)
                                for (s = {}; t = ht.exec(o);) s[t[1].toLowerCase()] = t[2];
                            t = s[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    },
                    getAllResponseHeaders: function() {
                        return 2 === b ? o : null
                    },
                    setRequestHeader: function(e, t) {
                        var n = e.toLowerCase();
                        return b || (e = y[n] = y[n] || e, v[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return b || (d.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (2 > b)
                                for (t in e) m[t] = [m[t], e[t]];
                            else x.always(e[x.status]);
                        return this
                    },
                    abort: function(e) {
                        var t = e || w;
                        return i && i.abort(t), n(0, t), this
                    }
                };
            if (f.promise(x).complete = g.add, x.success = x.done, x.error = x.fail, d.url = ((e || d.url || xt) + "").replace(dt, "").replace(mt, Ct[1] + "//"), d.type = t.method || t.type || d.method || d.type, d.dataTypes = J.trim(d.dataType || "*").toLowerCase().match(he) || [""], null == d.crossDomain && (l = vt.exec(d.url.toLowerCase()), d.crossDomain = !(!l || l[1] === Ct[1] && l[2] === Ct[2] && (l[3] || ("http:" === l[1] ? "80" : "443")) === (Ct[3] || ("http:" === Ct[1] ? "80" : "443")))), d.data && d.processData && "string" != typeof d.data && (d.data = J.param(d.data, d.traditional)), D(yt, d, t, x), 2 === b) return x;
            u = J.event && d.global, u && 0 === J.active++ && J.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !gt.test(d.type), r = d.url, d.hasContent || (d.data && (r = d.url += (ct.test(r) ? "&" : "?") + d.data, delete d.data), d.cache === !1 && (d.url = pt.test(r) ? r.replace(pt, "$1_=" + ut++) : r + (ct.test(r) ? "&" : "?") + "_=" + ut++)), d.ifModified && (J.lastModified[r] && x.setRequestHeader("If-Modified-Since", J.lastModified[r]), J.etag[r] && x.setRequestHeader("If-None-Match", J.etag[r])), (d.data && d.hasContent && d.contentType !== !1 || t.contentType) && x.setRequestHeader("Content-Type", d.contentType), x.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + wt + "; q=0.01" : "") : d.accepts["*"]);
            for (c in d.headers) x.setRequestHeader(c, d.headers[c]);
            if (d.beforeSend && (d.beforeSend.call(p, x, d) === !1 || 2 === b)) return x.abort();
            w = "abort";
            for (c in {
                    success: 1,
                    error: 1,
                    complete: 1
                }) x[c](d[c]);
            if (i = D(bt, d, t, x)) {
                x.readyState = 1, u && h.trigger("ajaxSend", [x, d]), d.async && d.timeout > 0 && (a = setTimeout(function() {
                    x.abort("timeout")
                }, d.timeout));
                try {
                    b = 1, i.send(v, n)
                } catch (C) {
                    if (!(2 > b)) throw C;
                    n(-1, C)
                }
            } else n(-1, "No Transport");
            return x
        },
        getJSON: function(e, t, n) {
            return J.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return J.get(e, void 0, t, "script")
        }
    }), J.each(["get", "post"], function(e, t) {
        J[t] = function(e, n, i, r) {
            return J.isFunction(n) && (r = r || i, i = n, n = void 0), J.ajax({
                url: e,
                type: t,
                dataType: r,
                data: n,
                success: i
            })
        }
    }), J._evalUrl = function(e) {
        return J.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            "throws": !0
        })
    }, J.fn.extend({
        wrapAll: function(e) {
            var t;
            return J.isFunction(e) ? this.each(function(t) {
                J(this).wrapAll(e.call(this, t))
            }) : (this[0] && (t = J(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this)
        },
        wrapInner: function(e) {
            return this.each(J.isFunction(e) ? function(t) {
                J(this).wrapInner(e.call(this, t))
            } : function() {
                var t = J(this),
                    n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        },
        wrap: function(e) {
            var t = J.isFunction(e);
            return this.each(function(n) {
                J(this).wrapAll(t ? e.call(this, n) : e)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                J.nodeName(this, "body") || J(this).replaceWith(this.childNodes)
            }).end()
        }
    }), J.expr.filters.hidden = function(e) {
        return e.offsetWidth <= 0 && e.offsetHeight <= 0
    }, J.expr.filters.visible = function(e) {
        return !J.expr.filters.hidden(e)
    };
    var St = /%20/g,
        _t = /\[\]$/,
        Tt = /\r?\n/g,
        At = /^(?:submit|button|image|reset|file)$/i,
        kt = /^(?:input|select|textarea|keygen)/i;
    J.param = function(e, t) {
        var n, i = [],
            r = function(e, t) {
                t = J.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
            };
        if (void 0 === t && (t = J.ajaxSettings && J.ajaxSettings.traditional), J.isArray(e) || e.jquery && !J.isPlainObject(e)) J.each(e, function() {
            r(this.name, this.value)
        });
        else
            for (n in e) R(n, e[n], t, r);
        return i.join("&").replace(St, "+")
    }, J.fn.extend({
        serialize: function() {
            return J.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = J.prop(this, "elements");
                return e ? J.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !J(this).is(":disabled") && kt.test(this.nodeName) && !At.test(e) && (this.checked || !_e.test(e))
            }).map(function(e, t) {
                var n = J(this).val();
                return null == n ? null : J.isArray(n) ? J.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Tt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Tt, "\r\n")
                }
            }).get()
        }
    }), J.ajaxSettings.xhr = function() {
        try {
            return new XMLHttpRequest
        } catch (e) {}
    };
    var Pt = 0,
        Et = {},
        It = {
            0: 200,
            1223: 204
        },
        Ot = J.ajaxSettings.xhr();
    e.attachEvent && e.attachEvent("onunload", function() {
        for (var e in Et) Et[e]()
    }), G.cors = !!Ot && "withCredentials" in Ot, G.ajax = Ot = !!Ot, J.ajaxTransport(function(e) {
        var t;
        return G.cors || Ot && !e.crossDomain ? {
            send: function(n, i) {
                var r, o = e.xhr(),
                    s = ++Pt;
                if (o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (r in e.xhrFields) o[r] = e.xhrFields[r];
                e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
                for (r in n) o.setRequestHeader(r, n[r]);
                t = function(e) {
                    return function() {
                        t && (delete Et[s], t = o.onload = o.onerror = null, "abort" === e ? o.abort() : "error" === e ? i(o.status, o.statusText) : i(It[o.status] || o.status, o.statusText, "string" == typeof o.responseText ? {
                            text: o.responseText
                        } : void 0, o.getAllResponseHeaders()))
                    }
                }, o.onload = t(), o.onerror = t("error"), t = Et[s] = t("abort");
                try {
                    o.send(e.hasContent && e.data || null)
                } catch (a) {
                    if (t) throw a
                }
            },
            abort: function() {
                t && t()
            }
        } : void 0
    }), J.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /(?:java|ecma)script/
        },
        converters: {
            "text script": function(e) {
                return J.globalEval(e), e
            }
        }
    }), J.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), J.ajaxTransport("script", function(e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function(i, r) {
                    t = J("<script>").prop({
                        async: !0,
                        charset: e.scriptCharset,
                        src: e.url
                    }).on("load error", n = function(e) {
                        t.remove(), n = null, e && r("error" === e.type ? 404 : 200, e.type)
                    }), Z.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var zt = [],
        Nt = /(=)\?(?=&|$)|\?\?/;
    J.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = zt.pop() || J.expando + "_" + ut++;
            return this[e] = !0, e
        }
    }), J.ajaxPrefilter("json jsonp", function(t, n, i) {
        var r, o, s, a = t.jsonp !== !1 && (Nt.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && Nt.test(t.data) && "data");
        return a || "jsonp" === t.dataTypes[0] ? (r = t.jsonpCallback = J.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Nt, "$1" + r) : t.jsonp !== !1 && (t.url += (ct.test(t.url) ? "&" : "?") + t.jsonp + "=" + r), t.converters["script json"] = function() {
            return s || J.error(r + " was not called"), s[0]
        }, t.dataTypes[0] = "json", o = e[r], e[r] = function() {
            s = arguments
        }, i.always(function() {
            e[r] = o, t[r] && (t.jsonpCallback = n.jsonpCallback, zt.push(r)), s && J.isFunction(o) && o(s[0]), s = o = void 0
        }), "script") : void 0
    }), J.parseHTML = function(e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || Z;
        var i = se.exec(e),
            r = !n && [];
        return i ? [t.createElement(i[1])] : (i = J.buildFragment([e], t, r), r && r.length && J(r).remove(), J.merge([], i.childNodes))
    };
    var jt = J.fn.load;
    J.fn.load = function(e, t, n) {
        if ("string" != typeof e && jt) return jt.apply(this, arguments);
        var i, r, o, s = this,
            a = e.indexOf(" ");
        return a >= 0 && (i = J.trim(e.slice(a)), e = e.slice(0, a)), J.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (r = "POST"), s.length > 0 && J.ajax({
            url: e,
            type: r,
            dataType: "html",
            data: t
        }).done(function(e) {
            o = arguments, s.html(i ? J("<div>").append(J.parseHTML(e)).find(i) : e)
        }).complete(n && function(e, t) {
            s.each(n, o || [e.responseText, t, e])
        }), this
    }, J.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        J.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), J.expr.filters.animated = function(e) {
        return J.grep(J.timers, function(t) {
            return e === t.elem
        }).length
    };
    var $t = e.document.documentElement;
    J.offset = {
        setOffset: function(e, t, n) {
            var i, r, o, s, a, l, u, c = J.css(e, "position"),
                d = J(e),
                p = {};
            "static" === c && (e.style.position = "relative"), a = d.offset(), o = J.css(e, "top"), l = J.css(e, "left"), u = ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1, u ? (i = d.position(), s = i.top, r = i.left) : (s = parseFloat(o) || 0, r = parseFloat(l) || 0), J.isFunction(t) && (t = t.call(e, n, a)), null != t.top && (p.top = t.top - a.top + s), null != t.left && (p.left = t.left - a.left + r), "using" in t ? t.using.call(e, p) : d.css(p)
        }
    }, J.fn.extend({
        offset: function(e) {
            if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                J.offset.setOffset(this, e, t)
            });
            var t, n, i = this[0],
                r = {
                    top: 0,
                    left: 0
                },
                o = i && i.ownerDocument;
            return o ? (t = o.documentElement, J.contains(t, i) ? (typeof i.getBoundingClientRect !== Te && (r = i.getBoundingClientRect()), n = H(o), {
                top: r.top + n.pageYOffset - t.clientTop,
                left: r.left + n.pageXOffset - t.clientLeft
            }) : r) : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n = this[0],
                    i = {
                        top: 0,
                        left: 0
                    };
                return "fixed" === J.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), J.nodeName(e[0], "html") || (i = e.offset()), i.top += J.css(e[0], "borderTopWidth", !0), i.left += J.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - i.top - J.css(n, "marginTop", !0),
                    left: t.left - i.left - J.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent || $t; e && !J.nodeName(e, "html") && "static" === J.css(e, "position");) e = e.offsetParent;
                return e || $t
            })
        }
    }), J.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, n) {
        var i = "pageYOffset" === n;
        J.fn[t] = function(r) {
            return me(this, function(t, r, o) {
                var s = H(t);
                return void 0 === o ? s ? s[n] : t[r] : void(s ? s.scrollTo(i ? e.pageXOffset : o, i ? o : e.pageYOffset) : t[r] = o)
            }, t, r, arguments.length, null)
        }
    }), J.each(["top", "left"], function(e, t) {
        J.cssHooks[t] = C(G.pixelPosition, function(e, n) {
            return n ? (n = x(e, t), Ve.test(n) ? J(e).position()[t] + "px" : n) : void 0
        })
    }), J.each({
        Height: "height",
        Width: "width"
    }, function(e, t) {
        J.each({
            padding: "inner" + e,
            content: t,
            "": "outer" + e
        }, function(n, i) {
            J.fn[i] = function(i, r) {
                var o = arguments.length && (n || "boolean" != typeof i),
                    s = n || (i === !0 || r === !0 ? "margin" : "border");
                return me(this, function(t, n, i) {
                    var r;
                    return J.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement, Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === i ? J.css(t, n, s) : J.style(t, n, i, s)
                }, t, o ? i : void 0, o, null)
            }
        })
    }), J.fn.size = function() {
        return this.length
    }, J.fn.andSelf = J.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return J
    });
    var Dt = e.jQuery,
        Ft = e.$;
    return J.noConflict = function(t) {
        return e.$ === J && (e.$ = Ft), t && e.jQuery === J && (e.jQuery = Dt), J
    }, typeof t === Te && (e.jQuery = e.$ = J), J
}), /*! loadCSS. [c]2017 Filament Group, Inc. MIT License */
function(e) {
    "use strict";
    var t = function(t, n, i) {
        function r(e) {
            return a.body ? e() : void setTimeout(function() {
                r(e)
            })
        }

        function o() {
            l.addEventListener && l.removeEventListener("load", o), l.media = i || "all"
        }
        var s, a = e.document,
            l = a.createElement("link");
        if (n) s = n;
        else {
            var u = (a.body || a.getElementsByTagName("head")[0]).childNodes;
            s = u[u.length - 1]
        }
        var c = a.styleSheets;
        l.rel = "stylesheet", l.href = t, l.media = "only x", r(function() {
            s.parentNode.insertBefore(l, n ? s : s.nextSibling)
        });
        var d = function(e) {
            for (var t = l.href, n = c.length; n--;)
                if (c[n].href === t) return e();
            setTimeout(function() {
                d(e)
            })
        };
        return l.addEventListener && l.addEventListener("load", o), l.onloadcssdefined = d, d(o), l
    };
    "undefined" != typeof exports ? exports.loadCSS = t : e.loadCSS = t
}("undefined" != typeof global ? global : this), /*! loadCSS rel=preload polyfill. [c]2017 Filament Group, Inc. MIT License */
function(e) {
    if (e.loadCSS) {
        var t = loadCSS.relpreload = {};
        if (t.support = function() {
                try {
                    return e.document.createElement("link").relList.supports("preload")
                } catch (t) {
                    return !1
                }
            }, t.poly = function() {
                for (var t = e.document.getElementsByTagName("link"), n = 0; n < t.length; n++) {
                    var i = t[n];
                    "preload" === i.rel && "style" === i.getAttribute("as") && (e.loadCSS(i.href, i, i.getAttribute("media")), i.rel = null)
                }
            }, !t.support()) {
            t.poly();
            var n = e.setInterval(t.poly, 300);
            e.addEventListener && e.addEventListener("load", function() {
                t.poly(), e.clearInterval(n)
            }), e.attachEvent && e.attachEvent("onload", function() {
                e.clearInterval(n)
            })
        }
    }
}(this),
function(e) {
    var t = !1;
    if ("function" == typeof define && define.amd && (define(e), t = !0), "object" == typeof exports && (module.exports = e(), t = !0), !t) {
        var n = window.Cookies,
            i = window.Cookies = e();
        i.noConflict = function() {
            return window.Cookies = n, i
        }
    }
}(function() {
    function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
            var n = arguments[e];
            for (var i in n) t[i] = n[i]
        }
        return t
    }

    function t(n) {
        function i(t, r, o) {
            var s;
            if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if (o = e({
                            path: "/"
                        }, i.defaults, o), "number" == typeof o.expires) {
                        var a = new Date;
                        a.setMilliseconds(a.getMilliseconds() + 864e5 * o.expires), o.expires = a
                    }
                    o.expires = o.expires ? o.expires.toUTCString() : "";
                    try {
                        s = JSON.stringify(r), /^[\{\[]/.test(s) && (r = s)
                    } catch (l) {}
                    r = n.write ? n.write(r, t) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)), t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), t = t.replace(/[\(\)]/g, escape);
                    var u = "";
                    for (var c in o) o[c] && (u += "; " + c, o[c] !== !0 && (u += "=" + o[c]));
                    return document.cookie = t + "=" + r + u
                }
                t || (s = {});
                for (var d = document.cookie ? document.cookie.split("; ") : [], p = /(%[0-9A-Z]{2})+/g, h = 0; h < d.length; h++) {
                    var f = d[h].split("="),
                        g = f.slice(1).join("=");
                    this.json || '"' !== g.charAt(0) || (g = g.slice(1, -1));
                    try {
                        var m = f[0].replace(p, decodeURIComponent);
                        if (g = n.read ? n.read(g, m) : n(g, m) || g.replace(p, decodeURIComponent), this.json) try {
                            g = JSON.parse(g)
                        } catch (l) {}
                        if (t === m) {
                            s = g;
                            break
                        }
                        t || (s[m] = g)
                    } catch (l) {}
                }
                return s
            }
        }
        return i.set = i, i.get = function(e) {
            return i.call(i, e)
        }, i.getJSON = function() {
            return i.apply({
                json: !0
            }, [].slice.call(arguments))
        }, i.defaults = {}, i.remove = function(t, n) {
            i(t, "", e(n, {
                expires: -1
            }))
        }, i.withConverter = t, i
    }
    return t(function() {})
}),
function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], function(t) {
        return e(t)
    }) : "object" == typeof module && "object" == typeof module.exports ? exports = e(require("jquery")) : e(jQuery)
}(function(e) {
    function t(e) {
        var t = 7.5625,
            n = 2.75;
        return e < 1 / n ? t * e * e : e < 2 / n ? t * (e -= 1.5 / n) * e + .75 : e < 2.5 / n ? t * (e -= 2.25 / n) * e + .9375 : t * (e -= 2.625 / n) * e + .984375
    }
    e.easing.jswing = e.easing.swing;
    var n = Math.pow,
        i = Math.sqrt,
        r = Math.sin,
        o = Math.cos,
        s = Math.PI,
        a = 1.70158,
        l = 1.525 * a,
        u = a + 1,
        c = 2 * s / 3,
        d = 2 * s / 4.5;
    e.extend(e.easing, {
        def: "easeOutQuad",
        swing: function(t) {
            return e.easing[e.easing.def](t)
        },
        easeInQuad: function(e) {
            return e * e
        },
        easeOutQuad: function(e) {
            return 1 - (1 - e) * (1 - e)
        },
        easeInOutQuad: function(e) {
            return e < .5 ? 2 * e * e : 1 - n(-2 * e + 2, 2) / 2
        },
        easeInCubic: function(e) {
            return e * e * e
        },
        easeOutCubic: function(e) {
            return 1 - n(1 - e, 3)
        },
        easeInOutCubic: function(e) {
            return e < .5 ? 4 * e * e * e : 1 - n(-2 * e + 2, 3) / 2
        },
        easeInQuart: function(e) {
            return e * e * e * e
        },
        easeOutQuart: function(e) {
            return 1 - n(1 - e, 4)
        },
        easeInOutQuart: function(e) {
            return e < .5 ? 8 * e * e * e * e : 1 - n(-2 * e + 2, 4) / 2
        },
        easeInQuint: function(e) {
            return e * e * e * e * e
        },
        easeOutQuint: function(e) {
            return 1 - n(1 - e, 5)
        },
        easeInOutQuint: function(e) {
            return e < .5 ? 16 * e * e * e * e * e : 1 - n(-2 * e + 2, 5) / 2
        },
        easeInSine: function(e) {
            return 1 - o(e * s / 2)
        },
        easeOutSine: function(e) {
            return r(e * s / 2)
        },
        easeInOutSine: function(e) {
            return -(o(s * e) - 1) / 2
        },
        easeInExpo: function(e) {
            return 0 === e ? 0 : n(2, 10 * e - 10)
        },
        easeOutExpo: function(e) {
            return 1 === e ? 1 : 1 - n(2, -10 * e)
        },
        easeInOutExpo: function(e) {
            return 0 === e ? 0 : 1 === e ? 1 : e < .5 ? n(2, 20 * e - 10) / 2 : (2 - n(2, -20 * e + 10)) / 2
        },
        easeInCirc: function(e) {
            return 1 - i(1 - n(e, 2))
        },
        easeOutCirc: function(e) {
            return i(1 - n(e - 1, 2))
        },
        easeInOutCirc: function(e) {
            return e < .5 ? (1 - i(1 - n(2 * e, 2))) / 2 : (i(1 - n(-2 * e + 2, 2)) + 1) / 2
        },
        easeInElastic: function(e) {
            return 0 === e ? 0 : 1 === e ? 1 : -n(2, 10 * e - 10) * r((10 * e - 10.75) * c)
        },
        easeOutElastic: function(e) {
            return 0 === e ? 0 : 1 === e ? 1 : n(2, -10 * e) * r((10 * e - .75) * c) + 1
        },
        easeInOutElastic: function(e) {
            return 0 === e ? 0 : 1 === e ? 1 : e < .5 ? -(n(2, 20 * e - 10) * r((20 * e - 11.125) * d)) / 2 : n(2, -20 * e + 10) * r((20 * e - 11.125) * d) / 2 + 1
        },
        easeInBack: function(e) {
            return u * e * e * e - a * e * e
        },
        easeOutBack: function(e) {
            return 1 + u * n(e - 1, 3) + a * n(e - 1, 2)
        },
        easeInOutBack: function(e) {
            return e < .5 ? n(2 * e, 2) * (2 * (l + 1) * e - l) / 2 : (n(2 * e - 2, 2) * ((l + 1) * (2 * e - 2) + l) + 2) / 2
        },
        easeInBounce: function(e) {
            return 1 - t(1 - e)
        },
        easeOutBounce: t,
        easeInOutBounce: function(e) {
            return e < .5 ? (1 - t(1 - 2 * e)) / 2 : (1 + t(2 * e - 1)) / 2
        }
    })
}),
function(e, t, n, i) {
    function r(t, n) {
        this.settings = null, this.options = e.extend({}, r.Defaults, n), this.$element = e(t), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {
                start: null,
                current: null
            },
            direction: null
        }, this._states = {
            current: {},
            tags: {
                initializing: ["busy"],
                animating: ["busy"],
                dragging: ["interacting"]
            }
        }, e.each(["onResize", "onThrottledResize"], e.proxy(function(t, n) {
            this._handlers[n] = e.proxy(this[n], this)
        }, this)), e.each(r.Plugins, e.proxy(function(e, t) {
            this._plugins[e.charAt(0).toLowerCase() + e.slice(1)] = new t(this)
        }, this)), e.each(r.Workers, e.proxy(function(t, n) {
            this._pipe.push({
                filter: n.filter,
                run: e.proxy(n.run, this)
            })
        }, this)), this.setup(), this.initialize()
    }
    r.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: t,
        fallbackEasing: "swing",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    }, r.Width = {
        Default: "default",
        Inner: "inner",
        Outer: "outer"
    }, r.Type = {
        Event: "event",
        State: "state"
    }, r.Plugins = {}, r.Workers = [{
        filter: ["width", "settings"],
        run: function() {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            e.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = this.settings.margin || "",
                n = !this.settings.autoWidth,
                i = this.settings.rtl,
                r = {
                    width: "auto",
                    "margin-left": i ? t : "",
                    "margin-right": i ? "" : t
                };
            !n && this.$stage.children().css(r), e.css = r
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                n = null,
                i = this._items.length,
                r = !this.settings.autoWidth,
                o = [];
            for (e.items = {
                    merge: !1,
                    width: t
                }; i--;) n = this._mergers[i], n = this.settings.mergeFit && Math.min(n, this.settings.items) || n, e.items.merge = n > 1 || e.items.merge, o[i] = r ? t * n : this._items[i].width();
            this._widths = o
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            var t = [],
                n = this._items,
                i = this.settings,
                r = Math.max(2 * i.items, 4),
                o = 2 * Math.ceil(n.length / 2),
                s = i.loop && n.length ? i.rewind ? r : Math.max(r, o) : 0,
                a = "",
                l = "";
            for (s /= 2; s--;) t.push(this.normalize(t.length / 2, !0)), a += n[t[t.length - 1]][0].outerHTML, t.push(this.normalize(n.length - 1 - (t.length - 1) / 2, !0)), l = n[t[t.length - 1]][0].outerHTML + l;
            this._clones = t, e(a).addClass("cloned").appendTo(this.$stage), e(l).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            for (var e = this.settings.rtl ? 1 : -1, t = this._clones.length + this._items.length, n = -1, i = 0, r = 0, o = []; ++n < t;) i = o[n - 1] || 0, r = this._widths[this.relative(n)] + this.settings.margin, o.push(i + r * e);
            this._coordinates = o
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            var e = this.settings.stagePadding,
                t = this._coordinates,
                n = {
                    width: Math.ceil(Math.abs(t[t.length - 1])) + 2 * e,
                    "padding-left": e || "",
                    "padding-right": e || ""
                };
            this.$stage.css(n)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = this._coordinates.length,
                n = !this.settings.autoWidth,
                i = this.$stage.children();
            if (n && e.items.merge)
                for (; t--;) e.css.width = this._widths[this.relative(t)], i.eq(t).css(e.css);
            else n && (e.css.width = e.items.width, i.css(e.css))
        }
    }, {
        filter: ["items"],
        run: function() {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            e.current = e.current ? this.$stage.children().index(e.current) : 0, e.current = Math.max(this.minimum(), Math.min(this.maximum(), e.current)), this.reset(e.current)
        }
    }, {
        filter: ["position"],
        run: function() {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"],
        run: function() {
            var e, t, n, i, r = this.settings.rtl ? 1 : -1,
                o = 2 * this.settings.stagePadding,
                s = this.coordinates(this.current()) + o,
                a = s + this.width() * r,
                l = [];
            for (n = 0, i = this._coordinates.length; n < i; n++) e = this._coordinates[n - 1] || 0, t = Math.abs(this._coordinates[n]) + o * r, (this.op(e, "<=", s) && this.op(e, ">", a) || this.op(t, "<", s) && this.op(t, ">", a)) && l.push(n);
            this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), this.settings.center && (this.$stage.children(".center").removeClass("center"), this.$stage.children().eq(this.current()).addClass("center"))
        }
    }], r.prototype.initialize = function() {
        if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) {
            var t, n, r;
            t = this.$element.find("img"), n = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : i, r = this.$element.children(n).width(), t.length && r <= 0 && this.preloadAutoWidthImages(t)
        }
        this.$element.addClass(this.options.loadingClass), this.$stage = e("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this.$element.is(":visible") ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
    }, r.prototype.setup = function() {
        var t = this.viewport(),
            n = this.options.responsive,
            i = -1,
            r = null;
        n ? (e.each(n, function(e) {
            e <= t && e > i && (i = Number(e))
        }), r = e.extend({}, this.options, n[i]), "function" == typeof r.stagePadding && (r.stagePadding = r.stagePadding()), delete r.responsive, r.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + i))) : r = e.extend({}, this.options), this.trigger("change", {
            property: {
                name: "settings",
                value: r
            }
        }), this._breakpoint = i, this.settings = r, this.invalidate("settings"), this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }, r.prototype.optionsLogic = function() {
        this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
    }, r.prototype.prepare = function(t) {
        var n = this.trigger("prepare", {
            content: t
        });
        return n.data || (n.data = e("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(t)), this.trigger("prepared", {
            content: n.data
        }), n.data
    }, r.prototype.update = function() {
        for (var t = 0, n = this._pipe.length, i = e.proxy(function(e) {
                return this[e]
            }, this._invalidated), r = {}; t < n;)(this._invalidated.all || e.grep(this._pipe[t].filter, i).length > 0) && this._pipe[t].run(r), t++;
        this._invalidated = {}, !this.is("valid") && this.enter("valid")
    }, r.prototype.width = function(e) {
        switch (e = e || r.Width.Default) {
            case r.Width.Inner:
            case r.Width.Outer:
                return this._width;
            default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }, r.prototype.refresh = function() {
        this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
    }, r.prototype.onThrottledResize = function() {
        t.clearTimeout(this.resizeTimer), this.resizeTimer = t.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }, r.prototype.onResize = function() {
        return !!this._items.length && (this._width !== this.$element.width() && (!!this.$element.is(":visible") && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))))
    }, r.prototype.registerEventHandlers = function() {
        e.support.transition && this.$stage.on(e.support.transition.end + ".owl.core", e.proxy(this.onTransitionEnd, this)), this.settings.responsive !== !1 && this.on(t, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", e.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
            return !1
        })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", e.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", e.proxy(this.onDragEnd, this)))
    }, r.prototype.onDragStart = function(t) {
        var i = null;
        3 !== t.which && (e.support.transform ? (i = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), i = {
            x: i[16 === i.length ? 12 : 4],
            y: i[16 === i.length ? 13 : 5]
        }) : (i = this.$stage.position(), i = {
            x: this.settings.rtl ? i.left + this.$stage.width() - this.width() + this.settings.margin : i.left,
            y: i.top
        }), this.is("animating") && (e.support.transform ? this.animate(i.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === t.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = e(t.target), this._drag.stage.start = i, this._drag.stage.current = i, this._drag.pointer = this.pointer(t), e(n).on("mouseup.owl.core touchend.owl.core", e.proxy(this.onDragEnd, this)), e(n).one("mousemove.owl.core touchmove.owl.core", e.proxy(function(t) {
            var i = this.difference(this._drag.pointer, this.pointer(t));
            e(n).on("mousemove.owl.core touchmove.owl.core", e.proxy(this.onDragMove, this)), Math.abs(i.x) < Math.abs(i.y) && this.is("valid") || (t.preventDefault(), this.enter("dragging"), this.trigger("drag"))
        }, this)))
    }, r.prototype.onDragMove = function(e) {
        var t = null,
            n = null,
            i = null,
            r = this.difference(this._drag.pointer, this.pointer(e)),
            o = this.difference(this._drag.stage.start, r);
        this.is("dragging") && (e.preventDefault(), this.settings.loop ? (t = this.coordinates(this.minimum()), n = this.coordinates(this.maximum() + 1) - t, o.x = ((o.x - t) % n + n) % n + t) : (t = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), n = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), i = this.settings.pullDrag ? -1 * r.x / 5 : 0, o.x = Math.max(Math.min(o.x, t + i), n + i)), this._drag.stage.current = o, this.animate(o.x))
    }, r.prototype.onDragEnd = function(t) {
        var i = this.difference(this._drag.pointer, this.pointer(t)),
            r = this._drag.stage.current,
            o = i.x > 0 ^ this.settings.rtl ? "left" : "right";
        e(n).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== i.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(r.x, 0 !== i.x ? o : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = o), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
    }, r.prototype.closest = function(t, n) {
        var i = -1,
            r = 30,
            o = this.width(),
            s = this.coordinates();
        return this.settings.freeDrag || e.each(s, e.proxy(function(e, a) {
            return "left" === n && t > a - r && t < a + r ? i = e : "right" === n && t > a - o - r && t < a - o + r ? i = e + 1 : this.op(t, "<", a) && this.op(t, ">", s[e + 1] || a - o) && (i = "left" === n ? e + 1 : e), i === -1
        }, this)), this.settings.loop || (this.op(t, ">", s[this.minimum()]) ? i = t = this.minimum() : this.op(t, "<", s[this.maximum()]) && (i = t = this.maximum())), i
    }, r.prototype.animate = function(t) {
        var n = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(), n && (this.enter("animating"), this.trigger("translate")), e.support.transform3d && e.support.transition ? this.$stage.css({
            transform: "translate3d(" + t + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s"
        }) : n ? this.$stage.animate({
            left: t + "px"
        }, this.speed(), this.settings.fallbackEasing, e.proxy(this.onTransitionEnd, this)) : this.$stage.css({
            left: t + "px"
        })
    }, r.prototype.is = function(e) {
        return this._states.current[e] && this._states.current[e] > 0
    }, r.prototype.current = function(e) {
        if (e === i) return this._current;
        if (0 === this._items.length) return i;
        if (e = this.normalize(e), this._current !== e) {
            var t = this.trigger("change", {
                property: {
                    name: "position",
                    value: e
                }
            });
            t.data !== i && (e = this.normalize(t.data)), this._current = e, this.invalidate("position"), this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            })
        }
        return this._current
    }, r.prototype.invalidate = function(t) {
        return "string" === e.type(t) && (this._invalidated[t] = !0, this.is("valid") && this.leave("valid")), e.map(this._invalidated, function(e, t) {
            return t
        })
    }, r.prototype.reset = function(e) {
        e = this.normalize(e), e !== i && (this._speed = 0, this._current = e, this.suppress(["translate", "translated"]), this.animate(this.coordinates(e)), this.release(["translate", "translated"]))
    }, r.prototype.normalize = function(e, t) {
        var n = this._items.length,
            r = t ? 0 : this._clones.length;
        return !this.isNumeric(e) || n < 1 ? e = i : (e < 0 || e >= n + r) && (e = ((e - r / 2) % n + n) % n + r / 2), e
    }, r.prototype.relative = function(e) {
        return e -= this._clones.length / 2, this.normalize(e, !0)
    }, r.prototype.maximum = function(e) {
        var t, n, i, r = this.settings,
            o = this._coordinates.length;
        if (r.loop) o = this._clones.length / 2 + this._items.length - 1;
        else if (r.autoWidth || r.merge) {
            for (t = this._items.length, n = this._items[--t].width(), i = this.$element.width(); t-- && (n += this._items[t].width() + this.settings.margin, !(n > i)););
            o = t + 1
        } else o = r.center ? this._items.length - 1 : this._items.length - r.items;
        return e && (o -= this._clones.length / 2), Math.max(o, 0)
    }, r.prototype.minimum = function(e) {
        return e ? 0 : this._clones.length / 2
    }, r.prototype.items = function(e) {
        return e === i ? this._items.slice() : (e = this.normalize(e, !0), this._items[e])
    }, r.prototype.mergers = function(e) {
        return e === i ? this._mergers.slice() : (e = this.normalize(e, !0), this._mergers[e])
    }, r.prototype.clones = function(t) {
        var n = this._clones.length / 2,
            r = n + this._items.length,
            o = function(e) {
                return e % 2 === 0 ? r + e / 2 : n - (e + 1) / 2
            };
        return t === i ? e.map(this._clones, function(e, t) {
            return o(t)
        }) : e.map(this._clones, function(e, n) {
            return e === t ? o(n) : null
        })
    }, r.prototype.speed = function(e) {
        return e !== i && (this._speed = e), this._speed
    }, r.prototype.coordinates = function(t) {
        var n, r = 1,
            o = t - 1;
        return t === i ? e.map(this._coordinates, e.proxy(function(e, t) {
            return this.coordinates(t)
        }, this)) : (this.settings.center ? (this.settings.rtl && (r = -1, o = t + 1), n = this._coordinates[t], n += (this.width() - n + (this._coordinates[o] || 0)) / 2 * r) : n = this._coordinates[o] || 0, n = Math.ceil(n))
    }, r.prototype.duration = function(e, t, n) {
        return 0 === n ? 0 : Math.min(Math.max(Math.abs(t - e), 1), 6) * Math.abs(n || this.settings.smartSpeed)
    }, r.prototype.to = function(e, t) {
        var n = this.current(),
            i = null,
            r = e - this.relative(n),
            o = (r > 0) - (r < 0),
            s = this._items.length,
            a = this.minimum(),
            l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(r) > s / 2 && (r += o * -1 * s), e = n + r, i = ((e - a) % s + s) % s + a, i !== e && i - r <= l && i - r > 0 && (n = i - r, e = i, this.reset(n))) : this.settings.rewind ? (l += 1, e = (e % l + l) % l) : e = Math.max(a, Math.min(l, e)), this.speed(this.duration(n, e, t)), this.current(e), this.$element.is(":visible") && this.update()
    }, r.prototype.next = function(e) {
        e = e || !1, this.to(this.relative(this.current()) + 1, e)
    }, r.prototype.prev = function(e) {
        e = e || !1, this.to(this.relative(this.current()) - 1, e)
    }, r.prototype.onTransitionEnd = function(e) {
        return (e === i || (e.stopPropagation(), (e.target || e.srcElement || e.originalTarget) === this.$stage.get(0))) && (this.leave("animating"), void this.trigger("translated"))
    }, r.prototype.viewport = function() {
        var i;
        if (this.options.responsiveBaseElement !== t) i = e(this.options.responsiveBaseElement).width();
        else if (t.innerWidth) i = t.innerWidth;
        else {
            if (!n.documentElement || !n.documentElement.clientWidth) throw "Can not detect viewport width.";
            i = n.documentElement.clientWidth
        }
        return i
    }, r.prototype.replace = function(t) {
        this.$stage.empty(), this._items = [], t && (t = t instanceof jQuery ? t : e(t)), this.settings.nestedItemSelector && (t = t.find("." + this.settings.nestedItemSelector)), t.filter(function() {
            return 1 === this.nodeType
        }).each(e.proxy(function(e, t) {
            t = this.prepare(t), this.$stage.append(t), this._items.push(t), this._mergers.push(1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
    }, r.prototype.add = function(t, n) {
        var r = this.relative(this._current);
        n = n === i ? this._items.length : this.normalize(n, !0), t = t instanceof jQuery ? t : e(t), this.trigger("add", {
            content: t,
            position: n
        }), t = this.prepare(t), 0 === this._items.length || n === this._items.length ? (0 === this._items.length && this.$stage.append(t), 0 !== this._items.length && this._items[n - 1].after(t), this._items.push(t), this._mergers.push(1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[n].before(t), this._items.splice(n, 0, t), this._mergers.splice(n, 0, 1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[r] && this.reset(this._items[r].index()), this.invalidate("items"), this.trigger("added", {
            content: t,
            position: n
        })
    }, r.prototype.remove = function(e) {
        e = this.normalize(e, !0), e !== i && (this.trigger("remove", {
            content: this._items[e],
            position: e
        }), this._items[e].remove(), this._items.splice(e, 1), this._mergers.splice(e, 1), this.invalidate("items"), this.trigger("removed", {
            content: null,
            position: e
        }))
    }, r.prototype.preloadAutoWidthImages = function(t) {
        t.each(e.proxy(function(t, n) {
            this.enter("pre-loading"), n = e(n), e(new Image).one("load", e.proxy(function(e) {
                n.attr("src", e.target.src), n.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh()
            }, this)).attr("src", n.attr("src") || n.attr("data-src") || n.attr("data-src-retina"))
        }, this))
    }, r.prototype.destroy = function() {
        this.$element.off(".owl.core"), this.$stage.off(".owl.core"), e(n).off(".owl.core"), this.settings.responsive !== !1 && (t.clearTimeout(this.resizeTimer), this.off(t, "resize", this._handlers.onThrottledResize));
        for (var i in this._plugins) this._plugins[i].destroy();
        this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
    }, r.prototype.op = function(e, t, n) {
        var i = this.settings.rtl;
        switch (t) {
            case "<":
                return i ? e > n : e < n;
            case ">":
                return i ? e < n : e > n;
            case ">=":
                return i ? e <= n : e >= n;
            case "<=":
                return i ? e >= n : e <= n
        }
    }, r.prototype.on = function(e, t, n, i) {
        e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent && e.attachEvent("on" + t, n)
    }, r.prototype.off = function(e, t, n, i) {
        e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent && e.detachEvent("on" + t, n)
    }, r.prototype.trigger = function(t, n, i, o, s) {
        var a = {
                item: {
                    count: this._items.length,
                    index: this.current()
                }
            },
            l = e.camelCase(e.grep(["on", t, i], function(e) {
                return e
            }).join("-").toLowerCase()),
            u = e.Event([t, "owl", i || "carousel"].join(".").toLowerCase(), e.extend({
                relatedTarget: this
            }, a, n));
        return this._supress[t] || (e.each(this._plugins, function(e, t) {
            t.onTrigger && t.onTrigger(u)
        }), this.register({
            type: r.Type.Event,
            name: t
        }), this.$element.trigger(u), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, u)), u
    }, r.prototype.enter = function(t) {
        e.each([t].concat(this._states.tags[t] || []), e.proxy(function(e, t) {
            this._states.current[t] === i && (this._states.current[t] = 0), this._states.current[t]++
        }, this))
    }, r.prototype.leave = function(t) {
        e.each([t].concat(this._states.tags[t] || []), e.proxy(function(e, t) {
            this._states.current[t]--
        }, this))
    }, r.prototype.register = function(t) {
        if (t.type === r.Type.Event) {
            if (e.event.special[t.name] || (e.event.special[t.name] = {}), !e.event.special[t.name].owl) {
                var n = e.event.special[t.name]._default;
                e.event.special[t.name]._default = function(e) {
                    return !n || !n.apply || e.namespace && e.namespace.indexOf("owl") !== -1 ? e.namespace && e.namespace.indexOf("owl") > -1 : n.apply(this, arguments)
                }, e.event.special[t.name].owl = !0
            }
        } else t.type === r.Type.State && (this._states.tags[t.name] ? this._states.tags[t.name] = this._states.tags[t.name].concat(t.tags) : this._states.tags[t.name] = t.tags, this._states.tags[t.name] = e.grep(this._states.tags[t.name], e.proxy(function(n, i) {
            return e.inArray(n, this._states.tags[t.name]) === i
        }, this)))
    }, r.prototype.suppress = function(t) {
        e.each(t, e.proxy(function(e, t) {
            this._supress[t] = !0
        }, this))
    }, r.prototype.release = function(t) {
        e.each(t, e.proxy(function(e, t) {
            delete this._supress[t]
        }, this))
    }, r.prototype.pointer = function(e) {
        var n = {
            x: null,
            y: null
        };
        return e = e.originalEvent || e || t.event, e = e.touches && e.touches.length ? e.touches[0] : e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e, e.pageX ? (n.x = e.pageX, n.y = e.pageY) : (n.x = e.clientX, n.y = e.clientY), n
    }, r.prototype.isNumeric = function(e) {
        return !isNaN(parseFloat(e))
    }, r.prototype.difference = function(e, t) {
        return {
            x: e.x - t.x,
            y: e.y - t.y
        }
    }, e.fn.owlCarousel = function(t) {
        var n = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var i = e(this),
                o = i.data("owl.carousel");
            o || (o = new r(this, "object" == typeof t && t), i.data("owl.carousel", o), e.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(t, n) {
                o.register({
                    type: r.Type.Event,
                    name: n
                }), o.$element.on(n + ".owl.carousel.core", e.proxy(function(e) {
                    e.namespace && e.relatedTarget !== this && (this.suppress([n]), o[n].apply(this, [].slice.call(arguments, 1)), this.release([n]))
                }, o))
            })), "string" == typeof t && "_" !== t.charAt(0) && o[t].apply(o, n)
        })
    }, e.fn.owlCarousel.Constructor = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this._core = t, this._interval = null, this._visible = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        autoRefresh: !0,
        autoRefreshInterval: 500
    }, r.prototype.watch = function() {
        this._interval || (this._visible = this._core.$element.is(":visible"), this._interval = t.setInterval(e.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }, r.prototype.refresh = function() {
        this._core.$element.is(":visible") !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
    }, r.prototype.destroy = function() {
        var e, n;
        t.clearInterval(this._interval);
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.AutoRefresh = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this._core = t, this._loaded = [], this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": e.proxy(function(t) {
                if (t.namespace && this._core.settings && this._core.settings.lazyLoad && (t.property && "position" == t.property.name || "initialized" == t.type))
                    for (var n = this._core.settings, r = n.center && Math.ceil(n.items / 2) || n.items, o = n.center && r * -1 || 0, s = (t.property && t.property.value !== i ? t.property.value : this._core.current()) + o, a = this._core.clones().length, l = e.proxy(function(e, t) {
                            this.load(t)
                        }, this); o++ < r;) this.load(a / 2 + this._core.relative(s)), a && e.each(this._core.clones(this._core.relative(s)), l), s++
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        lazyLoad: !1
    }, r.prototype.load = function(n) {
        var i = this._core.$stage.children().eq(n),
            r = i && i.find(".owl-lazy");
        !r || e.inArray(i.get(0), this._loaded) > -1 || (r.each(e.proxy(function(n, i) {
            var r, o = e(i),
                s = t.devicePixelRatio > 1 && o.attr("data-src-retina") || o.attr("data-src"),
                a = o.attr("data-sizes"),
                l = o.attr("data-srcset");
            this._core.trigger("load", {
                element: o,
                url: s
            }, "lazy"), o.is("img") ? (o.one("load.owl.lazy", e.proxy(function() {
                o.css("opacity", 1), this._core.trigger("loaded", {
                    element: o,
                    url: s
                }, "lazy")
            }, this)).attr("src", s), o.attr("srcset", l), o.attr("sizes", a)) : (r = new Image, r.onload = e.proxy(function() {
                o.css({
                    "background-image": "url(" + s + ")",
                    opacity: "1"
                }), this._core.trigger("loaded", {
                    element: o,
                    url: s
                }, "lazy")
            }, this), r.src = s)
        }, this)), this._loaded.push(i.get(0)))
    }, r.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers) this._core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.Lazy = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this._core = t, this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && this.update()
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && "position" == e.property.name && this.update()
            }, this),
            "loaded.owl.lazy": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && e.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    r.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    }, r.prototype.update = function() {
        var t = this._core._current,
            n = t + this._core.settings.items,
            i = this._core.$stage.children().toArray().slice(t, n),
            r = [],
            o = 0;
        e.each(i, function(t, n) {
            r.push(e(n).height())
        }), o = Math.max.apply(null, r), this._core.$stage.parent().height(o).addClass(this._core.settings.autoHeightClass)
    }, r.prototype.destroy = function() {
        var e, t;
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.AutoHeight = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this._core = t, this._videos = {}, this._playing = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.register({
                    type: "state",
                    name: "playing",
                    tags: ["interacting"]
                })
            }, this),
            "resize.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.video && this.isInFullScreen() && e.preventDefault()
            }, this),
            "refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" === e.property.name && this._playing && this.stop()
            }, this),
            "prepared.owl.carousel": e.proxy(function(t) {
                if (t.namespace) {
                    var n = e(t.content).find(".owl-video");
                    n.length && (n.css("display", "none"), this.fetch(n, e(t.content)))
                }
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", e.proxy(function(e) {
            this.play(e)
        }, this))
    };
    r.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    }, r.prototype.fetch = function(e, t) {
        var n = function() {
                return e.attr("data-vimeo-id") ? "vimeo" : e.attr("data-vzaar-id") ? "vzaar" : "youtube"
            }(),
            i = e.attr("data-vimeo-id") || e.attr("data-youtube-id") || e.attr("data-vzaar-id"),
            r = e.attr("data-width") || this._core.settings.videoWidth,
            o = e.attr("data-height") || this._core.settings.videoHeight,
            s = e.attr("href");
        if (!s) throw new Error("Missing video URL.");
        if (i = s.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), i[3].indexOf("youtu") > -1) n = "youtube";
        else if (i[3].indexOf("vimeo") > -1) n = "vimeo";
        else {
            if (!(i[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
            n = "vzaar"
        }
        i = i[6], this._videos[s] = {
            type: n,
            id: i,
            width: r,
            height: o
        }, t.attr("data-video", s), this.thumbnail(e, this._videos[s])
    }, r.prototype.thumbnail = function(t, n) {
        var i, r, o, s = n.width && n.height ? 'style="width:' + n.width + "px;height:" + n.height + 'px;"' : "",
            a = t.find("img"),
            l = "src",
            u = "",
            c = this._core.settings,
            d = function(e) {
                r = '<div class="owl-video-play-icon"></div>', i = c.lazyLoad ? '<div class="owl-video-tn ' + u + '" ' + l + '="' + e + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + e + ')"></div>', t.after(i), t.after(r)
            };
        return t.wrap('<div class="owl-video-wrapper"' + s + "></div>"), this._core.settings.lazyLoad && (l = "data-src", u = "owl-lazy"), a.length ? (d(a.attr(l)), a.remove(), !1) : void("youtube" === n.type ? (o = "//img.youtube.com/vi/" + n.id + "/hqdefault.jpg", d(o)) : "vimeo" === n.type ? e.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e[0].thumbnail_large, d(o)
            }
        }) : "vzaar" === n.type && e.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e.framegrab_url, d(o)
            }
        }))
    }, r.prototype.stop = function() {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
    }, r.prototype.play = function(t) {
        var n, i = e(t.target),
            r = i.closest("." + this._core.settings.itemClass),
            o = this._videos[r.attr("data-video")],
            s = o.width || "100%",
            a = o.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), r = this._core.items(this._core.relative(r.index())), this._core.reset(r.index()), "youtube" === o.type ? n = '<iframe width="' + s + '" height="' + a + '" src="//www.youtube.com/embed/' + o.id + "?autoplay=1&rel=0&v=" + o.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === o.type ? n = '<iframe src="//player.vimeo.com/video/' + o.id + '?autoplay=1" width="' + s + '" height="' + a + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "vzaar" === o.type && (n = '<iframe frameborder="0"height="' + a + '"width="' + s + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + o.id + '/player?autoplay=true"></iframe>'), e('<div class="owl-video-frame">' + n + "</div>").insertAfter(r.find(".owl-video")), this._playing = r.addClass("owl-video-playing"))
    }, r.prototype.isInFullScreen = function() {
        var t = n.fullscreenElement || n.mozFullScreenElement || n.webkitFullscreenElement;
        return t && e(t).parent().hasClass("owl-video-frame")
    }, r.prototype.destroy = function() {
        var e, t;
        this._core.$element.off("click.owl.video");
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.Video = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this.core = t, this.core.options = e.extend({}, r.Defaults, this.core.options), this.swapping = !0, this.previous = i, this.next = i, this.handlers = {
            "change.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" == e.property.name && (this.previous = this.core.current(), this.next = e.property.value)
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": e.proxy(function(e) {
                e.namespace && (this.swapping = "translated" == e.type)
            }, this),
            "translate.owl.carousel": e.proxy(function(e) {
                e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        }, this.core.$element.on(this.handlers)
    };
    r.Defaults = {
        animateOut: !1,
        animateIn: !1
    }, r.prototype.swap = function() {
        if (1 === this.core.settings.items && e.support.animation && e.support.transition) {
            this.core.speed(0);
            var t, n = e.proxy(this.clear, this),
                i = this.core.$stage.children().eq(this.previous),
                r = this.core.$stage.children().eq(this.next),
                o = this.core.settings.animateIn,
                s = this.core.settings.animateOut;
            this.core.current() !== this.previous && (s && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), i.one(e.support.animation.end, n).css({
                left: t + "px"
            }).addClass("animated owl-animated-out").addClass(s)), o && r.one(e.support.animation.end, n).addClass("animated owl-animated-in").addClass(o))
        }
    }, r.prototype.clear = function(t) {
        e(t.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
    }, r.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers) this.core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.Animate = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    var r = function(t) {
        this._core = t, this._timeout = null, this._paused = !1, this._handlers = {
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "settings" === e.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : e.namespace && "position" === e.property.name && this._core.settings.autoplay && this._setAutoPlayInterval()
            }, this),
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoplay && this.play()
            }, this),
            "play.owl.autoplay": e.proxy(function(e, t, n) {
                e.namespace && this.play(t, n)
            }, this),
            "stop.owl.autoplay": e.proxy(function(e) {
                e.namespace && this.stop()
            }, this),
            "mouseover.owl.autoplay": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "mouseleave.owl.autoplay": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this),
            "touchstart.owl.core": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "touchend.owl.core": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        }, this._core.$element.on(this._handlers), this._core.options = e.extend({}, r.Defaults, this._core.options)
    };
    r.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, r.prototype.play = function(e, t) {
        this._paused = !1, this._core.is("rotating") || (this._core.enter("rotating"), this._setAutoPlayInterval())
    }, r.prototype._getNextTimeout = function(i, r) {
        return this._timeout && t.clearTimeout(this._timeout), t.setTimeout(e.proxy(function() {
            this._paused || this._core.is("busy") || this._core.is("interacting") || n.hidden || this._core.next(r || this._core.settings.autoplaySpeed)
        }, this), i || this._core.settings.autoplayTimeout)
    }, r.prototype._setAutoPlayInterval = function() {
        this._timeout = this._getNextTimeout()
    }, r.prototype.stop = function() {
        this._core.is("rotating") && (t.clearTimeout(this._timeout), this._core.leave("rotating"))
    }, r.prototype.pause = function() {
        this._core.is("rotating") && (this._paused = !0)
    }, r.prototype.destroy = function() {
        var e, t;
        this.stop();
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.autoplay = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    "use strict";
    var r = function(t) {
        this._core = t, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        }, this._handlers = {
            "prepared.owl.carousel": e.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + e(t.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
            }, this),
            "added.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 0, this._templates.pop())
            }, this),
            "remove.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 1)
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" == e.property.name && this.draw()
            }, this),
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
            }, this),
            "refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this.$element.on(this._handlers)
    };
    r.Defaults = {
        nav: !1,
        navText: ["prev", "next"],
        navSpeed: !1,
        navElement: "div",
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    }, r.prototype.initialize = function() {
        var t, n = this._core.settings;
        this._controls.$relative = (n.navContainer ? e(n.navContainer) : e("<div>").addClass(n.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = e("<" + n.navElement + ">").addClass(n.navClass[0]).html(n.navText[0]).prependTo(this._controls.$relative).on("click", e.proxy(function(e) {
            this.prev(n.navSpeed)
        }, this)), this._controls.$next = e("<" + n.navElement + ">").addClass(n.navClass[1]).html(n.navText[1]).appendTo(this._controls.$relative).on("click", e.proxy(function(e) {
            this.next(n.navSpeed)
        }, this)), n.dotsData || (this._templates = [e("<div>").addClass(n.dotClass).append(e("<span>")).prop("outerHTML")]), this._controls.$absolute = (n.dotsContainer ? e(n.dotsContainer) : e("<div>").addClass(n.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "div", e.proxy(function(t) {
            var i = e(t.target).parent().is(this._controls.$absolute) ? e(t.target).index() : e(t.target).parent().index();
            t.preventDefault(), this.to(i, n.dotsSpeed)
        }, this));
        for (t in this._overrides) this._core[t] = e.proxy(this[t], this)
    }, r.prototype.destroy = function() {
        var e, t, n, i;
        for (e in this._handlers) this.$element.off(e, this._handlers[e]);
        for (t in this._controls) this._controls[t].remove();
        for (i in this.overides) this._core[i] = this._overrides[i];
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
    }, r.prototype.update = function() {
        var e, t, n, i = this._core.clones().length / 2,
            r = i + this._core.items().length,
            o = this._core.maximum(!0),
            s = this._core.settings,
            a = s.center || s.autoWidth || s.dotsData ? 1 : s.dotsEach || s.items;
        if ("page" !== s.slideBy && (s.slideBy = Math.min(s.slideBy, s.items)), s.dots || "page" == s.slideBy)
            for (this._pages = [], e = i, t = 0, n = 0; e < r; e++) {
                if (t >= a || 0 === t) {
                    if (this._pages.push({
                            start: Math.min(o, e - i),
                            end: e - i + a - 1
                        }), Math.min(o, e - i) === o) break;
                    t = 0, ++n
                }
                t += this._core.mergers(this._core.relative(e))
            }
    }, r.prototype.draw = function() {
        var t, n = this._core.settings,
            i = this._core.items().length <= n.items,
            r = this._core.relative(this._core.current()),
            o = n.loop || n.rewind;
        this._controls.$relative.toggleClass("disabled", !n.nav || i), n.nav && (this._controls.$previous.toggleClass("disabled", !o && r <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !o && r >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !n.dots || i), n.dots && (t = this._pages.length - this._controls.$absolute.children().length, n.dotsData && 0 !== t ? this._controls.$absolute.html(this._templates.join("")) : t > 0 ? this._controls.$absolute.append(new Array(t + 1).join(this._templates[0])) : t < 0 && this._controls.$absolute.children().slice(t).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(e.inArray(this.current(), this._pages)).addClass("active"))
    }, r.prototype.onTrigger = function(t) {
        var n = this._core.settings;
        t.page = {
            index: e.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: n && (n.center || n.autoWidth || n.dotsData ? 1 : n.dotsEach || n.items)
        }
    }, r.prototype.current = function() {
        var t = this._core.relative(this._core.current());
        return e.grep(this._pages, e.proxy(function(e, n) {
            return e.start <= t && e.end >= t
        }, this)).pop()
    }, r.prototype.getPosition = function(t) {
        var n, i, r = this._core.settings;
        return "page" == r.slideBy ? (n = e.inArray(this.current(), this._pages), i = this._pages.length, t ? ++n : --n, n = this._pages[(n % i + i) % i].start) : (n = this._core.relative(this._core.current()), i = this._core.items().length, t ? n += r.slideBy : n -= r.slideBy), n
    }, r.prototype.next = function(t) {
        e.proxy(this._overrides.to, this._core)(this.getPosition(!0), t)
    }, r.prototype.prev = function(t) {
        e.proxy(this._overrides.to, this._core)(this.getPosition(!1), t)
    }, r.prototype.to = function(t, n, i) {
        var r;
        !i && this._pages.length ? (r = this._pages.length, e.proxy(this._overrides.to, this._core)(this._pages[(t % r + r) % r].start, n)) : e.proxy(this._overrides.to, this._core)(t, n)
    }, e.fn.owlCarousel.Constructor.Plugins.Navigation = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    "use strict";
    var r = function(n) {
        this._core = n, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(n) {
                n.namespace && "URLHash" === this._core.settings.startPosition && e(t).trigger("hashchange.owl.navigation")
            }, this),
            "prepared.owl.carousel": e.proxy(function(t) {
                if (t.namespace) {
                    var n = e(t.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                    if (!n) return;
                    this._hashes[n] = t.content
                }
            }, this),
            "changed.owl.carousel": e.proxy(function(n) {
                if (n.namespace && "position" === n.property.name) {
                    var i = this._core.items(this._core.relative(this._core.current())),
                        r = e.map(this._hashes, function(e, t) {
                            return e === i ? t : null
                        }).join();
                    if (!r || t.location.hash.slice(1) === r) return;
                    t.location.hash = r
                }
            }, this)
        }, this._core.options = e.extend({}, r.Defaults, this._core.options), this.$element.on(this._handlers), e(t).on("hashchange.owl.navigation", e.proxy(function(e) {
            var n = t.location.hash.substring(1),
                r = this._core.$stage.children(),
                o = this._hashes[n] && r.index(this._hashes[n]);
            o !== i && o !== this._core.current() && this._core.to(this._core.relative(o), !1, !0)
        }, this))
    };
    r.Defaults = {
        URLhashListener: !1
    }, r.prototype.destroy = function() {
        var n, i;
        e(t).off("hashchange.owl.navigation");
        for (n in this._handlers) this._core.$element.off(n, this._handlers[n]);
        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
    }, e.fn.owlCarousel.Constructor.Plugins.Hash = r
}(window.Zepto || window.jQuery, window, document),
function(e, t, n, i) {
    function r(t, n) {
        var r = !1,
            o = t.charAt(0).toUpperCase() + t.slice(1);
        return e.each((t + " " + a.join(o + " ") + o).split(" "), function(e, t) {
            if (s[t] !== i) return r = !n || t, !1
        }), r
    }

    function o(e) {
        return r(e, !0)
    }
    var s = e("<support>").get(0).style,
        a = "Webkit Moz O ms".split(" "),
        l = {
            transition: {
                end: {
                    WebkitTransition: "webkitTransitionEnd",
                    MozTransition: "transitionend",
                    OTransition: "oTransitionEnd",
                    transition: "transitionend"
                }
            },
            animation: {
                end: {
                    WebkitAnimation: "webkitAnimationEnd",
                    MozAnimation: "animationend",
                    OAnimation: "oAnimationEnd",
                    animation: "animationend"
                }
            }
        },
        u = {
            csstransforms: function() {
                return !!r("transform")
            },
            csstransforms3d: function() {
                return !!r("perspective")
            },
            csstransitions: function() {
                return !!r("transition")
            },
            cssanimations: function() {
                return !!r("animation")
            }
        };
    u.csstransitions() && (e.support.transition = new String(o("transition")), e.support.transition.end = l.transition.end[e.support.transition]), u.cssanimations() && (e.support.animation = new String(o("animation")), e.support.animation.end = l.animation.end[e.support.animation]), u.csstransforms() && (e.support.transform = new String(o("transform")), e.support.transform3d = u.csstransforms3d())
}(window.Zepto || window.jQuery, window, document),
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
function(e) {
    var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
    };
    e.zoom = function(t, n, i, r) {
        var o, s, a, l, u, c, d, p = e(t),
            h = p.css("position"),
            f = e(n);
        return t.style.position = /(absolute|fixed)/.test(h) ? h : "relative", t.style.overflow = "hidden", i.style.width = i.style.height = "", e(i).addClass("zoomImg").css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: i.width * r,
            height: i.height * r,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
        }).appendTo(t), {
            init: function() {
                s = p.outerWidth(), o = p.outerHeight(), n === t ? (l = s, a = o) : (l = f.outerWidth(), a = f.outerHeight()), u = (i.width - s) / l, c = (i.height - o) / a, d = f.offset()
            },
            move: function(e) {
                var t = e.pageX - d.left,
                    n = e.pageY - d.top;
                n = Math.max(Math.min(n, a), 0), t = Math.max(Math.min(t, l), 0), i.style.left = t * -u + "px", i.style.top = n * -c + "px"
            }
        }
    }, e.fn.zoom = function(n) {
        return this.each(function() {
            var i = e.extend({}, t, n || {}),
                r = i.target && e(i.target)[0] || this,
                o = this,
                s = e(o),
                a = document.createElement("img"),
                l = e(a),
                u = "mousemove.zoom",
                c = !1,
                d = !1;
            if (!i.url) {
                var p = o.querySelector("img");
                if (p && (i.url = p.getAttribute("data-src") || p.currentSrc || p.src), !i.url) return
            }
            s.one("zoom.destroy", function(e, t) {
                s.off(".zoom"), r.style.position = e, r.style.overflow = t, a.onload = null, l.remove()
            }.bind(this, r.style.position, r.style.overflow)), a.onload = function() {
                function t(t) {
                    p.init(), p.move(t), l.stop().fadeTo(e.support.opacity ? i.duration : 0, 1, !!e.isFunction(i.onZoomIn) && i.onZoomIn.call(a))
                }

                function n() {
                    l.stop().fadeTo(i.duration, 0, !!e.isFunction(i.onZoomOut) && i.onZoomOut.call(a))
                }
                var p = e.zoom(r, o, a, i.magnify);
                "grab" === i.on ? s.on("mousedown.zoom", function(i) {
                    1 === i.which && (e(document).one("mouseup.zoom", function() {
                        n(), e(document).off(u, p.move)
                    }), t(i), e(document).on(u, p.move), i.preventDefault())
                }) : "click" === i.on ? s.on("click.zoom", function(i) {
                    return c ? void 0 : (c = !0, t(i), e(document).on(u, p.move), e(document).one("click.zoom", function() {
                        n(), c = !1, e(document).off(u, p.move)
                    }), !1)
                }) : "toggle" === i.on ? s.on("click.zoom", function(e) {
                    c ? n() : t(e), c = !c
                }) : "mouseover" === i.on && (p.init(), s.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(u, p.move)), i.touch && s.on("touchstart.zoom", function(e) {
                    e.preventDefault(), d ? (d = !1, n()) : (d = !0, t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                }).on("touchmove.zoom", function(e) {
                    e.preventDefault(), p.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                }).on("touchend.zoom", function(e) {
                    e.preventDefault(), d && (d = !1, n())
                }), e.isFunction(i.callback) && i.callback.call(a)
            }, a.setAttribute("role", "presentation"), a.alt = "", a.src = i.url
        })
    }, e.fn.zoom.defaults = t
}(window.jQuery),
/*!
 * jQuery Cycle2; version: 2.1.6 build: 20141007
 * http://jquery.malsup.com/cycle2/
 * Copyright (c) 2014 M. Alsup; Dual licensed: MIT/GPL
 */
! function(e) {
    "use strict";

    function t(e) {
        return (e || "").toLowerCase()
    }
    var n = "2.1.6";
    e.fn.cycle = function(n) {
        var i;
        return 0 !== this.length || e.isReady ? this.each(function() {
            var i, r, o, s, a = e(this),
                l = e.fn.cycle.log;
            if (!a.data("cycle.opts")) {
                (a.data("cycle-log") === !1 || n && n.log === !1 || r && r.log === !1) && (l = e.noop), l("--c2 init--"), i = a.data();
                for (var u in i) i.hasOwnProperty(u) && /^cycle[A-Z]+/.test(u) && (s = i[u], o = u.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, t), l(o + ":", s, "(" + typeof s + ")"), i[o] = s);
                r = e.extend({}, e.fn.cycle.defaults, i, n || {}), r.timeoutId = 0, r.paused = r.paused || !1, r.container = a, r._maxZ = r.maxZ, r.API = e.extend({
                    _container: a
                }, e.fn.cycle.API), r.API.log = l, r.API.trigger = function(e, t) {
                    return r.container.trigger(e, t), r.API
                }, a.data("cycle.opts", r), a.data("cycle.API", r.API), r.API.trigger("cycle-bootstrap", [r, r.API]), r.API.addInitialSlides(), r.API.preInitSlideshow(), r.slides.length && r.API.initSlideshow()
            }
        }) : (i = {
            s: this.selector,
            c: this.context
        }, e.fn.cycle.log("requeuing slideshow (dom not ready)"), e(function() {
            e(i.s, i.c).cycle(n)
        }), this)
    }, e.fn.cycle.API = {
        opts: function() {
            return this._container.data("cycle.opts")
        },
        addInitialSlides: function() {
            var t = this.opts(),
                n = t.slides;
            t.slideCount = 0, t.slides = e(), n = n.jquery ? n : t.container.find(n), t.random && n.sort(function() {
                return Math.random() - .5
            }), t.API.add(n)
        },
        preInitSlideshow: function() {
            var t = this.opts();
            t.API.trigger("cycle-pre-initialize", [t]);
            var n = e.fn.cycle.transitions[t.fx];
            n && e.isFunction(n.preInit) && n.preInit(t), t._preInitialized = !0
        },
        postInitSlideshow: function() {
            var t = this.opts();
            t.API.trigger("cycle-post-initialize", [t]);
            var n = e.fn.cycle.transitions[t.fx];
            n && e.isFunction(n.postInit) && n.postInit(t)
        },
        initSlideshow: function() {
            var t, n = this.opts(),
                i = n.container;
            n.API.calcFirstSlide(), "static" == n.container.css("position") && n.container.css("position", "relative"), e(n.slides[n.currSlide]).css({
                opacity: 1,
                display: "block",
                visibility: "visible"
            }), n.API.stackSlides(n.slides[n.currSlide], n.slides[n.nextSlide], !n.reverse), n.pauseOnHover && (n.pauseOnHover !== !0 && (i = e(n.pauseOnHover)), i.hover(function() {
                n.API.pause(!0)
            }, function() {
                n.API.resume(!0)
            })), n.timeout && (t = n.API.getSlideOpts(n.currSlide), n.API.queueTransition(t, t.timeout + n.delay)), n._initialized = !0, n.API.updateView(!0), n.API.trigger("cycle-initialized", [n]), n.API.postInitSlideshow()
        },
        pause: function(t) {
            var n = this.opts(),
                i = n.API.getSlideOpts(),
                r = n.hoverPaused || n.paused;
            t ? n.hoverPaused = !0 : n.paused = !0, r || (n.container.addClass("cycle-paused"), n.API.trigger("cycle-paused", [n]).log("cycle-paused"), i.timeout && (clearTimeout(n.timeoutId), n.timeoutId = 0, n._remainingTimeout -= e.now() - n._lastQueue, (n._remainingTimeout < 0 || isNaN(n._remainingTimeout)) && (n._remainingTimeout = void 0)))
        },
        resume: function(e) {
            var t = this.opts(),
                n = !t.hoverPaused && !t.paused;
            e ? t.hoverPaused = !1 : t.paused = !1, n || (t.container.removeClass("cycle-paused"), 0 === t.slides.filter(":animated").length && t.API.queueTransition(t.API.getSlideOpts(), t._remainingTimeout), t.API.trigger("cycle-resumed", [t, t._remainingTimeout]).log("cycle-resumed"))
        },
        add: function(t, n) {
            var i, r = this.opts(),
                o = r.slideCount,
                s = !1;
            "string" == e.type(t) && (t = e.trim(t)), e(t).each(function() {
                var t, i = e(this);
                n ? r.container.prepend(i) : r.container.append(i), r.slideCount++, t = r.API.buildSlideOpts(i), r.slides = n ? e(i).add(r.slides) : r.slides.add(i), r.API.initSlide(t, i, --r._maxZ), i.data("cycle.opts", t), r.API.trigger("cycle-slide-added", [r, t, i])
            }), r.API.updateView(!0), s = r._preInitialized && 2 > o && r.slideCount >= 1, s && (r._initialized ? r.timeout && (i = r.slides.length, r.nextSlide = r.reverse ? i - 1 : 1, r.timeoutId || r.API.queueTransition(r)) : r.API.initSlideshow())
        },
        calcFirstSlide: function() {
            var e, t = this.opts();
            e = parseInt(t.startingSlide || 0, 10), (e >= t.slides.length || 0 > e) && (e = 0), t.currSlide = e, t.reverse ? (t.nextSlide = e - 1, t.nextSlide < 0 && (t.nextSlide = t.slides.length - 1)) : (t.nextSlide = e + 1, t.nextSlide == t.slides.length && (t.nextSlide = 0))
        },
        calcNextSlide: function() {
            var e, t = this.opts();
            t.reverse ? (e = t.nextSlide - 1 < 0, t.nextSlide = e ? t.slideCount - 1 : t.nextSlide - 1, t.currSlide = e ? 0 : t.nextSlide + 1) : (e = t.nextSlide + 1 == t.slides.length, t.nextSlide = e ? 0 : t.nextSlide + 1, t.currSlide = e ? t.slides.length - 1 : t.nextSlide - 1)
        },
        calcTx: function(t, n) {
            var i, r = t;
            return r._tempFx ? i = e.fn.cycle.transitions[r._tempFx] : n && r.manualFx && (i = e.fn.cycle.transitions[r.manualFx]), i || (i = e.fn.cycle.transitions[r.fx]), r._tempFx = null, this.opts()._tempFx = null, i || (i = e.fn.cycle.transitions.fade, r.API.log('Transition "' + r.fx + '" not found.  Using fade.')), i
        },
        prepareTx: function(e, t) {
            var n, i, r, o, s, a = this.opts();
            return a.slideCount < 2 ? void(a.timeoutId = 0) : (!e || a.busy && !a.manualTrump || (a.API.stopTransition(), a.busy = !1, clearTimeout(a.timeoutId), a.timeoutId = 0), void(a.busy || (0 !== a.timeoutId || e) && (i = a.slides[a.currSlide], r = a.slides[a.nextSlide], o = a.API.getSlideOpts(a.nextSlide), s = a.API.calcTx(o, e), a._tx = s, e && void 0 !== o.manualSpeed && (o.speed = o.manualSpeed), a.nextSlide != a.currSlide && (e || !a.paused && !a.hoverPaused && a.timeout) ? (a.API.trigger("cycle-before", [o, i, r, t]), s.before && s.before(o, i, r, t), n = function() {
                a.busy = !1, a.container.data("cycle.opts") && (s.after && s.after(o, i, r, t), a.API.trigger("cycle-after", [o, i, r, t]), a.API.queueTransition(o), a.API.updateView(!0))
            }, a.busy = !0, s.transition ? s.transition(o, i, r, t, n) : a.API.doTransition(o, i, r, t, n), a.API.calcNextSlide(), a.API.updateView()) : a.API.queueTransition(o))))
        },
        doTransition: function(t, n, i, r, o) {
            var s = t,
                a = e(n),
                l = e(i),
                u = function() {
                    l.animate(s.animIn || {
                        opacity: 1
                    }, s.speed, s.easeIn || s.easing, o)
                };
            l.css(s.cssBefore || {}), a.animate(s.animOut || {}, s.speed, s.easeOut || s.easing, function() {
                a.css(s.cssAfter || {}), s.sync || u()
            }), s.sync && u()
        },
        queueTransition: function(t, n) {
            var i = this.opts(),
                r = void 0 !== n ? n : t.timeout;
            return 0 === i.nextSlide && 0 === --i.loop ? (i.API.log("terminating; loop=0"), i.timeout = 0, r ? setTimeout(function() {
                i.API.trigger("cycle-finished", [i])
            }, r) : i.API.trigger("cycle-finished", [i]), void(i.nextSlide = i.currSlide)) : void 0 !== i.continueAuto && (i.continueAuto === !1 || e.isFunction(i.continueAuto) && i.continueAuto() === !1) ? (i.API.log("terminating automatic transitions"), i.timeout = 0, void(i.timeoutId && clearTimeout(i.timeoutId))) : void(r && (i._lastQueue = e.now(), void 0 === n && (i._remainingTimeout = t.timeout), i.paused || i.hoverPaused || (i.timeoutId = setTimeout(function() {
                i.API.prepareTx(!1, !i.reverse)
            }, r))))
        },
        stopTransition: function() {
            var e = this.opts();
            e.slides.filter(":animated").length && (e.slides.stop(!1, !0), e.API.trigger("cycle-transition-stopped", [e])), e._tx && e._tx.stopTransition && e._tx.stopTransition(e)
        },
        advanceSlide: function(e) {
            var t = this.opts();
            return clearTimeout(t.timeoutId), t.timeoutId = 0, t.nextSlide = t.currSlide + e, t.nextSlide < 0 ? t.nextSlide = t.slides.length - 1 : t.nextSlide >= t.slides.length && (t.nextSlide = 0), t.API.prepareTx(!0, e >= 0), !1
        },
        buildSlideOpts: function(n) {
            var i, r, o = this.opts(),
                s = n.data() || {};
            for (var a in s) s.hasOwnProperty(a) && /^cycle[A-Z]+/.test(a) && (i = s[a], r = a.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, t), o.API.log("[" + (o.slideCount - 1) + "]", r + ":", i, "(" + typeof i + ")"), s[r] = i);
            s = e.extend({}, e.fn.cycle.defaults, o, s), s.slideNum = o.slideCount;
            try {
                delete s.API, delete s.slideCount, delete s.currSlide, delete s.nextSlide, delete s.slides
            } catch (l) {}
            return s
        },
        getSlideOpts: function(t) {
            var n = this.opts();
            void 0 === t && (t = n.currSlide);
            var i = n.slides[t],
                r = e(i).data("cycle.opts");
            return e.extend({}, n, r)
        },
        initSlide: function(t, n, i) {
            var r = this.opts();
            n.css(t.slideCss || {}), i > 0 && n.css("zIndex", i), isNaN(t.speed) && (t.speed = e.fx.speeds[t.speed] || e.fx.speeds._default), t.sync || (t.speed = t.speed / 2), n.addClass(r.slideClass)
        },
        updateView: function(e, t) {
            var n = this.opts();
            if (n._initialized) {
                var i = n.API.getSlideOpts(),
                    r = n.slides[n.currSlide];
                !e && t !== !0 && (n.API.trigger("cycle-update-view-before", [n, i, r]), n.updateView < 0) || (n.slideActiveClass && n.slides.removeClass(n.slideActiveClass).eq(n.currSlide).addClass(n.slideActiveClass), e && n.hideNonActive && n.slides.filter(":not(." + n.slideActiveClass + ")").css("visibility", "hidden"), 0 === n.updateView && setTimeout(function() {
                    n.API.trigger("cycle-update-view", [n, i, r, e])
                }, i.speed / (n.sync ? 2 : 1)), 0 !== n.updateView && n.API.trigger("cycle-update-view", [n, i, r, e]), e && n.API.trigger("cycle-update-view-after", [n, i, r]))
            }
        },
        getComponent: function(t) {
            var n = this.opts(),
                i = n[t];
            return "string" == typeof i ? /^\s*[\>|\+|~]/.test(i) ? n.container.find(i) : e(i) : i.jquery ? i : e(i)
        },
        stackSlides: function(t, n, i) {
            var r = this.opts();
            t || (t = r.slides[r.currSlide], n = r.slides[r.nextSlide], i = !r.reverse), e(t).css("zIndex", r.maxZ);
            var o, s = r.maxZ - 2,
                a = r.slideCount;
            if (i) {
                for (o = r.currSlide + 1; a > o; o++) e(r.slides[o]).css("zIndex", s--);
                for (o = 0; o < r.currSlide; o++) e(r.slides[o]).css("zIndex", s--)
            } else {
                for (o = r.currSlide - 1; o >= 0; o--) e(r.slides[o]).css("zIndex", s--);
                for (o = a - 1; o > r.currSlide; o--) e(r.slides[o]).css("zIndex", s--)
            }
            e(n).css("zIndex", r.maxZ - 1)
        },
        getSlideIndex: function(e) {
            return this.opts().slides.index(e)
        }
    }, e.fn.cycle.log = function() {
        window.console && console.log && console.log("[cycle2] " + Array.prototype.join.call(arguments, " "))
    }, e.fn.cycle.version = function() {
        return "Cycle2: " + n
    }, e.fn.cycle.transitions = {
        custom: {},
        none: {
            before: function(e, t, n, i) {
                e.API.stackSlides(n, t, i), e.cssBefore = {
                    opacity: 1,
                    visibility: "visible",
                    display: "block"
                }
            }
        },
        fade: {
            before: function(t, n, i, r) {
                var o = t.API.getSlideOpts(t.nextSlide).slideCss || {};
                t.API.stackSlides(n, i, r), t.cssBefore = e.extend(o, {
                    opacity: 0,
                    visibility: "visible",
                    display: "block"
                }), t.animIn = {
                    opacity: 1
                }, t.animOut = {
                    opacity: 0
                }
            }
        },
        fadeout: {
            before: function(t, n, i, r) {
                var o = t.API.getSlideOpts(t.nextSlide).slideCss || {};
                t.API.stackSlides(n, i, r), t.cssBefore = e.extend(o, {
                    opacity: 1,
                    visibility: "visible",
                    display: "block"
                }), t.animOut = {
                    opacity: 0
                }
            }
        },
        scrollHorz: {
            before: function(e, t, n, i) {
                e.API.stackSlides(t, n, i);
                var r = e.container.css("overflow", "hidden").width();
                e.cssBefore = {
                    left: i ? r : -r,
                    top: 0,
                    opacity: 1,
                    visibility: "visible",
                    display: "block"
                }, e.cssAfter = {
                    zIndex: e._maxZ - 2,
                    left: 0
                }, e.animIn = {
                    left: 0
                }, e.animOut = {
                    left: i ? -r : r
                }
            }
        }
    }, e.fn.cycle.defaults = {
        allowWrap: !0,
        autoSelector: ".cycle-slideshow[data-cycle-auto-init!=false]",
        delay: 0,
        easing: null,
        fx: "fade",
        hideNonActive: !0,
        loop: 0,
        manualFx: void 0,
        manualSpeed: void 0,
        manualTrump: !0,
        maxZ: 100,
        pauseOnHover: !1,
        reverse: !1,
        slideActiveClass: "cycle-slide-active",
        slideClass: "cycle-slide",
        slideCss: {
            position: "absolute",
            top: 0,
            left: 0
        },
        slides: "> img",
        speed: 500,
        startingSlide: 0,
        sync: !0,
        timeout: 4e3,
        updateView: 0
    }, e(document).ready(function() {
        e(e.fn.cycle.defaults.autoSelector).cycle()
    })
}(jQuery), /*! Cycle2 autoheight plugin; Copyright (c) M.Alsup, 2012; version: 20130913 */
function(e) {
    "use strict";

    function t(t, i) {
        var r, o, s, a = i.autoHeight;
        if ("container" == a) o = e(i.slides[i.currSlide]).outerHeight(), i.container.height(o);
        else if (i._autoHeightRatio) i.container.height(i.container.width() / i._autoHeightRatio);
        else if ("calc" === a || "number" == e.type(a) && a >= 0) {
            if (s = "calc" === a ? n(t, i) : a >= i.slides.length ? 0 : a, s == i._sentinelIndex) return;
            i._sentinelIndex = s, i._sentinel && i._sentinel.remove(), r = e(i.slides[s].cloneNode(!0)), r.removeAttr("id name rel").find("[id],[name],[rel]").removeAttr("id name rel"), r.css({
                position: "static",
                visibility: "hidden",
                display: "block"
            }).prependTo(i.container).addClass("cycle-sentinel cycle-slide").removeClass("cycle-slide-active"), r.find("*").css("visibility", "hidden"), i._sentinel = r
        }
    }

    function n(t, n) {
        var i = 0,
            r = -1;
        return n.slides.each(function(t) {
            var n = e(this).height();
            n > r && (r = n, i = t)
        }), i
    }

    function i(t, n, i, r) {
        var o = e(r).outerHeight();
        n.container.animate({
            height: o
        }, n.autoHeightSpeed, n.autoHeightEasing)
    }

    function r(n, o) {
        o._autoHeightOnResize && (e(window).off("resize orientationchange", o._autoHeightOnResize), o._autoHeightOnResize = null), o.container.off("cycle-slide-added cycle-slide-removed", t), o.container.off("cycle-destroyed", r), o.container.off("cycle-before", i), o._sentinel && (o._sentinel.remove(), o._sentinel = null)
    }
    e.extend(e.fn.cycle.defaults, {
        autoHeight: 0,
        autoHeightSpeed: 250,
        autoHeightEasing: null
    }), e(document).on("cycle-initialized", function(n, o) {
        function s() {
            t(n, o)
        }
        var a, l = o.autoHeight,
            u = e.type(l),
            c = null;
        ("string" === u || "number" === u) && (o.container.on("cycle-slide-added cycle-slide-removed", t), o.container.on("cycle-destroyed", r), "container" == l ? o.container.on("cycle-before", i) : "string" === u && /\d+\:\d+/.test(l) && (a = l.match(/(\d+)\:(\d+)/), a = a[1] / a[2], o._autoHeightRatio = a), "number" !== u && (o._autoHeightOnResize = function() {
            clearTimeout(c), c = setTimeout(s, 50)
        }, e(window).on("resize orientationchange", o._autoHeightOnResize)), setTimeout(s, 30))
    })
}(jQuery), /*! caption plugin for Cycle2;  version: 20130306 */
function(e) {
    "use strict";
    e.extend(e.fn.cycle.defaults, {
        caption: "> .cycle-caption",
        captionTemplate: "{{slideNum}} / {{slideCount}}",
        overlay: "> .cycle-overlay",
        overlayTemplate: "<div>{{title}}</div><div>{{desc}}</div>",
        captionModule: "caption"
    }), e(document).on("cycle-update-view", function(t, n, i, r) {
        "caption" === n.captionModule && e.each(["caption", "overlay"], function() {
            var e = this,
                t = i[e + "Template"],
                o = n.API.getComponent(e);
            o.length && t ? (o.html(n.API.tmpl(t, i, n, r)), o.show()) : o.hide()
        })
    }), e(document).on("cycle-destroyed", function(t, n) {
        var i;
        e.each(["caption", "overlay"], function() {
            var e = this,
                t = n[e + "Template"];
            n[e] && t && (i = n.API.getComponent("caption"), i.empty())
        })
    })
}(jQuery), /*! command plugin for Cycle2;  version: 20140415 */
function(e) {
    "use strict";
    var t = e.fn.cycle;
    e.fn.cycle = function(n) {
        var i, r, o, s = e.makeArray(arguments);
        return "number" == e.type(n) ? this.cycle("goto", n) : "string" == e.type(n) ? this.each(function() {
            var a;
            return i = n, o = e(this).data("cycle.opts"), void 0 === o ? void t.log('slideshow must be initialized before sending commands; "' + i + '" ignored') : (i = "goto" == i ? "jump" : i, r = o.API[i], e.isFunction(r) ? (a = e.makeArray(s), a.shift(), r.apply(o.API, a)) : void t.log("unknown command: ", i))
        }) : t.apply(this, arguments)
    }, e.extend(e.fn.cycle, t), e.extend(t.API, {
        next: function() {
            var e = this.opts();
            if (!e.busy || e.manualTrump) {
                var t = e.reverse ? -1 : 1;
                e.allowWrap === !1 && e.currSlide + t >= e.slideCount || (e.API.advanceSlide(t), e.API.trigger("cycle-next", [e]).log("cycle-next"))
            }
        },
        prev: function() {
            var e = this.opts();
            if (!e.busy || e.manualTrump) {
                var t = e.reverse ? 1 : -1;
                e.allowWrap === !1 && e.currSlide + t < 0 || (e.API.advanceSlide(t), e.API.trigger("cycle-prev", [e]).log("cycle-prev"))
            }
        },
        destroy: function() {
            this.stop();
            var t = this.opts(),
                n = e.isFunction(e._data) ? e._data : e.noop;
            clearTimeout(t.timeoutId), t.timeoutId = 0, t.API.stop(), t.API.trigger("cycle-destroyed", [t]).log("cycle-destroyed"), t.container.removeData(), n(t.container[0], "parsedAttrs", !1), t.retainStylesOnDestroy || (t.container.removeAttr("style"), t.slides.removeAttr("style"), t.slides.removeClass(t.slideActiveClass)), t.slides.each(function() {
                var i = e(this);
                i.removeData(), i.removeClass(t.slideClass), n(this, "parsedAttrs", !1)
            })
        },
        jump: function(e, t) {
            var n, i = this.opts();
            if (!i.busy || i.manualTrump) {
                var r = parseInt(e, 10);
                if (isNaN(r) || 0 > r || r >= i.slides.length) return void i.API.log("goto: invalid slide index: " + r);
                if (r == i.currSlide) return void i.API.log("goto: skipping, already on slide", r);
                i.nextSlide = r, clearTimeout(i.timeoutId), i.timeoutId = 0, i.API.log("goto: ", r, " (zero-index)"), n = i.currSlide < i.nextSlide, i._tempFx = t, i.API.prepareTx(!0, n)
            }
        },
        stop: function() {
            var t = this.opts(),
                n = t.container;
            clearTimeout(t.timeoutId), t.timeoutId = 0, t.API.stopTransition(), t.pauseOnHover && (t.pauseOnHover !== !0 && (n = e(t.pauseOnHover)), n.off("mouseenter mouseleave")), t.API.trigger("cycle-stopped", [t]).log("cycle-stopped")
        },
        reinit: function() {
            var e = this.opts();
            e.API.destroy(), e.container.cycle()
        },
        remove: function(t) {
            for (var n, i, r = this.opts(), o = [], s = 1, a = 0; a < r.slides.length; a++) n = r.slides[a], a == t ? i = n : (o.push(n), e(n).data("cycle.opts").slideNum = s, s++);
            i && (r.slides = e(o), r.slideCount--, e(i).remove(), t == r.currSlide ? r.API.advanceSlide(1) : t < r.currSlide ? r.currSlide-- : r.currSlide++, r.API.trigger("cycle-slide-removed", [r, t, i]).log("cycle-slide-removed"), r.API.updateView())
        }
    }), e(document).on("click.cycle", "[data-cycle-cmd]", function(t) {
        t.preventDefault();
        var n = e(this),
            i = n.data("cycle-cmd"),
            r = n.data("cycle-context") || ".cycle-slideshow";
        e(r).cycle(i, n.data("cycle-arg"))
    })
}(jQuery), /*! hash plugin for Cycle2;  version: 20130905 */
function(e) {
    "use strict";

    function t(t, n) {
        var i;
        return t._hashFence ? void(t._hashFence = !1) : (i = window.location.hash.substring(1), void t.slides.each(function(r) {
            if (e(this).data("cycle-hash") == i) {
                if (n === !0) t.startingSlide = r;
                else {
                    var o = t.currSlide < r;
                    t.nextSlide = r, t.API.prepareTx(!0, o)
                }
                return !1
            }
        }))
    }
    e(document).on("cycle-pre-initialize", function(n, i) {
        t(i, !0), i._onHashChange = function() {
            t(i, !1)
        }, e(window).on("hashchange", i._onHashChange)
    }), e(document).on("cycle-update-view", function(e, t, n) {
        n.hash && "#" + n.hash != window.location.hash && (t._hashFence = !0, window.location.hash = n.hash)
    }), e(document).on("cycle-destroyed", function(t, n) {
        n._onHashChange && e(window).off("hashchange", n._onHashChange)
    })
}(jQuery), /*! loader plugin for Cycle2;  version: 20131121 */
function(e) {
    "use strict";
    e.extend(e.fn.cycle.defaults, {
        loader: !1
    }), e(document).on("cycle-bootstrap", function(t, n) {
        function i(t, i) {
            function o(t) {
                var o;
                "wait" == n.loader ? (a.push(t), 0 === u && (a.sort(s), r.apply(n.API, [a, i]), n.container.removeClass("cycle-loading"))) : (o = e(n.slides[n.currSlide]), r.apply(n.API, [t, i]), o.show(), n.container.removeClass("cycle-loading"))
            }

            function s(e, t) {
                return e.data("index") - t.data("index")
            }
            var a = [];
            if ("string" == e.type(t)) t = e.trim(t);
            else if ("array" === e.type(t))
                for (var l = 0; l < t.length; l++) t[l] = e(t[l])[0];
            t = e(t);
            var u = t.length;
            u && (t.css("visibility", "hidden").appendTo("body").each(function(t) {
                function s() {
                    0 === --l && (--u, o(c))
                }
                var l = 0,
                    c = e(this),
                    d = c.is("img") ? c : c.find("img");
                return c.data("index", t), d = d.filter(":not(.cycle-loader-ignore)").filter(':not([src=""])'), d.length ? (l = d.length, void d.each(function() {
                    this.complete ? s() : e(this).load(function() {
                        s()
                    }).on("error", function() {
                        0 === --l && (n.API.log("slide skipped; img not loaded:", this.src), 0 === --u && "wait" == n.loader && r.apply(n.API, [a, i]))
                    })
                })) : (--u, void a.push(c))
            }), u && n.container.addClass("cycle-loading"))
        }
        var r;
        n.loader && (r = n.API.add, n.API.add = i)
    })
}(jQuery), /*! pager plugin for Cycle2;  version: 20140415 */
function(e) {
    "use strict";

    function t(t, n, i) {
        var r, o = t.API.getComponent("pager");
        o.each(function() {
            var o = e(this);
            if (n.pagerTemplate) {
                var s = t.API.tmpl(n.pagerTemplate, n, t, i[0]);
                r = e(s).appendTo(o)
            } else r = o.children().eq(t.slideCount - 1);
            r.on(t.pagerEvent, function(e) {
                t.pagerEventBubble || e.preventDefault(), t.API.page(o, e.currentTarget)
            })
        })
    }

    function n(e, t) {
        var n = this.opts();
        if (!n.busy || n.manualTrump) {
            var i = e.children().index(t),
                r = i,
                o = n.currSlide < r;
            n.currSlide != r && (n.nextSlide = r, n._tempFx = n.pagerFx, n.API.prepareTx(!0, o), n.API.trigger("cycle-pager-activated", [n, e, t]))
        }
    }
    e.extend(e.fn.cycle.defaults, {
        pager: "> .cycle-pager",
        pagerActiveClass: "cycle-pager-active",
        pagerEvent: "click.cycle",
        pagerEventBubble: void 0,
        pagerTemplate: "<span>&bull;</span>"
    }), e(document).on("cycle-bootstrap", function(e, n, i) {
        i.buildPagerLink = t
    }), e(document).on("cycle-slide-added", function(e, t, i, r) {
        t.pager && (t.API.buildPagerLink(t, i, r), t.API.page = n)
    }), e(document).on("cycle-slide-removed", function(t, n, i) {
        if (n.pager) {
            var r = n.API.getComponent("pager");
            r.each(function() {
                var t = e(this);
                e(t.children()[i]).remove()
            })
        }
    }), e(document).on("cycle-update-view", function(t, n) {
        var i;
        n.pager && (i = n.API.getComponent("pager"), i.each(function() {
            e(this).children().removeClass(n.pagerActiveClass).eq(n.currSlide).addClass(n.pagerActiveClass)
        }))
    }), e(document).on("cycle-destroyed", function(e, t) {
        var n = t.API.getComponent("pager");
        n && (n.children().off(t.pagerEvent), t.pagerTemplate && n.empty())
    })
}(jQuery), /*! prevnext plugin for Cycle2;  version: 20140408 */
function(e) {
    "use strict";
    e.extend(e.fn.cycle.defaults, {
        next: "> .cycle-next",
        nextEvent: "click.cycle",
        disabledClass: "disabled",
        prev: "> .cycle-prev",
        prevEvent: "click.cycle",
        swipe: !1
    }), e(document).on("cycle-initialized", function(e, t) {
        if (t.API.getComponent("next").on(t.nextEvent, function(e) {
                e.preventDefault(), t.API.next()
            }), t.API.getComponent("prev").on(t.prevEvent, function(e) {
                e.preventDefault(), t.API.prev()
            }), t.swipe) {
            var n = t.swipeVert ? "swipeUp.cycle" : "swipeLeft.cycle swipeleft.cycle",
                i = t.swipeVert ? "swipeDown.cycle" : "swipeRight.cycle swiperight.cycle";
            t.container.on(n, function() {
                t._tempFx = t.swipeFx, t.API.next()
            }), t.container.on(i, function() {
                t._tempFx = t.swipeFx, t.API.prev()
            })
        }
    }), e(document).on("cycle-update-view", function(e, t) {
        if (!t.allowWrap) {
            var n = t.disabledClass,
                i = t.API.getComponent("next"),
                r = t.API.getComponent("prev"),
                o = t._prevBoundry || 0,
                s = void 0 !== t._nextBoundry ? t._nextBoundry : t.slideCount - 1;
            t.currSlide == s ? i.addClass(n).prop("disabled", !0) : i.removeClass(n).prop("disabled", !1), t.currSlide === o ? r.addClass(n).prop("disabled", !0) : r.removeClass(n).prop("disabled", !1)
        }
    }), e(document).on("cycle-destroyed", function(e, t) {
        t.API.getComponent("prev").off(t.nextEvent), t.API.getComponent("next").off(t.prevEvent), t.container.off("swipeleft.cycle swiperight.cycle swipeLeft.cycle swipeRight.cycle swipeUp.cycle swipeDown.cycle")
    })
}(jQuery), /*! progressive loader plugin for Cycle2;  version: 20130315 */
function(e) {
    "use strict";
    e.extend(e.fn.cycle.defaults, {
        progressive: !1
    }), e(document).on("cycle-pre-initialize", function(t, n) {
        if (n.progressive) {
            var i, r, o = n.API,
                s = o.next,
                a = o.prev,
                l = o.prepareTx,
                u = e.type(n.progressive);
            if ("array" == u) i = n.progressive;
            else if (e.isFunction(n.progressive)) i = n.progressive(n);
            else if ("string" == u) {
                if (r = e(n.progressive), i = e.trim(r.html()), !i) return;
                if (/^(\[)/.test(i)) try {
                    i = e.parseJSON(i)
                } catch (c) {
                    return void o.log("error parsing progressive slides", c)
                } else i = i.split(new RegExp(r.data("cycle-split") || "\n")), i[i.length - 1] || i.pop()
            }
            l && (o.prepareTx = function(e, t) {
                var r, o;
                return e || 0 === i.length ? void l.apply(n.API, [e, t]) : void(t && n.currSlide == n.slideCount - 1 ? (o = i[0], i = i.slice(1), n.container.one("cycle-slide-added", function(e, t) {
                    setTimeout(function() {
                        t.API.advanceSlide(1)
                    }, 50)
                }), n.API.add(o)) : t || 0 !== n.currSlide ? l.apply(n.API, [e, t]) : (r = i.length - 1, o = i[r], i = i.slice(0, r), n.container.one("cycle-slide-added", function(e, t) {
                    setTimeout(function() {
                        t.currSlide = 1, t.API.advanceSlide(-1)
                    }, 50)
                }), n.API.add(o, !0)))
            }), s && (o.next = function() {
                var e = this.opts();
                if (i.length && e.currSlide == e.slideCount - 1) {
                    var t = i[0];
                    i = i.slice(1), e.container.one("cycle-slide-added", function(e, t) {
                        s.apply(t.API), t.container.removeClass("cycle-loading")
                    }), e.container.addClass("cycle-loading"), e.API.add(t)
                } else s.apply(e.API)
            }), a && (o.prev = function() {
                var e = this.opts();
                if (i.length && 0 === e.currSlide) {
                    var t = i.length - 1,
                        n = i[t];
                    i = i.slice(0, t), e.container.one("cycle-slide-added", function(e, t) {
                        t.currSlide = 1, t.API.advanceSlide(-1), t.container.removeClass("cycle-loading")
                    }), e.container.addClass("cycle-loading"), e.API.add(n, !0)
                } else a.apply(e.API)
            })
        }
    })
}(jQuery), /*! tmpl plugin for Cycle2;  version: 20121227 */
function(e) {
    "use strict";
    e.extend(e.fn.cycle.defaults, {
        tmplRegex: "{{((.)?.*?)}}"
    }), e.extend(e.fn.cycle.API, {
        tmpl: function(t, n) {
            var i = new RegExp(n.tmplRegex || e.fn.cycle.defaults.tmplRegex, "g"),
                r = e.makeArray(arguments);
            return r.shift(), t.replace(i, function(t, n) {
                var i, o, s, a, l = n.split(".");
                for (i = 0; i < r.length; i++)
                    if (s = r[i]) {
                        if (l.length > 1)
                            for (a = s, o = 0; o < l.length; o++) s = a, a = a[l[o]] || n;
                        else a = s[n];
                        if (e.isFunction(a)) return a.apply(s, r);
                        if (void 0 !== a && null !== a && a != n) return a
                    } return n
            })
        }
    })
}(jQuery), /* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20141007 */
! function(e) {
    "use strict";
    e(document).on("cycle-bootstrap", function(e, t, n) {
        "carousel" === t.fx && (n.getSlideIndex = function(e) {
            var t = this.opts()._carouselWrap.children(),
                n = t.index(e);
            return n % t.length
        }, n.next = function() {
            var e = t.reverse ? -1 : 1;
            t.allowWrap === !1 && t.currSlide + e > t.slideCount - t.carouselVisible || (t.API.advanceSlide(e), t.API.trigger("cycle-next", [t]).log("cycle-next"))
        })
    }), e.fn.cycle.transitions.carousel = {
        preInit: function(t) {
            t.hideNonActive = !1, t.container.on("cycle-destroyed", e.proxy(this.onDestroy, t.API)), t.API.stopTransition = this.stopTransition;
            for (var n = 0; n < t.startingSlide; n++) t.container.append(t.slides[0])
        },
        postInit: function(t) {
            var n, i, r, o, s = t.carouselVertical;
            t.carouselVisible && t.carouselVisible > t.slideCount && (t.carouselVisible = t.slideCount - 1);
            var a = t.carouselVisible || t.slides.length,
                l = {
                    display: s ? "block" : "inline-block",
                    position: "static"
                };
            if (t.container.css({
                    position: "relative",
                    overflow: "hidden"
                }), t.slides.css(l), t._currSlide = t.currSlide, o = e('<div class="cycle-carousel-wrap"></div>').prependTo(t.container).css({
                    margin: 0,
                    padding: 0,
                    top: 0,
                    left: 0,
                    position: "absolute"
                }).append(t.slides), t._carouselWrap = o, s || o.css("white-space", "nowrap"), t.allowWrap !== !1) {
                for (i = 0; i < (void 0 === t.carouselVisible ? 2 : 1); i++) {
                    for (n = 0; n < t.slideCount; n++) o.append(t.slides[n].cloneNode(!0));
                    for (n = t.slideCount; n--;) o.prepend(t.slides[n].cloneNode(!0))
                }
                o.find(".cycle-slide-active").removeClass("cycle-slide-active"), t.slides.eq(t.startingSlide).addClass("cycle-slide-active")
            }
            t.pager && t.allowWrap === !1 && (r = t.slideCount - a, e(t.pager).children().filter(":gt(" + r + ")").hide()), t._nextBoundry = t.slideCount - t.carouselVisible, this.prepareDimensions(t)
        },
        prepareDimensions: function(t) {
            var n, i, r, o, s = t.carouselVertical,
                a = t.carouselVisible || t.slides.length;
            if (t.carouselFluid && t.carouselVisible ? t._carouselResizeThrottle || this.fluidSlides(t) : t.carouselVisible && t.carouselSlideDimension ? (n = a * t.carouselSlideDimension, t.container[s ? "height" : "width"](n)) : t.carouselVisible && (n = a * e(t.slides[0])[s ? "outerHeight" : "outerWidth"](!0), t.container[s ? "height" : "width"](n)), i = t.carouselOffset || 0, t.allowWrap !== !1)
                if (t.carouselSlideDimension) i -= (t.slideCount + t.currSlide) * t.carouselSlideDimension;
                else
                    for (r = t._carouselWrap.children(), o = 0; o < t.slideCount + t.currSlide; o++) i -= e(r[o])[s ? "outerHeight" : "outerWidth"](!0);
            t._carouselWrap.css(s ? "top" : "left", i)
        },
        fluidSlides: function(t) {
            function n() {
                clearTimeout(r), r = setTimeout(i, 20)
            }

            function i() {
                t._carouselWrap.stop(!1, !0);
                var e = t.container.width() / t.carouselVisible;
                e = Math.ceil(e - s), t._carouselWrap.children().width(e), t._sentinel && t._sentinel.width(e), a(t)
            }
            var r, o = t.slides.eq(0),
                s = o.outerWidth() - o.width(),
                a = this.prepareDimensions;
            e(window).on("resize", n), t._carouselResizeThrottle = n, i()
        },
        transition: function(t, n, i, r, o) {
            var s, a = {},
                l = t.nextSlide - t.currSlide,
                u = t.carouselVertical,
                c = t.speed;
            if (t.allowWrap === !1) {
                r = l > 0;
                var d = t._currSlide,
                    p = t.slideCount - t.carouselVisible;
                l > 0 && t.nextSlide > p && d == p ? l = 0 : l > 0 && t.nextSlide > p ? l = t.nextSlide - d - (t.nextSlide - p) : 0 > l && t.currSlide > p && t.nextSlide > p ? l = 0 : 0 > l && t.currSlide > p ? l += t.currSlide - p : d = t.currSlide, s = this.getScroll(t, u, d, l), t.API.opts()._currSlide = t.nextSlide > p ? p : t.nextSlide
            } else r && 0 === t.nextSlide ? (s = this.getDim(t, t.currSlide, u), o = this.genCallback(t, r, u, o)) : r || t.nextSlide != t.slideCount - 1 ? s = this.getScroll(t, u, t.currSlide, l) : (s = this.getDim(t, t.currSlide, u), o = this.genCallback(t, r, u, o));
            a[u ? "top" : "left"] = r ? "-=" + s : "+=" + s, t.throttleSpeed && (c = s / e(t.slides[0])[u ? "height" : "width"]() * t.speed), t._carouselWrap.animate(a, c, t.easing, o)
        },
        getDim: function(t, n, i) {
            var r = e(t.slides[n]);
            return r[i ? "outerHeight" : "outerWidth"](!0)
        },
        getScroll: function(e, t, n, i) {
            var r, o = 0;
            if (i > 0)
                for (r = n; n + i > r; r++) o += this.getDim(e, r, t);
            else
                for (r = n; r > n + i; r--) o += this.getDim(e, r, t);
            return o
        },
        genCallback: function(t, n, i, r) {
            return function() {
                var n = e(t.slides[t.nextSlide]).position(),
                    o = 0 - n[i ? "top" : "left"] + (t.carouselOffset || 0);
                t._carouselWrap.css(t.carouselVertical ? "top" : "left", o), r()
            }
        },
        stopTransition: function() {
            var e = this.opts();
            e.slides.stop(!1, !0), e._carouselWrap.stop(!1, !0)
        },
        onDestroy: function() {
            var t = this.opts();
            t._carouselResizeThrottle && e(window).off("resize", t._carouselResizeThrottle), t.slides.prependTo(t.container), t._carouselWrap.remove()
        }
    }
}(jQuery), /* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20141007 */
! function(e) {
    "use strict";
    e.fn.cycle.transitions.scrollVert = {
        before: function(e, t, n, i) {
            e.API.stackSlides(e, t, n, i);
            var r = e.container.css("overflow", "hidden").height();
            e.cssBefore = {
                top: i ? -r : r,
                left: 0,
                opacity: 1,
                display: "block",
                visibility: "visible"
            }, e.animIn = {
                top: 0
            }, e.animOut = {
                top: i ? r : -r
            }
        }
    }
}(jQuery),
// license: MIT
function() {
    function e(e, n, i, r) {
        return new t(e, n, i, r)
    }

    function t(e, t, i, r) {
        this.options = r || {}, this.options.adapters = this.options.adapters || {}, this.obj = e, this.keypath = t, this.callback = i, this.objectPath = [], this.parse(), n(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
    }

    function n(e) {
        return "object" == typeof e && null !== e
    }

    function i(e) {
        throw new Error("[sightglass] " + e)
    }
    e.adapters = {}, t.tokenize = function(e, t, n) {
        var i, r, o = [],
            s = {
                i: n,
                path: ""
            };
        for (i = 0; i < e.length; i++) r = e.charAt(i), ~t.indexOf(r) ? (o.push(s), s = {
            i: r,
            path: ""
        }) : s.path += r;
        return o.push(s), o
    }, t.prototype.parse = function() {
        var n, r, o = this.interfaces();
        o.length || i("Must define at least one adapter interface."), ~o.indexOf(this.keypath[0]) ? (n = this.keypath[0], r = this.keypath.substr(1)) : ("undefined" == typeof(n = this.options.root || e.root) && i("Must define a default root adapter."), r = this.keypath), this.tokens = t.tokenize(r, o, n), this.key = this.tokens.pop()
    }, t.prototype.realize = function() {
        var e, t = this.obj,
            i = !1;
        return this.tokens.forEach(function(r, o) {
            n(t) ? ("undefined" != typeof this.objectPath[o] ? t !== (e = this.objectPath[o]) && (this.set(!1, r, e, this.update.bind(this)), this.set(!0, r, t, this.update.bind(this)), this.objectPath[o] = t) : (this.set(!0, r, t, this.update.bind(this)), this.objectPath[o] = t), t = this.get(r, t)) : (i === !1 && (i = o), (e = this.objectPath[o]) && this.set(!1, r, e, this.update.bind(this)))
        }, this), i !== !1 && this.objectPath.splice(i), t
    }, t.prototype.update = function() {
        var e, t;
        (e = this.realize()) !== this.target && (n(this.target) && this.set(!1, this.key, this.target, this.callback), n(e) && this.set(!0, this.key, e, this.callback), t = this.value(), this.target = e, this.value() !== t && this.callback())
    }, t.prototype.value = function() {
        return n(this.target) ? this.get(this.key, this.target) : void 0
    }, t.prototype.setValue = function(e) {
        n(this.target) && this.adapter(this.key).set(this.target, this.key.path, e)
    }, t.prototype.get = function(e, t) {
        return this.adapter(e).get(t, e.path)
    }, t.prototype.set = function(e, t, n, i) {
        var r = e ? "observe" : "unobserve";
        this.adapter(t)[r](n, t.path, i)
    }, t.prototype.interfaces = function() {
        var t = Object.keys(this.options.adapters);
        return Object.keys(e.adapters).forEach(function(e) {
            ~t.indexOf(e) || t.push(e)
        }), t
    }, t.prototype.adapter = function(t) {
        return this.options.adapters[t.i] || e.adapters[t.i]
    }, t.prototype.unobserve = function() {
        var e;
        this.tokens.forEach(function(t, n) {
            (e = this.objectPath[n]) && this.set(!1, t, e, this.update.bind(this))
        }, this), n(this.target) && this.set(!1, this.key, this.target, this.callback)
    }, "undefined" != typeof module && module.exports ? module.exports = e : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = e
    }) : this.sightglass = e
}.call(this),
    function() {
        var e, t, n, i, r = function(e, t) {
                return function() {
                    return e.apply(t, arguments)
                }
            },
            o = [].slice,
            s = {}.hasOwnProperty,
            a = function(e, t) {
                function n() {
                    this.constructor = e
                }
                for (var i in t) s.call(t, i) && (e[i] = t[i]);
                return n.prototype = t.prototype, e.prototype = new n, e.__super__ = t.prototype, e
            },
            l = [].indexOf || function(e) {
                for (var t = 0, n = this.length; n > t; t++)
                    if (t in this && this[t] === e) return t;
                return -1
            };
        e = {
            options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
            extensions: ["binders", "formatters", "components", "adapters"],
            "public": {
                binders: {},
                components: {},
                formatters: {},
                adapters: {},
                prefix: "rv",
                templateDelimiters: ["{", "}"],
                rootInterface: ".",
                preloadData: !0,
                handler: function(e, t, n) {
                    return this.call(e, t, n.view.models)
                },
                configure: function(t) {
                    var n, i, r, o;
                    null == t && (t = {});
                    for (r in t)
                        if (o = t[r], "binders" === r || "components" === r || "formatters" === r || "adapters" === r)
                            for (i in o) n = o[i], e[r][i] = n;
                        else e["public"][r] = o
                },
                bind: function(t, n, i) {
                    var r;
                    return null == n && (n = {}), null == i && (i = {}), r = new e.View(t, n, i), r.bind(), r
                },
                init: function(t, n, i) {
                    var r, o;
                    return null == i && (i = {}), null == n && (n = document.createElement("div")), t = e["public"].components[t], n.innerHTML = t.template.call(this, n), r = t.initialize.call(this, n, i), o = new e.View(n, r), o.bind(), o
                }
            }
        }, window.jQuery || window.$ ? (i = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"], t = i[0], n = i[1], e.Util = {
            bindEvent: function(e, n, i) {
                return jQuery(e)[t](n, i)
            },
            unbindEvent: function(e, t, i) {
                return jQuery(e)[n](t, i)
            },
            getInputValue: function(e) {
                var t;
                return t = jQuery(e), "checkbox" === t.attr("type") ? t.is(":checked") : t.val()
            }
        }) : e.Util = {
            bindEvent: function() {
                return "addEventListener" in window ? function(e, t, n) {
                    return e.addEventListener(t, n, !1)
                } : function(e, t, n) {
                    return e.attachEvent("on" + t, n)
                }
            }(),
            unbindEvent: function() {
                return "removeEventListener" in window ? function(e, t, n) {
                    return e.removeEventListener(t, n, !1)
                } : function(e, t, n) {
                    return e.detachEvent("on" + t, n)
                }
            }(),
            getInputValue: function(e) {
                var t, n, i, r;
                if ("checkbox" === e.type) return e.checked;
                if ("select-multiple" === e.type) {
                    for (r = [], n = 0, i = e.length; i > n; n++) t = e[n], t.selected && r.push(t.value);
                    return r
                }
                return e.value
            }
        }, e.TypeParser = function() {
            function e() {}
            return e.types = {
                primitive: 0,
                keypath: 1
            }, e.parse = function(e) {
                return /^'.*'$|^".*"$/.test(e) ? {
                    type: this.types.primitive,
                    value: e.slice(1, -1)
                } : "true" === e ? {
                    type: this.types.primitive,
                    value: !0
                } : "false" === e ? {
                    type: this.types.primitive,
                    value: !1
                } : "null" === e ? {
                    type: this.types.primitive,
                    value: null
                } : "undefined" === e ? {
                    type: this.types.primitive,
                    value: void 0
                } : isNaN(Number(e)) === !1 ? {
                    type: this.types.primitive,
                    value: Number(e)
                } : {
                    type: this.types.keypath,
                    value: e
                }
            }, e
        }(), e.TextTemplateParser = function() {
            function e() {}
            return e.types = {
                text: 0,
                binding: 1
            }, e.parse = function(e, t) {
                var n, i, r, o, s, a, l;
                for (a = [], o = e.length, n = 0, i = 0; o > i;) {
                    if (n = e.indexOf(t[0], i), 0 > n) {
                        a.push({
                            type: this.types.text,
                            value: e.slice(i)
                        });
                        break
                    }
                    if (n > 0 && n > i && a.push({
                            type: this.types.text,
                            value: e.slice(i, n)
                        }), i = n + t[0].length, n = e.indexOf(t[1], i), 0 > n) {
                        s = e.slice(i - t[1].length), r = a[a.length - 1], (null != r ? r.type : void 0) === this.types.text ? r.value += s : a.push({
                            type: this.types.text,
                            value: s
                        });
                        break
                    }
                    l = e.slice(i, n).trim(), a.push({
                        type: this.types.binding,
                        value: l
                    }), i = n + t[1].length
                }
                return a
            }, e
        }(), e.View = function() {
            function t(t, n, i) {
                var o, s, a, l, u, c, d, p, h, f, g, m, v;
                for (this.els = t, this.models = n, null == i && (i = {}), this.update = r(this.update, this), this.publish = r(this.publish, this), this.sync = r(this.sync, this), this.unbind = r(this.unbind, this), this.bind = r(this.bind, this), this.select = r(this.select, this), this.traverse = r(this.traverse, this), this.build = r(this.build, this), this.buildBinding = r(this.buildBinding, this), this.bindingRegExp = r(this.bindingRegExp, this), this.options = r(this.options, this), this.els.jquery || this.els instanceof Array || (this.els = [this.els]), h = e.extensions, u = 0, d = h.length; d > u; u++) {
                    if (s = h[u], this[s] = {}, i[s]) {
                        f = i[s];
                        for (o in f) a = f[o], this[s][o] = a
                    }
                    g = e["public"][s];
                    for (o in g) a = g[o], null == (l = this[s])[o] && (l[o] = a)
                }
                for (m = e.options, c = 0, p = m.length; p > c; c++) s = m[c], this[s] = null != (v = i[s]) ? v : e["public"][s];
                this.build()
            }
            return t.prototype.options = function() {
                var t, n, i, r, o;
                for (n = {}, o = e.extensions.concat(e.options), i = 0, r = o.length; r > i; i++) t = o[i], n[t] = this[t];
                return n
            }, t.prototype.bindingRegExp = function() {
                return new RegExp("^" + this.prefix + "-")
            }, t.prototype.buildBinding = function(t, n, i, r) {
                var o, s, a, l, u, c, d;
                return u = {}, d = function() {
                    var e, t, n, i;
                    for (n = r.split("|"), i = [], e = 0, t = n.length; t > e; e++) c = n[e], i.push(c.trim());
                    return i
                }(), o = function() {
                    var e, t, n, i;
                    for (n = d.shift().split("<"), i = [], e = 0, t = n.length; t > e; e++) s = n[e], i.push(s.trim());
                    return i
                }(), l = o.shift(), u.formatters = d, (a = o.shift()) && (u.dependencies = a.split(/\s+/)), this.bindings.push(new e[t](this, n, i, l, u))
            }, t.prototype.build = function() {
                var t, n, i, r, o;
                for (this.bindings = [], n = function(t) {
                        return function(i) {
                            var r, o, s, a, l, u, c, d, p, h, f, g, m, v;
                            if (3 === i.nodeType) {
                                if (l = e.TextTemplateParser, (s = t.templateDelimiters) && (d = l.parse(i.data, s)).length && (1 !== d.length || d[0].type !== l.types.text)) {
                                    for (p = 0, f = d.length; f > p; p++) c = d[p], u = document.createTextNode(c.value), i.parentNode.insertBefore(u, i), 1 === c.type && t.buildBinding("TextBinding", u, null, c.value);
                                    i.parentNode.removeChild(i)
                                }
                            } else 1 === i.nodeType && (r = t.traverse(i));
                            if (!r) {
                                for (m = function() {
                                        var e, t, n, r;
                                        for (n = i.childNodes, r = [], e = 0, t = n.length; t > e; e++) a = n[e], r.push(a);
                                        return r
                                    }(), v = [], h = 0, g = m.length; g > h; h++) o = m[h], v.push(n(o));
                                return v
                            }
                        }
                    }(this), o = this.els, i = 0, r = o.length; r > i; i++) t = o[i], n(t);
                this.bindings.sort(function(e, t) {
                    var n, i;
                    return ((null != (n = t.binder) ? n.priority : void 0) || 0) - ((null != (i = e.binder) ? i.priority : void 0) || 0)
                })
            }, t.prototype.traverse = function(t) {
                var n, i, r, o, s, a, l, u, c, d, p, h, f, g, m, v;
                for (o = this.bindingRegExp(), s = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName, g = t.attributes, d = 0, h = g.length; h > d; d++)
                    if (n = g[d], o.test(n.name)) {
                        if (u = n.name.replace(o, ""), !(r = this.binders[u])) {
                            m = this.binders;
                            for (a in m) c = m[a], "*" !== a && -1 !== a.indexOf("*") && (l = new RegExp("^" + a.replace(/\*/g, ".+") + "$"), l.test(u) && (r = c))
                        }
                        r || (r = this.binders["*"]), r.block && (s = !0, i = [n])
                    } for (v = i || t.attributes, p = 0, f = v.length; f > p; p++) n = v[p], o.test(n.name) && (u = n.name.replace(o, ""), this.buildBinding("Binding", t, u, n.value));
                return s || (u = t.nodeName.toLowerCase(), this.components[u] && !t._bound && (this.bindings.push(new e.ComponentBinding(this, t, u)), s = !0)), s
            }, t.prototype.select = function(e) {
                var t, n, i, r, o;
                for (r = this.bindings, o = [], n = 0, i = r.length; i > n; n++) t = r[n], e(t) && o.push(t);
                return o
            }, t.prototype.bind = function() {
                var e, t, n, i, r;
                for (i = this.bindings, r = [], t = 0, n = i.length; n > t; t++) e = i[t], r.push(e.bind());
                return r
            }, t.prototype.unbind = function() {
                var e, t, n, i, r;
                for (i = this.bindings, r = [], t = 0, n = i.length; n > t; t++) e = i[t], r.push(e.unbind());
                return r
            }, t.prototype.sync = function() {
                var e, t, n, i, r;
                for (i = this.bindings, r = [], t = 0, n = i.length; n > t; t++) e = i[t], r.push("function" == typeof e.sync ? e.sync() : void 0);
                return r
            }, t.prototype.publish = function() {
                var e, t, n, i, r;
                for (i = this.select(function(e) {
                        var t;
                        return null != (t = e.binder) ? t.publishes : void 0
                    }), r = [], t = 0, n = i.length; n > t; t++) e = i[t], r.push(e.publish());
                return r
            }, t.prototype.update = function(e) {
                var t, n, i, r, o, s, a;
                null == e && (e = {});
                for (n in e) i = e[n], this.models[n] = i;
                for (s = this.bindings, a = [], r = 0, o = s.length; o > r; r++) t = s[r], a.push("function" == typeof t.update ? t.update(e) : void 0);
                return a
            }, t
        }(), e.Binding = function() {
            function t(e, t, n, i, o) {
                this.view = e, this.el = t, this.type = n, this.keypath = i, this.options = null != o ? o : {}, this.getValue = r(this.getValue, this), this.update = r(this.update, this), this.unbind = r(this.unbind, this), this.bind = r(this.bind, this), this.publish = r(this.publish, this), this.sync = r(this.sync, this), this.set = r(this.set, this), this.eventHandler = r(this.eventHandler, this), this.formattedValue = r(this.formattedValue, this), this.parseTarget = r(this.parseTarget, this), this.observe = r(this.observe, this), this.setBinder = r(this.setBinder, this), this.formatters = this.options.formatters || [], this.dependencies = [], this.formatterObservers = {}, this.model = void 0, this.setBinder()
            }
            return t.prototype.setBinder = function() {
                var e, t, n, i;
                if (!(this.binder = this.view.binders[this.type])) {
                    i = this.view.binders;
                    for (e in i) n = i[e], "*" !== e && -1 !== e.indexOf("*") && (t = new RegExp("^" + e.replace(/\*/g, ".+") + "$"), t.test(this.type) && (this.binder = n, this.args = new RegExp("^" + e.replace(/\*/g, "(.+)") + "$").exec(this.type), this.args.shift()))
                }
                return this.binder || (this.binder = this.view.binders["*"]), this.binder instanceof Function ? this.binder = {
                    routine: this.binder
                } : void 0
            }, t.prototype.observe = function(t, n, i) {
                return e.sightglass(t, n, i, {
                    root: this.view.rootInterface,
                    adapters: this.view.adapters
                })
            }, t.prototype.parseTarget = function() {
                var t;
                return t = e.TypeParser.parse(this.keypath), 0 === t.type ? this.value = t.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync), this.model = this.observer.target)
            }, t.prototype.formattedValue = function(t) {
                var n, i, r, s, a, l, u, c, d, p, h, f, g, m;
                for (m = this.formatters, s = p = 0, f = m.length; f > p; s = ++p) {
                    for (a = m[s], r = a.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g), l = r.shift(), a = this.view.formatters[l], r = function() {
                            var t, n, o;
                            for (o = [], t = 0, n = r.length; n > t; t++) i = r[t], o.push(e.TypeParser.parse(i));
                            return o
                        }(), c = [], n = h = 0, g = r.length; g > h; n = ++h) i = r[n], c.push(0 === i.type ? i.value : ((d = this.formatterObservers)[s] || (d[s] = {}), (u = this.formatterObservers[s][n]) ? void 0 : (u = this.observe(this.view.models, i.value, this.sync), this.formatterObservers[s][n] = u), u.value()));
                    (null != a ? a.read : void 0) instanceof Function ? t = a.read.apply(a, [t].concat(o.call(c))) : a instanceof Function && (t = a.apply(null, [t].concat(o.call(c))))
                }
                return t
            }, t.prototype.eventHandler = function(e) {
                var t, n;
                return n = (t = this).view.handler,
                    function(i) {
                        return n.call(e, this, i, t)
                    }
            }, t.prototype.set = function(e) {
                var t;
                return e = this.formattedValue(e instanceof Function && !this.binder["function"] ? e.call(this.model) : e), null != (t = this.binder.routine) ? t.call(this, this.el, e) : void 0
            }, t.prototype.sync = function() {
                var e, t;
                return this.set(function() {
                    var n, i, r, o, s, a, l;
                    if (this.observer) {
                        if (this.model !== this.observer.target) {
                            for (s = this.dependencies, n = 0, r = s.length; r > n; n++) t = s[n], t.unobserve();
                            if (this.dependencies = [], null != (this.model = this.observer.target) && (null != (a = this.options.dependencies) ? a.length : void 0))
                                for (l = this.options.dependencies, i = 0, o = l.length; o > i; i++) e = l[i], t = this.observe(this.model, e, this.sync), this.dependencies.push(t)
                        }
                        return this.observer.value()
                    }
                    return this.value
                }.call(this))
            }, t.prototype.publish = function() {
                var e, t, n, i, r, s, a, l, u;
                if (this.observer) {
                    for (i = this.getValue(this.el), a = this.formatters.slice(0).reverse(), r = 0, s = a.length; s > r; r++) t = a[r], e = t.split(/\s+/), n = e.shift(), (null != (l = this.view.formatters[n]) ? l.publish : void 0) && (i = (u = this.view.formatters[n]).publish.apply(u, [i].concat(o.call(e))));
                    return this.observer.setValue(i)
                }
            }, t.prototype.bind = function() {
                var e, t, n, i, r, o, s;
                if (this.parseTarget(), null != (r = this.binder.bind) && r.call(this, this.el), null != this.model && (null != (o = this.options.dependencies) ? o.length : void 0))
                    for (s = this.options.dependencies, n = 0, i = s.length; i > n; n++) e = s[n], t = this.observe(this.model, e, this.sync), this.dependencies.push(t);
                return this.view.preloadData ? this.sync() : void 0
            }, t.prototype.unbind = function() {
                var e, t, n, i, r, o, s, a, l, u;
                for (null != (s = this.binder.unbind) && s.call(this, this.el), null != (a = this.observer) && a.unobserve(), l = this.dependencies, r = 0, o = l.length; o > r; r++) i = l[r], i.unobserve();
                this.dependencies = [], u = this.formatterObservers;
                for (n in u) {
                    t = u[n];
                    for (e in t) i = t[e], i.unobserve()
                }
                return this.formatterObservers = {}
            }, t.prototype.update = function(e) {
                var t, n;
                return null == e && (e = {}), this.model = null != (t = this.observer) ? t.target : void 0, null != (n = this.binder.update) ? n.call(this, e) : void 0
            }, t.prototype.getValue = function(t) {
                return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, t) : e.Util.getInputValue(t)
            }, t
        }(), e.ComponentBinding = function(t) {
            function n(e, t, n) {
                var i, o, s, a, u, c, d;
                for (this.view = e, this.el = t, this.type = n, this.unbind = r(this.unbind, this), this.bind = r(this.bind, this), this.locals = r(this.locals, this), this.component = this.view.components[this.type], this["static"] = {}, this.observers = {}, this.upstreamObservers = {}, o = e.bindingRegExp(), c = this.el.attributes || [], a = 0, u = c.length; u > a; a++) i = c[a], o.test(i.name) || (s = this.camelCase(i.name), l.call(null != (d = this.component["static"]) ? d : [], s) >= 0 ? this["static"][s] = i.value : this.observers[s] = i.value)
            }
            return a(n, t), n.prototype.sync = function() {}, n.prototype.update = function() {}, n.prototype.publish = function() {}, n.prototype.locals = function() {
                var e, t, n, i, r, o;
                n = {}, r = this["static"];
                for (e in r) i = r[e], n[e] = i;
                o = this.observers;
                for (e in o) t = o[e], n[e] = t.value();
                return n
            }, n.prototype.camelCase = function(e) {
                return e.replace(/-([a-z])/g, function(e) {
                    return e[1].toUpperCase()
                })
            }, n.prototype.bind = function() {
                var t, n, i, r, o, s, a, l, u, c, d, p, h, f, g, m, v, y, b, w, x;
                if (!this.bound) {
                    f = this.observers;
                    for (n in f) i = f[n], this.observers[n] = this.observe(this.view.models, i, function(e) {
                        return function(t) {
                            return function() {
                                return e.componentView.models[t] = e.observers[t].value()
                            }
                        }
                    }(this).call(this, n));
                    this.bound = !0
                }
                if (null != this.componentView) return this.componentView.bind();
                for (this.el.innerHTML = this.component.template.call(this), a = this.component.initialize.call(this, this.el, this.locals()), this.el._bound = !0, s = {}, g = e.extensions, c = 0, p = g.length; p > c; c++) {
                    if (o = g[c], s[o] = {}, this.component[o]) {
                        m = this.component[o];
                        for (t in m) l = m[t], s[o][t] = l
                    }
                    v = this.view[o];
                    for (t in v) l = v[t], null == (u = s[o])[t] && (u[t] = l)
                }
                for (y = e.options, d = 0, h = y.length; h > d; d++) o = y[d], s[o] = null != (b = this.component[o]) ? b : this.view[o];
                this.componentView = new e.View(this.el, a, s), this.componentView.bind(), w = this.observers, x = [];
                for (n in w) r = w[n], x.push(this.upstreamObservers[n] = this.observe(this.componentView.models, n, function(e) {
                    return function(t, n) {
                        return function() {
                            return n.setValue(e.componentView.models[t])
                        }
                    }
                }(this).call(this, n, r)));
                return x
            }, n.prototype.unbind = function() {
                var e, t, n, i, r;
                n = this.upstreamObservers;
                for (e in n) t = n[e], t.unobserve();
                i = this.observers;
                for (e in i) t = i[e], t.unobserve();
                return null != (r = this.componentView) ? r.unbind.call(this) : void 0
            }, n
        }(e.Binding), e.TextBinding = function(e) {
            function t(e, t, n, i, o) {
                this.view = e, this.el = t, this.type = n, this.keypath = i, this.options = null != o ? o : {}, this.sync = r(this.sync, this), this.formatters = this.options.formatters || [], this.dependencies = [], this.formatterObservers = {}
            }
            return a(t, e), t.prototype.binder = {
                routine: function(e, t) {
                    return e.data = null != t ? t : ""
                }
            }, t.prototype.sync = function() {
                return t.__super__.sync.apply(this, arguments)
            }, t
        }(e.Binding), e["public"].binders.text = function(e, t) {
            return null != e.textContent ? e.textContent = null != t ? t : "" : e.innerText = null != t ? t : ""
        }, e["public"].binders.html = function(e, t) {
            return e.innerHTML = null != t ? t : ""
        }, e["public"].binders.show = function(e, t) {
            return e.style.display = t ? "" : "none"
        }, e["public"].binders.hide = function(e, t) {
            return e.style.display = t ? "none" : ""
        }, e["public"].binders.enabled = function(e, t) {
            return e.disabled = !t
        }, e["public"].binders.disabled = function(e, t) {
            return e.disabled = !!t
        }, e["public"].binders.checked = {
            publishes: !0,
            priority: 2e3,
            bind: function(t) {
                return e.Util.bindEvent(t, "change", this.publish)
            },
            unbind: function(t) {
                return e.Util.unbindEvent(t, "change", this.publish)
            },
            routine: function(e, t) {
                var n;
                return e.checked = "radio" === e.type ? (null != (n = e.value) ? n.toString() : void 0) === (null != t ? t.toString() : void 0) : !!t
            }
        }, e["public"].binders.unchecked = {
            publishes: !0,
            priority: 2e3,
            bind: function(t) {
                return e.Util.bindEvent(t, "change", this.publish)
            },
            unbind: function(t) {
                return e.Util.unbindEvent(t, "change", this.publish)
            },
            routine: function(e, t) {
                var n;
                return e.checked = "radio" === e.type ? (null != (n = e.value) ? n.toString() : void 0) !== (null != t ? t.toString() : void 0) : !t
            }
        }, e["public"].binders.value = {
            publishes: !0,
            priority: 3e3,
            bind: function(t) {
                return "INPUT" !== t.tagName || "radio" !== t.type ? (this.event = "SELECT" === t.tagName ? "change" : "input", e.Util.bindEvent(t, this.event, this.publish)) : void 0
            },
            unbind: function(t) {
                return "INPUT" !== t.tagName || "radio" !== t.type ? e.Util.unbindEvent(t, this.event, this.publish) : void 0
            },
            routine: function(e, t) {
                var n, i, r, o, s, a, u;
                if ("INPUT" === e.tagName && "radio" === e.type) return e.setAttribute("value", t);
                if (null != window.jQuery) {
                    if (e = jQuery(e), (null != t ? t.toString() : void 0) !== (null != (o = e.val()) ? o.toString() : void 0)) return e.val(null != t ? t : "")
                } else if ("select-multiple" === e.type) {
                    if (null != t) {
                        for (u = [], i = 0, r = e.length; r > i; i++) n = e[i], u.push(n.selected = (s = n.value, l.call(t, s) >= 0));
                        return u
                    }
                } else if ((null != t ? t.toString() : void 0) !== (null != (a = e.value) ? a.toString() : void 0)) return e.value = null != t ? t : ""
            }
        }, e["public"].binders["if"] = {
            block: !0,
            priority: 4e3,
            bind: function(e) {
                var t, n;
                return null == this.marker ? (t = [this.view.prefix, this.type].join("-").replace("--", "-"), n = e.getAttribute(t), this.marker = document.createComment(" rivets: " + this.type + " " + n + " "), this.bound = !1, e.removeAttribute(t), e.parentNode.insertBefore(this.marker, e), e.parentNode.removeChild(e)) : void 0
            },
            unbind: function() {
                var e;
                return null != (e = this.nested) ? e.unbind() : void 0
            },
            routine: function(t, n) {
                var i, r, o, s;
                if (!!n == !this.bound) {
                    if (n) {
                        o = {}, s = this.view.models;
                        for (i in s) r = s[i], o[i] = r;
                        return (this.nested || (this.nested = new e.View(t, o, this.view.options()))).bind(), this.marker.parentNode.insertBefore(t, this.marker.nextSibling), this.bound = !0
                    }
                    return t.parentNode.removeChild(t), this.nested.unbind(), this.bound = !1
                }
            },
            update: function(e) {
                var t;
                return null != (t = this.nested) ? t.update(e) : void 0
            }
        }, e["public"].binders.unless = {
            block: !0,
            priority: 4e3,
            bind: function(t) {
                return e["public"].binders["if"].bind.call(this, t)
            },
            unbind: function() {
                return e["public"].binders["if"].unbind.call(this)
            },
            routine: function(t, n) {
                return e["public"].binders["if"].routine.call(this, t, !n)
            },
            update: function(t) {
                return e["public"].binders["if"].update.call(this, t)
            }
        }, e["public"].binders["on-*"] = {
            "function": !0,
            priority: 1e3,
            unbind: function(t) {
                return this.handler ? e.Util.unbindEvent(t, this.args[0], this.handler) : void 0
            },
            routine: function(t, n) {
                return this.handler && e.Util.unbindEvent(t, this.args[0], this.handler), e.Util.bindEvent(t, this.args[0], this.handler = this.eventHandler(n))
            }
        }, e["public"].binders["each-*"] = {
            block: !0,
            priority: 4e3,
            bind: function(e) {
                var t, n, i, r, o;
                if (null == this.marker) t = [this.view.prefix, this.type].join("-").replace("--", "-"), this.marker = document.createComment(" rivets: " + this.type + " "), this.iterated = [], e.removeAttribute(t), e.parentNode.insertBefore(this.marker, e), e.parentNode.removeChild(e);
                else
                    for (o = this.iterated, i = 0, r = o.length; r > i; i++) n = o[i], n.bind()
            },
            unbind: function() {
                var e, t, n, i, r;
                if (null != this.iterated) {
                    for (i = this.iterated, r = [], t = 0, n = i.length; n > t; t++) e = i[t], r.push(e.unbind());
                    return r
                }
            },
            routine: function(t, n) {
                var i, r, o, s, a, l, u, c, d, p, h, f, g, m, v, y, b, w, x, C, S;
                if (u = this.args[0], n = n || [], this.iterated.length > n.length)
                    for (w = Array(this.iterated.length - n.length), f = 0, v = w.length; v > f; f++) o = w[f], h = this.iterated.pop(), h.unbind(), this.marker.parentNode.removeChild(h.els[0]);
                for (s = g = 0, y = n.length; y > g; s = ++g)
                    if (l = n[s], r = {
                            index: s
                        }, r[u] = l, null == this.iterated[s]) {
                        x = this.view.models;
                        for (a in x) l = x[a], null == r[a] && (r[a] = l);
                        d = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker, c = this.view.options(), c.preloadData = !0, p = t.cloneNode(!0), h = new e.View(p, r, c), h.bind(), this.iterated.push(h), this.marker.parentNode.insertBefore(p, d.nextSibling)
                    } else this.iterated[s].models[u] !== l && this.iterated[s].update(r);
                if ("OPTION" === t.nodeName) {
                    for (C = this.view.bindings, S = [], m = 0, b = C.length; b > m; m++) i = C[m], S.push(i.el === this.marker.parentNode && "value" === i.type ? i.sync() : void 0);
                    return S
                }
            },
            update: function(e) {
                var t, n, i, r, o, s, a, l;
                t = {};
                for (n in e) i = e[n], n !== this.args[0] && (t[n] = i);
                for (a = this.iterated, l = [], o = 0, s = a.length; s > o; o++) r = a[o], l.push(r.update(t));
                return l
            }
        }, e["public"].binders["class-*"] = function(e, t) {
            var n;
            return n = " " + e.className + " ", !t == (-1 !== n.indexOf(" " + this.args[0] + " ")) ? e.className = t ? "" + e.className + " " + this.args[0] : n.replace(" " + this.args[0] + " ", " ").trim() : void 0
        }, e["public"].binders["*"] = function(e, t) {
            return null != t ? e.setAttribute(this.type, t) : e.removeAttribute(this.type)
        }, e["public"].adapters["."] = {
            id: "_rv",
            counter: 0,
            weakmap: {},
            weakReference: function(e) {
                var t, n, i;
                return e.hasOwnProperty(this.id) || (t = this.counter++, Object.defineProperty(e, this.id, {
                    value: t
                })), (n = this.weakmap)[i = e[this.id]] || (n[i] = {
                    callbacks: {}
                })
            },
            cleanupWeakReference: function(e, t) {
                return Object.keys(e.callbacks).length || e.pointers && Object.keys(e.pointers).length ? void 0 : delete this.weakmap[t]
            },
            stubFunction: function(e, t) {
                var n, i, r;
                return i = e[t], n = this.weakReference(e), r = this.weakmap, e[t] = function() {
                    var t, o, s, a, l, u, c, d, p, h;
                    a = i.apply(e, arguments), c = n.pointers;
                    for (s in c)
                        for (o = c[s], h = null != (d = null != (p = r[s]) ? p.callbacks[o] : void 0) ? d : [], l = 0, u = h.length; u > l; l++)(t = h[l])();
                    return a
                }
            },
            observeMutations: function(e, t, n) {
                var i, r, o, s, a, u;
                if (Array.isArray(e)) {
                    if (o = this.weakReference(e), null == o.pointers)
                        for (o.pointers = {}, r = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"], a = 0, u = r.length; u > a; a++) i = r[a], this.stubFunction(e, i);
                    if (null == (s = o.pointers)[t] && (s[t] = []), l.call(o.pointers[t], n) < 0) return o.pointers[t].push(n)
                }
            },
            unobserveMutations: function(e, t, n) {
                var i, r, o;
                return Array.isArray(e) && null != e[this.id] && (r = this.weakmap[e[this.id]]) && (o = r.pointers[t]) ? ((i = o.indexOf(n)) >= 0 && o.splice(i, 1), o.length || delete r.pointers[t], this.cleanupWeakReference(r, e[this.id])) : void 0
            },
            observe: function(e, t, n) {
                var i, r, o;
                return i = this.weakReference(e).callbacks, null == i[t] && (i[t] = [], r = Object.getOwnPropertyDescriptor(e, t), (null != r ? r.get : void 0) || (null != r ? r.set : void 0) || (o = e[t], Object.defineProperty(e, t, {
                    enumerable: !0,
                    get: function() {
                        return o
                    },
                    set: function(r) {
                        return function(s) {
                            var a, u, c, d;
                            if (s !== o && (r.unobserveMutations(o, e[r.id], t), o = s, a = r.weakmap[e[r.id]])) {
                                if (i = a.callbacks, i[t])
                                    for (d = i[t].slice(), u = 0, c = d.length; c > u; u++) n = d[u], l.call(i[t], n) >= 0 && n();
                                return r.observeMutations(s, e[r.id], t)
                            }
                        }
                    }(this)
                }))), l.call(i[t], n) < 0 && i[t].push(n), this.observeMutations(e[t], e[this.id], t)
            },
            unobserve: function(e, t, n) {
                var i, r, o;
                return (o = this.weakmap[e[this.id]]) && (i = o.callbacks[t]) ? ((r = i.indexOf(n)) >= 0 && (i.splice(r, 1), i.length || delete o.callbacks[t]), this.unobserveMutations(e[t], e[this.id], t), this.cleanupWeakReference(o, e[this.id])) : void 0
            },
            get: function(e, t) {
                return e[t]
            },
            set: function(e, t, n) {
                return e[t] = n
            }
        }, e.factory = function(t) {
            return e.sightglass = t, e["public"]._ = e, e["public"]
        }, "object" == typeof("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = e.factory(require("sightglass")) : "function" == typeof define && define.amd ? define(["sightglass"], function(t) {
            return this.rivets = e.factory(t)
        }) : this.rivets = e.factory(sightglass)
    }.call(this),
    function() {
        var e, t, n, i, r, o, s = function(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        };
        t = function() {
            function e() {
                this.update = s(this.update, this)
            }
            return e.prototype.update = function(e) {
                var t, n, r;
                for (n in e) r = e[n], "items" !== n && (this[n] = r);
                return this.items = function() {
                    var n, r, o, s;
                    for (o = e.items, s = [], n = 0, r = o.length; r > n; n++) t = o[n], s.push(new i(t));
                    return s
                }()
            }, e
        }(), i = function() {
            function e(e) {
                this.propertyArray = s(this.propertyArray, this), this.update = s(this.update, this), this.update(e)
            }
            return e.prototype.update = function(e) {
                var t, i;
                for (t in e) i = e[t], "properties" !== t && (this[t] = i);
                return this.properties = n.Utils.extend({}, e.properties)
            }, e.prototype.propertyArray = function() {
                var e, t, n, i;
                n = this.properties, i = [];
                for (e in n) t = n[e], i.push({
                    name: e,
                    value: t
                });
                return i
            }, e
        }(), n = {
            settings: {
                debug: !1,
                dataAPI: !0,
                requestBodyClass: null,
                rivetsModels: {},
                currency: null,
                moneyFormat: null,
                moneyWithCurrencyFormat: null,
                weightUnit: "g",
                weightPrecision: 0
            },
            cart: new t
        }, n.init = function(e, t) {
            return null == t && (t = {}), n.configure(t), n.Utils.log("Initialising CartJS."), n.cart.update(e), n.settings.dataAPI && (n.Utils.log('"dataAPI" setting is true, initialising Data API.'), n.Data.init()), n.settings.requestBodyClass && (n.Utils.log('"requestBodyClass" set, adding event listeners.'), jQuery(document).on("cart.requestStarted", function() {
                return jQuery("body").addClass(n.settings.requestBodyClass)
            }), jQuery(document).on("cart.requestComplete", function() {
                return jQuery("body").removeClass(n.settings.requestBodyClass)
            })), n.Rivets.init(), jQuery(document).trigger("cart.ready", [n.cart])
        }, n.configure = function(e) {
            return null == e && (e = {}), n.Utils.extend(n.settings, e)
        }, null == window.console && (window.console = {}, window.console.log = function() {}), n.Utils = {
            log: function() {
                return n.Utils.console(console.log, arguments)
            },
            error: function() {
                return n.Utils.console(console.error, arguments)
            },
            console: function(e, t) {
                return n.settings.debug && "undefined" != typeof console && null !== console ? (t = Array.prototype.slice.call(t), t.unshift("[CartJS]:"), e.apply(console, t)) : void 0
            },
            wrapKeys: function(e, t, n) {
                var i, r, o;
                null == t && (t = "properties"), o = {};
                for (i in e) r = e[i], o["" + t + "[" + i + "]"] = null != n ? n : r;
                return o
            },
            unwrapKeys: function(e, t, n) {
                var i, r, o, s;
                null == t && (t = "properties"), r = {};
                for (i in e) s = e[i], o = i.replace("" + t + "[", "").replace("]", ""), r[o] = null != n ? n : s;
                return r
            },
            extend: function(e, t) {
                var n, i;
                for (n in t) i = t[n], e[n] = i;
                return e
            },
            clone: function(e) {
                var t, n;
                if (null == e || "object" != typeof e) return e;
                n = new e.constructor;
                for (t in e) n[t] = clone(e[t]);
                return n
            },
            isArray: Array.isArray || function(e) {
                return "[object Array]" === {}.toString.call(e)
            },
            ensureArray: function(e) {
                return n.Utils.isArray(e) ? e : null != e ? [e] : []
            },
            formatMoney: function(e, t, i, r) {
                var o, s;
                return null == r && (r = ""), r || (r = n.settings.currency), null != window.Currency && r !== n.settings.currency && (e = Currency.convert(e, n.settings.currency, r), null != (null != (o = window.Currency) ? o.moneyFormats : void 0) && r in window.Currency.moneyFormats && (t = window.Currency.moneyFormats[r][i])), null != (null != (s = window.Shopify) ? s.formatMoney : void 0) ? Shopify.formatMoney(e, t) : e
            },
            getSizedImageUrl: function(e, t) {
                var n, i;
                return null != (null != (n = window.Shopify) && null != (i = n.Image) ? i.getSizedImageUrl : void 0) ? e ? Shopify.Image.getSizedImageUrl(e, t) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", t).replace("-_", "-") : e ? e : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
            }
        }, o = [], r = !1, n.Queue = {
            add: function(e, t, i) {
                var s;
                return null == i && (i = {}), s = {
                    url: e,
                    data: t,
                    type: i.type || "POST",
                    dataType: i.dataType || "json",
                    success: n.Utils.ensureArray(i.success),
                    error: n.Utils.ensureArray(i.error),
                    complete: n.Utils.ensureArray(i.complete)
                }, i.updateCart && s.success.push(n.cart.update), o.push(s), r ? void 0 : (jQuery(document).trigger("cart.requestStarted", [n.cart]), n.Queue.process())
            },
            process: function() {
                var e;
                return o.length ? (r = !0, e = o.shift(), e.complete = n.Queue.process, jQuery.ajax(e)) : (r = !1, void jQuery(document).trigger("cart.requestComplete", [n.cart]))
            }
        }, n.Core = {
            getCart: function(e) {
                return null == e && (e = {}), e.type = "GET", e.updateCart = !0, n.Queue.add("/cart.js", {}, e)
            },
            addItem: function(e, t, i, r) {
                var o;
                return null == t && (t = 1), null == i && (i = {}), null == r && (r = {}), o = n.Utils.wrapKeys(i), o.id = e, o.quantity = t, n.Queue.add("/cart/add.js", o, r), n.Core.getCart()
            },
            updateItem: function(e, t, i, r) {
                var o;
                return null == i && (i = {}), null == r && (r = {}), o = n.Utils.wrapKeys(i), o.line = e, null != t && (o.quantity = t), r.updateCart = !0, n.Queue.add("/cart/change.js", o, r)
            },
            removeItem: function(e, t) {
                return null == t && (t = {}), n.Core.updateItem(e, 0, {}, t)
            },
            updateItemById: function(e, t, i, r) {
                var o;
                return null == i && (i = {}), null == r && (r = {}), o = n.Utils.wrapKeys(i), o.id = e, null != t && (o.quantity = t), r.updateCart = !0, n.Queue.add("/cart/change.js", o, r)
            },
            updateItemQuantitiesById: function(e, t) {
                return null == e && (e = {}), null == t && (t = {}), t.updateCart = !0, n.Queue.add("/cart/update.js", {
                    updates: e
                }, t)
            },
            removeItemById: function(e, t) {
                var i;
                return null == t && (t = {}), i = {
                    id: e,
                    quantity: 0
                }, t.updateCart = !0, n.Queue.add("/cart/change.js", i, t)
            },
            clear: function(e) {
                return null == e && (e = {}), e.updateCart = !0, n.Queue.add("/cart/clear.js", {}, e)
            },
            getAttribute: function(e, t) {
                return e in n.cart.attributes ? n.cart.attributes[e] : t
            },
            setAttribute: function(e, t, i) {
                var r;
                return null == i && (i = {}), r = {}, r[e] = t, n.Core.setAttributes(r, i)
            },
            getAttributes: function() {
                return n.cart.attributes
            },
            setAttributes: function(e, t) {
                return null == e && (e = {}), null == t && (t = {}), t.updateCart = !0, n.Queue.add("/cart/update.js", n.Utils.wrapKeys(e, "attributes"), t)
            },
            clearAttributes: function(e) {
                return null == e && (e = {}), e.updateCart = !0, n.Queue.add("/cart/update.js", n.Utils.wrapKeys(n.Core.getAttributes(), "attributes", ""), e)
            },
            getNote: function() {
                return n.cart.note
            },
            setNote: function(e, t) {
                return null == t && (t = {}), t.updateCart = !0, n.Queue.add("/cart/update.js", {
                    note: e
                }, t)
            }
        }, e = null, n.Data = {
            init: function() {
                return e = jQuery(document), n.Data.setEventListeners("on"), n.Data.render(null, n.cart)
            },
            destroy: function() {
                return n.Data.setEventListeners("off")
            },
            setEventListeners: function(t) {
                return e[t]("click", "[data-cart-add]", n.Data.add), e[t]("click", "[data-cart-remove]", n.Data.remove), e[t]("click", "[data-cart-remove-id]", n.Data.removeById), e[t]("click", "[data-cart-update]", n.Data.update), e[t]("click", "[data-cart-update-id]", n.Data.updateById), e[t]("click", "[data-cart-clear]", n.Data.clear), e[t]("change", "[data-cart-toggle]", n.Data.toggle), e[t]("change", "[data-cart-toggle-attribute]", n.Data.toggleAttribute), e[t]("submit", "[data-cart-submit]", n.Data.submit), e[t]("cart.requestComplete", n.Data.render)
            },
            add: function(e) {
                var t;
                return e.preventDefault(), t = jQuery(this), n.Core.addItem(t.attr("data-cart-add"), t.attr("data-cart-quantity"))
            },
            remove: function(e) {
                var t;
                return e.preventDefault(), t = jQuery(this), n.Core.removeItem(t.attr("data-cart-remove"))
            },
            removeById: function(e) {
                var t;
                return e.preventDefault(), t = jQuery(this), n.Core.removeItemById(t.attr("data-cart-remove-id"))
            },
            update: function(e) {
                var t;
                return e.preventDefault(), t = jQuery(this), n.Core.updateItem(t.attr("data-cart-update"), t.attr("data-cart-quantity"))
            },
            updateById: function(e) {
                var t;
                return e.preventDefault(), t = jQuery(this), n.Core.updateItemById(t.attr("data-cart-update-id"), t.attr("data-cart-quantity"))
            },
            clear: function(e) {
                return e.preventDefault(), n.Core.clear()
            },
            toggle: function() {
                var e, t;
                return e = jQuery(this), t = e.attr("data-cart-toggle"), e.is(":checked") ? n.Core.addItem(t) : n.Core.removeItemById(t);
            },
            toggleAttribute: function() {
                var e, t;
                return e = jQuery(this), t = e.attr("data-cart-toggle-attribute"), n.Core.setAttribute(t, e.is(":checked") ? "Yes" : "")
            },
            submit: function(e) {
                var t, i, r, o;
                return e.preventDefault(), t = jQuery(this).serializeArray(), i = void 0, o = void 0, r = {}, jQuery.each(t, function(e, t) {
                    return "id" === t.name ? i = t.value : "quantity" === t.name ? o = t.value : r[t.name] = t.value
                }), n.Core.addItem(i, o, n.Utils.unwrapKeys(r))
            },
            render: function(e, t) {
                var i;
                return i = {
                    item_count: t.item_count,
                    total_price: t.total_price,
                    total_price_money: n.Utils.formatMoney(t.total_price, n.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                    total_price_money_with_currency: n.Utils.formatMoney(t.total_price, n.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
                }, jQuery("[data-cart-render]").each(function() {
                    var e;
                    return e = jQuery(this), e.html(i[e.attr("data-cart-render")])
                })
            }
        }, "rivets" in window ? (n.Rivets = {
            model: null,
            boundViews: [],
            init: function() {
                return n.Rivets.bindViews()
            },
            destroy: function() {
                return n.Rivets.unbindViews()
            },
            bindViews: function() {
                return n.Utils.log("Rivets.js is present, binding views."), n.Rivets.unbindViews(), n.Rivets.model = n.Utils.extend({
                    cart: n.cart
                }, n.settings.rivetsModels), null != window.Currency && (n.Rivets.model.Currency = window.Currency), jQuery("[data-cart-view]").each(function() {
                    var e;
                    return e = rivets.bind(jQuery(this), n.Rivets.model), n.Rivets.boundViews.push(e)
                })
            },
            unbindViews: function() {
                var e, t, i, r;
                for (r = n.Rivets.boundViews, t = 0, i = r.length; i > t; t++) e = r[t], e.unbind();
                return n.Rivets.boundViews = []
            }
        }, rivets.formatters.eq = function(e, t) {
            return e === t
        }, rivets.formatters.includes = function(e, t) {
            return e.indexOf(t) >= 0
        }, rivets.formatters.match = function(e, t, n) {
            return e.match(new RegExp(t, n))
        }, rivets.formatters.lt = function(e, t) {
            return t > e
        }, rivets.formatters.gt = function(e, t) {
            return e > t
        }, rivets.formatters.not = function(e) {
            return !e
        }, rivets.formatters.empty = function(e) {
            return !e.length
        }, rivets.formatters.plus = function(e, t) {
            return parseInt(e) + parseInt(t)
        }, rivets.formatters.minus = function(e, t) {
            return parseInt(e) - parseInt(t)
        }, rivets.formatters.prepend = function(e, t) {
            return t + e
        }, rivets.formatters.append = function(e, t) {
            return e + t
        }, rivets.formatters.slice = function(e, t, n) {
            return e.slice(t, n)
        }, rivets.formatters.pluralize = function(e, t, i) {
            return null == i && (i = t + "s"), n.Utils.isArray(e) && (e = e.length), 1 === e ? t : i
        }, rivets.formatters.array_element = function(e, t) {
            return e[t]
        }, rivets.formatters.array_first = function(e) {
            return e[0]
        }, rivets.formatters.array_last = function(e) {
            return e[e.length - 1]
        }, rivets.formatters.money = function(e, t) {
            return n.Utils.formatMoney(e, n.settings.moneyFormat, "money_format", t)
        }, rivets.formatters.money_with_currency = function(e, t) {
            return n.Utils.formatMoney(e, n.settings.moneyWithCurrencyFormat, "money_with_currency_format", t)
        }, rivets.formatters.weight = function(e) {
            switch (n.settings.weightUnit) {
                case "kg":
                    return (e / 1e3).toFixed(n.settings.weightPrecision);
                case "oz":
                    return (.035274 * e).toFixed(n.settings.weightPrecision);
                case "lb":
                    return (.00220462 * e).toFixed(n.settings.weightPrecision);
                default:
                    return e.toFixed(n.settings.weightPrecision)
            }
        }, rivets.formatters.weight_with_unit = function(e) {
            return rivets.formatters.weight(e) + n.settings.weightUnit
        }, rivets.formatters.product_image_size = function(e, t) {
            return n.Utils.getSizedImageUrl(e, t)
        }, rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency, rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit, rivets.formatters.productImageSize = rivets.formatters.product_image_size) : n.Rivets = {
            init: function() {},
            destroy: function() {}
        }, n.factory = function(e) {
            return e.init = n.init, e.configure = n.configure, e.cart = n.cart, e.settings = n.settings, e.getCart = n.Core.getCart, e.addItem = n.Core.addItem, e.updateItem = n.Core.updateItem, e.updateItemById = n.Core.updateItemById, e.updateItemQuantitiesById = n.Core.updateItemQuantitiesById, e.removeItem = n.Core.removeItem, e.removeItemById = n.Core.removeItemById, e.clear = n.Core.clear, e.getAttribute = n.Core.getAttribute, e.setAttribute = n.Core.setAttribute, e.getAttributes = n.Core.getAttributes, e.setAttributes = n.Core.setAttributes, e.clearAttributes = n.Core.clearAttributes, e.getNote = n.Core.getNote, e.setNote = n.Core.setNote, e.render = n.Data.render
        }, "object" == typeof exports ? n.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(e) {
            return n.factory(this.CartJS = e), e
        }) : n.factory(this.CartJS = {})
    }.call(this),
    /*! Hammer.JS - v2.0.7 - 2016-04-22
     * http://hammerjs.github.io/
     *
     * Copyright (c) 2016 Jorik Tangelder;
     * Licensed under the MIT license */
    ! function(e, t, n, i) {
        "use strict";

        function r(e, t, n) {
            return setTimeout(u(e, n), t)
        }

        function o(e, t, n) {
            return !!Array.isArray(e) && (s(e, n[t], n), !0)
        }

        function s(e, t, n) {
            var r;
            if (e)
                if (e.forEach) e.forEach(t, n);
                else if (e.length !== i)
                for (r = 0; r < e.length;) t.call(n, e[r], r, e), r++;
            else
                for (r in e) e.hasOwnProperty(r) && t.call(n, e[r], r, e)
        }

        function a(t, n, i) {
            var r = "DEPRECATED METHOD: " + n + "\n" + i + " AT \n";
            return function() {
                var n = new Error("get-stack-trace"),
                    i = n && n.stack ? n.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
                    o = e.console && (e.console.warn || e.console.log);
                return o && o.call(e.console, r, i), t.apply(this, arguments)
            }
        }

        function l(e, t, n) {
            var i, r = t.prototype;
            i = e.prototype = Object.create(r), i.constructor = e, i._super = r, n && de(i, n)
        }

        function u(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        }

        function c(e, t) {
            return typeof e == fe ? e.apply(t ? t[0] || i : i, t) : e
        }

        function d(e, t) {
            return e === i ? t : e
        }

        function p(e, t, n) {
            s(m(t), function(t) {
                e.addEventListener(t, n, !1)
            })
        }

        function h(e, t, n) {
            s(m(t), function(t) {
                e.removeEventListener(t, n, !1)
            })
        }

        function f(e, t) {
            for (; e;) {
                if (e == t) return !0;
                e = e.parentNode
            }
            return !1
        }

        function g(e, t) {
            return e.indexOf(t) > -1
        }

        function m(e) {
            return e.trim().split(/\s+/g)
        }

        function v(e, t, n) {
            if (e.indexOf && !n) return e.indexOf(t);
            for (var i = 0; i < e.length;) {
                if (n && e[i][n] == t || !n && e[i] === t) return i;
                i++
            }
            return -1
        }

        function y(e) {
            return Array.prototype.slice.call(e, 0)
        }

        function b(e, t, n) {
            for (var i = [], r = [], o = 0; o < e.length;) {
                var s = t ? e[o][t] : e[o];
                v(r, s) < 0 && i.push(e[o]), r[o] = s, o++
            }
            return n && (i = t ? i.sort(function(e, n) {
                return e[t] > n[t]
            }) : i.sort()), i
        }

        function w(e, t) {
            for (var n, r, o = t[0].toUpperCase() + t.slice(1), s = 0; s < pe.length;) {
                if (n = pe[s], r = n ? n + o : t, r in e) return r;
                s++
            }
            return i
        }

        function x() {
            return we++
        }

        function C(t) {
            var n = t.ownerDocument || t;
            return n.defaultView || n.parentWindow || e
        }

        function S(e, t) {
            var n = this;
            this.manager = e, this.callback = t, this.element = e.element, this.target = e.options.inputTarget, this.domHandler = function(t) {
                c(e.options.enable, [e]) && n.handler(t)
            }, this.init()
        }

        function _(e) {
            var t, n = e.options.inputClass;
            return new(t = n ? n : Se ? q : _e ? H : Ce ? M : F)(e, T)
        }

        function T(e, t, n) {
            var i = n.pointers.length,
                r = n.changedPointers.length,
                o = t & Ie && i - r === 0,
                s = t & (ze | Ne) && i - r === 0;
            n.isFirst = !!o, n.isFinal = !!s, o && (e.session = {}), n.eventType = t, A(e, n), e.emit("hammer.input", n), e.recognize(n), e.session.prevInput = n
        }

        function A(e, t) {
            var n = e.session,
                i = t.pointers,
                r = i.length;
            n.firstInput || (n.firstInput = E(t)), r > 1 && !n.firstMultiple ? n.firstMultiple = E(t) : 1 === r && (n.firstMultiple = !1);
            var o = n.firstInput,
                s = n.firstMultiple,
                a = s ? s.center : o.center,
                l = t.center = I(i);
            t.timeStamp = ve(), t.deltaTime = t.timeStamp - o.timeStamp, t.angle = j(a, l), t.distance = N(a, l), k(n, t), t.offsetDirection = z(t.deltaX, t.deltaY);
            var u = O(t.deltaTime, t.deltaX, t.deltaY);
            t.overallVelocityX = u.x, t.overallVelocityY = u.y, t.overallVelocity = me(u.x) > me(u.y) ? u.x : u.y, t.scale = s ? D(s.pointers, i) : 1, t.rotation = s ? $(s.pointers, i) : 0, t.maxPointers = n.prevInput ? t.pointers.length > n.prevInput.maxPointers ? t.pointers.length : n.prevInput.maxPointers : t.pointers.length, P(n, t);
            var c = e.element;
            f(t.srcEvent.target, c) && (c = t.srcEvent.target), t.target = c
        }

        function k(e, t) {
            var n = t.center,
                i = e.offsetDelta || {},
                r = e.prevDelta || {},
                o = e.prevInput || {};
            t.eventType !== Ie && o.eventType !== ze || (r = e.prevDelta = {
                x: o.deltaX || 0,
                y: o.deltaY || 0
            }, i = e.offsetDelta = {
                x: n.x,
                y: n.y
            }), t.deltaX = r.x + (n.x - i.x), t.deltaY = r.y + (n.y - i.y)
        }

        function P(e, t) {
            var n, r, o, s, a = e.lastInterval || t,
                l = t.timeStamp - a.timeStamp;
            if (t.eventType != Ne && (l > Ee || a.velocity === i)) {
                var u = t.deltaX - a.deltaX,
                    c = t.deltaY - a.deltaY,
                    d = O(l, u, c);
                r = d.x, o = d.y, n = me(d.x) > me(d.y) ? d.x : d.y, s = z(u, c), e.lastInterval = t
            } else n = a.velocity, r = a.velocityX, o = a.velocityY, s = a.direction;
            t.velocity = n, t.velocityX = r, t.velocityY = o, t.direction = s
        }

        function E(e) {
            for (var t = [], n = 0; n < e.pointers.length;) t[n] = {
                clientX: ge(e.pointers[n].clientX),
                clientY: ge(e.pointers[n].clientY)
            }, n++;
            return {
                timeStamp: ve(),
                pointers: t,
                center: I(t),
                deltaX: e.deltaX,
                deltaY: e.deltaY
            }
        }

        function I(e) {
            var t = e.length;
            if (1 === t) return {
                x: ge(e[0].clientX),
                y: ge(e[0].clientY)
            };
            for (var n = 0, i = 0, r = 0; t > r;) n += e[r].clientX, i += e[r].clientY, r++;
            return {
                x: ge(n / t),
                y: ge(i / t)
            }
        }

        function O(e, t, n) {
            return {
                x: t / e || 0,
                y: n / e || 0
            }
        }

        function z(e, t) {
            return e === t ? je : me(e) >= me(t) ? 0 > e ? $e : De : 0 > t ? Fe : qe
        }

        function N(e, t, n) {
            n || (n = Ve);
            var i = t[n[0]] - e[n[0]],
                r = t[n[1]] - e[n[1]];
            return Math.sqrt(i * i + r * r)
        }

        function j(e, t, n) {
            n || (n = Ve);
            var i = t[n[0]] - e[n[0]],
                r = t[n[1]] - e[n[1]];
            return 180 * Math.atan2(r, i) / Math.PI
        }

        function $(e, t) {
            return j(t[1], t[0], Me) + j(e[1], e[0], Me)
        }

        function D(e, t) {
            return N(t[0], t[1], Me) / N(e[0], e[1], Me)
        }

        function F() {
            this.evEl = Be, this.evWin = Ue, this.pressed = !1, S.apply(this, arguments)
        }

        function q() {
            this.evEl = Ye, this.evWin = Ge, S.apply(this, arguments), this.store = this.manager.session.pointerEvents = []
        }

        function L() {
            this.evTarget = Ke, this.evWin = Je, this.started = !1, S.apply(this, arguments)
        }

        function R(e, t) {
            var n = y(e.touches),
                i = y(e.changedTouches);
            return t & (ze | Ne) && (n = b(n.concat(i), "identifier", !0)), [n, i]
        }

        function H() {
            this.evTarget = tt, this.targetIds = {}, S.apply(this, arguments)
        }

        function V(e, t) {
            var n = y(e.touches),
                i = this.targetIds;
            if (t & (Ie | Oe) && 1 === n.length) return i[n[0].identifier] = !0, [n, n];
            var r, o, s = y(e.changedTouches),
                a = [],
                l = this.target;
            if (o = n.filter(function(e) {
                    return f(e.target, l)
                }), t === Ie)
                for (r = 0; r < o.length;) i[o[r].identifier] = !0, r++;
            for (r = 0; r < s.length;) i[s[r].identifier] && a.push(s[r]), t & (ze | Ne) && delete i[s[r].identifier], r++;
            return a.length ? [b(o.concat(a), "identifier", !0), a] : void 0
        }

        function M() {
            S.apply(this, arguments);
            var e = u(this.handler, this);
            this.touch = new H(this.manager, e), this.mouse = new F(this.manager, e), this.primaryTouch = null, this.lastTouches = []
        }

        function W(e, t) {
            e & Ie ? (this.primaryTouch = t.changedPointers[0].identifier, B.call(this, t)) : e & (ze | Ne) && B.call(this, t)
        }

        function B(e) {
            var t = e.changedPointers[0];
            if (t.identifier === this.primaryTouch) {
                var n = {
                    x: t.clientX,
                    y: t.clientY
                };
                this.lastTouches.push(n);
                var i = this.lastTouches,
                    r = function() {
                        var e = i.indexOf(n);
                        e > -1 && i.splice(e, 1)
                    };
                setTimeout(r, nt)
            }
        }

        function U(e) {
            for (var t = e.srcEvent.clientX, n = e.srcEvent.clientY, i = 0; i < this.lastTouches.length; i++) {
                var r = this.lastTouches[i],
                    o = Math.abs(t - r.x),
                    s = Math.abs(n - r.y);
                if (it >= o && it >= s) return !0
            }
            return !1
        }

        function Q(e, t) {
            this.manager = e, this.set(t)
        }

        function X(e) {
            if (g(e, ut)) return ut;
            var t = g(e, ct),
                n = g(e, dt);
            return t && n ? ut : t || n ? t ? ct : dt : g(e, lt) ? lt : at
        }

        function Y() {
            if (!ot) return !1;
            var t = {},
                n = e.CSS && e.CSS.supports;
            return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(i) {
                t[i] = !n || e.CSS.supports("touch-action", i)
            }), t
        }

        function G(e) {
            this.options = de({}, this.defaults, e || {}), this.id = x(), this.manager = null, this.options.enable = d(this.options.enable, !0), this.state = ht, this.simultaneous = {}, this.requireFail = []
        }

        function Z(e) {
            return e & yt ? "cancel" : e & mt ? "end" : e & gt ? "move" : e & ft ? "start" : ""
        }

        function K(e) {
            return e == qe ? "down" : e == Fe ? "up" : e == $e ? "left" : e == De ? "right" : ""
        }

        function J(e, t) {
            var n = t.manager;
            return n ? n.get(e) : e
        }

        function ee() {
            G.apply(this, arguments)
        }

        function te() {
            ee.apply(this, arguments), this.pX = null, this.pY = null
        }

        function ne() {
            ee.apply(this, arguments)
        }

        function ie() {
            G.apply(this, arguments), this._timer = null, this._input = null
        }

        function re() {
            ee.apply(this, arguments)
        }

        function oe() {
            ee.apply(this, arguments)
        }

        function se() {
            G.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0
        }

        function ae(e, t) {
            return t = t || {}, t.recognizers = d(t.recognizers, ae.defaults.preset), new le(e, t)
        }

        function le(e, t) {
            this.options = de({}, ae.defaults, t || {}), this.options.inputTarget = this.options.inputTarget || e, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = e, this.input = _(this), this.touchAction = new Q(this, this.options.touchAction), ue(this, !0), s(this.options.recognizers, function(e) {
                var t = this.add(new e[0](e[1]));
                e[2] && t.recognizeWith(e[2]), e[3] && t.requireFailure(e[3])
            }, this)
        }

        function ue(e, t) {
            var n = e.element;
            if (n.style) {
                var i;
                s(e.options.cssProps, function(r, o) {
                    i = w(n.style, o), t ? (e.oldCssProps[i] = n.style[i], n.style[i] = r) : n.style[i] = e.oldCssProps[i] || ""
                }), t || (e.oldCssProps = {})
            }
        }

        function ce(e, n) {
            var i = t.createEvent("Event");
            i.initEvent(e, !0, !0), i.gesture = n, n.target.dispatchEvent(i)
        }
        var de, pe = ["", "webkit", "Moz", "MS", "ms", "o"],
            he = t.createElement("div"),
            fe = "function",
            ge = Math.round,
            me = Math.abs,
            ve = Date.now;
        de = "function" != typeof Object.assign ? function(e) {
            if (e === i || null === e) throw new TypeError("Cannot convert undefined or null to object");
            for (var t = Object(e), n = 1; n < arguments.length; n++) {
                var r = arguments[n];
                if (r !== i && null !== r)
                    for (var o in r) r.hasOwnProperty(o) && (t[o] = r[o])
            }
            return t
        } : Object.assign;
        var ye = a(function(e, t, n) {
                for (var r = Object.keys(t), o = 0; o < r.length;)(!n || n && e[r[o]] === i) && (e[r[o]] = t[r[o]]), o++;
                return e
            }, "extend", "Use `assign`."),
            be = a(function(e, t) {
                return ye(e, t, !0)
            }, "merge", "Use `assign`."),
            we = 1,
            xe = /mobile|tablet|ip(ad|hone|od)|android/i,
            Ce = "ontouchstart" in e,
            Se = w(e, "PointerEvent") !== i,
            _e = Ce && xe.test(navigator.userAgent),
            Te = "touch",
            Ae = "pen",
            ke = "mouse",
            Pe = "kinect",
            Ee = 25,
            Ie = 1,
            Oe = 2,
            ze = 4,
            Ne = 8,
            je = 1,
            $e = 2,
            De = 4,
            Fe = 8,
            qe = 16,
            Le = $e | De,
            Re = Fe | qe,
            He = Le | Re,
            Ve = ["x", "y"],
            Me = ["clientX", "clientY"];
        S.prototype = {
            handler: function() {},
            init: function() {
                this.evEl && p(this.element, this.evEl, this.domHandler), this.evTarget && p(this.target, this.evTarget, this.domHandler), this.evWin && p(C(this.element), this.evWin, this.domHandler)
            },
            destroy: function() {
                this.evEl && h(this.element, this.evEl, this.domHandler), this.evTarget && h(this.target, this.evTarget, this.domHandler), this.evWin && h(C(this.element), this.evWin, this.domHandler)
            }
        };
        var We = {
                mousedown: Ie,
                mousemove: Oe,
                mouseup: ze
            },
            Be = "mousedown",
            Ue = "mousemove mouseup";
        l(F, S, {
            handler: function(e) {
                var t = We[e.type];
                t & Ie && 0 === e.button && (this.pressed = !0), t & Oe && 1 !== e.which && (t = ze), this.pressed && (t & ze && (this.pressed = !1), this.callback(this.manager, t, {
                    pointers: [e],
                    changedPointers: [e],
                    pointerType: ke,
                    srcEvent: e
                }))
            }
        });
        var Qe = {
                pointerdown: Ie,
                pointermove: Oe,
                pointerup: ze,
                pointercancel: Ne,
                pointerout: Ne
            },
            Xe = {
                2: Te,
                3: Ae,
                4: ke,
                5: Pe
            },
            Ye = "pointerdown",
            Ge = "pointermove pointerup pointercancel";
        e.MSPointerEvent && !e.PointerEvent && (Ye = "MSPointerDown", Ge = "MSPointerMove MSPointerUp MSPointerCancel"), l(q, S, {
            handler: function(e) {
                var t = this.store,
                    n = !1,
                    i = e.type.toLowerCase().replace("ms", ""),
                    r = Qe[i],
                    o = Xe[e.pointerType] || e.pointerType,
                    s = o == Te,
                    a = v(t, e.pointerId, "pointerId");
                r & Ie && (0 === e.button || s) ? 0 > a && (t.push(e), a = t.length - 1) : r & (ze | Ne) && (n = !0), 0 > a || (t[a] = e, this.callback(this.manager, r, {
                    pointers: t,
                    changedPointers: [e],
                    pointerType: o,
                    srcEvent: e
                }), n && t.splice(a, 1))
            }
        });
        var Ze = {
                touchstart: Ie,
                touchmove: Oe,
                touchend: ze,
                touchcancel: Ne
            },
            Ke = "touchstart",
            Je = "touchstart touchmove touchend touchcancel";
        l(L, S, {
            handler: function(e) {
                var t = Ze[e.type];
                if (t === Ie && (this.started = !0), this.started) {
                    var n = R.call(this, e, t);
                    t & (ze | Ne) && n[0].length - n[1].length === 0 && (this.started = !1), this.callback(this.manager, t, {
                        pointers: n[0],
                        changedPointers: n[1],
                        pointerType: Te,
                        srcEvent: e
                    })
                }
            }
        });
        var et = {
                touchstart: Ie,
                touchmove: Oe,
                touchend: ze,
                touchcancel: Ne
            },
            tt = "touchstart touchmove touchend touchcancel";
        l(H, S, {
            handler: function(e) {
                var t = et[e.type],
                    n = V.call(this, e, t);
                n && this.callback(this.manager, t, {
                    pointers: n[0],
                    changedPointers: n[1],
                    pointerType: Te,
                    srcEvent: e
                })
            }
        });
        var nt = 2500,
            it = 25;
        l(M, S, {
            handler: function(e, t, n) {
                var i = n.pointerType == Te,
                    r = n.pointerType == ke;
                if (!(r && n.sourceCapabilities && n.sourceCapabilities.firesTouchEvents)) {
                    if (i) W.call(this, t, n);
                    else if (r && U.call(this, n)) return;
                    this.callback(e, t, n)
                }
            },
            destroy: function() {
                this.touch.destroy(), this.mouse.destroy()
            }
        });
        var rt = w(he.style, "touchAction"),
            ot = rt !== i,
            st = "compute",
            at = "auto",
            lt = "manipulation",
            ut = "none",
            ct = "pan-x",
            dt = "pan-y",
            pt = Y();
        Q.prototype = {
            set: function(e) {
                e == st && (e = this.compute()), ot && this.manager.element.style && pt[e] && (this.manager.element.style[rt] = e), this.actions = e.toLowerCase().trim()
            },
            update: function() {
                this.set(this.manager.options.touchAction)
            },
            compute: function() {
                var e = [];
                return s(this.manager.recognizers, function(t) {
                    c(t.options.enable, [t]) && (e = e.concat(t.getTouchAction()))
                }), X(e.join(" "))
            },
            preventDefaults: function(e) {
                var t = e.srcEvent,
                    n = e.offsetDirection;
                if (this.manager.session.prevented) return void t.preventDefault();
                var i = this.actions,
                    r = g(i, ut) && !pt[ut],
                    o = g(i, dt) && !pt[dt],
                    s = g(i, ct) && !pt[ct];
                if (r) {
                    var a = 1 === e.pointers.length,
                        l = e.distance < 2,
                        u = e.deltaTime < 250;
                    if (a && l && u) return
                }
                return s && o ? void 0 : r || o && n & Le || s && n & Re ? this.preventSrc(t) : void 0
            },
            preventSrc: function(e) {
                this.manager.session.prevented = !0, e.preventDefault()
            }
        };
        var ht = 1,
            ft = 2,
            gt = 4,
            mt = 8,
            vt = mt,
            yt = 16,
            bt = 32;
        G.prototype = {
            defaults: {},
            set: function(e) {
                return de(this.options, e), this.manager && this.manager.touchAction.update(), this
            },
            recognizeWith: function(e) {
                if (o(e, "recognizeWith", this)) return this;
                var t = this.simultaneous;
                return e = J(e, this), t[e.id] || (t[e.id] = e, e.recognizeWith(this)), this
            },
            dropRecognizeWith: function(e) {
                return o(e, "dropRecognizeWith", this) ? this : (e = J(e, this), delete this.simultaneous[e.id], this)
            },
            requireFailure: function(e) {
                if (o(e, "requireFailure", this)) return this;
                var t = this.requireFail;
                return e = J(e, this), -1 === v(t, e) && (t.push(e), e.requireFailure(this)), this
            },
            dropRequireFailure: function(e) {
                if (o(e, "dropRequireFailure", this)) return this;
                e = J(e, this);
                var t = v(this.requireFail, e);
                return t > -1 && this.requireFail.splice(t, 1), this
            },
            hasRequireFailures: function() {
                return this.requireFail.length > 0
            },
            canRecognizeWith: function(e) {
                return !!this.simultaneous[e.id]
            },
            emit: function(e) {
                function t(t) {
                    n.manager.emit(t, e)
                }
                var n = this,
                    i = this.state;
                mt > i && t(n.options.event + Z(i)), t(n.options.event), e.additionalEvent && t(e.additionalEvent), i >= mt && t(n.options.event + Z(i))
            },
            tryEmit: function(e) {
                return this.canEmit() ? this.emit(e) : void(this.state = bt)
            },
            canEmit: function() {
                for (var e = 0; e < this.requireFail.length;) {
                    if (!(this.requireFail[e].state & (bt | ht))) return !1;
                    e++
                }
                return !0
            },
            recognize: function(e) {
                var t = de({}, e);
                return c(this.options.enable, [this, t]) ? (this.state & (vt | yt | bt) && (this.state = ht), this.state = this.process(t), void(this.state & (ft | gt | mt | yt) && this.tryEmit(t))) : (this.reset(), void(this.state = bt))
            },
            process: function(e) {},
            getTouchAction: function() {},
            reset: function() {}
        }, l(ee, G, {
            defaults: {
                pointers: 1
            },
            attrTest: function(e) {
                var t = this.options.pointers;
                return 0 === t || e.pointers.length === t
            },
            process: function(e) {
                var t = this.state,
                    n = e.eventType,
                    i = t & (ft | gt),
                    r = this.attrTest(e);
                return i && (n & Ne || !r) ? t | yt : i || r ? n & ze ? t | mt : t & ft ? t | gt : ft : bt
            }
        }), l(te, ee, {
            defaults: {
                event: "pan",
                threshold: 10,
                pointers: 1,
                direction: He
            },
            getTouchAction: function() {
                var e = this.options.direction,
                    t = [];
                return e & Le && t.push(dt), e & Re && t.push(ct), t
            },
            directionTest: function(e) {
                var t = this.options,
                    n = !0,
                    i = e.distance,
                    r = e.direction,
                    o = e.deltaX,
                    s = e.deltaY;
                return r & t.direction || (t.direction & Le ? (r = 0 === o ? je : 0 > o ? $e : De, n = o != this.pX, i = Math.abs(e.deltaX)) : (r = 0 === s ? je : 0 > s ? Fe : qe, n = s != this.pY, i = Math.abs(e.deltaY))), e.direction = r, n && i > t.threshold && r & t.direction
            },
            attrTest: function(e) {
                return ee.prototype.attrTest.call(this, e) && (this.state & ft || !(this.state & ft) && this.directionTest(e))
            },
            emit: function(e) {
                this.pX = e.deltaX, this.pY = e.deltaY;
                var t = K(e.direction);
                t && (e.additionalEvent = this.options.event + t), this._super.emit.call(this, e)
            }
        }), l(ne, ee, {
            defaults: {
                event: "pinch",
                threshold: 0,
                pointers: 2
            },
            getTouchAction: function() {
                return [ut]
            },
            attrTest: function(e) {
                return this._super.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || this.state & ft)
            },
            emit: function(e) {
                if (1 !== e.scale) {
                    var t = e.scale < 1 ? "in" : "out";
                    e.additionalEvent = this.options.event + t
                }
                this._super.emit.call(this, e)
            }
        }), l(ie, G, {
            defaults: {
                event: "press",
                pointers: 1,
                time: 251,
                threshold: 9
            },
            getTouchAction: function() {
                return [at]
            },
            process: function(e) {
                var t = this.options,
                    n = e.pointers.length === t.pointers,
                    i = e.distance < t.threshold,
                    o = e.deltaTime > t.time;
                if (this._input = e, !i || !n || e.eventType & (ze | Ne) && !o) this.reset();
                else if (e.eventType & Ie) this.reset(), this._timer = r(function() {
                    this.state = vt, this.tryEmit()
                }, t.time, this);
                else if (e.eventType & ze) return vt;
                return bt
            },
            reset: function() {
                clearTimeout(this._timer)
            },
            emit: function(e) {
                this.state === vt && (e && e.eventType & ze ? this.manager.emit(this.options.event + "up", e) : (this._input.timeStamp = ve(), this.manager.emit(this.options.event, this._input)))
            }
        }), l(re, ee, {
            defaults: {
                event: "rotate",
                threshold: 0,
                pointers: 2
            },
            getTouchAction: function() {
                return [ut]
            },
            attrTest: function(e) {
                return this._super.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || this.state & ft)
            }
        }), l(oe, ee, {
            defaults: {
                event: "swipe",
                threshold: 10,
                velocity: .3,
                direction: Le | Re,
                pointers: 1
            },
            getTouchAction: function() {
                return te.prototype.getTouchAction.call(this)
            },
            attrTest: function(e) {
                var t, n = this.options.direction;
                return n & (Le | Re) ? t = e.overallVelocity : n & Le ? t = e.overallVelocityX : n & Re && (t = e.overallVelocityY), this._super.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers == this.options.pointers && me(t) > this.options.velocity && e.eventType & ze
            },
            emit: function(e) {
                var t = K(e.offsetDirection);
                t && this.manager.emit(this.options.event + t, e), this.manager.emit(this.options.event, e)
            }
        }), l(se, G, {
            defaults: {
                event: "tap",
                pointers: 1,
                taps: 1,
                interval: 300,
                time: 250,
                threshold: 9,
                posThreshold: 10
            },
            getTouchAction: function() {
                return [lt]
            },
            process: function(e) {
                var t = this.options,
                    n = e.pointers.length === t.pointers,
                    i = e.distance < t.threshold,
                    o = e.deltaTime < t.time;
                if (this.reset(), e.eventType & Ie && 0 === this.count) return this.failTimeout();
                if (i && o && n) {
                    if (e.eventType != ze) return this.failTimeout();
                    var s = !this.pTime || e.timeStamp - this.pTime < t.interval,
                        a = !this.pCenter || N(this.pCenter, e.center) < t.posThreshold;
                    this.pTime = e.timeStamp, this.pCenter = e.center, a && s ? this.count += 1 : this.count = 1, this._input = e;
                    var l = this.count % t.taps;
                    if (0 === l) return this.hasRequireFailures() ? (this._timer = r(function() {
                        this.state = vt, this.tryEmit()
                    }, t.interval, this), ft) : vt
                }
                return bt
            },
            failTimeout: function() {
                return this._timer = r(function() {
                    this.state = bt
                }, this.options.interval, this), bt
            },
            reset: function() {
                clearTimeout(this._timer)
            },
            emit: function() {
                this.state == vt && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input))
            }
        }), ae.VERSION = "2.0.7", ae.defaults = {
            domEvents: !1,
            touchAction: st,
            enable: !0,
            inputTarget: null,
            inputClass: null,
            preset: [
                [re, {
                    enable: !1
                }],
                [ne, {
                        enable: !1
                    },
                    ["rotate"]
                ],
                [oe, {
                    direction: Le
                }],
                [te, {
                        direction: Le
                    },
                    ["swipe"]
                ],
                [se],
                [se, {
                        event: "doubletap",
                        taps: 2
                    },
                    ["tap"]
                ],
                [ie]
            ],
            cssProps: {
                userSelect: "none",
                touchSelect: "none",
                touchCallout: "none",
                contentZooming: "none",
                userDrag: "none",
                tapHighlightColor: "rgba(0,0,0,0)"
            }
        };
        var wt = 1,
            xt = 2;
        le.prototype = {
            set: function(e) {
                return de(this.options, e), e.touchAction && this.touchAction.update(), e.inputTarget && (this.input.destroy(), this.input.target = e.inputTarget, this.input.init()), this
            },
            stop: function(e) {
                this.session.stopped = e ? xt : wt
            },
            recognize: function(e) {
                var t = this.session;
                if (!t.stopped) {
                    this.touchAction.preventDefaults(e);
                    var n, i = this.recognizers,
                        r = t.curRecognizer;
                    (!r || r && r.state & vt) && (r = t.curRecognizer = null);
                    for (var o = 0; o < i.length;) n = i[o], t.stopped === xt || r && n != r && !n.canRecognizeWith(r) ? n.reset() : n.recognize(e), !r && n.state & (ft | gt | mt) && (r = t.curRecognizer = n), o++
                }
            },
            get: function(e) {
                if (e instanceof G) return e;
                for (var t = this.recognizers, n = 0; n < t.length; n++)
                    if (t[n].options.event == e) return t[n];
                return null
            },
            add: function(e) {
                if (o(e, "add", this)) return this;
                var t = this.get(e.options.event);
                return t && this.remove(t), this.recognizers.push(e), e.manager = this, this.touchAction.update(), e
            },
            remove: function(e) {
                if (o(e, "remove", this)) return this;
                if (e = this.get(e)) {
                    var t = this.recognizers,
                        n = v(t, e); - 1 !== n && (t.splice(n, 1), this.touchAction.update())
                }
                return this
            },
            on: function(e, t) {
                if (e !== i && t !== i) {
                    var n = this.handlers;
                    return s(m(e), function(e) {
                        n[e] = n[e] || [], n[e].push(t)
                    }), this
                }
            },
            off: function(e, t) {
                if (e !== i) {
                    var n = this.handlers;
                    return s(m(e), function(e) {
                        t ? n[e] && n[e].splice(v(n[e], t), 1) : delete n[e]
                    }), this
                }
            },
            emit: function(e, t) {
                this.options.domEvents && ce(e, t);
                var n = this.handlers[e] && this.handlers[e].slice();
                if (n && n.length) {
                    t.type = e, t.preventDefault = function() {
                        t.srcEvent.preventDefault()
                    };
                    for (var i = 0; i < n.length;) n[i](t), i++
                }
            },
            destroy: function() {
                this.element && ue(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null
            }
        }, de(ae, {
            INPUT_START: Ie,
            INPUT_MOVE: Oe,
            INPUT_END: ze,
            INPUT_CANCEL: Ne,
            STATE_POSSIBLE: ht,
            STATE_BEGAN: ft,
            STATE_CHANGED: gt,
            STATE_ENDED: mt,
            STATE_RECOGNIZED: vt,
            STATE_CANCELLED: yt,
            STATE_FAILED: bt,
            DIRECTION_NONE: je,
            DIRECTION_LEFT: $e,
            DIRECTION_RIGHT: De,
            DIRECTION_UP: Fe,
            DIRECTION_DOWN: qe,
            DIRECTION_HORIZONTAL: Le,
            DIRECTION_VERTICAL: Re,
            DIRECTION_ALL: He,
            Manager: le,
            Input: S,
            TouchAction: Q,
            TouchInput: H,
            MouseInput: F,
            PointerEventInput: q,
            TouchMouseInput: M,
            SingleTouchInput: L,
            Recognizer: G,
            AttrRecognizer: ee,
            Tap: se,
            Pan: te,
            Swipe: oe,
            Pinch: ne,
            Rotate: re,
            Press: ie,
            on: p,
            off: h,
            each: s,
            merge: be,
            extend: ye,
            assign: de,
            inherit: l,
            bindFn: u,
            prefixed: w
        });
        var Ct = "undefined" != typeof e ? e : "undefined" != typeof self ? self : {};
        Ct.Hammer = ae, "function" == typeof define && define.amd ? define(function() {
            return ae
        }) : "undefined" != typeof module && module.exports ? module.exports = ae : e[n] = ae
    }(window, document, "Hammer"), /*! VelocityJS.org (1.5.2). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
    /*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
    ! function(e) {
        "use strict";

        function t(e) {
            var t = e.length,
                i = n.type(e);
            return "function" !== i && !n.isWindow(e) && (!(1 !== e.nodeType || !t) || "array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
        }
        if (!e.jQuery) {
            var n = function(e, t) {
                return new n.fn.init(e, t)
            };
            n.isWindow = function(e) {
                return e && e === e.window
            }, n.type = function(e) {
                return e ? "object" == typeof e || "function" == typeof e ? r[s.call(e)] || "object" : typeof e : e + ""
            }, n.isArray = Array.isArray || function(e) {
                return "array" === n.type(e)
            }, n.isPlainObject = function(e) {
                var t;
                if (!e || "object" !== n.type(e) || e.nodeType || n.isWindow(e)) return !1;
                try {
                    if (e.constructor && !o.call(e, "constructor") && !o.call(e.constructor.prototype, "isPrototypeOf")) return !1
                } catch (i) {
                    return !1
                }
                for (t in e);
                return void 0 === t || o.call(e, t)
            }, n.each = function(e, n, i) {
                var r = 0,
                    o = e.length,
                    s = t(e);
                if (i) {
                    if (s)
                        for (; r < o && !1 !== n.apply(e[r], i); r++);
                    else
                        for (r in e)
                            if (e.hasOwnProperty(r) && !1 === n.apply(e[r], i)) break
                } else if (s)
                    for (; r < o && !1 !== n.call(e[r], r, e[r]); r++);
                else
                    for (r in e)
                        if (e.hasOwnProperty(r) && !1 === n.call(e[r], r, e[r])) break;
                return e
            }, n.data = function(e, t, r) {
                if (void 0 === r) {
                    var o = e[n.expando],
                        s = o && i[o];
                    if (void 0 === t) return s;
                    if (s && t in s) return s[t]
                } else if (void 0 !== t) {
                    var a = e[n.expando] || (e[n.expando] = ++n.uuid);
                    return i[a] = i[a] || {}, i[a][t] = r, r
                }
            }, n.removeData = function(e, t) {
                var r = e[n.expando],
                    o = r && i[r];
                o && (t ? n.each(t, function(e, t) {
                    delete o[t]
                }) : delete i[r])
            }, n.extend = function() {
                var e, t, i, r, o, s, a = arguments[0] || {},
                    l = 1,
                    u = arguments.length,
                    c = !1;
                for ("boolean" == typeof a && (c = a, a = arguments[l] || {}, l++), "object" != typeof a && "function" !== n.type(a) && (a = {}), l === u && (a = this, l--); l < u; l++)
                    if (o = arguments[l])
                        for (r in o) o.hasOwnProperty(r) && (e = a[r], i = o[r], a !== i && (c && i && (n.isPlainObject(i) || (t = n.isArray(i))) ? (t ? (t = !1, s = e && n.isArray(e) ? e : []) : s = e && n.isPlainObject(e) ? e : {}, a[r] = n.extend(c, s, i)) : void 0 !== i && (a[r] = i)));
                return a
            }, n.queue = function(e, i, r) {
                if (e) {
                    i = (i || "fx") + "queue";
                    var o = n.data(e, i);
                    return r ? (!o || n.isArray(r) ? o = n.data(e, i, function(e, n) {
                        var i = n || [];
                        return e && (t(Object(e)) ? function(e, t) {
                            for (var n = +t.length, i = 0, r = e.length; i < n;) e[r++] = t[i++];
                            if (n !== n)
                                for (; void 0 !== t[i];) e[r++] = t[i++];
                            e.length = r
                        }(i, "string" == typeof e ? [e] : e) : [].push.call(i, e)), i
                    }(r)) : o.push(r), o) : o || []
                }
            }, n.dequeue = function(e, t) {
                n.each(e.nodeType ? [e] : e, function(e, i) {
                    t = t || "fx";
                    var r = n.queue(i, t),
                        o = r.shift();
                    "inprogress" === o && (o = r.shift()), o && ("fx" === t && r.unshift("inprogress"), o.call(i, function() {
                        n.dequeue(i, t)
                    }))
                })
            }, n.fn = n.prototype = {
                init: function(e) {
                    if (e.nodeType) return this[0] = e, this;
                    throw new Error("Not a DOM node.")
                },
                offset: function() {
                    var t = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
                        top: 0,
                        left: 0
                    };
                    return {
                        top: t.top + (e.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
                        left: t.left + (e.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
                    }
                },
                position: function() {
                    var e = this[0],
                        t = function(e) {
                            for (var t = e.offsetParent; t && "html" !== t.nodeName.toLowerCase() && t.style && "static" === t.style.position.toLowerCase();) t = t.offsetParent;
                            return t || document
                        }(e),
                        i = this.offset(),
                        r = /^(?:body|html)$/i.test(t.nodeName) ? {
                            top: 0,
                            left: 0
                        } : n(t).offset();
                    return i.top -= parseFloat(e.style.marginTop) || 0, i.left -= parseFloat(e.style.marginLeft) || 0, t.style && (r.top += parseFloat(t.style.borderTopWidth) || 0, r.left += parseFloat(t.style.borderLeftWidth) || 0), {
                        top: i.top - r.top,
                        left: i.left - r.left
                    }
                }
            };
            var i = {};
            n.expando = "velocity" + (new Date).getTime(), n.uuid = 0;
            for (var r = {}, o = r.hasOwnProperty, s = r.toString, a = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < a.length; l++) r["[object " + a[l] + "]"] = a[l].toLowerCase();
            n.fn.init.prototype = n.fn, e.Velocity = {
                Utilities: n
            }
        }
    }(window),
    function(e) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : e()
    }(function() {
        "use strict";
        return function(e, t, n, i) {
            function r(e) {
                for (var t = -1, n = e ? e.length : 0, i = []; ++t < n;) {
                    var r = e[t];
                    r && i.push(r)
                }
                return i
            }

            function o(e) {
                return w.isWrapped(e) ? e = y.call(e) : w.isNode(e) && (e = [e]), e
            }

            function s(e) {
                var t = f.data(e, "velocity");
                return null === t ? i : t
            }

            function a(e, t) {
                var n = s(e);
                n && n.delayTimer && !n.delayPaused && (n.delayRemaining = n.delay - t + n.delayBegin, n.delayPaused = !0, clearTimeout(n.delayTimer.setTimeout))
            }

            function l(e, t) {
                var n = s(e);
                n && n.delayTimer && n.delayPaused && (n.delayPaused = !1, n.delayTimer.setTimeout = setTimeout(n.delayTimer.next, n.delayRemaining))
            }

            function u(e) {
                return function(t) {
                    return Math.round(t * e) * (1 / e)
                }
            }

            function c(e, n, i, r) {
                function o(e, t) {
                    return 1 - 3 * t + 3 * e
                }

                function s(e, t) {
                    return 3 * t - 6 * e
                }

                function a(e) {
                    return 3 * e
                }

                function l(e, t, n) {
                    return ((o(t, n) * e + s(t, n)) * e + a(t)) * e
                }

                function u(e, t, n) {
                    return 3 * o(t, n) * e * e + 2 * s(t, n) * e + a(t)
                }

                function c(t, n) {
                    for (var r = 0; r < g; ++r) {
                        var o = u(n, e, i);
                        if (0 === o) return n;
                        n -= (l(n, e, i) - t) / o
                    }
                    return n
                }

                function d() {
                    for (var t = 0; t < b; ++t) S[t] = l(t * w, e, i)
                }

                function p(t, n, r) {
                    var o, s, a = 0;
                    do s = n + (r - n) / 2, o = l(s, e, i) - t, o > 0 ? r = s : n = s; while (Math.abs(o) > v && ++a < y);
                    return s
                }

                function h(t) {
                    for (var n = 0, r = 1, o = b - 1; r !== o && S[r] <= t; ++r) n += w;
                    --r;
                    var s = (t - S[r]) / (S[r + 1] - S[r]),
                        a = n + s * w,
                        l = u(a, e, i);
                    return l >= m ? c(t, a) : 0 === l ? a : p(t, n, n + w)
                }

                function f() {
                    _ = !0, e === n && i === r || d()
                }
                var g = 4,
                    m = .001,
                    v = 1e-7,
                    y = 10,
                    b = 11,
                    w = 1 / (b - 1),
                    x = "Float32Array" in t;
                if (4 !== arguments.length) return !1;
                for (var C = 0; C < 4; ++C)
                    if ("number" != typeof arguments[C] || isNaN(arguments[C]) || !isFinite(arguments[C])) return !1;
                e = Math.min(e, 1), i = Math.min(i, 1), e = Math.max(e, 0), i = Math.max(i, 0);
                var S = x ? new Float32Array(b) : new Array(b),
                    _ = !1,
                    T = function(t) {
                        return _ || f(), e === n && i === r ? t : 0 === t ? 0 : 1 === t ? 1 : l(h(t), n, r)
                    };
                T.getControlPoints = function() {
                    return [{
                        x: e,
                        y: n
                    }, {
                        x: i,
                        y: r
                    }]
                };
                var A = "generateBezier(" + [e, n, i, r] + ")";
                return T.toString = function() {
                    return A
                }, T
            }

            function d(e, t) {
                var n = e;
                return w.isString(e) ? _.Easings[e] || (n = !1) : n = w.isArray(e) && 1 === e.length ? u.apply(null, e) : w.isArray(e) && 2 === e.length ? T.apply(null, e.concat([t])) : !(!w.isArray(e) || 4 !== e.length) && c.apply(null, e), !1 === n && (n = _.Easings[_.defaults.easing] ? _.defaults.easing : S), n
            }

            function p(e) {
                if (e) {
                    var t = _.timestamp && !0 !== e ? e : v.now(),
                        n = _.State.calls.length;
                    n > 1e4 && (_.State.calls = r(_.State.calls), n = _.State.calls.length);
                    for (var o = 0; o < n; o++)
                        if (_.State.calls[o]) {
                            var a = _.State.calls[o],
                                l = a[0],
                                u = a[2],
                                c = a[3],
                                d = !c,
                                m = null,
                                y = a[5],
                                b = a[6];
                            if (c || (c = _.State.calls[o][3] = t - 16), y) {
                                if (!0 !== y.resume) continue;
                                c = a[3] = Math.round(t - b - 16), a[5] = null
                            }
                            b = a[6] = t - c;
                            for (var x = Math.min(b / u.duration, 1), C = 0, S = l.length; C < S; C++) {
                                var T = l[C],
                                    k = T.element;
                                if (s(k)) {
                                    var E = !1;
                                    if (u.display !== i && null !== u.display && "none" !== u.display) {
                                        if ("flex" === u.display) {
                                            var I = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
                                            f.each(I, function(e, t) {
                                                A.setPropertyValue(k, "display", t)
                                            })
                                        }
                                        A.setPropertyValue(k, "display", u.display)
                                    }
                                    u.visibility !== i && "hidden" !== u.visibility && A.setPropertyValue(k, "visibility", u.visibility);
                                    for (var O in T)
                                        if (T.hasOwnProperty(O) && "element" !== O) {
                                            var z, N = T[O],
                                                j = w.isString(N.easing) ? _.Easings[N.easing] : N.easing;
                                            if (w.isString(N.pattern)) {
                                                var $ = 1 === x ? function(e, t, n) {
                                                    var i = N.endValue[t];
                                                    return n ? Math.round(i) : i
                                                } : function(e, t, n) {
                                                    var i = N.startValue[t],
                                                        r = N.endValue[t] - i,
                                                        o = i + r * j(x, u, r);
                                                    return n ? Math.round(o) : o
                                                };
                                                z = N.pattern.replace(/{(\d+)(!)?}/g, $)
                                            } else if (1 === x) z = N.endValue;
                                            else {
                                                var D = N.endValue - N.startValue;
                                                z = N.startValue + D * j(x, u, D)
                                            }
                                            if (!d && z === N.currentValue) continue;
                                            if (N.currentValue = z, "tween" === O) m = z;
                                            else {
                                                var F;
                                                if (A.Hooks.registered[O]) {
                                                    F = A.Hooks.getRoot(O);
                                                    var q = s(k).rootPropertyValueCache[F];
                                                    q && (N.rootPropertyValue = q)
                                                }
                                                var L = A.setPropertyValue(k, O, N.currentValue + (g < 9 && 0 === parseFloat(z) ? "" : N.unitType), N.rootPropertyValue, N.scrollData);
                                                A.Hooks.registered[O] && (A.Normalizations.registered[F] ? s(k).rootPropertyValueCache[F] = A.Normalizations.registered[F]("extract", null, L[1]) : s(k).rootPropertyValueCache[F] = L[1]), "transform" === L[0] && (E = !0)
                                            }
                                        } u.mobileHA && s(k).transformCache.translate3d === i && (s(k).transformCache.translate3d = "(0px, 0px, 0px)", E = !0), E && A.flushTransformCache(k)
                                }
                            }
                            u.display !== i && "none" !== u.display && (_.State.calls[o][2].display = !1), u.visibility !== i && "hidden" !== u.visibility && (_.State.calls[o][2].visibility = !1), u.progress && u.progress.call(a[1], a[1], x, Math.max(0, c + u.duration - t), c, m), 1 === x && h(o)
                        }
                }
                _.State.isTicking && P(p)
            }

            function h(e, t) {
                if (!_.State.calls[e]) return !1;
                for (var n = _.State.calls[e][0], r = _.State.calls[e][1], o = _.State.calls[e][2], a = _.State.calls[e][4], l = !1, u = 0, c = n.length; u < c; u++) {
                    var d = n[u].element;
                    t || o.loop || ("none" === o.display && A.setPropertyValue(d, "display", o.display), "hidden" === o.visibility && A.setPropertyValue(d, "visibility", o.visibility));
                    var p = s(d);
                    if (!0 !== o.loop && (f.queue(d)[1] === i || !/\.velocityQueueEntryFlag/i.test(f.queue(d)[1])) && p) {
                        p.isAnimating = !1, p.rootPropertyValueCache = {};
                        var h = !1;
                        f.each(A.Lists.transforms3D, function(e, t) {
                            var n = /^scale/.test(t) ? 1 : 0,
                                r = p.transformCache[t];
                            p.transformCache[t] !== i && new RegExp("^\\(" + n + "[^.]").test(r) && (h = !0, delete p.transformCache[t])
                        }), o.mobileHA && (h = !0, delete p.transformCache.translate3d), h && A.flushTransformCache(d), A.Values.removeClass(d, "velocity-animating")
                    }
                    if (!t && o.complete && !o.loop && u === c - 1) try {
                        o.complete.call(r, r)
                    } catch (g) {
                        setTimeout(function() {
                            throw g
                        }, 1)
                    }
                    a && !0 !== o.loop && a(r), p && !0 === o.loop && !t && (f.each(p.tweensContainer, function(e, t) {
                        if (/^rotate/.test(e) && (parseFloat(t.startValue) - parseFloat(t.endValue)) % 360 == 0) {
                            var n = t.startValue;
                            t.startValue = t.endValue, t.endValue = n
                        }
                        /^backgroundPosition/.test(e) && 100 === parseFloat(t.endValue) && "%" === t.unitType && (t.endValue = 0, t.startValue = 100)
                    }), _(d, "reverse", {
                        loop: !0,
                        delay: o.delay
                    })), !1 !== o.queue && f.dequeue(d, o.queue)
                }
                _.State.calls[e] = !1;
                for (var m = 0, v = _.State.calls.length; m < v; m++)
                    if (!1 !== _.State.calls[m]) {
                        l = !0;
                        break
                    }! 1 === l && (_.State.isTicking = !1, delete _.State.calls, _.State.calls = [])
            }
            var f, g = function() {
                    if (n.documentMode) return n.documentMode;
                    for (var e = 7; e > 4; e--) {
                        var t = n.createElement("div");
                        if (t.innerHTML = "<!--[if IE " + e + "]><span></span><![endif]-->", t.getElementsByTagName("span").length) return t = null, e
                    }
                    return i
                }(),
                m = function() {
                    var e = 0;
                    return t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function(t) {
                        var n, i = (new Date).getTime();
                        return n = Math.max(0, 16 - (i - e)), e = i + n, setTimeout(function() {
                            t(i + n)
                        }, n)
                    }
                }(),
                v = function() {
                    var e = t.performance || {};
                    if ("function" != typeof e.now) {
                        var n = e.timing && e.timing.navigationStart ? e.timing.navigationStart : (new Date).getTime();
                        e.now = function() {
                            return (new Date).getTime() - n
                        }
                    }
                    return e
                }(),
                y = function() {
                    var e = Array.prototype.slice;
                    try {
                        return e.call(n.documentElement), e
                    } catch (t) {
                        return function(t, n) {
                            var i = this.length;
                            if ("number" != typeof t && (t = 0), "number" != typeof n && (n = i), this.slice) return e.call(this, t, n);
                            var r, o = [],
                                s = t >= 0 ? t : Math.max(0, i + t),
                                a = n < 0 ? i + n : Math.min(n, i),
                                l = a - s;
                            if (l > 0)
                                if (o = new Array(l), this.charAt)
                                    for (r = 0; r < l; r++) o[r] = this.charAt(s + r);
                                else
                                    for (r = 0; r < l; r++) o[r] = this[s + r];
                            return o
                        }
                    }
                }(),
                b = function() {
                    return Array.prototype.includes ? function(e, t) {
                        return e.includes(t)
                    } : Array.prototype.indexOf ? function(e, t) {
                        return e.indexOf(t) >= 0
                    } : function(e, t) {
                        for (var n = 0; n < e.length; n++)
                            if (e[n] === t) return !0;
                        return !1
                    }
                },
                w = {
                    isNumber: function(e) {
                        return "number" == typeof e
                    },
                    isString: function(e) {
                        return "string" == typeof e
                    },
                    isArray: Array.isArray || function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e)
                    },
                    isFunction: function(e) {
                        return "[object Function]" === Object.prototype.toString.call(e)
                    },
                    isNode: function(e) {
                        return e && e.nodeType
                    },
                    isWrapped: function(e) {
                        return e && e !== t && w.isNumber(e.length) && !w.isString(e) && !w.isFunction(e) && !w.isNode(e) && (0 === e.length || w.isNode(e[0]))
                    },
                    isSVG: function(e) {
                        return t.SVGElement && e instanceof t.SVGElement
                    },
                    isEmptyObject: function(e) {
                        for (var t in e)
                            if (e.hasOwnProperty(t)) return !1;
                        return !0
                    }
                },
                x = !1;
            if (e.fn && e.fn.jquery ? (f = e, x = !0) : f = t.Velocity.Utilities, g <= 8 && !x) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
            if (g <= 7) return void(jQuery.fn.velocity = jQuery.fn.animate);
            var C = 400,
                S = "swing",
                _ = {
                    State: {
                        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(t.navigator.userAgent),
                        isAndroid: /Android/i.test(t.navigator.userAgent),
                        isGingerbread: /Android 2\.3\.[3-7]/i.test(t.navigator.userAgent),
                        isChrome: t.chrome,
                        isFirefox: /Firefox/i.test(t.navigator.userAgent),
                        prefixElement: n.createElement("div"),
                        prefixMatches: {},
                        scrollAnchor: null,
                        scrollPropertyLeft: null,
                        scrollPropertyTop: null,
                        isTicking: !1,
                        calls: [],
                        delayedElements: {
                            count: 0
                        }
                    },
                    CSS: {},
                    Utilities: f,
                    Redirects: {},
                    Easings: {},
                    Promise: t.Promise,
                    defaults: {
                        queue: "",
                        duration: C,
                        easing: S,
                        begin: i,
                        complete: i,
                        progress: i,
                        display: i,
                        visibility: i,
                        loop: !1,
                        delay: !1,
                        mobileHA: !0,
                        _cacheValues: !0,
                        promiseRejectEmpty: !0
                    },
                    init: function(e) {
                        f.data(e, "velocity", {
                            isSVG: w.isSVG(e),
                            isAnimating: !1,
                            computedStyle: null,
                            tweensContainer: null,
                            rootPropertyValueCache: {},
                            transformCache: {}
                        })
                    },
                    hook: null,
                    mock: !1,
                    version: {
                        major: 1,
                        minor: 5,
                        patch: 2
                    },
                    debug: !1,
                    timestamp: !0,
                    pauseAll: function(e) {
                        var t = (new Date).getTime();
                        f.each(_.State.calls, function(t, n) {
                            if (n) {
                                if (e !== i && (n[2].queue !== e || !1 === n[2].queue)) return !0;
                                n[5] = {
                                    resume: !1
                                }
                            }
                        }), f.each(_.State.delayedElements, function(e, n) {
                            n && a(n, t)
                        })
                    },
                    resumeAll: function(e) {
                        var t = (new Date).getTime();
                        f.each(_.State.calls, function(t, n) {
                            if (n) {
                                if (e !== i && (n[2].queue !== e || !1 === n[2].queue)) return !0;
                                n[5] && (n[5].resume = !0)
                            }
                        }), f.each(_.State.delayedElements, function(e, n) {
                            n && l(n, t)
                        })
                    }
                };
            t.pageYOffset !== i ? (_.State.scrollAnchor = t, _.State.scrollPropertyLeft = "pageXOffset", _.State.scrollPropertyTop = "pageYOffset") : (_.State.scrollAnchor = n.documentElement || n.body.parentNode || n.body, _.State.scrollPropertyLeft = "scrollLeft", _.State.scrollPropertyTop = "scrollTop");
            var T = function() {
                function e(e) {
                    return -e.tension * e.x - e.friction * e.v
                }

                function t(t, n, i) {
                    var r = {
                        x: t.x + i.dx * n,
                        v: t.v + i.dv * n,
                        tension: t.tension,
                        friction: t.friction
                    };
                    return {
                        dx: r.v,
                        dv: e(r)
                    }
                }

                function n(n, i) {
                    var r = {
                            dx: n.v,
                            dv: e(n)
                        },
                        o = t(n, .5 * i, r),
                        s = t(n, .5 * i, o),
                        a = t(n, i, s),
                        l = 1 / 6 * (r.dx + 2 * (o.dx + s.dx) + a.dx),
                        u = 1 / 6 * (r.dv + 2 * (o.dv + s.dv) + a.dv);
                    return n.x = n.x + l * i, n.v = n.v + u * i, n
                }
                return function i(e, t, r) {
                    var o, s, a, l = {
                            x: -1,
                            v: 0,
                            tension: null,
                            friction: null
                        },
                        u = [0],
                        c = 0;
                    for (e = parseFloat(e) || 500, t = parseFloat(t) || 20, r = r || null, l.tension = e, l.friction = t, o = null !== r, o ? (c = i(e, t), s = c / r * .016) : s = .016; a = n(a || l, s), u.push(1 + a.x), c += 16, Math.abs(a.x) > 1e-4 && Math.abs(a.v) > 1e-4;);
                    return o ? function(e) {
                        return u[e * (u.length - 1) | 0]
                    } : c
                }
            }();
            _.Easings = {
                linear: function(e) {
                    return e
                },
                swing: function(e) {
                    return .5 - Math.cos(e * Math.PI) / 2
                },
                spring: function(e) {
                    return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e)
                }
            }, f.each([
                ["ease", [.25, .1, .25, 1]],
                ["ease-in", [.42, 0, 1, 1]],
                ["ease-out", [0, 0, .58, 1]],
                ["ease-in-out", [.42, 0, .58, 1]],
                ["easeInSine", [.47, 0, .745, .715]],
                ["easeOutSine", [.39, .575, .565, 1]],
                ["easeInOutSine", [.445, .05, .55, .95]],
                ["easeInQuad", [.55, .085, .68, .53]],
                ["easeOutQuad", [.25, .46, .45, .94]],
                ["easeInOutQuad", [.455, .03, .515, .955]],
                ["easeInCubic", [.55, .055, .675, .19]],
                ["easeOutCubic", [.215, .61, .355, 1]],
                ["easeInOutCubic", [.645, .045, .355, 1]],
                ["easeInQuart", [.895, .03, .685, .22]],
                ["easeOutQuart", [.165, .84, .44, 1]],
                ["easeInOutQuart", [.77, 0, .175, 1]],
                ["easeInQuint", [.755, .05, .855, .06]],
                ["easeOutQuint", [.23, 1, .32, 1]],
                ["easeInOutQuint", [.86, 0, .07, 1]],
                ["easeInExpo", [.95, .05, .795, .035]],
                ["easeOutExpo", [.19, 1, .22, 1]],
                ["easeInOutExpo", [1, 0, 0, 1]],
                ["easeInCirc", [.6, .04, .98, .335]],
                ["easeOutCirc", [.075, .82, .165, 1]],
                ["easeInOutCirc", [.785, .135, .15, .86]]
            ], function(e, t) {
                _.Easings[t[0]] = c.apply(null, t[1])
            });
            var A = _.CSS = {
                RegEx: {
                    isHex: /^#([A-f\d]{3}){1,2}$/i,
                    valueUnwrap: /^[A-z]+\((.*)\)$/i,
                    wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
                    valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
                },
                Lists: {
                    colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                    transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                    transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
                    units: ["%", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "cm", "mm", "Q", "in", "pc", "pt", "px", "deg", "grad", "rad", "turn", "s", "ms"],
                    colorNames: {
                        aliceblue: "240,248,255",
                        antiquewhite: "250,235,215",
                        aquamarine: "127,255,212",
                        aqua: "0,255,255",
                        azure: "240,255,255",
                        beige: "245,245,220",
                        bisque: "255,228,196",
                        black: "0,0,0",
                        blanchedalmond: "255,235,205",
                        blueviolet: "138,43,226",
                        blue: "0,0,255",
                        brown: "165,42,42",
                        burlywood: "222,184,135",
                        cadetblue: "95,158,160",
                        chartreuse: "127,255,0",
                        chocolate: "210,105,30",
                        coral: "255,127,80",
                        cornflowerblue: "100,149,237",
                        cornsilk: "255,248,220",
                        crimson: "220,20,60",
                        cyan: "0,255,255",
                        darkblue: "0,0,139",
                        darkcyan: "0,139,139",
                        darkgoldenrod: "184,134,11",
                        darkgray: "169,169,169",
                        darkgrey: "169,169,169",
                        darkgreen: "0,100,0",
                        darkkhaki: "189,183,107",
                        darkmagenta: "139,0,139",
                        darkolivegreen: "85,107,47",
                        darkorange: "255,140,0",
                        darkorchid: "153,50,204",
                        darkred: "139,0,0",
                        darksalmon: "233,150,122",
                        darkseagreen: "143,188,143",
                        darkslateblue: "72,61,139",
                        darkslategray: "47,79,79",
                        darkturquoise: "0,206,209",
                        darkviolet: "148,0,211",
                        deeppink: "255,20,147",
                        deepskyblue: "0,191,255",
                        dimgray: "105,105,105",
                        dimgrey: "105,105,105",
                        dodgerblue: "30,144,255",
                        firebrick: "178,34,34",
                        floralwhite: "255,250,240",
                        forestgreen: "34,139,34",
                        fuchsia: "255,0,255",
                        gainsboro: "220,220,220",
                        ghostwhite: "248,248,255",
                        gold: "255,215,0",
                        goldenrod: "218,165,32",
                        gray: "128,128,128",
                        grey: "128,128,128",
                        greenyellow: "173,255,47",
                        green: "0,128,0",
                        honeydew: "240,255,240",
                        hotpink: "255,105,180",
                        indianred: "205,92,92",
                        indigo: "75,0,130",
                        ivory: "255,255,240",
                        khaki: "240,230,140",
                        lavenderblush: "255,240,245",
                        lavender: "230,230,250",
                        lawngreen: "124,252,0",
                        lemonchiffon: "255,250,205",
                        lightblue: "173,216,230",
                        lightcoral: "240,128,128",
                        lightcyan: "224,255,255",
                        lightgoldenrodyellow: "250,250,210",
                        lightgray: "211,211,211",
                        lightgrey: "211,211,211",
                        lightgreen: "144,238,144",
                        lightpink: "255,182,193",
                        lightsalmon: "255,160,122",
                        lightseagreen: "32,178,170",
                        lightskyblue: "135,206,250",
                        lightslategray: "119,136,153",
                        lightsteelblue: "176,196,222",
                        lightyellow: "255,255,224",
                        limegreen: "50,205,50",
                        lime: "0,255,0",
                        linen: "250,240,230",
                        magenta: "255,0,255",
                        maroon: "128,0,0",
                        mediumaquamarine: "102,205,170",
                        mediumblue: "0,0,205",
                        mediumorchid: "186,85,211",
                        mediumpurple: "147,112,219",
                        mediumseagreen: "60,179,113",
                        mediumslateblue: "123,104,238",
                        mediumspringgreen: "0,250,154",
                        mediumturquoise: "72,209,204",
                        mediumvioletred: "199,21,133",
                        midnightblue: "25,25,112",
                        mintcream: "245,255,250",
                        mistyrose: "255,228,225",
                        moccasin: "255,228,181",
                        navajowhite: "255,222,173",
                        navy: "0,0,128",
                        oldlace: "253,245,230",
                        olivedrab: "107,142,35",
                        olive: "128,128,0",
                        orangered: "255,69,0",
                        orange: "255,165,0",
                        orchid: "218,112,214",
                        palegoldenrod: "238,232,170",
                        palegreen: "152,251,152",
                        paleturquoise: "175,238,238",
                        palevioletred: "219,112,147",
                        papayawhip: "255,239,213",
                        peachpuff: "255,218,185",
                        peru: "205,133,63",
                        pink: "255,192,203",
                        plum: "221,160,221",
                        powderblue: "176,224,230",
                        purple: "128,0,128",
                        red: "255,0,0",
                        rosybrown: "188,143,143",
                        royalblue: "65,105,225",
                        saddlebrown: "139,69,19",
                        salmon: "250,128,114",
                        sandybrown: "244,164,96",
                        seagreen: "46,139,87",
                        seashell: "255,245,238",
                        sienna: "160,82,45",
                        silver: "192,192,192",
                        skyblue: "135,206,235",
                        slateblue: "106,90,205",
                        slategray: "112,128,144",
                        snow: "255,250,250",
                        springgreen: "0,255,127",
                        steelblue: "70,130,180",
                        tan: "210,180,140",
                        teal: "0,128,128",
                        thistle: "216,191,216",
                        tomato: "255,99,71",
                        turquoise: "64,224,208",
                        violet: "238,130,238",
                        wheat: "245,222,179",
                        whitesmoke: "245,245,245",
                        white: "255,255,255",
                        yellowgreen: "154,205,50",
                        yellow: "255,255,0"
                    }
                },
                Hooks: {
                    templates: {
                        textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                        boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                        clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                        backgroundPosition: ["X Y", "0% 0%"],
                        transformOrigin: ["X Y Z", "50% 50% 0px"],
                        perspectiveOrigin: ["X Y", "50% 50%"]
                    },
                    registered: {},
                    register: function() {
                        for (var e = 0; e < A.Lists.colors.length; e++) {
                            var t = "color" === A.Lists.colors[e] ? "0 0 0 1" : "255 255 255 1";
                            A.Hooks.templates[A.Lists.colors[e]] = ["Red Green Blue Alpha", t]
                        }
                        var n, i, r;
                        if (g)
                            for (n in A.Hooks.templates)
                                if (A.Hooks.templates.hasOwnProperty(n)) {
                                    i = A.Hooks.templates[n], r = i[0].split(" ");
                                    var o = i[1].match(A.RegEx.valueSplit);
                                    "Color" === r[0] && (r.push(r.shift()), o.push(o.shift()), A.Hooks.templates[n] = [r.join(" "), o.join(" ")])
                                } for (n in A.Hooks.templates)
                            if (A.Hooks.templates.hasOwnProperty(n)) {
                                i = A.Hooks.templates[n], r = i[0].split(" ");
                                for (var s in r)
                                    if (r.hasOwnProperty(s)) {
                                        var a = n + r[s],
                                            l = s;
                                        A.Hooks.registered[a] = [n, l]
                                    }
                            }
                    },
                    getRoot: function(e) {
                        var t = A.Hooks.registered[e];
                        return t ? t[0] : e
                    },
                    getUnit: function(e, t) {
                        var n = (e.substr(t || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
                        return n && b(A.Lists.units, n) ? n : ""
                    },
                    fixColors: function(e) {
                        return e.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function(e, t, n) {
                            return A.Lists.colorNames.hasOwnProperty(n) ? (t || "rgba(") + A.Lists.colorNames[n] + (t ? "" : ",1)") : t + n
                        })
                    },
                    cleanRootPropertyValue: function(e, t) {
                        return A.RegEx.valueUnwrap.test(t) && (t = t.match(A.RegEx.valueUnwrap)[1]), A.Values.isCSSNullValue(t) && (t = A.Hooks.templates[e][1]), t
                    },
                    extractValue: function(e, t) {
                        var n = A.Hooks.registered[e];
                        if (n) {
                            var i = n[0],
                                r = n[1];
                            return t = A.Hooks.cleanRootPropertyValue(i, t), t.toString().match(A.RegEx.valueSplit)[r]
                        }
                        return t
                    },
                    injectValue: function(e, t, n) {
                        var i = A.Hooks.registered[e];
                        if (i) {
                            var r, o = i[0],
                                s = i[1];
                            return n = A.Hooks.cleanRootPropertyValue(o, n), r = n.toString().match(A.RegEx.valueSplit), r[s] = t, r.join(" ")
                        }
                        return n
                    }
                },
                Normalizations: {
                    registered: {
                        clip: function(e, t, n) {
                            switch (e) {
                                case "name":
                                    return "clip";
                                case "extract":
                                    var i;
                                    return A.RegEx.wrappedValueAlreadyExtracted.test(n) ? i = n : (i = n.toString().match(A.RegEx.valueUnwrap), i = i ? i[1].replace(/,(\s+)?/g, " ") : n), i;
                                case "inject":
                                    return "rect(" + n + ")"
                            }
                        },
                        blur: function(e, t, n) {
                            switch (e) {
                                case "name":
                                    return _.State.isFirefox ? "filter" : "-webkit-filter";
                                case "extract":
                                    var i = parseFloat(n);
                                    if (!i && 0 !== i) {
                                        var r = n.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                                        i = r ? r[1] : 0
                                    }
                                    return i;
                                case "inject":
                                    return parseFloat(n) ? "blur(" + n + ")" : "none"
                            }
                        },
                        opacity: function(e, t, n) {
                            if (g <= 8) switch (e) {
                                case "name":
                                    return "filter";
                                case "extract":
                                    var i = n.toString().match(/alpha\(opacity=(.*)\)/i);
                                    return n = i ? i[1] / 100 : 1;
                                case "inject":
                                    return t.style.zoom = 1, parseFloat(n) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(n), 10) + ")"
                            } else switch (e) {
                                case "name":
                                    return "opacity";
                                case "extract":
                                case "inject":
                                    return n
                            }
                        }
                    },
                    register: function() {
                        function e(e, t, n) {
                            if ("border-box" === A.getPropertyValue(t, "boxSizing").toString().toLowerCase() === (n || !1)) {
                                var i, r, o = 0,
                                    s = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"],
                                    a = ["padding" + s[0], "padding" + s[1], "border" + s[0] + "Width", "border" + s[1] + "Width"];
                                for (i = 0; i < a.length; i++) r = parseFloat(A.getPropertyValue(t, a[i])), isNaN(r) || (o += r);
                                return n ? -o : o
                            }
                            return 0
                        }

                        function t(t, n) {
                            return function(i, r, o) {
                                switch (i) {
                                    case "name":
                                        return t;
                                    case "extract":
                                        return parseFloat(o) + e(t, r, n);
                                    case "inject":
                                        return parseFloat(o) - e(t, r, n) + "px"
                                }
                            }
                        }
                        g && !(g > 9) || _.State.isGingerbread || (A.Lists.transformsBase = A.Lists.transformsBase.concat(A.Lists.transforms3D));
                        for (var n = 0; n < A.Lists.transformsBase.length; n++) ! function() {
                            var e = A.Lists.transformsBase[n];
                            A.Normalizations.registered[e] = function(t, n, r) {
                                switch (t) {
                                    case "name":
                                        return "transform";
                                    case "extract":
                                        return s(n) === i || s(n).transformCache[e] === i ? /^scale/i.test(e) ? 1 : 0 : s(n).transformCache[e].replace(/[()]/g, "");
                                    case "inject":
                                        var o = !1;
                                        switch (e.substr(0, e.length - 1)) {
                                            case "translate":
                                                o = !/(%|px|em|rem|vw|vh|\d)$/i.test(r);
                                                break;
                                            case "scal":
                                            case "scale":
                                                _.State.isAndroid && s(n).transformCache[e] === i && r < 1 && (r = 1), o = !/(\d)$/i.test(r);
                                                break;
                                            case "skew":
                                            case "rotate":
                                                o = !/(deg|\d)$/i.test(r)
                                        }
                                        return o || (s(n).transformCache[e] = "(" + r + ")"), s(n).transformCache[e]
                                }
                            }
                        }();
                        for (var r = 0; r < A.Lists.colors.length; r++) ! function() {
                            var e = A.Lists.colors[r];
                            A.Normalizations.registered[e] = function(t, n, r) {
                                switch (t) {
                                    case "name":
                                        return e;
                                    case "extract":
                                        var o;
                                        if (A.RegEx.wrappedValueAlreadyExtracted.test(r)) o = r;
                                        else {
                                            var s, a = {
                                                black: "rgb(0, 0, 0)",
                                                blue: "rgb(0, 0, 255)",
                                                gray: "rgb(128, 128, 128)",
                                                green: "rgb(0, 128, 0)",
                                                red: "rgb(255, 0, 0)",
                                                white: "rgb(255, 255, 255)"
                                            };
                                            /^[A-z]+$/i.test(r) ? s = a[r] !== i ? a[r] : a.black : A.RegEx.isHex.test(r) ? s = "rgb(" + A.Values.hexToRgb(r).join(" ") + ")" : /^rgba?\(/i.test(r) || (s = a.black), o = (s || r).toString().match(A.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
                                        }
                                        return (!g || g > 8) && 3 === o.split(" ").length && (o += " 1"), o;
                                    case "inject":
                                        return /^rgb/.test(r) ? r : (g <= 8 ? 4 === r.split(" ").length && (r = r.split(/\s+/).slice(0, 3).join(" ")) : 3 === r.split(" ").length && (r += " 1"), (g <= 8 ? "rgb" : "rgba") + "(" + r.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")")
                                }
                            }
                        }();
                        A.Normalizations.registered.innerWidth = t("width", !0), A.Normalizations.registered.innerHeight = t("height", !0), A.Normalizations.registered.outerWidth = t("width"), A.Normalizations.registered.outerHeight = t("height")
                    }
                },
                Names: {
                    camelCase: function(e) {
                        return e.replace(/-(\w)/g, function(e, t) {
                            return t.toUpperCase()
                        })
                    },
                    SVGAttribute: function(e) {
                        var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                        return (g || _.State.isAndroid && !_.State.isChrome) && (t += "|transform"), new RegExp("^(" + t + ")$", "i").test(e)
                    },
                    prefixCheck: function(e) {
                        if (_.State.prefixMatches[e]) return [_.State.prefixMatches[e], !0];
                        for (var t = ["", "Webkit", "Moz", "ms", "O"], n = 0, i = t.length; n < i; n++) {
                            var r;
                            if (r = 0 === n ? e : t[n] + e.replace(/^\w/, function(e) {
                                    return e.toUpperCase()
                                }), w.isString(_.State.prefixElement.style[r])) return _.State.prefixMatches[e] = r, [r, !0]
                        }
                        return [e, !1]
                    }
                },
                Values: {
                    hexToRgb: function(e) {
                        var t, n = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                            i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
                        return e = e.replace(n, function(e, t, n, i) {
                            return t + t + n + n + i + i
                        }), t = i.exec(e), t ? [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)] : [0, 0, 0]
                    },
                    isCSSNullValue: function(e) {
                        return !e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
                    },
                    getUnitType: function(e) {
                        return /^(rotate|skew)/i.test(e) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(e) ? "" : "px"
                    },
                    getDisplayType: function(e) {
                        var t = e && e.tagName.toString().toLowerCase();
                        return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(t) ? "inline" : /^(li)$/i.test(t) ? "list-item" : /^(tr)$/i.test(t) ? "table-row" : /^(table)$/i.test(t) ? "table" : /^(tbody)$/i.test(t) ? "table-row-group" : "block"
                    },
                    addClass: function(e, t) {
                        if (e)
                            if (e.classList) e.classList.add(t);
                            else if (w.isString(e.className)) e.className += (e.className.length ? " " : "") + t;
                        else {
                            var n = e.getAttribute(g <= 7 ? "className" : "class") || "";
                            e.setAttribute("class", n + (n ? " " : "") + t)
                        }
                    },
                    removeClass: function(e, t) {
                        if (e)
                            if (e.classList) e.classList.remove(t);
                            else if (w.isString(e.className)) e.className = e.className.toString().replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " ");
                        else {
                            var n = e.getAttribute(g <= 7 ? "className" : "class") || "";
                            e.setAttribute("class", n.replace(new RegExp("(^|s)" + t.split(" ").join("|") + "(s|$)", "gi"), " "))
                        }
                    }
                },
                getPropertyValue: function(e, n, r, o) {
                    function a(e, n) {
                        var r = 0;
                        if (g <= 8) r = f.css(e, n);
                        else {
                            var l = !1;
                            /^(width|height)$/.test(n) && 0 === A.getPropertyValue(e, "display") && (l = !0, A.setPropertyValue(e, "display", A.Values.getDisplayType(e)));
                            var u = function() {
                                l && A.setPropertyValue(e, "display", "none")
                            };
                            if (!o) {
                                if ("height" === n && "border-box" !== A.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                    var c = e.offsetHeight - (parseFloat(A.getPropertyValue(e, "borderTopWidth")) || 0) - (parseFloat(A.getPropertyValue(e, "borderBottomWidth")) || 0) - (parseFloat(A.getPropertyValue(e, "paddingTop")) || 0) - (parseFloat(A.getPropertyValue(e, "paddingBottom")) || 0);
                                    return u(), c
                                }
                                if ("width" === n && "border-box" !== A.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                    var d = e.offsetWidth - (parseFloat(A.getPropertyValue(e, "borderLeftWidth")) || 0) - (parseFloat(A.getPropertyValue(e, "borderRightWidth")) || 0) - (parseFloat(A.getPropertyValue(e, "paddingLeft")) || 0) - (parseFloat(A.getPropertyValue(e, "paddingRight")) || 0);
                                    return u(), d
                                }
                            }
                            var p;
                            p = s(e) === i ? t.getComputedStyle(e, null) : s(e).computedStyle ? s(e).computedStyle : s(e).computedStyle = t.getComputedStyle(e, null), "borderColor" === n && (n = "borderTopColor"), r = 9 === g && "filter" === n ? p.getPropertyValue(n) : p[n], "" !== r && null !== r || (r = e.style[n]), u()
                        }
                        if ("auto" === r && /^(top|right|bottom|left)$/i.test(n)) {
                            var h = a(e, "position");
                            ("fixed" === h || "absolute" === h && /top|left/i.test(n)) && (r = f(e).position()[n] + "px")
                        }
                        return r
                    }
                    var l;
                    if (A.Hooks.registered[n]) {
                        var u = n,
                            c = A.Hooks.getRoot(u);
                        r === i && (r = A.getPropertyValue(e, A.Names.prefixCheck(c)[0])), A.Normalizations.registered[c] && (r = A.Normalizations.registered[c]("extract", e, r)), l = A.Hooks.extractValue(u, r)
                    } else if (A.Normalizations.registered[n]) {
                        var d, p;
                        d = A.Normalizations.registered[n]("name", e), "transform" !== d && (p = a(e, A.Names.prefixCheck(d)[0]), A.Values.isCSSNullValue(p) && A.Hooks.templates[n] && (p = A.Hooks.templates[n][1])), l = A.Normalizations.registered[n]("extract", e, p)
                    }
                    if (!/^[\d-]/.test(l)) {
                        var h = s(e);
                        if (h && h.isSVG && A.Names.SVGAttribute(n))
                            if (/^(height|width)$/i.test(n)) try {
                                l = e.getBBox()[n]
                            } catch (m) {
                                l = 0
                            } else l = e.getAttribute(n);
                            else l = a(e, A.Names.prefixCheck(n)[0])
                    }
                    return A.Values.isCSSNullValue(l) && (l = 0), _.debug >= 2 && console.log("Get " + n + ": " + l), l
                },
                setPropertyValue: function(e, n, i, r, o) {
                    var a = n;
                    if ("scroll" === n) o.container ? o.container["scroll" + o.direction] = i : "Left" === o.direction ? t.scrollTo(i, o.alternateValue) : t.scrollTo(o.alternateValue, i);
                    else if (A.Normalizations.registered[n] && "transform" === A.Normalizations.registered[n]("name", e)) A.Normalizations.registered[n]("inject", e, i), a = "transform", i = s(e).transformCache[n];
                    else {
                        if (A.Hooks.registered[n]) {
                            var l = n,
                                u = A.Hooks.getRoot(n);
                            r = r || A.getPropertyValue(e, u), i = A.Hooks.injectValue(l, i, r), n = u
                        }
                        if (A.Normalizations.registered[n] && (i = A.Normalizations.registered[n]("inject", e, i), n = A.Normalizations.registered[n]("name", e)), a = A.Names.prefixCheck(n)[0], g <= 8) try {
                            e.style[a] = i
                        } catch (c) {
                            _.debug && console.log("Browser does not support [" + i + "] for [" + a + "]")
                        } else {
                            var d = s(e);
                            d && d.isSVG && A.Names.SVGAttribute(n) ? e.setAttribute(n, i) : e.style[a] = i
                        }
                        _.debug >= 2 && console.log("Set " + n + " (" + a + "): " + i)
                    }
                    return [a, i]
                },
                flushTransformCache: function(e) {
                    var t = "",
                        n = s(e);
                    if ((g || _.State.isAndroid && !_.State.isChrome) && n && n.isSVG) {
                        var i = function(t) {
                                return parseFloat(A.getPropertyValue(e, t))
                            },
                            r = {
                                translate: [i("translateX"), i("translateY")],
                                skewX: [i("skewX")],
                                skewY: [i("skewY")],
                                scale: 1 !== i("scale") ? [i("scale"), i("scale")] : [i("scaleX"), i("scaleY")],
                                rotate: [i("rotateZ"), 0, 0]
                            };
                        f.each(s(e).transformCache, function(e) {
                            /^translate/i.test(e) ? e = "translate" : /^scale/i.test(e) ? e = "scale" : /^rotate/i.test(e) && (e = "rotate"), r[e] && (t += e + "(" + r[e].join(" ") + ") ", delete r[e])
                        })
                    } else {
                        var o, a;
                        f.each(s(e).transformCache, function(n) {
                            return o = s(e).transformCache[n], "transformPerspective" === n ? (a = o, !0) : (9 === g && "rotateZ" === n && (n = "rotate"), void(t += n + o + " "))
                        }), a && (t = "perspective" + a + " " + t)
                    }
                    A.setPropertyValue(e, "transform", t)
                }
            };
            A.Hooks.register(), A.Normalizations.register(), _.hook = function(e, t, n) {
                var r;
                return e = o(e), f.each(e, function(e, o) {
                    if (s(o) === i && _.init(o), n === i) r === i && (r = A.getPropertyValue(o, t));
                    else {
                        var a = A.setPropertyValue(o, t, n);
                        "transform" === a[0] && _.CSS.flushTransformCache(o), r = a
                    }
                }), r
            };
            var k = function() {
                function e() {
                    return c ? T.promise || null : g
                }

                function r(e, r) {
                    function o(o) {
                        var c, h;
                        if (l.begin && 0 === E) try {
                            l.begin.call(v, v)
                        } catch (g) {
                            setTimeout(function() {
                                throw g
                            }, 1)
                        }
                        if ("scroll" === z) {
                            var m, C, S, k = /^x$/i.test(l.axis) ? "Left" : "Top",
                                I = parseFloat(l.offset) || 0;
                            l.container ? w.isWrapped(l.container) || w.isNode(l.container) ? (l.container = l.container[0] || l.container, m = l.container["scroll" + k], S = m + f(e).position()[k.toLowerCase()] + I) : l.container = null : (m = _.State.scrollAnchor[_.State["scrollProperty" + k]], C = _.State.scrollAnchor[_.State["scrollProperty" + ("Left" === k ? "Top" : "Left")]], S = f(e).offset()[k.toLowerCase()] + I), u = {
                                scroll: {
                                    rootPropertyValue: !1,
                                    startValue: m,
                                    currentValue: m,
                                    endValue: S,
                                    unitType: "",
                                    easing: l.easing,
                                    scrollData: {
                                        container: l.container,
                                        direction: k,
                                        alternateValue: C
                                    }
                                },
                                element: e
                            }, _.debug && console.log("tweensContainer (scroll): ", u.scroll, e)
                        } else if ("reverse" === z) {
                            if (!(c = s(e))) return;
                            if (!c.tweensContainer) return void f.dequeue(e, l.queue);
                            "none" === c.opts.display && (c.opts.display = "auto"), "hidden" === c.opts.visibility && (c.opts.visibility = "visible"), c.opts.loop = !1, c.opts.begin = null, c.opts.complete = null, x.easing || delete l.easing, x.duration || delete l.duration, l = f.extend({}, c.opts, l), h = f.extend(!0, {}, c ? c.tweensContainer : null);
                            for (var O in h)
                                if (h.hasOwnProperty(O) && "element" !== O) {
                                    var N = h[O].startValue;
                                    h[O].startValue = h[O].currentValue = h[O].endValue, h[O].endValue = N, w.isEmptyObject(x) || (h[O].easing = l.easing), _.debug && console.log("reverse tweensContainer (" + O + "): " + JSON.stringify(h[O]), e)
                                } u = h
                        } else if ("start" === z) {
                            c = s(e), c && c.tweensContainer && !0 === c.isAnimating && (h = c.tweensContainer);
                            var j = function(r, o) {
                                var s, d = A.Hooks.getRoot(r),
                                    p = !1,
                                    g = o[0],
                                    m = o[1],
                                    v = o[2];
                                if (!(c && c.isSVG || "tween" === d || !1 !== A.Names.prefixCheck(d)[1] || A.Normalizations.registered[d] !== i)) return void(_.debug && console.log("Skipping [" + d + "] due to a lack of browser support."));
                                (l.display !== i && null !== l.display && "none" !== l.display || l.visibility !== i && "hidden" !== l.visibility) && /opacity|filter/.test(r) && !v && 0 !== g && (v = 0), l._cacheValues && h && h[r] ? (v === i && (v = h[r].endValue + h[r].unitType), p = c.rootPropertyValueCache[d]) : A.Hooks.registered[r] ? v === i ? (p = A.getPropertyValue(e, d), v = A.getPropertyValue(e, r, p)) : p = A.Hooks.templates[d][1] : v === i && (v = A.getPropertyValue(e, r));
                                var y, b, x, C = !1,
                                    S = function(e, t) {
                                        var n, i;
                                        return i = (t || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(e) {
                                            return n = e, ""
                                        }), n || (n = A.Values.getUnitType(e)), [i, n]
                                    };
                                if (v !== g && w.isString(v) && w.isString(g)) {
                                    s = "";
                                    var T = 0,
                                        k = 0,
                                        P = [],
                                        E = [],
                                        I = 0,
                                        O = 0,
                                        z = 0;
                                    for (v = A.Hooks.fixColors(v), g = A.Hooks.fixColors(g); T < v.length && k < g.length;) {
                                        var N = v[T],
                                            j = g[k];
                                        if (/[\d\.-]/.test(N) && /[\d\.-]/.test(j)) {
                                            for (var $ = N, D = j, F = ".", L = "."; ++T < v.length;) {
                                                if ((N = v[T]) === F) F = "..";
                                                else if (!/\d/.test(N)) break;
                                                $ += N
                                            }
                                            for (; ++k < g.length;) {
                                                if ((j = g[k]) === L) L = "..";
                                                else if (!/\d/.test(j)) break;
                                                D += j
                                            }
                                            var R = A.Hooks.getUnit(v, T),
                                                H = A.Hooks.getUnit(g, k);
                                            if (T += R.length, k += H.length, R === H) $ === D ? s += $ + R : (s += "{" + P.length + (O ? "!" : "") + "}" + R, P.push(parseFloat($)), E.push(parseFloat(D)));
                                            else {
                                                var V = parseFloat($),
                                                    M = parseFloat(D);
                                                s += (I < 5 ? "calc" : "") + "(" + (V ? "{" + P.length + (O ? "!" : "") + "}" : "0") + R + " + " + (M ? "{" + (P.length + (V ? 1 : 0)) + (O ? "!" : "") + "}" : "0") + H + ")", V && (P.push(V), E.push(0)), M && (P.push(0), E.push(M))
                                            }
                                        } else {
                                            if (N !== j) {
                                                I = 0;
                                                break
                                            }
                                            s += N, T++, k++, 0 === I && "c" === N || 1 === I && "a" === N || 2 === I && "l" === N || 3 === I && "c" === N || I >= 4 && "(" === N ? I++ : (I && I < 5 || I >= 4 && ")" === N && --I < 5) && (I = 0), 0 === O && "r" === N || 1 === O && "g" === N || 2 === O && "b" === N || 3 === O && "a" === N || O >= 3 && "(" === N ? (3 === O && "a" === N && (z = 1), O++) : z && "," === N ? ++z > 3 && (O = z = 0) : (z && O < (z ? 5 : 4) || O >= (z ? 4 : 3) && ")" === N && --O < (z ? 5 : 4)) && (O = z = 0)
                                        }
                                    }
                                    T === v.length && k === g.length || (_.debug && console.error('Trying to pattern match mis-matched strings ["' + g + '", "' + v + '"]'), s = i), s && (P.length ? (_.debug && console.log('Pattern found "' + s + '" -> ', P, E, "[" + v + "," + g + "]"), v = P, g = E, b = x = "") : s = i)
                                }
                                if (s || (y = S(r, v), v = y[0], x = y[1], y = S(r, g), g = y[0].replace(/^([+-\/*])=/, function(e, t) {
                                        return C = t, ""
                                    }), b = y[1], v = parseFloat(v) || 0, g = parseFloat(g) || 0, "%" === b && (/^(fontSize|lineHeight)$/.test(r) ? (g /= 100, b = "em") : /^scale/.test(r) ? (g /= 100, b = "") : /(Red|Green|Blue)$/i.test(r) && (g = g / 100 * 255, b = ""))), /[\/*]/.test(C)) b = x;
                                else if (x !== b && 0 !== v)
                                    if (0 === g) b = x;
                                    else {
                                        a = a || function() {
                                            var i = {
                                                    myParent: e.parentNode || n.body,
                                                    position: A.getPropertyValue(e, "position"),
                                                    fontSize: A.getPropertyValue(e, "fontSize")
                                                },
                                                r = i.position === q.lastPosition && i.myParent === q.lastParent,
                                                o = i.fontSize === q.lastFontSize;
                                            q.lastParent = i.myParent, q.lastPosition = i.position, q.lastFontSize = i.fontSize;
                                            var s = {};
                                            if (o && r) s.emToPx = q.lastEmToPx, s.percentToPxWidth = q.lastPercentToPxWidth, s.percentToPxHeight = q.lastPercentToPxHeight;
                                            else {
                                                var a = c && c.isSVG ? n.createElementNS("http://www.w3.org/2000/svg", "rect") : n.createElement("div");
                                                _.init(a), i.myParent.appendChild(a), f.each(["overflow", "overflowX", "overflowY"], function(e, t) {
                                                    _.CSS.setPropertyValue(a, t, "hidden")
                                                }), _.CSS.setPropertyValue(a, "position", i.position), _.CSS.setPropertyValue(a, "fontSize", i.fontSize), _.CSS.setPropertyValue(a, "boxSizing", "content-box"), f.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(e, t) {
                                                    _.CSS.setPropertyValue(a, t, "100%")
                                                }), _.CSS.setPropertyValue(a, "paddingLeft", "100em"), s.percentToPxWidth = q.lastPercentToPxWidth = (parseFloat(A.getPropertyValue(a, "width", null, !0)) || 1) / 100, s.percentToPxHeight = q.lastPercentToPxHeight = (parseFloat(A.getPropertyValue(a, "height", null, !0)) || 1) / 100, s.emToPx = q.lastEmToPx = (parseFloat(A.getPropertyValue(a, "paddingLeft")) || 1) / 100, i.myParent.removeChild(a)
                                            }
                                            return null === q.remToPx && (q.remToPx = parseFloat(A.getPropertyValue(n.body, "fontSize")) || 16), null === q.vwToPx && (q.vwToPx = parseFloat(t.innerWidth) / 100, q.vhToPx = parseFloat(t.innerHeight) / 100), s.remToPx = q.remToPx, s.vwToPx = q.vwToPx, s.vhToPx = q.vhToPx, _.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(s), e), s
                                        }();
                                        var W = /margin|padding|left|right|width|text|word|letter/i.test(r) || /X$/.test(r) || "x" === r ? "x" : "y";
                                        switch (x) {
                                            case "%":
                                                v *= "x" === W ? a.percentToPxWidth : a.percentToPxHeight;
                                                break;
                                            case "px":
                                                break;
                                            default:
                                                v *= a[x + "ToPx"]
                                        }
                                        switch (b) {
                                            case "%":
                                                v *= 1 / ("x" === W ? a.percentToPxWidth : a.percentToPxHeight);
                                                break;
                                            case "px":
                                                break;
                                            default:
                                                v *= 1 / a[b + "ToPx"]
                                        }
                                    } switch (C) {
                                    case "+":
                                        g = v + g;
                                        break;
                                    case "-":
                                        g = v - g;
                                        break;
                                    case "*":
                                        g *= v;
                                        break;
                                    case "/":
                                        g = v / g
                                }
                                u[r] = {
                                    rootPropertyValue: p,
                                    startValue: v,
                                    currentValue: v,
                                    endValue: g,
                                    unitType: b,
                                    easing: m
                                }, s && (u[r].pattern = s), _.debug && console.log("tweensContainer (" + r + "): " + JSON.stringify(u[r]), e)
                            };
                            for (var $ in y)
                                if (y.hasOwnProperty($)) {
                                    var D = A.Names.camelCase($),
                                        F = function(t, n) {
                                            var i, o, s;
                                            return w.isFunction(t) && (t = t.call(e, r, P)), w.isArray(t) ? (i = t[0], !w.isArray(t[1]) && /^[\d-]/.test(t[1]) || w.isFunction(t[1]) || A.RegEx.isHex.test(t[1]) ? s = t[1] : w.isString(t[1]) && !A.RegEx.isHex.test(t[1]) && _.Easings[t[1]] || w.isArray(t[1]) ? (o = n ? t[1] : d(t[1], l.duration), s = t[2]) : s = t[1] || t[2]) : i = t, n || (o = o || l.easing), w.isFunction(i) && (i = i.call(e, r, P)), w.isFunction(s) && (s = s.call(e, r, P)), [i || 0, o, s]
                                        }(y[$]);
                                    if (b(A.Lists.colors, D)) {
                                        var R = F[0],
                                            H = F[1],
                                            V = F[2];
                                        if (A.RegEx.isHex.test(R)) {
                                            for (var M = ["Red", "Green", "Blue"], W = A.Values.hexToRgb(R), B = V ? A.Values.hexToRgb(V) : i, U = 0; U < M.length; U++) {
                                                var Q = [W[U]];
                                                H && Q.push(H), B !== i && Q.push(B[U]), j(D + M[U], Q)
                                            }
                                            continue
                                        }
                                    }
                                    j(D, F)
                                } u.element = e
                        }
                        u.element && (A.Values.addClass(e, "velocity-animating"), L.push(u), c = s(e), c && ("" === l.queue && (c.tweensContainer = u, c.opts = l), c.isAnimating = !0), E === P - 1 ? (_.State.calls.push([L, v, l, null, T.resolver, null, 0]), !1 === _.State.isTicking && (_.State.isTicking = !0, p())) : E++)
                    }
                    var a, l = f.extend({}, _.defaults, x),
                        u = {};
                    switch (s(e) === i && _.init(e), parseFloat(l.delay) && !1 !== l.queue && f.queue(e, l.queue, function(t, n) {
                        if (!0 === n) return !0;
                        _.velocityQueueEntryFlag = !0;
                        var i = _.State.delayedElements.count++;
                        _.State.delayedElements[i] = e;
                        var r = function(e) {
                            return function() {
                                _.State.delayedElements[e] = !1, t()
                            }
                        }(i);
                        s(e).delayBegin = (new Date).getTime(), s(e).delay = parseFloat(l.delay), s(e).delayTimer = {
                            setTimeout: setTimeout(t, parseFloat(l.delay)),
                            next: r
                        }
                    }), l.duration.toString().toLowerCase()) {
                        case "fast":
                            l.duration = 200;
                            break;
                        case "normal":
                            l.duration = C;
                            break;
                        case "slow":
                            l.duration = 600;
                            break;
                        default:
                            l.duration = parseFloat(l.duration) || 1
                    }
                    if (!1 !== _.mock && (!0 === _.mock ? l.duration = l.delay = 1 : (l.duration *= parseFloat(_.mock) || 1, l.delay *= parseFloat(_.mock) || 1)), l.easing = d(l.easing, l.duration), l.begin && !w.isFunction(l.begin) && (l.begin = null), l.progress && !w.isFunction(l.progress) && (l.progress = null), l.complete && !w.isFunction(l.complete) && (l.complete = null), l.display !== i && null !== l.display && (l.display = l.display.toString().toLowerCase(), "auto" === l.display && (l.display = _.CSS.Values.getDisplayType(e))), l.visibility !== i && null !== l.visibility && (l.visibility = l.visibility.toString().toLowerCase()), l.mobileHA = l.mobileHA && _.State.isMobile && !_.State.isGingerbread, !1 === l.queue)
                        if (l.delay) {
                            var c = _.State.delayedElements.count++;
                            _.State.delayedElements[c] = e;
                            var h = function(e) {
                                return function() {
                                    _.State.delayedElements[e] = !1, o()
                                }
                            }(c);
                            s(e).delayBegin = (new Date).getTime(), s(e).delay = parseFloat(l.delay), s(e).delayTimer = {
                                setTimeout: setTimeout(o, parseFloat(l.delay)),
                                next: h
                            }
                        } else o();
                    else f.queue(e, l.queue, function(e, t) {
                        return !0 === t ? (T.promise && T.resolver(v), !0) : (_.velocityQueueEntryFlag = !0, void o(e))
                    });
                    "" !== l.queue && "fx" !== l.queue || "inprogress" === f.queue(e)[0] || f.dequeue(e)
                }
                var u, c, g, m, v, y, x, S = arguments[0] && (arguments[0].p || f.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || w.isString(arguments[0].properties));
                w.isWrapped(this) ? (c = !1, m = 0, v = this, g = this) : (c = !0, m = 1, v = S ? arguments[0].elements || arguments[0].e : arguments[0]);
                var T = {
                    promise: null,
                    resolver: null,
                    rejecter: null
                };
                if (c && _.Promise && (T.promise = new _.Promise(function(e, t) {
                        T.resolver = e, T.rejecter = t
                    })), S ? (y = arguments[0].properties || arguments[0].p, x = arguments[0].options || arguments[0].o) : (y = arguments[m], x = arguments[m + 1]), !(v = o(v))) return void(T.promise && (y && x && !1 === x.promiseRejectEmpty ? T.resolver() : T.rejecter()));
                var P = v.length,
                    E = 0;
                if (!/^(stop|finish|finishAll|pause|resume)$/i.test(y) && !f.isPlainObject(x)) {
                    var I = m + 1;
                    x = {};
                    for (var O = I; O < arguments.length; O++) w.isArray(arguments[O]) || !/^(fast|normal|slow)$/i.test(arguments[O]) && !/^\d/.test(arguments[O]) ? w.isString(arguments[O]) || w.isArray(arguments[O]) ? x.easing = arguments[O] : w.isFunction(arguments[O]) && (x.complete = arguments[O]) : x.duration = arguments[O]
                }
                var z;
                switch (y) {
                    case "scroll":
                        z = "scroll";
                        break;
                    case "reverse":
                        z = "reverse";
                        break;
                    case "pause":
                        var N = (new Date).getTime();
                        return f.each(v, function(e, t) {
                            a(t, N)
                        }), f.each(_.State.calls, function(e, t) {
                            var n = !1;
                            t && f.each(t[1], function(e, r) {
                                var o = x === i ? "" : x;
                                return !0 !== o && t[2].queue !== o && (x !== i || !1 !== t[2].queue) || (f.each(v, function(e, i) {
                                    if (i === r) return t[5] = {
                                        resume: !1
                                    }, n = !0, !1
                                }), !n && void 0)
                            })
                        }), e();
                    case "resume":
                        return f.each(v, function(e, t) {
                            l(t, N)
                        }), f.each(_.State.calls, function(e, t) {
                            var n = !1;
                            t && f.each(t[1], function(e, r) {
                                var o = x === i ? "" : x;
                                return !0 !== o && t[2].queue !== o && (x !== i || !1 !== t[2].queue) || !t[5] || (f.each(v, function(e, i) {
                                    if (i === r) return t[5].resume = !0, n = !0, !1
                                }), !n && void 0)
                            })
                        }), e();
                    case "finish":
                    case "finishAll":
                    case "stop":
                        f.each(v, function(e, t) {
                            s(t) && s(t).delayTimer && (clearTimeout(s(t).delayTimer.setTimeout), s(t).delayTimer.next && s(t).delayTimer.next(), delete s(t).delayTimer), "finishAll" !== y || !0 !== x && !w.isString(x) || (f.each(f.queue(t, w.isString(x) ? x : ""), function(e, t) {
                                w.isFunction(t) && t()
                            }), f.queue(t, w.isString(x) ? x : "", []))
                        });
                        var j = [];
                        return f.each(_.State.calls, function(e, t) {
                            t && f.each(t[1], function(n, r) {
                                var o = x === i ? "" : x;
                                return !0 !== o && t[2].queue !== o && (x !== i || !1 !== t[2].queue) || void f.each(v, function(n, i) {
                                    if (i === r)
                                        if ((!0 === x || w.isString(x)) && (f.each(f.queue(i, w.isString(x) ? x : ""), function(e, t) {
                                                w.isFunction(t) && t(null, !0)
                                            }), f.queue(i, w.isString(x) ? x : "", [])), "stop" === y) {
                                            var a = s(i);
                                            a && a.tweensContainer && (!0 === o || "" === o) && f.each(a.tweensContainer, function(e, t) {
                                                t.endValue = t.currentValue
                                            }), j.push(e)
                                        } else "finish" !== y && "finishAll" !== y || (t[2].duration = 1)
                                })
                            })
                        }), "stop" === y && (f.each(j, function(e, t) {
                            h(t, !0)
                        }), T.promise && T.resolver(v)), e();
                    default:
                        if (!f.isPlainObject(y) || w.isEmptyObject(y)) {
                            if (w.isString(y) && _.Redirects[y]) {
                                u = f.extend({}, x);
                                var $ = u.duration,
                                    D = u.delay || 0;
                                return !0 === u.backwards && (v = f.extend(!0, [], v).reverse()), f.each(v, function(e, t) {
                                    parseFloat(u.stagger) ? u.delay = D + parseFloat(u.stagger) * e : w.isFunction(u.stagger) && (u.delay = D + u.stagger.call(t, e, P)), u.drag && (u.duration = parseFloat($) || (/^(callout|transition)/.test(y) ? 1e3 : C), u.duration = Math.max(u.duration * (u.backwards ? 1 - e / P : (e + 1) / P), .75 * u.duration, 200)), _.Redirects[y].call(t, t, u || {}, e, P, v, T.promise ? T : i)
                                }), e()
                            }
                            var F = "Velocity: First argument (" + y + ") was not a property map, a known action, or a registered redirect. Aborting.";
                            return T.promise ? T.rejecter(new Error(F)) : t.console && console.log(F), e()
                        }
                        z = "start"
                }
                var q = {
                        lastParent: null,
                        lastPosition: null,
                        lastFontSize: null,
                        lastPercentToPxWidth: null,
                        lastPercentToPxHeight: null,
                        lastEmToPx: null,
                        remToPx: null,
                        vwToPx: null,
                        vhToPx: null
                    },
                    L = [];
                f.each(v, function(e, t) {
                    w.isNode(t) && r(t, e)
                }), u = f.extend({}, _.defaults, x), u.loop = parseInt(u.loop, 10);
                var R = 2 * u.loop - 1;
                if (u.loop)
                    for (var H = 0; H < R; H++) {
                        var V = {
                            delay: u.delay,
                            progress: u.progress
                        };
                        H === R - 1 && (V.display = u.display, V.visibility = u.visibility, V.complete = u.complete), k(v, "reverse", V)
                    }
                return e()
            };
            _ = f.extend(k, _), _.animate = k;
            var P = t.requestAnimationFrame || m;
            if (!_.State.isMobile && n.hidden !== i) {
                var E = function() {
                    n.hidden ? (P = function(e) {
                        return setTimeout(function() {
                            e(!0)
                        }, 16)
                    }, p()) : P = t.requestAnimationFrame || m
                };
                E(), n.addEventListener("visibilitychange", E)
            }
            return e.Velocity = _, e !== t && (e.fn.velocity = k, e.fn.velocity.defaults = _.defaults), f.each(["Down", "Up"], function(e, t) {
                _.Redirects["slide" + t] = function(e, n, r, o, s, a) {
                    var l = f.extend({}, n),
                        u = l.begin,
                        c = l.complete,
                        d = {},
                        p = {
                            height: "",
                            marginTop: "",
                            marginBottom: "",
                            paddingTop: "",
                            paddingBottom: ""
                        };
                    l.display === i && (l.display = "Down" === t ? "inline" === _.CSS.Values.getDisplayType(e) ? "inline-block" : "block" : "none"), l.begin = function() {
                        0 === r && u && u.call(s, s);
                        for (var n in p)
                            if (p.hasOwnProperty(n)) {
                                d[n] = e.style[n];
                                var i = A.getPropertyValue(e, n);
                                p[n] = "Down" === t ? [i, 0] : [0, i]
                            } d.overflow = e.style.overflow, e.style.overflow = "hidden"
                    }, l.complete = function() {
                        for (var t in d) d.hasOwnProperty(t) && (e.style[t] = d[t]);
                        r === o - 1 && (c && c.call(s, s), a && a.resolver(s))
                    }, _(e, p, l)
                }
            }), f.each(["In", "Out"], function(e, t) {
                _.Redirects["fade" + t] = function(e, n, r, o, s, a) {
                    var l = f.extend({}, n),
                        u = l.complete,
                        c = {
                            opacity: "In" === t ? 1 : 0
                        };
                    0 !== r && (l.begin = null), l.complete = r !== o - 1 ? null : function() {
                        u && u.call(s, s), a && a.resolver(s)
                    }, l.display === i && (l.display = "In" === t ? "auto" : "none"), _(this, c, l)
                }
            }), _
        }(window.jQuery || window.Zepto || window, window, window ? window.document : void 0)
    }), /*! pace 1.0.2 */
    function() {
        var e, t, n, i, r, o, s, a, l, u, c, d, p, h, f, g, m, v, y, b, w, x, C, S, _, T, A, k, P, E, I, O, z, N, j, $, D, F, q, L, R, H, V, M, W, B, U, Q, X, Y = [].slice,
            G = {}.hasOwnProperty,
            Z = function(e, t) {
                function n() {
                    this.constructor = e
                }
                for (var i in t) G.call(t, i) && (e[i] = t[i]);
                return n.prototype = t.prototype, e.prototype = new n, e.__super__ = t.prototype, e
            },
            K = [].indexOf || function(e) {
                for (var t = 0, n = this.length; n > t; t++)
                    if (t in this && this[t] === e) return t;
                return -1
            };
        for (w = {
                catchupTime: 100,
                initialRate: .03,
                minTime: 250,
                ghostTime: 100,
                maxProgressPerFrame: 20,
                easeFactor: 1.25,
                startOnPageLoad: !0,
                restartOnPushState: !0,
                restartOnRequestAfter: 500,
                target: "body",
                elements: {
                    checkInterval: 100,
                    selectors: ["body"]
                },
                eventLag: {
                    minSamples: 10,
                    sampleCount: 3,
                    lagThreshold: 3
                },
                ajax: {
                    trackMethods: ["GET"],
                    trackWebSockets: !0,
                    ignoreURLs: []
                }
            }, P = function() {
                var e;
                return null != (e = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance.now() : void 0) ? e : +new Date
            }, I = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame, b = window.cancelAnimationFrame || window.mozCancelAnimationFrame, null == I && (I = function(e) {
                return setTimeout(e, 50)
            }, b = function(e) {
                return clearTimeout(e)
            }), z = function(e) {
                var t, n;
                return t = P(), (n = function() {
                    var i;
                    return i = P() - t, i >= 33 ? (t = P(), e(i, function() {
                        return I(n)
                    })) : setTimeout(n, 33 - i)
                })()
            }, O = function() {
                var e, t, n;
                return n = arguments[0], t = arguments[1], e = 3 <= arguments.length ? Y.call(arguments, 2) : [], "function" == typeof n[t] ? n[t].apply(n, e) : n[t]
            }, x = function() {
                var e, t, n, i, r, o, s;
                for (t = arguments[0], i = 2 <= arguments.length ? Y.call(arguments, 1) : [], o = 0, s = i.length; s > o; o++)
                    if (n = i[o])
                        for (e in n) G.call(n, e) && (r = n[e], null != t[e] && "object" == typeof t[e] && null != r && "object" == typeof r ? x(t[e], r) : t[e] = r);
                return t
            }, m = function(e) {
                var t, n, i, r, o;
                for (n = t = 0, r = 0, o = e.length; o > r; r++) i = e[r], n += Math.abs(i), t++;
                return n / t
            }, S = function(e, t) {
                var n, i, r;
                if (null == e && (e = "options"), null == t && (t = !0), r = document.querySelector("[data-pace-" + e + "]")) {
                    if (n = r.getAttribute("data-pace-" + e), !t) return n;
                    try {
                        return JSON.parse(n)
                    } catch (o) {
                        return i = o, "undefined" != typeof console && null !== console ? console.error("Error parsing inline pace options", i) : void 0
                    }
                }
            }, s = function() {
                function e() {}
                return e.prototype.on = function(e, t, n, i) {
                    var r;
                    return null == i && (i = !1), null == this.bindings && (this.bindings = {}), null == (r = this.bindings)[e] && (r[e] = []), this.bindings[e].push({
                        handler: t,
                        ctx: n,
                        once: i
                    })
                }, e.prototype.once = function(e, t, n) {
                    return this.on(e, t, n, !0)
                }, e.prototype.off = function(e, t) {
                    var n, i, r;
                    if (null != (null != (i = this.bindings) ? i[e] : void 0)) {
                        if (null == t) return delete this.bindings[e];
                        for (n = 0, r = []; n < this.bindings[e].length;) r.push(this.bindings[e][n].handler === t ? this.bindings[e].splice(n, 1) : n++);
                        return r
                    }
                }, e.prototype.trigger = function() {
                    var e, t, n, i, r, o, s, a, l;
                    if (n = arguments[0], e = 2 <= arguments.length ? Y.call(arguments, 1) : [], null != (s = this.bindings) ? s[n] : void 0) {
                        for (r = 0, l = []; r < this.bindings[n].length;) a = this.bindings[n][r], i = a.handler, t = a.ctx, o = a.once, i.apply(null != t ? t : this, e), l.push(o ? this.bindings[n].splice(r, 1) : r++);
                        return l
                    }
                }, e
            }(), u = window.Pace || {}, window.Pace = u, x(u, s.prototype), E = u.options = x({}, w, window.paceOptions, S()), U = ["ajax", "document", "eventLag", "elements"], V = 0, W = U.length; W > V; V++) D = U[V], E[D] === !0 && (E[D] = w[D]);
        l = function(e) {
            function t() {
                return Q = t.__super__.constructor.apply(this, arguments)
            }
            return Z(t, e), t
        }(Error), t = function() {
            function e() {
                this.progress = 0
            }
            return e.prototype.getElement = function() {
                var e;
                if (null == this.el) {
                    if (e = document.querySelector(E.target), !e) throw new l;
                    this.el = document.createElement("div"), this.el.className = "pace pace-active", document.body.className = document.body.className.replace(/pace-done/g, ""), document.body.className += " pace-running", this.el.innerHTML = '<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>', null != e.firstChild ? e.insertBefore(this.el, e.firstChild) : e.appendChild(this.el)
                }
                return this.el
            }, e.prototype.finish = function() {
                var e;
                return e = this.getElement(), e.className = e.className.replace("pace-active", ""), e.className += " pace-inactive", document.body.className = document.body.className.replace("pace-running", ""), document.body.className += " pace-done"
            }, e.prototype.update = function(e) {
                return this.progress = e, this.render()
            }, e.prototype.destroy = function() {
                try {
                    this.getElement().parentNode.removeChild(this.getElement())
                } catch (e) {
                    l = e
                }
                return this.el = void 0
            }, e.prototype.render = function() {
                var e, t, n, i, r, o, s;
                if (null == document.querySelector(E.target)) return !1;
                for (e = this.getElement(), i = "translate3d(" + this.progress + "%, 0, 0)", s = ["webkitTransform", "msTransform", "transform"], r = 0, o = s.length; o > r; r++) t = s[r], e.children[0].style[t] = i;
                return (!this.lastRenderedProgress || this.lastRenderedProgress | 0 !== this.progress | 0) && (e.children[0].setAttribute("data-progress-text", "" + (0 | this.progress) + "%"), this.progress >= 100 ? n = "99" : (n = this.progress < 10 ? "0" : "", n += 0 | this.progress), e.children[0].setAttribute("data-progress", "" + n)), this.lastRenderedProgress = this.progress
            }, e.prototype.done = function() {
                return this.progress >= 100
            }, e
        }(), a = function() {
            function e() {
                this.bindings = {}
            }
            return e.prototype.trigger = function(e, t) {
                var n, i, r, o, s;
                if (null != this.bindings[e]) {
                    for (o = this.bindings[e], s = [], i = 0, r = o.length; r > i; i++) n = o[i], s.push(n.call(this, t));
                    return s
                }
            }, e.prototype.on = function(e, t) {
                var n;
                return null == (n = this.bindings)[e] && (n[e] = []), this.bindings[e].push(t)
            }, e
        }(), H = window.XMLHttpRequest, R = window.XDomainRequest, L = window.WebSocket, C = function(e, t) {
            var n, i, r;
            r = [];
            for (i in t.prototype) try {
                r.push(null == e[i] && "function" != typeof t[i] ? "function" == typeof Object.defineProperty ? Object.defineProperty(e, i, {
                    get: function() {
                        return t.prototype[i]
                    },
                    configurable: !0,
                    enumerable: !0
                }) : e[i] = t.prototype[i] : void 0)
            } catch (o) {
                n = o
            }
            return r
        }, A = [], u.ignore = function() {
            var e, t, n;
            return t = arguments[0], e = 2 <= arguments.length ? Y.call(arguments, 1) : [], A.unshift("ignore"), n = t.apply(null, e), A.shift(), n
        }, u.track = function() {
            var e, t, n;
            return t = arguments[0], e = 2 <= arguments.length ? Y.call(arguments, 1) : [], A.unshift("track"), n = t.apply(null, e), A.shift(), n
        }, $ = function(e) {
            var t;
            if (null == e && (e = "GET"), "track" === A[0]) return "force";
            if (!A.length && E.ajax) {
                if ("socket" === e && E.ajax.trackWebSockets) return !0;
                if (t = e.toUpperCase(), K.call(E.ajax.trackMethods, t) >= 0) return !0
            }
            return !1
        }, c = function(e) {
            function t() {
                var e, n = this;
                t.__super__.constructor.apply(this, arguments), e = function(e) {
                    var t;
                    return t = e.open, e.open = function(i, r) {
                        return $(i) && n.trigger("request", {
                            type: i,
                            url: r,
                            request: e
                        }), t.apply(e, arguments)
                    }
                }, window.XMLHttpRequest = function(t) {
                    var n;
                    return n = new H(t), e(n), n
                };
                try {
                    C(window.XMLHttpRequest, H)
                } catch (i) {}
                if (null != R) {
                    window.XDomainRequest = function() {
                        var t;
                        return t = new R, e(t), t
                    };
                    try {
                        C(window.XDomainRequest, R)
                    } catch (i) {}
                }
                if (null != L && E.ajax.trackWebSockets) {
                    window.WebSocket = function(e, t) {
                        var i;
                        return i = null != t ? new L(e, t) : new L(e), $("socket") && n.trigger("request", {
                            type: "socket",
                            url: e,
                            protocols: t,
                            request: i
                        }), i
                    };
                    try {
                        C(window.WebSocket, L)
                    } catch (i) {}
                }
            }
            return Z(t, e), t
        }(a), M = null, _ = function() {
            return null == M && (M = new c), M
        }, j = function(e) {
            var t, n, i, r;
            for (r = E.ajax.ignoreURLs, n = 0, i = r.length; i > n; n++)
                if (t = r[n], "string" == typeof t) {
                    if (-1 !== e.indexOf(t)) return !0
                } else if (t.test(e)) return !0;
            return !1
        }, _().on("request", function(t) {
            var n, i, r, o, s;
            return o = t.type, r = t.request, s = t.url, j(s) ? void 0 : u.running || E.restartOnRequestAfter === !1 && "force" !== $(o) ? void 0 : (i = arguments, n = E.restartOnRequestAfter || 0, "boolean" == typeof n && (n = 0), setTimeout(function() {
                var t, n, s, a, l, c;
                if (t = "socket" === o ? r.readyState < 2 : 0 < (a = r.readyState) && 4 > a) {
                    for (u.restart(), l = u.sources, c = [], n = 0, s = l.length; s > n; n++) {
                        if (D = l[n], D instanceof e) {
                            D.watch.apply(D, i);
                            break
                        }
                        c.push(void 0)
                    }
                    return c
                }
            }, n))
        }), e = function() {
            function e() {
                var e = this;
                this.elements = [], _().on("request", function() {
                    return e.watch.apply(e, arguments)
                })
            }
            return e.prototype.watch = function(e) {
                var t, n, i, r;
                return i = e.type, t = e.request, r = e.url, j(r) ? void 0 : (n = "socket" === i ? new h(t) : new f(t), this.elements.push(n))
            }, e
        }(), f = function() {
            function e(e) {
                var t, n, i, r, o, s, a = this;
                if (this.progress = 0, null != window.ProgressEvent)
                    for (n = null, e.addEventListener("progress", function(e) {
                            return a.progress = e.lengthComputable ? 100 * e.loaded / e.total : a.progress + (100 - a.progress) / 2
                        }, !1), s = ["load", "abort", "timeout", "error"], i = 0, r = s.length; r > i; i++) t = s[i], e.addEventListener(t, function() {
                        return a.progress = 100
                    }, !1);
                else o = e.onreadystatechange, e.onreadystatechange = function() {
                    var t;
                    return 0 === (t = e.readyState) || 4 === t ? a.progress = 100 : 3 === e.readyState && (a.progress = 50), "function" == typeof o ? o.apply(null, arguments) : void 0
                }
            }
            return e
        }(), h = function() {
            function e(e) {
                var t, n, i, r, o = this;
                for (this.progress = 0, r = ["error", "open"], n = 0, i = r.length; i > n; n++) t = r[n], e.addEventListener(t, function() {
                    return o.progress = 100
                }, !1)
            }
            return e
        }(), i = function() {
            function e(e) {
                var t, n, i, o;
                for (null == e && (e = {}), this.elements = [], null == e.selectors && (e.selectors = []), o = e.selectors, n = 0, i = o.length; i > n; n++) t = o[n], this.elements.push(new r(t))
            }
            return e
        }(), r = function() {
            function e(e) {
                this.selector = e, this.progress = 0, this.check()
            }
            return e.prototype.check = function() {
                var e = this;
                return document.querySelector(this.selector) ? this.done() : setTimeout(function() {
                    return e.check()
                }, E.elements.checkInterval)
            }, e.prototype.done = function() {
                return this.progress = 100
            }, e
        }(), n = function() {
            function e() {
                var e, t, n = this;
                this.progress = null != (t = this.states[document.readyState]) ? t : 100, e = document.onreadystatechange, document.onreadystatechange = function() {
                    return null != n.states[document.readyState] && (n.progress = n.states[document.readyState]), "function" == typeof e ? e.apply(null, arguments) : void 0
                }
            }
            return e.prototype.states = {
                loading: 0,
                interactive: 50,
                complete: 100
            }, e
        }(), o = function() {
            function e() {
                var e, t, n, i, r, o = this;
                this.progress = 0, e = 0, r = [], i = 0, n = P(), t = setInterval(function() {
                    var s;
                    return s = P() - n - 50, n = P(), r.push(s), r.length > E.eventLag.sampleCount && r.shift(), e = m(r), ++i >= E.eventLag.minSamples && e < E.eventLag.lagThreshold ? (o.progress = 100, clearInterval(t)) : o.progress = 100 * (3 / (e + 3))
                }, 50)
            }
            return e
        }(), p = function() {
            function e(e) {
                this.source = e, this.last = this.sinceLastUpdate = 0, this.rate = E.initialRate, this.catchup = 0, this.progress = this.lastProgress = 0, null != this.source && (this.progress = O(this.source, "progress"))
            }
            return e.prototype.tick = function(e, t) {
                var n;
                return null == t && (t = O(this.source, "progress")), t >= 100 && (this.done = !0), t === this.last ? this.sinceLastUpdate += e : (this.sinceLastUpdate && (this.rate = (t - this.last) / this.sinceLastUpdate), this.catchup = (t - this.progress) / E.catchupTime, this.sinceLastUpdate = 0, this.last = t), t > this.progress && (this.progress += this.catchup * e), n = 1 - Math.pow(this.progress / 100, E.easeFactor), this.progress += n * this.rate * e, this.progress = Math.min(this.lastProgress + E.maxProgressPerFrame, this.progress), this.progress = Math.max(0, this.progress), this.progress = Math.min(100, this.progress), this.lastProgress = this.progress, this.progress
            }, e
        }(), F = null, N = null, v = null, q = null, g = null, y = null, u.running = !1, T = function() {
            return E.restartOnPushState ? u.restart() : void 0
        }, null != window.history.pushState && (B = window.history.pushState, window.history.pushState = function() {
            return T(), B.apply(window.history, arguments)
        }), null != window.history.replaceState && (X = window.history.replaceState, window.history.replaceState = function() {
            return T(), X.apply(window.history, arguments)
        }), d = {
            ajax: e,
            elements: i,
            document: n,
            eventLag: o
        }, (k = function() {
            var e, n, i, r, o, s, a, l;
            for (u.sources = F = [], s = ["ajax", "elements", "document", "eventLag"], n = 0, r = s.length; r > n; n++) e = s[n], E[e] !== !1 && F.push(new d[e](E[e]));
            for (l = null != (a = E.extraSources) ? a : [], i = 0, o = l.length; o > i; i++) D = l[i], F.push(new D(E));
            return u.bar = v = new t, N = [], q = new p
        })(), u.stop = function() {
            return u.trigger("stop"), u.running = !1, v.destroy(), y = !0, null != g && ("function" == typeof b && b(g), g = null), k()
        }, u.restart = function() {
            return u.trigger("restart"), u.stop(), u.start()
        }, u.go = function() {
            var e;
            return u.running = !0, v.render(), e = P(), y = !1, g = z(function(t, n) {
                var i, r, o, s, a, l, c, d, h, f, g, m, b, w, x, C;
                for (d = 100 - v.progress, r = g = 0, o = !0, l = m = 0, w = F.length; w > m; l = ++m)
                    for (D = F[l], f = null != N[l] ? N[l] : N[l] = [], a = null != (C = D.elements) ? C : [D], c = b = 0, x = a.length; x > b; c = ++b) s = a[c], h = null != f[c] ? f[c] : f[c] = new p(s), o &= h.done, h.done || (r++, g += h.tick(t));
                return i = g / r, v.update(q.tick(t, i)), v.done() || o || y ? (v.update(100), u.trigger("done"), setTimeout(function() {
                    return v.finish(), u.running = !1, u.trigger("hide")
                }, Math.max(E.ghostTime, Math.max(E.minTime - (P() - e), 0)))) : n()
            })
        }, u.start = function(e) {
            x(E, e), u.running = !0;
            try {
                v.render()
            } catch (t) {
                l = t
            }
            return document.querySelector(".pace") ? (u.trigger("start"), u.go()) : setTimeout(u.start, 50)
        }, "function" == typeof define && define.amd ? define(["pace"], function() {
            return u
        }) : "object" == typeof exports ? module.exports = u : E.startOnPageLoad && u.start()
    }.call(this), /*! lazysizes - v3.0.0 */
    ! function() {
        "use strict";
        if (window.addEventListener) {
            var e = /\s+/g,
                t = /\s*\|\s+|\s+\|\s*/g,
                n = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                i = /\(|\)|'/,
                r = {
                    contain: 1,
                    cover: 1
                },
                o = function(e) {
                    var t = lazySizes.gW(e, e.parentNode);
                    return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), e._lazysizesWidth
                },
                s = function(e) {
                    var t;
                    return t = (getComputedStyle(e) || {
                        getPropertyValue: function() {}
                    }).getPropertyValue("background-size"), !r[t] && r[e.style.backgroundSize] && (t = e.style.backgroundSize), t
                },
                a = function(i, r, o) {
                    var s = document.createElement("picture"),
                        a = r.getAttribute(lazySizesConfig.sizesAttr),
                        l = r.getAttribute("data-ratio"),
                        u = r.getAttribute("data-optimumx");
                    r._lazybgset && r._lazybgset.parentNode == r && r.removeChild(r._lazybgset), Object.defineProperty(o, "_lazybgset", {
                        value: r,
                        writable: !0
                    }), Object.defineProperty(r, "_lazybgset", {
                        value: s,
                        writable: !0
                    }), i = i.replace(e, " ").split(t), s.style.display = "none", o.className = lazySizesConfig.lazyClass, 1 != i.length || a || (a = "auto"), i.forEach(function(e) {
                        var t = document.createElement("source");
                        a && "auto" != a && t.setAttribute("sizes", a), e.match(n) && (t.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && t.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)), s.appendChild(t)
                    }), a && (o.setAttribute(lazySizesConfig.sizesAttr, a), r.removeAttribute(lazySizesConfig.sizesAttr), r.removeAttribute("sizes")), u && o.setAttribute("data-optimumx", u), l && o.setAttribute("data-ratio", l), s.appendChild(o), r.appendChild(s)
                },
                l = function(e) {
                    if (e.target._lazybgset) {
                        var t = e.target,
                            n = t._lazybgset,
                            r = t.currentSrc || t.src;
                        r && (n.style.backgroundImage = "url(" + (i.test(r) ? JSON.stringify(r) : r) + ")"), t._lazybgsetLoading && (lazySizes.fire(n, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading)
                    }
                };
            addEventListener("lazybeforeunveil", function(e) {
                var t, n, i;
                !e.defaultPrevented && (t = e.target.getAttribute("data-bgset")) && (i = e.target, n = document.createElement("img"), n.alt = "", n._lazybgsetLoading = !0, e.detail.firesLoad = !0, a(t, i, n), setTimeout(function() {
                    lazySizes.loader.unveil(n), lazySizes.rAF(function() {
                        lazySizes.fire(n, "_lazyloaded", {}, !0, !0), n.complete && l({
                            target: n
                        })
                    })
                }))
            }), document.addEventListener("load", l, !0), window.addEventListener("lazybeforesizes", function(e) {
                if (e.target._lazybgset && e.detail.dataAttr) {
                    var t = e.target._lazybgset,
                        n = s(t);
                    r[n] && (e.target._lazysizesParentFit = n, lazySizes.rAF(function() {
                        e.target.setAttribute("data-parent-fit", n), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                    }))
                }
            }, !0), document.documentElement.addEventListener("lazybeforesizes", function(e) {
                !e.defaultPrevented && e.target._lazybgset && (e.detail.width = o(e.target._lazybgset))
            })
        }
    }(), /*! lazysizes - v3.0.0 */
    ! function(e, t) {
        var n = t(e, e.document);
        e.lazySizes = n, "object" == typeof module && module.exports && (module.exports = n)
    }(window, function(e, t) {
        "use strict";
        if (t.getElementsByClassName) {
            var n, i = t.documentElement,
                r = e.Date,
                o = e.HTMLPictureElement,
                s = "addEventListener",
                a = "getAttribute",
                l = e[s],
                u = e.setTimeout,
                c = e.requestAnimationFrame || u,
                d = e.requestIdleCallback,
                p = /^picture$/i,
                h = ["load", "error", "lazyincluded", "_lazyloaded"],
                f = {},
                g = Array.prototype.forEach,
                m = function(e, t) {
                    return f[t] || (f[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), f[t].test(e[a]("class") || "") && f[t]
                },
                v = function(e, t) {
                    m(e, t) || e.setAttribute("class", (e[a]("class") || "").trim() + " " + t)
                },
                y = function(e, t) {
                    var n;
                    (n = m(e, t)) && e.setAttribute("class", (e[a]("class") || "").replace(n, " "))
                },
                b = function(e, t, n) {
                    var i = n ? s : "removeEventListener";
                    n && b(e, t), h.forEach(function(n) {
                        e[i](n, t)
                    })
                },
                w = function(e, n, i, r, o) {
                    var s = t.createEvent("CustomEvent");
                    return s.initCustomEvent(n, !r, !o, i || {}), e.dispatchEvent(s), s
                },
                x = function(t, i) {
                    var r;
                    !o && (r = e.picturefill || n.pf) ? r({
                        reevaluate: !0,
                        elements: [t]
                    }) : i && i.src && (t.src = i.src)
                },
                C = function(e, t) {
                    return (getComputedStyle(e, null) || {})[t]
                },
                S = function(e, t, i) {
                    for (i = i || e.offsetWidth; i < n.minSize && t && !e._lazysizesWidth;) i = t.offsetWidth, t = t.parentNode;
                    return i
                },
                _ = function() {
                    var e, n, i = [],
                        r = [],
                        o = i,
                        s = function() {
                            var t = o;
                            for (o = i.length ? r : i, e = !0, n = !1; t.length;) t.shift()();
                            e = !1
                        },
                        a = function(i, r) {
                            e && !r ? i.apply(this, arguments) : (o.push(i), n || (n = !0, (t.hidden ? u : c)(s)))
                        };
                    return a._lsFlush = s, a
                }(),
                T = function(e, t) {
                    return t ? function() {
                        _(e)
                    } : function() {
                        var t = this,
                            n = arguments;
                        _(function() {
                            e.apply(t, n)
                        })
                    }
                },
                A = function(e) {
                    var t, n = 0,
                        i = 125,
                        o = 666,
                        s = o,
                        a = function() {
                            t = !1, n = r.now(), e()
                        },
                        l = d ? function() {
                            d(a, {
                                timeout: s
                            }), s !== o && (s = o)
                        } : T(function() {
                            u(a)
                        }, !0);
                    return function(e) {
                        var o;
                        (e = e === !0) && (s = 44), t || (t = !0, o = i - (r.now() - n), 0 > o && (o = 0), e || 9 > o && d ? l() : u(l, o))
                    }
                },
                k = function(e) {
                    var t, n, i = 99,
                        o = function() {
                            t = null, e()
                        },
                        s = function() {
                            var e = r.now() - n;
                            i > e ? u(s, i - e) : (d || o)(o)
                        };
                    return function() {
                        n = r.now(), t || (t = u(s, i))
                    }
                },
                P = function() {
                    var o, c, d, h, f, S, P, I, O, z, N, j, $, D, F, q = /^img$/i,
                        L = /^iframe$/i,
                        R = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                        H = 0,
                        V = 0,
                        M = 0,
                        W = -1,
                        B = function(e) {
                            M--, e && e.target && b(e.target, B), (!e || 0 > M || !e.target) && (M = 0)
                        },
                        U = function(e, n) {
                            var r, o = e,
                                s = "hidden" == C(t.body, "visibility") || "hidden" != C(e, "visibility");
                            for (O -= n, j += n, z -= n, N += n; s && (o = o.offsetParent) && o != t.body && o != i;) s = (C(o, "opacity") || 1) > 0, s && "visible" != C(o, "overflow") && (r = o.getBoundingClientRect(), s = N > r.left && z < r.right && j > r.top - 1 && O < r.bottom + 1);
                            return s
                        },
                        Q = function() {
                            var e, r, s, l, u, p, h, g, m;
                            if ((f = n.loadMode) && 8 > M && (e = o.length)) {
                                r = 0, W++, null == D && ("expand" in n || (n.expand = i.clientHeight > 500 && i.clientWidth > 500 ? 500 : 370), $ = n.expand, D = $ * n.expFactor), D > V && 1 > M && W > 2 && f > 2 && !t.hidden ? (V = D, W = 0) : V = f > 1 && W > 1 && 6 > M ? $ : H;
                                for (; e > r; r++)
                                    if (o[r] && !o[r]._lazyRace)
                                        if (R)
                                            if ((g = o[r][a]("data-expand")) && (p = 1 * g) || (p = V), m !== p && (P = innerWidth + p * F, I = innerHeight + p, h = -1 * p, m = p), s = o[r].getBoundingClientRect(), (j = s.bottom) >= h && (O = s.top) <= I && (N = s.right) >= h * F && (z = s.left) <= P && (j || N || z || O) && (d && 3 > M && !g && (3 > f || 4 > W) || U(o[r], p))) {
                                                if (te(o[r]), u = !0, M > 9) break
                                            } else !u && d && !l && 4 > M && 4 > W && f > 2 && (c[0] || n.preloadAfterLoad) && (c[0] || !g && (j || N || z || O || "auto" != o[r][a](n.sizesAttr))) && (l = c[0] || o[r]);
                                else te(o[r]);
                                l && !u && te(l)
                            }
                        },
                        X = A(Q),
                        Y = function(e) {
                            v(e.target, n.loadedClass), y(e.target, n.loadingClass), b(e.target, Z)
                        },
                        G = T(Y),
                        Z = function(e) {
                            G({
                                target: e.target
                            })
                        },
                        K = function(e, t) {
                            try {
                                e.contentWindow.location.replace(t)
                            } catch (n) {
                                e.src = t
                            }
                        },
                        J = function(e) {
                            var t, i, r = e[a](n.srcsetAttr);
                            (t = n.customMedia[e[a]("data-media") || e[a]("media")]) && e.setAttribute("media", t), r && e.setAttribute("srcset", r), t && (i = e.parentNode, i.insertBefore(e.cloneNode(), e), i.removeChild(e))
                        },
                        ee = T(function(e, t, i, r, o) {
                            var s, l, c, d, f, m;
                            (f = w(e, "lazybeforeunveil", t)).defaultPrevented || (r && (i ? v(e, n.autosizesClass) : e.setAttribute("sizes", r)), l = e[a](n.srcsetAttr), s = e[a](n.srcAttr), o && (c = e.parentNode, d = c && p.test(c.nodeName || "")), m = t.firesLoad || "src" in e && (l || s || d), f = {
                                target: e
                            }, m && (b(e, B, !0), clearTimeout(h), h = u(B, 2500), v(e, n.loadingClass), b(e, Z, !0)), d && g.call(c.getElementsByTagName("source"), J), l ? e.setAttribute("srcset", l) : s && !d && (L.test(e.nodeName) ? K(e, s) : e.src = s), (l || d) && x(e, {
                                src: s
                            })), e._lazyRace && delete e._lazyRace, y(e, n.lazyClass), _(function() {
                                (!m || e.complete && e.naturalWidth > 1) && (m ? B(f) : M--, Y(f))
                            }, !0)
                        }),
                        te = function(e) {
                            var t, i = q.test(e.nodeName),
                                r = i && (e[a](n.sizesAttr) || e[a]("sizes")),
                                o = "auto" == r;
                            (!o && d || !i || !e.src && !e.srcset || e.complete || m(e, n.errorClass)) && (t = w(e, "lazyunveilread").detail, o && E.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, M++, ee(e, t, o, r, i))
                        },
                        ne = function() {
                            if (!d) {
                                if (r.now() - S < 999) return void u(ne, 999);
                                var e = k(function() {
                                    n.loadMode = 3, X()
                                });
                                d = !0, n.loadMode = 3, X(), l("scroll", function() {
                                    3 == n.loadMode && (n.loadMode = 2), e()
                                }, !0)
                            }
                        };
                    return {
                        _: function() {
                            S = r.now(), o = t.getElementsByClassName(n.lazyClass), c = t.getElementsByClassName(n.lazyClass + " " + n.preloadClass), F = n.hFac, l("scroll", X, !0), l("resize", X, !0), e.MutationObserver ? new MutationObserver(X).observe(i, {
                                childList: !0,
                                subtree: !0,
                                attributes: !0
                            }) : (i[s]("DOMNodeInserted", X, !0), i[s]("DOMAttrModified", X, !0), setInterval(X, 999)), l("hashchange", X, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(e) {
                                t[s](e, X, !0)
                            }), /d$|^c/.test(t.readyState) ? ne() : (l("load", ne), t[s]("DOMContentLoaded", X), u(ne, 2e4)), o.length ? (Q(), _._lsFlush()) : X()
                        },
                        checkElems: X,
                        unveil: te
                    }
                }(),
                E = function() {
                    var e, i = T(function(e, t, n, i) {
                            var r, o, s;
                            if (e._lazysizesWidth = i, i += "px", e.setAttribute("sizes", i), p.test(t.nodeName || ""))
                                for (r = t.getElementsByTagName("source"), o = 0, s = r.length; s > o; o++) r[o].setAttribute("sizes", i);
                            n.detail.dataAttr || x(e, n.detail)
                        }),
                        r = function(e, t, n) {
                            var r, o = e.parentNode;
                            o && (n = S(e, o, n), r = w(e, "lazybeforesizes", {
                                width: n,
                                dataAttr: !!t
                            }), r.defaultPrevented || (n = r.detail.width, n && n !== e._lazysizesWidth && i(e, o, r, n)))
                        },
                        o = function() {
                            var t, n = e.length;
                            if (n)
                                for (t = 0; n > t; t++) r(e[t])
                        },
                        s = k(o);
                    return {
                        _: function() {
                            e = t.getElementsByClassName(n.autosizesClass), l("resize", s)
                        },
                        checkElems: s,
                        updateElem: r
                    }
                }(),
                I = function() {
                    I.i || (I.i = !0, E._(), P._())
                };
            return function() {
                var t, i = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: .8,
                    loadMode: 2
                };
                n = e.lazySizesConfig || e.lazysizesConfig || {};
                for (t in i) t in n || (n[t] = i[t]);
                e.lazySizesConfig = n, u(function() {
                    n.init && I()
                })
            }(), {
                cfg: n,
                autoSizer: E,
                loader: P,
                init: I,
                uP: x,
                aC: v,
                rC: y,
                hC: m,
                fire: w,
                gW: S,
                rAF: _
            }
        }
    }),
    function(e, t, n) {
        function i(e, t) {
            return typeof e === t
        }

        function r() {
            var e, t, n, r, o, s, a;
            for (var l in w)
                if (w.hasOwnProperty(l)) {
                    if (e = [], t = w[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                        for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                    for (r = i(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) s = e[o], a = s.split("."), 1 === a.length ? C[a[0]] = r : (!C[a[0]] || C[a[0]] instanceof Boolean || (C[a[0]] = new Boolean(C[a[0]])), C[a[0]][a[1]] = r), _.push((r ? "" : "no-") + a.join("-"))
                }
        }

        function o(e) {
            var t = T.className,
                n = C._config.classPrefix || "";
            if (A && (t = t.baseVal), C._config.enableJSClass) {
                var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                t = t.replace(i, "$1" + n + "js$2")
            }
            C._config.enableClasses && (t += " " + n + e.join(" " + n), A ? T.className.baseVal = t : T.className = t)
        }

        function s(e, t) {
            if ("object" == typeof e)
                for (var n in e) S(e, n) && s(n, e[n]);
            else {
                e = e.toLowerCase();
                var i = e.split("."),
                    r = C[i[0]];
                if (2 == i.length && (r = r[i[1]]), "undefined" != typeof r) return C;
                t = "function" == typeof t ? t() : t, 1 == i.length ? C[i[0]] = t : (!C[i[0]] || C[i[0]] instanceof Boolean || (C[i[0]] = new Boolean(C[i[0]])), C[i[0]][i[1]] = t), o([(t && 0 != t ? "" : "no-") + i.join("-")]), C._trigger(e, t)
            }
            return C
        }

        function a() {
            return "function" != typeof t.createElement ? t.createElement(arguments[0]) : A ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
        }

        function l() {
            var e = t.body;
            return e || (e = a(A ? "svg" : "body"), e.fake = !0), e
        }

        function u(e, n, i, r) {
            var o, s, u, c, d = "modernizr",
                p = a("div"),
                h = l();
            if (parseInt(i, 10))
                for (; i--;) u = a("div"), u.id = r ? r[i] : d + (i + 1), p.appendChild(u);
            return o = a("style"), o.type = "text/css", o.id = "s" + d, (h.fake ? h : p).appendChild(o), h.appendChild(p), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), p.id = d, h.fake && (h.style.background = "", h.style.overflow = "hidden", c = T.style.overflow, T.style.overflow = "hidden", T.appendChild(h)), s = n(p, e), h.fake ? (h.parentNode.removeChild(h), T.style.overflow = c, T.offsetHeight) : p.parentNode.removeChild(p), !!s
        }

        function c(e, t) {
            return !!~("" + e).indexOf(t)
        }

        function d(e) {
            return e.replace(/([A-Z])/g, function(e, t) {
                return "-" + t.toLowerCase()
            }).replace(/^ms-/, "-ms-")
        }

        function p(t, n, i) {
            var r;
            if ("getComputedStyle" in e) {
                r = getComputedStyle.call(e, t, n);
                var o = e.console;
                if (null !== r) i && (r = r.getPropertyValue(i));
                else if (o) {
                    var s = o.error ? "error" : "log";
                    o[s].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
                }
            } else r = !n && t.currentStyle && t.currentStyle[i];
            return r
        }

        function h(t, i) {
            var r = t.length;
            if ("CSS" in e && "supports" in e.CSS) {
                for (; r--;)
                    if (e.CSS.supports(d(t[r]), i)) return !0;
                return !1
            }
            if ("CSSSupportsRule" in e) {
                for (var o = []; r--;) o.push("(" + d(t[r]) + ":" + i + ")");
                return o = o.join(" or "), u("@supports (" + o + ") { #modernizr { position: absolute; } }", function(e) {
                    return "absolute" == p(e, null, "position")
                })
            }
            return n
        }

        function f(e) {
            return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
                return t + n.toUpperCase()
            }).replace(/^-/, "")
        }

        function g(e, t, r, o) {
            function s() {
                u && (delete D.style, delete D.modElem)
            }
            if (o = !i(o, "undefined") && o, !i(r, "undefined")) {
                var l = h(e, r);
                if (!i(l, "undefined")) return l
            }
            for (var u, d, p, g, m, v = ["modernizr", "tspan", "samp"]; !D.style && v.length;) u = !0, D.modElem = a(v.shift()), D.style = D.modElem.style;
            for (p = e.length, d = 0; d < p; d++)
                if (g = e[d], m = D.style[g], c(g, "-") && (g = f(g)), D.style[g] !== n) {
                    if (o || i(r, "undefined")) return s(), "pfx" != t || g;
                    try {
                        D.style[g] = r
                    } catch (y) {}
                    if (D.style[g] != m) return s(), "pfx" != t || g
                } return s(), !1
        }

        function m(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        }

        function v(e, t, n) {
            var r;
            for (var o in e)
                if (e[o] in t) return n === !1 ? e[o] : (r = t[e[o]], i(r, "function") ? m(r, n || t) : r);
            return !1
        }

        function y(e, t, n, r, o) {
            var s = e.charAt(0).toUpperCase() + e.slice(1),
                a = (e + " " + P.join(s + " ") + s).split(" ");
            return i(t, "string") || i(t, "undefined") ? g(a, t, r, o) : (a = (e + " " + I.join(s + " ") + s).split(" "), v(a, t, n))
        }

        function b(e, t, i) {
            return y(e, n, n, t, i)
        }
        var w = [],
            x = {
                _version: "3.6.0",
                _config: {
                    classPrefix: "",
                    enableClasses: !0,
                    enableJSClass: !0,
                    usePrefixes: !0
                },
                _q: [],
                on: function(e, t) {
                    var n = this;
                    setTimeout(function() {
                        t(n[e])
                    }, 0)
                },
                addTest: function(e, t, n) {
                    w.push({
                        name: e,
                        fn: t,
                        options: n
                    })
                },
                addAsyncTest: function(e) {
                    w.push({
                        name: null,
                        fn: e
                    })
                }
            },
            C = function() {};
        C.prototype = x, C = new C;
        var S, _ = [],
            T = t.documentElement,
            A = "svg" === T.nodeName.toLowerCase();
        ! function() {
            var e = {}.hasOwnProperty;
            S = i(e, "undefined") || i(e.call, "undefined") ? function(e, t) {
                return t in e && i(e.constructor.prototype[t], "undefined")
            } : function(t, n) {
                return e.call(t, n)
            }
        }(), x._l = {}, x.on = function(e, t) {
            this._l[e] || (this._l[e] = []), this._l[e].push(t), C.hasOwnProperty(e) && setTimeout(function() {
                C._trigger(e, C[e])
            }, 0)
        }, x._trigger = function(e, t) {
            if (this._l[e]) {
                var n = this._l[e];
                setTimeout(function() {
                    var e, i;
                    for (e = 0; e < n.length; e++)(i = n[e])(t)
                }, 0), delete this._l[e]
            }
        }, C._q.push(function() {
            x.addTest = s
        });
        var k = "Moz O ms Webkit",
            P = x._config.usePrefixes ? k.split(" ") : [];
        x._cssomPrefixes = P;
        var E = function(t) {
            var i, r = q.length,
                o = e.CSSRule;
            if ("undefined" == typeof o) return n;
            if (!t) return !1;
            if (t = t.replace(/^@/, ""), i = t.replace(/-/g, "_").toUpperCase() + "_RULE", i in o) return "@" + t;
            for (var s = 0; s < r; s++) {
                var a = q[s],
                    l = a.toUpperCase() + "_" + i;
                if (l in o) return "@-" + a.toLowerCase() + "-" + t
            }
            return !1
        };
        x.atRule = E;
        var I = x._config.usePrefixes ? k.toLowerCase().split(" ") : [];
        x._domPrefixes = I;
        var O = function() {
            function e(e, t) {
                var r;
                return !!e && (t && "string" != typeof t || (t = a(t || "div")), e = "on" + e, r = e in t, !r && i && (t.setAttribute || (t = a("div")), t.setAttribute(e, ""), r = "function" == typeof t[e], t[e] !== n && (t[e] = n), t.removeAttribute(e)), r)
            }
            var i = !("onblur" in t.documentElement);
            return e
        }();
        x.hasEvent = O;
        A || ! function(e, t) {
            function n(e, t) {
                var n = e.createElement("p"),
                    i = e.getElementsByTagName("head")[0] || e.documentElement;
                return n.innerHTML = "x<style>" + t + "</style>", i.insertBefore(n.lastChild, i.firstChild)
            }

            function i() {
                var e = _.elements;
                return "string" == typeof e ? e.split(" ") : e
            }

            function r(e, t) {
                var n = _.elements;
                "string" != typeof n && (n = n.join(" ")), "string" != typeof e && (e = e.join(" ")), _.elements = n + " " + e, u(t)
            }

            function o(e) {
                var t = S[e[x]];
                return t || (t = {}, C++, e[x] = C, S[C] = t), t
            }

            function s(e, n, i) {
                if (n || (n = t), m) return n.createElement(e);
                i || (i = o(n));
                var r;
                return r = i.cache[e] ? i.cache[e].cloneNode() : w.test(e) ? (i.cache[e] = i.createElem(e)).cloneNode() : i.createElem(e), !r.canHaveChildren || b.test(e) || r.tagUrn ? r : i.frag.appendChild(r)
            }

            function a(e, n) {
                if (e || (e = t), m) return e.createDocumentFragment();
                n = n || o(e);
                for (var r = n.frag.cloneNode(), s = 0, a = i(), l = a.length; s < l; s++) r.createElement(a[s]);
                return r
            }

            function l(e, t) {
                t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, t.frag = t.createFrag()), e.createElement = function(n) {
                    return _.shivMethods ? s(n, e, t) : t.createElem(n)
                }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + i().join().replace(/[\w\-:]+/g, function(e) {
                    return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")'
                }) + ");return n}")(_, t.frag)
            }

            function u(e) {
                e || (e = t);
                var i = o(e);
                return !_.shivCSS || g || i.hasCSS || (i.hasCSS = !!n(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), m || l(e, i), e
            }

            function c(e) {
                for (var t, n = e.getElementsByTagName("*"), r = n.length, o = RegExp("^(?:" + i().join("|") + ")$", "i"), s = []; r--;) t = n[r], o.test(t.nodeName) && s.push(t.applyElement(d(t)));
                return s
            }

            function d(e) {
                for (var t, n = e.attributes, i = n.length, r = e.ownerDocument.createElement(A + ":" + e.nodeName); i--;) t = n[i], t.specified && r.setAttribute(t.nodeName, t.nodeValue);
                return r.style.cssText = e.style.cssText, r
            }

            function p(e) {
                for (var t, n = e.split("{"), r = n.length, o = RegExp("(^|[\\s,>+~])(" + i().join("|") + ")(?=[[\\s,>+~#.:]|$)", "gi"), s = "$1" + A + "\\:$2"; r--;) t = n[r] = n[r].split("}"), t[t.length - 1] = t[t.length - 1].replace(o, s), n[r] = t.join("}");
                return n.join("{")
            }

            function h(e) {
                for (var t = e.length; t--;) e[t].removeNode()
            }

            function f(e) {
                function t() {
                    clearTimeout(s._removeSheetTimer), i && i.removeNode(!0), i = null
                }
                var i, r, s = o(e),
                    a = e.namespaces,
                    l = e.parentWindow;
                return !k || e.printShived ? e : ("undefined" == typeof a[A] && a.add(A), l.attachEvent("onbeforeprint", function() {
                    t();
                    for (var o, s, a, l = e.styleSheets, u = [], d = l.length, h = Array(d); d--;) h[d] = l[d];
                    for (; a = h.pop();)
                        if (!a.disabled && T.test(a.media)) {
                            try {
                                o = a.imports, s = o.length
                            } catch (f) {
                                s = 0
                            }
                            for (d = 0; d < s; d++) h.push(o[d]);
                            try {
                                u.push(a.cssText)
                            } catch (f) {}
                        } u = p(u.reverse().join("")), r = c(e), i = n(e, u)
                }), l.attachEvent("onafterprint", function() {
                    h(r), clearTimeout(s._removeSheetTimer), s._removeSheetTimer = setTimeout(t, 500)
                }), e.printShived = !0, e)
            }
            var g, m, v = "3.7.3",
                y = e.html5 || {},
                b = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
                w = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
                x = "_html5shiv",
                C = 0,
                S = {};
            ! function() {
                try {
                    var e = t.createElement("a");
                    e.innerHTML = "<xyz></xyz>", g = "hidden" in e, m = 1 == e.childNodes.length || function() {
                        t.createElement("a");
                        var e = t.createDocumentFragment();
                        return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement
                    }()
                } catch (n) {
                    g = !0, m = !0
                }
            }();
            var _ = {
                elements: y.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",
                version: v,
                shivCSS: y.shivCSS !== !1,
                supportsUnknownElements: m,
                shivMethods: y.shivMethods !== !1,
                type: "default",
                shivDocument: u,
                createElement: s,
                createDocumentFragment: a,
                addElements: r
            };
            e.html5 = _, u(t);
            var T = /^$|\b(?:all|print)\b/,
                A = "html5shiv",
                k = !m && function() {
                    var n = t.documentElement;
                    return !("undefined" == typeof t.namespaces || "undefined" == typeof t.parentWindow || "undefined" == typeof n.applyElement || "undefined" == typeof n.removeNode || "undefined" == typeof e.attachEvent)
                }();
            _.type += " print", _.shivPrint = f, f(t), "object" == typeof module && module.exports && (module.exports = _)
        }("undefined" != typeof e ? e : this, t);
        var z = function() {},
            N = function() {};
        e.console && (z = function() {
            var t = console.error ? "error" : "log";
            e.console[t].apply(e.console, Array.prototype.slice.call(arguments))
        }, N = function() {
            var t = console.warn ? "warn" : "log";
            e.console[t].apply(e.console, Array.prototype.slice.call(arguments))
        }), x.load = function() {
            "yepnope" in e ? (N("yepnope.js (aka Modernizr.load) is no longer included as part of Modernizr. yepnope appears to be available on the page, so we’ll use it to handle this call to Modernizr.load, but please update your code to use yepnope directly.\n See http://github.com/Modernizr/Modernizr/issues/1182 for more information."), e.yepnope.apply(e, [].slice.call(arguments, 0))) : z("yepnope.js (aka Modernizr.load) is no longer included as part of Modernizr. Get it from http://yepnopejs.com. See http://github.com/Modernizr/Modernizr/issues/1182 for more information.")
        };
        var j = function() {
            var t = e.matchMedia || e.msMatchMedia;
            return t ? function(e) {
                var n = t(e);
                return n && n.matches || !1
            } : function(t) {
                var n = !1;
                return u("@media " + t + " { #modernizr { position: absolute; } }", function(t) {
                    n = "absolute" == (e.getComputedStyle ? e.getComputedStyle(t, null) : t.currentStyle).position
                }), n
            }
        }();
        x.mq = j;
        var $ = {
            elem: a("modernizr")
        };
        C._q.push(function() {
            delete $.elem
        });
        var D = {
            style: $.elem.style
        };
        C._q.unshift(function() {
            delete D.style
        }), x.testAllProps = y;
        var F = x.prefixed = function(e, t, n) {
                return 0 === e.indexOf("@") ? E(e) : (e.indexOf("-") != -1 && (e = f(e)), t ? y(e, t, n) : y(e, "pfx"))
            },
            q = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
        x._prefixes = q;
        x.prefixedCSS = function(e) {
            var t = F(e);
            return t && d(t)
        };
        x.testAllProps = b;
        x.testProp = function(e, t, i) {
            return g([e], n, t, i)
        }, x.testStyles = u;
        /*!
        {
          "name": "picture Element",
          "property": "picture",
          "tags": ["elem"],
          "authors": ["Scott Jehl", "Mat Marquis"],
          "notes": [{
            "name": "Specification",
            "href": "http://picture.responsiveimages.org"
          },{
            "name": "Relevant spec issue",
            "href": "https://github.com/ResponsiveImagesCG/picture-element/issues/87"
          }]
        }
        !*/
        C.addTest("picture", "HTMLPictureElement" in e),
            /*!
            {
              "name": "CSS Object Fit",
              "caniuse": "object-fit",
              "property": "objectfit",
              "tags": ["css"],
              "builderAliases": ["css_objectfit"],
              "notes": [{
                "name": "Opera Article on Object Fit",
                "href": "https://dev.opera.com/articles/css3-object-fit-object-position/"
              }]
            }
            !*/
            C.addTest("objectfit", !!F("objectFit"), {
                aliases: ["object-fit"]
            }), r(), o(_), delete x.addTest, delete x.addAsyncTest;
        for (var L = 0; L < C._q.length; L++) C._q[L]();
        e.Modernizr = C
    }(window, document), /*! selectize.js - v0.12.6 | https://github.com/selectize/selectize.js | Apache License (v2) */
    ! function(e, t) {
        "function" == typeof define && define.amd ? define("sifter", t) : "object" == typeof exports ? module.exports = t() : e.Sifter = t()
    }(this, function() {
        var e = function(e, t) {
            this.items = e, this.settings = t || {
                diacritics: !0
            }
        };
        e.prototype.tokenize = function(e) {
            if (!(e = r(String(e || "").toLowerCase())) || !e.length) return [];
            var t, n, i, s, l = [],
                u = e.split(/ +/);
            for (t = 0, n = u.length; t < n; t++) {
                if (i = o(u[t]), this.settings.diacritics)
                    for (s in a) a.hasOwnProperty(s) && (i = i.replace(new RegExp(s, "g"), a[s]));
                l.push({
                    string: u[t],
                    regex: new RegExp(i, "i")
                })
            }
            return l
        }, e.prototype.iterator = function(e, t) {
            var n;
            n = s(e) ? Array.prototype.forEach || function(e) {
                for (var t = 0, n = this.length; t < n; t++) e(this[t], t, this)
            } : function(e) {
                for (var t in this) this.hasOwnProperty(t) && e(this[t], t, this)
            }, n.apply(e, [t])
        }, e.prototype.getScoreFunction = function(e, t) {
            var n, r, o, s, a;
            n = this, e = n.prepareSearch(e, t), o = e.tokens, r = e.options.fields, s = o.length, a = e.options.nesting;
            var l = function(e, t) {
                    var n, i;
                    return e ? (e = String(e || ""), -1 === (i = e.search(t.regex)) ? 0 : (n = t.string.length / e.length, 0 === i && (n += .5), n)) : 0
                },
                u = function() {
                    var e = r.length;
                    return e ? 1 === e ? function(e, t) {
                        return l(i(t, r[0], a), e)
                    } : function(t, n) {
                        for (var o = 0, s = 0; o < e; o++) s += l(i(n, r[o], a), t);
                        return s / e
                    } : function() {
                        return 0
                    }
                }();
            return s ? 1 === s ? function(e) {
                return u(o[0], e)
            } : "and" === e.options.conjunction ? function(e) {
                for (var t, n = 0, i = 0; n < s; n++) {
                    if ((t = u(o[n], e)) <= 0) return 0;
                    i += t
                }
                return i / s
            } : function(e) {
                for (var t = 0, n = 0; t < s; t++) n += u(o[t], e);
                return n / s
            } : function() {
                return 0
            }
        }, e.prototype.getSortFunction = function(e, n) {
            var r, o, s, a, l, u, c, d, p, h, f;
            if (s = this, e = s.prepareSearch(e, n), f = !e.query && n.sort_empty || n.sort, p = function(e, t) {
                    return "$score" === e ? t.score : i(s.items[t.id], e, n.nesting)
                }, l = [], f)
                for (r = 0, o = f.length; r < o; r++)(e.query || "$score" !== f[r].field) && l.push(f[r]);
            if (e.query) {
                for (h = !0, r = 0, o = l.length; r < o; r++)
                    if ("$score" === l[r].field) {
                        h = !1;
                        break
                    } h && l.unshift({
                    field: "$score",
                    direction: "desc"
                })
            } else
                for (r = 0, o = l.length; r < o; r++)
                    if ("$score" === l[r].field) {
                        l.splice(r, 1);
                        break
                    } for (d = [], r = 0, o = l.length; r < o; r++) d.push("desc" === l[r].direction ? -1 : 1);
            return u = l.length, u ? 1 === u ? (a = l[0].field, c = d[0], function(e, n) {
                return c * t(p(a, e), p(a, n))
            }) : function(e, n) {
                var i, r, o;
                for (i = 0; i < u; i++)
                    if (o = l[i].field, r = d[i] * t(p(o, e), p(o, n))) return r;
                return 0
            } : null
        }, e.prototype.prepareSearch = function(e, t) {
            if ("object" == typeof e) return e;
            t = n({}, t);
            var i = t.fields,
                r = t.sort,
                o = t.sort_empty;
            return i && !s(i) && (t.fields = [i]), r && !s(r) && (t.sort = [r]), o && !s(o) && (t.sort_empty = [o]), {
                options: t,
                query: String(e || "").toLowerCase(),
                tokens: this.tokenize(e),
                total: 0,
                items: []
            }
        }, e.prototype.search = function(e, t) {
            var n, i, r, o, s = this;
            return i = this.prepareSearch(e, t), t = i.options, e = i.query, o = t.score || s.getScoreFunction(i), e.length ? s.iterator(s.items, function(e, r) {
                n = o(e), (!1 === t.filter || n > 0) && i.items.push({
                    score: n,
                    id: r
                })
            }) : s.iterator(s.items, function(e, t) {
                i.items.push({
                    score: 1,
                    id: t
                })
            }), r = s.getSortFunction(i, t), r && i.items.sort(r), i.total = i.items.length, "number" == typeof t.limit && (i.items = i.items.slice(0, t.limit)), i
        };
        var t = function(e, t) {
                return "number" == typeof e && "number" == typeof t ? e > t ? 1 : e < t ? -1 : 0 : (e = l(String(e || "")), t = l(String(t || "")), e > t ? 1 : t > e ? -1 : 0)
            },
            n = function(e, t) {
                var n, i, r, o;
                for (n = 1, i = arguments.length; n < i; n++)
                    if (o = arguments[n])
                        for (r in o) o.hasOwnProperty(r) && (e[r] = o[r]);
                return e
            },
            i = function(e, t, n) {
                if (e && t) {
                    if (!n) return e[t];
                    for (var i = t.split("."); i.length && (e = e[i.shift()]););
                    return e
                }
            },
            r = function(e) {
                return (e + "").replace(/^\s+|\s+$|/g, "")
            },
            o = function(e) {
                return (e + "").replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1")
            },
            s = Array.isArray || "undefined" != typeof $ && $.isArray || function(e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            },
            a = {
                a: "[aḀḁĂăÂâǍǎȺⱥȦȧẠạÄäÀàÁáĀāÃãÅåąĄÃąĄ]",
                b: "[b␢βΒB฿𐌁ᛒ]",
                c: "[cĆćĈĉČčĊċC̄c̄ÇçḈḉȻȼƇƈɕᴄＣｃ]",
                d: "[dĎďḊḋḐḑḌḍḒḓḎḏĐđD̦d̦ƉɖƊɗƋƌᵭᶁᶑȡᴅＤｄð]",
                e: "[eÉéÈèÊêḘḙĚěĔĕẼẽḚḛẺẻĖėËëĒēȨȩĘęᶒɆɇȄȅẾếỀềỄễỂểḜḝḖḗḔḕȆȇẸẹỆệⱸᴇＥｅɘǝƏƐε]",
                f: "[fƑƒḞḟ]",
                g: "[gɢ₲ǤǥĜĝĞğĢģƓɠĠġ]",
                h: "[hĤĥĦħḨḩẖẖḤḥḢḣɦʰǶƕ]",
                i: "[iÍíÌìĬĭÎîǏǐÏïḮḯĨĩĮįĪīỈỉȈȉȊȋỊịḬḭƗɨɨ̆ᵻᶖİiIıɪＩｉ]",
                j: "[jȷĴĵɈɉʝɟʲ]",
                k: "[kƘƙꝀꝁḰḱǨǩḲḳḴḵκϰ₭]",
                l: "[lŁłĽľĻļĹĺḶḷḸḹḼḽḺḻĿŀȽƚⱠⱡⱢɫɬᶅɭȴʟＬｌ]",
                n: "[nŃńǸǹŇňÑñṄṅŅņṆṇṊṋṈṉN̈n̈ƝɲȠƞᵰᶇɳȵɴＮｎŊŋ]",
                o: "[oØøÖöÓóÒòÔôǑǒŐőŎŏȮȯỌọƟɵƠơỎỏŌōÕõǪǫȌȍՕօ]",
                p: "[pṔṕṖṗⱣᵽƤƥᵱ]",
                q: "[qꝖꝗʠɊɋꝘꝙq̃]",
                r: "[rŔŕɌɍŘřŖŗṘṙȐȑȒȓṚṛⱤɽ]",
                s: "[sŚśṠṡṢṣꞨꞩŜŝŠšŞşȘșS̈s̈]",
                t: "[tŤťṪṫŢţṬṭƮʈȚțṰṱṮṯƬƭ]",
                u: "[uŬŭɄʉỤụÜüÚúÙùÛûǓǔŰűŬŭƯưỦủŪūŨũŲųȔȕ∪]",
                v: "[vṼṽṾṿƲʋꝞꝟⱱʋ]",
                w: "[wẂẃẀẁŴŵẄẅẆẇẈẉ]",
                x: "[xẌẍẊẋχ]",
                y: "[yÝýỲỳŶŷŸÿỸỹẎẏỴỵɎɏƳƴ]",
                z: "[zŹźẐẑŽžŻżẒẓẔẕƵƶ]"
            },
            l = function() {
                var e, t, n, i, r = "",
                    o = {};
                for (n in a)
                    if (a.hasOwnProperty(n))
                        for (i = a[n].substring(2, a[n].length - 1), r += i, e = 0, t = i.length; e < t; e++) o[i.charAt(e)] = n;
                var s = new RegExp("[" + r + "]", "g");
                return function(e) {
                    return e.replace(s, function(e) {
                        return o[e]
                    }).toLowerCase()
                }
            }();
        return e
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("microplugin", t) : "object" == typeof exports ? module.exports = t() : e.MicroPlugin = t()
    }(this, function() {
        var e = {};
        e.mixin = function(e) {
            e.plugins = {}, e.prototype.initializePlugins = function(e) {
                var n, i, r, o = this,
                    s = [];
                if (o.plugins = {
                        names: [],
                        settings: {},
                        requested: {},
                        loaded: {}
                    }, t.isArray(e))
                    for (n = 0, i = e.length; n < i; n++) "string" == typeof e[n] ? s.push(e[n]) : (o.plugins.settings[e[n].name] = e[n].options, s.push(e[n].name));
                else if (e)
                    for (r in e) e.hasOwnProperty(r) && (o.plugins.settings[r] = e[r], s.push(r));
                for (; s.length;) o.require(s.shift())
            }, e.prototype.loadPlugin = function(t) {
                var n = this,
                    i = n.plugins,
                    r = e.plugins[t];
                if (!e.plugins.hasOwnProperty(t)) throw new Error('Unable to find "' + t + '" plugin');
                i.requested[t] = !0, i.loaded[t] = r.fn.apply(n, [n.plugins.settings[t] || {}]), i.names.push(t)
            }, e.prototype.require = function(e) {
                var t = this,
                    n = t.plugins;
                if (!t.plugins.loaded.hasOwnProperty(e)) {
                    if (n.requested[e]) throw new Error('Plugin has circular dependency ("' + e + '")');
                    t.loadPlugin(e)
                }
                return n.loaded[e]
            }, e.define = function(t, n) {
                e.plugins[t] = {
                    name: t,
                    fn: n
                }
            }
        };
        var t = {
            isArray: Array.isArray || function(e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            }
        };
        return e
    }),
    function(e, t) {
        "function" == typeof define && define.amd ? define("selectize", ["jquery", "sifter", "microplugin"], t) : "object" == typeof exports ? module.exports = t(require("jquery"), require("sifter"), require("microplugin")) : e.Selectize = t(e.jQuery, e.Sifter, e.MicroPlugin)
    }(this, function(e, t, n) {
        "use strict";
        var i = function(e, t) {
            if ("string" != typeof t || t.length) {
                var n = "string" == typeof t ? new RegExp(t, "i") : t,
                    i = function(e) {
                        var t = 0;
                        if (3 === e.nodeType) {
                            var r = e.data.search(n);
                            if (r >= 0 && e.data.length > 0) {
                                var o = e.data.match(n),
                                    s = document.createElement("span");
                                s.className = "highlight";
                                var a = e.splitText(r),
                                    l = (a.splitText(o[0].length), a.cloneNode(!0));
                                s.appendChild(l), a.parentNode.replaceChild(s, a), t = 1
                            }
                        } else if (1 === e.nodeType && e.childNodes && !/(script|style)/i.test(e.tagName) && ("highlight" !== e.className || "SPAN" !== e.tagName))
                            for (var u = 0; u < e.childNodes.length; ++u) u += i(e.childNodes[u]);
                        return t
                    };
                return e.each(function() {
                    i(this)
                })
            }
        };
        e.fn.removeHighlight = function() {
            return this.find("span.highlight").each(function() {
                this.parentNode.firstChild.nodeName;
                var e = this.parentNode;
                e.replaceChild(this.firstChild, this), e.normalize()
            }).end()
        };
        var r = function() {};
        r.prototype = {
            on: function(e, t) {
                this._events = this._events || {}, this._events[e] = this._events[e] || [], this._events[e].push(t)
            },
            off: function(e, t) {
                var n = arguments.length;
                return 0 === n ? delete this._events : 1 === n ? delete this._events[e] : (this._events = this._events || {}, void(e in this._events != 0 && this._events[e].splice(this._events[e].indexOf(t), 1)))
            },
            trigger: function(e) {
                if (this._events = this._events || {}, e in this._events != 0)
                    for (var t = 0; t < this._events[e].length; t++) this._events[e][t].apply(this, Array.prototype.slice.call(arguments, 1))
            }
        }, r.mixin = function(e) {
            for (var t = ["on", "off", "trigger"], n = 0; n < t.length; n++) e.prototype[t[n]] = r.prototype[t[n]]
        };
        var o = /Mac/.test(navigator.userAgent),
            s = o ? 91 : 17,
            a = o ? 18 : 17,
            l = !/android/i.test(window.navigator.userAgent) && !!document.createElement("input").validity,
            u = function(e) {
                return void 0 !== e
            },
            c = function(e) {
                return void 0 === e || null === e ? null : "boolean" == typeof e ? e ? "1" : "0" : e + ""
            },
            d = function(e) {
                return (e + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
            },
            p = {};
        p.before = function(e, t, n) {
            var i = e[t];
            e[t] = function() {
                return n.apply(e, arguments), i.apply(e, arguments)
            }
        }, p.after = function(e, t, n) {
            var i = e[t];
            e[t] = function() {
                var t = i.apply(e, arguments);
                return n.apply(e, arguments), t
            }
        };
        var h = function(e) {
                var t = !1;
                return function() {
                    t || (t = !0, e.apply(this, arguments))
                }
            },
            f = function(e, t) {
                var n;
                return function() {
                    var i = this,
                        r = arguments;
                    window.clearTimeout(n), n = window.setTimeout(function() {
                        e.apply(i, r)
                    }, t)
                }
            },
            g = function(e, t, n) {
                var i, r = e.trigger,
                    o = {};
                e.trigger = function() {
                    var n = arguments[0];
                    return -1 === t.indexOf(n) ? r.apply(e, arguments) : void(o[n] = arguments)
                }, n.apply(e, []), e.trigger = r;
                for (i in o) o.hasOwnProperty(i) && r.apply(e, o[i])
            },
            m = function(e, t, n, i) {
                e.on(t, n, function(t) {
                    for (var n = t.target; n && n.parentNode !== e[0];) n = n.parentNode;
                    return t.currentTarget = n, i.apply(this, [t])
                })
            },
            v = function(e) {
                var t = {};
                if ("selectionStart" in e) t.start = e.selectionStart, t.length = e.selectionEnd - t.start;
                else if (document.selection) {
                    e.focus();
                    var n = document.selection.createRange(),
                        i = document.selection.createRange().text.length;
                    n.moveStart("character", -e.value.length), t.start = n.text.length - i, t.length = i
                }
                return t
            },
            y = function(e, t, n) {
                var i, r, o = {};
                if (n)
                    for (i = 0, r = n.length; i < r; i++) o[n[i]] = e.css(n[i]);
                else o = e.css();
                t.css(o)
            },
            b = function(t, n) {
                return t ? (C.$testInput || (C.$testInput = e("<span />").css({
                    position: "absolute",
                    top: -99999,
                    left: -99999,
                    width: "auto",
                    padding: 0,
                    whiteSpace: "pre"
                }).appendTo("body")), C.$testInput.text(t), y(n, C.$testInput, ["letterSpacing", "fontSize", "fontFamily", "fontWeight", "textTransform"]), C.$testInput.width()) : 0
            },
            w = function(e) {
                var t = null,
                    n = function(n, i) {
                        var r, o, s, a, l, u, c, d;
                        n = n || window.event || {}, i = i || {}, n.metaKey || n.altKey || (i.force || !1 !== e.data("grow")) && (r = e.val(), n.type && "keydown" === n.type.toLowerCase() && (o = n.keyCode, s = o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 96 && o <= 111 || o >= 186 && o <= 222 || 32 === o, 46 === o || 8 === o ? (d = v(e[0]), d.length ? r = r.substring(0, d.start) + r.substring(d.start + d.length) : 8 === o && d.start ? r = r.substring(0, d.start - 1) + r.substring(d.start + 1) : 46 === o && void 0 !== d.start && (r = r.substring(0, d.start) + r.substring(d.start + 1))) : s && (u = n.shiftKey, c = String.fromCharCode(n.keyCode), c = u ? c.toUpperCase() : c.toLowerCase(), r += c)), a = e.attr("placeholder"), !r && a && (r = a), (l = b(r, e) + 4) !== t && (t = l, e.width(l), e.triggerHandler("resize")))
                    };
                e.on("keydown keyup update blur", n), n()
            },
            x = function(e) {
                var t = document.createElement("div");
                return t.appendChild(e.cloneNode(!0)), t.innerHTML
            },
            C = function(n, i) {
                var r, o, s, a, l = this;
                a = n[0], a.selectize = l;
                var u = window.getComputedStyle && window.getComputedStyle(a, null);
                if (s = u ? u.getPropertyValue("direction") : a.currentStyle && a.currentStyle.direction, s = s || n.parents("[dir]:first").attr("dir") || "", e.extend(l, {
                        order: 0,
                        settings: i,
                        $input: n,
                        tabIndex: n.attr("tabindex") || "",
                        tagType: "select" === a.tagName.toLowerCase() ? 1 : 2,
                        rtl: /rtl/i.test(s),
                        eventNS: ".selectize" + ++C.count,
                        highlightedValue: null,
                        isBlurring: !1,
                        isOpen: !1,
                        isDisabled: !1,
                        isRequired: n.is("[required]"),
                        isInvalid: !1,
                        isLocked: !1,
                        isFocused: !1,
                        isInputHidden: !1,
                        isSetup: !1,
                        isShiftDown: !1,
                        isCmdDown: !1,
                        isCtrlDown: !1,
                        ignoreFocus: !1,
                        ignoreBlur: !1,
                        ignoreHover: !1,
                        hasOptions: !1,
                        currentResults: null,
                        lastValue: "",
                        caretPos: 0,
                        loading: 0,
                        loadedSearches: {},
                        $activeOption: null,
                        $activeItems: [],
                        optgroups: {},
                        options: {},
                        userOptions: {},
                        items: [],
                        renderCache: {},
                        onSearchChange: null === i.loadThrottle ? l.onSearchChange : f(l.onSearchChange, i.loadThrottle)
                    }), l.sifter = new t(this.options, {
                        diacritics: i.diacritics
                    }), l.settings.options) {
                    for (r = 0, o = l.settings.options.length; r < o; r++) l.registerOption(l.settings.options[r]);
                    delete l.settings.options
                }
                if (l.settings.optgroups) {
                    for (r = 0, o = l.settings.optgroups.length; r < o; r++) l.registerOptionGroup(l.settings.optgroups[r]);
                    delete l.settings.optgroups
                }
                l.settings.mode = l.settings.mode || (1 === l.settings.maxItems ? "single" : "multi"), "boolean" != typeof l.settings.hideSelected && (l.settings.hideSelected = "multi" === l.settings.mode), l.initializePlugins(l.settings.plugins), l.setupCallbacks(), l.setupTemplates(), l.setup()
            };
        return r.mixin(C), void 0 !== n ? n.mixin(C) : function(e, t) {
            t || (t = {}), console.error("Selectize: " + e), t.explanation && (console.group && console.group(), console.error(t.explanation), console.group && console.groupEnd())
        }("Dependency MicroPlugin is missing", {
            explanation: 'Make sure you either: (1) are using the "standalone" version of Selectize, or (2) require MicroPlugin before you load Selectize.'
        }), e.extend(C.prototype, {
            setup: function() {
                var t, n, i, r, u, c, d, p, h, f, g = this,
                    v = g.settings,
                    y = g.eventNS,
                    b = e(window),
                    x = e(document),
                    C = g.$input;
                if (d = g.settings.mode, p = C.attr("class") || "", t = e("<div>").addClass(v.wrapperClass).addClass(p).addClass(d), n = e("<div>").addClass(v.inputClass).addClass("items").appendTo(t), i = e('<input type="text" autocomplete="off" />').appendTo(n).attr("tabindex", C.is(":disabled") ? "-1" : g.tabIndex), c = e(v.dropdownParent || t), r = e("<div>").addClass(v.dropdownClass).addClass(d).hide().appendTo(c), u = e("<div>").addClass(v.dropdownContentClass).appendTo(r), (f = C.attr("id")) && (i.attr("id", f + "-selectized"), e("label[for='" + f + "']").attr("for", f + "-selectized")), g.settings.copyClassesToDropdown && r.addClass(p), t.css({
                        width: C[0].style.width
                    }), g.plugins.names.length && (h = "plugin-" + g.plugins.names.join(" plugin-"), t.addClass(h), r.addClass(h)), (null === v.maxItems || v.maxItems > 1) && 1 === g.tagType && C.attr("multiple", "multiple"), g.settings.placeholder && i.attr("placeholder", v.placeholder), !g.settings.splitOn && g.settings.delimiter) {
                    var S = g.settings.delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                    g.settings.splitOn = new RegExp("\\s*" + S + "+\\s*")
                }
                C.attr("autocorrect") && i.attr("autocorrect", C.attr("autocorrect")), C.attr("autocapitalize") && i.attr("autocapitalize", C.attr("autocapitalize")), i[0].type = C[0].type, g.$wrapper = t, g.$control = n, g.$control_input = i, g.$dropdown = r, g.$dropdown_content = u, r.on("mouseenter mousedown click", "[data-disabled]>[data-selectable]", function(e) {
                    e.stopImmediatePropagation()
                }), r.on("mouseenter", "[data-selectable]", function() {
                    return g.onOptionHover.apply(g, arguments)
                }), r.on("mousedown click", "[data-selectable]", function() {
                    return g.onOptionSelect.apply(g, arguments)
                }), m(n, "mousedown", "*:not(input)", function() {
                    return g.onItemSelect.apply(g, arguments)
                }), w(i), n.on({
                    mousedown: function() {
                        return g.onMouseDown.apply(g, arguments)
                    },
                    click: function() {
                        return g.onClick.apply(g, arguments)
                    }
                }), i.on({
                    mousedown: function(e) {
                        e.stopPropagation()
                    },
                    keydown: function() {
                        return g.onKeyDown.apply(g, arguments)
                    },
                    keyup: function() {
                        return g.onKeyUp.apply(g, arguments)
                    },
                    keypress: function() {
                        return g.onKeyPress.apply(g, arguments)
                    },
                    resize: function() {
                        g.positionDropdown.apply(g, [])
                    },
                    blur: function() {
                        return g.onBlur.apply(g, arguments)
                    },
                    focus: function() {
                        return g.ignoreBlur = !1, g.onFocus.apply(g, arguments)
                    },
                    paste: function() {
                        return g.onPaste.apply(g, arguments)
                    }
                }), x.on("keydown" + y, function(e) {
                    g.isCmdDown = e[o ? "metaKey" : "ctrlKey"], g.isCtrlDown = e[o ? "altKey" : "ctrlKey"], g.isShiftDown = e.shiftKey
                }), x.on("keyup" + y, function(e) {
                    e.keyCode === a && (g.isCtrlDown = !1), 16 === e.keyCode && (g.isShiftDown = !1), e.keyCode === s && (g.isCmdDown = !1)
                }), x.on("mousedown" + y, function(e) {
                    if (g.isFocused) {
                        if (e.target === g.$dropdown[0] || e.target.parentNode === g.$dropdown[0]) return !1;
                        g.$control.has(e.target).length || e.target === g.$control[0] || g.blur(e.target)
                    }
                }), b.on(["scroll" + y, "resize" + y].join(" "), function() {
                    g.isOpen && g.positionDropdown.apply(g, arguments)
                }), b.on("mousemove" + y, function() {
                    g.ignoreHover = !1
                }), this.revertSettings = {
                    $children: C.children().detach(),
                    tabindex: C.attr("tabindex")
                }, C.attr("tabindex", -1).hide().after(g.$wrapper), e.isArray(v.items) && (g.setValue(v.items), delete v.items), l && C.on("invalid" + y, function(e) {
                    e.preventDefault(), g.isInvalid = !0, g.refreshState()
                }), g.updateOriginalInput(), g.refreshItems(), g.refreshState(), g.updatePlaceholder(), g.isSetup = !0, C.is(":disabled") && g.disable(), g.on("change", this.onChange), C.data("selectize", g), C.addClass("selectized"), g.trigger("initialize"), !0 === v.preload && g.onSearchChange("")
            },
            setupTemplates: function() {
                var t = this,
                    n = t.settings.labelField,
                    i = t.settings.optgroupLabelField,
                    r = {
                        optgroup: function(e) {
                            return '<div class="optgroup">' + e.html + "</div>"
                        },
                        optgroup_header: function(e, t) {
                            return '<div class="optgroup-header">' + t(e[i]) + "</div>"
                        },
                        option: function(e, t) {
                            return '<div class="option">' + t(e[n]) + "</div>"
                        },
                        item: function(e, t) {
                            return '<div class="item">' + t(e[n]) + "</div>"
                        },
                        option_create: function(e, t) {
                            return '<div class="create">Add <strong>' + t(e.input) + "</strong>&hellip;</div>"
                        }
                    };
                t.settings.render = e.extend({}, r, t.settings.render)
            },
            setupCallbacks: function() {
                var e, t, n = {
                    initialize: "onInitialize",
                    change: "onChange",
                    item_add: "onItemAdd",
                    item_remove: "onItemRemove",
                    clear: "onClear",
                    option_add: "onOptionAdd",
                    option_remove: "onOptionRemove",
                    option_clear: "onOptionClear",
                    optgroup_add: "onOptionGroupAdd",
                    optgroup_remove: "onOptionGroupRemove",
                    optgroup_clear: "onOptionGroupClear",
                    dropdown_open: "onDropdownOpen",
                    dropdown_close: "onDropdownClose",
                    type: "onType",
                    load: "onLoad",
                    focus: "onFocus",
                    blur: "onBlur"
                };
                for (e in n) n.hasOwnProperty(e) && (t = this.settings[n[e]]) && this.on(e, t)
            },
            onClick: function(e) {
                var t = this;
                t.isFocused && t.isOpen || (t.focus(), e.preventDefault())
            },
            onMouseDown: function(t) {
                var n = this,
                    i = t.isDefaultPrevented();
                if (e(t.target), n.isFocused) {
                    if (t.target !== n.$control_input[0]) return "single" === n.settings.mode ? n.isOpen ? n.close() : n.open() : i || n.setActiveItem(null), !1
                } else i || window.setTimeout(function() {
                    n.focus()
                }, 0)
            },
            onChange: function() {
                this.$input.trigger("change")
            },
            onPaste: function(t) {
                var n = this;
                return n.isFull() || n.isInputHidden || n.isLocked ? void t.preventDefault() : void(n.settings.splitOn && setTimeout(function() {
                    var t = n.$control_input.val();
                    if (t.match(n.settings.splitOn))
                        for (var i = e.trim(t).split(n.settings.splitOn), r = 0, o = i.length; r < o; r++) n.createItem(i[r])
                }, 0))
            },
            onKeyPress: function(e) {
                if (this.isLocked) return e && e.preventDefault();
                var t = String.fromCharCode(e.keyCode || e.which);
                return this.settings.create && "multi" === this.settings.mode && t === this.settings.delimiter ? (this.createItem(), e.preventDefault(), !1) : void 0
            },
            onKeyDown: function(e) {
                var t = (e.target, this.$control_input[0], this);
                if (t.isLocked) return void(9 !== e.keyCode && e.preventDefault());
                switch (e.keyCode) {
                    case 65:
                        if (t.isCmdDown) return void t.selectAll();
                        break;
                    case 27:
                        return void(t.isOpen && (e.preventDefault(), e.stopPropagation(), t.close()));
                    case 78:
                        if (!e.ctrlKey || e.altKey) break;
                    case 40:
                        if (!t.isOpen && t.hasOptions) t.open();
                        else if (t.$activeOption) {
                            t.ignoreHover = !0;
                            var n = t.getAdjacentOption(t.$activeOption, 1);
                            n.length && t.setActiveOption(n, !0, !0)
                        }
                        return void e.preventDefault();
                    case 80:
                        if (!e.ctrlKey || e.altKey) break;
                    case 38:
                        if (t.$activeOption) {
                            t.ignoreHover = !0;
                            var i = t.getAdjacentOption(t.$activeOption, -1);
                            i.length && t.setActiveOption(i, !0, !0)
                        }
                        return void e.preventDefault();
                    case 13:
                        return void(t.isOpen && t.$activeOption && (t.onOptionSelect({
                            currentTarget: t.$activeOption
                        }), e.preventDefault()));
                    case 37:
                        return void t.advanceSelection(-1, e);
                    case 39:
                        return void t.advanceSelection(1, e);
                    case 9:
                        return t.settings.selectOnTab && t.isOpen && t.$activeOption && (t.onOptionSelect({
                            currentTarget: t.$activeOption
                        }), t.isFull() || e.preventDefault()), void(t.settings.create && t.createItem() && e.preventDefault());
                    case 8:
                    case 46:
                        return void t.deleteSelection(e)
                }
                return !t.isFull() && !t.isInputHidden || (o ? e.metaKey : e.ctrlKey) ? void 0 : void e.preventDefault()
            },
            onKeyUp: function(e) {
                var t = this;
                if (t.isLocked) return e && e.preventDefault();
                var n = t.$control_input.val() || "";
                t.lastValue !== n && (t.lastValue = n, t.onSearchChange(n), t.refreshOptions(), t.trigger("type", n))
            },
            onSearchChange: function(e) {
                var t = this,
                    n = t.settings.load;
                n && (t.loadedSearches.hasOwnProperty(e) || (t.loadedSearches[e] = !0, t.load(function(i) {
                    n.apply(t, [e, i])
                })))
            },
            onFocus: function(e) {
                var t = this,
                    n = t.isFocused;
                return t.isDisabled ? (t.blur(), e && e.preventDefault(), !1) : void(t.ignoreFocus || (t.isFocused = !0, "focus" === t.settings.preload && t.onSearchChange(""), n || t.trigger("focus"), t.$activeItems.length || (t.showInput(), t.setActiveItem(null), t.refreshOptions(!!t.settings.openOnFocus)), t.refreshState()))
            },
            onBlur: function(e, t) {
                var n = this;
                if (n.isFocused && (n.isFocused = !1, !n.ignoreFocus)) {
                    if (!n.ignoreBlur && document.activeElement === n.$dropdown_content[0]) return n.ignoreBlur = !0, void n.onFocus(e);
                    var i = function() {
                        n.close(), n.setTextboxValue(""), n.setActiveItem(null), n.setActiveOption(null), n.setCaret(n.items.length), n.refreshState(), t && t.focus && t.focus(), n.isBlurring = !1, n.ignoreFocus = !1, n.trigger("blur")
                    };
                    n.isBlurring = !0, n.ignoreFocus = !0, n.settings.create && n.settings.createOnBlur ? n.createItem(null, !1, i) : i()
                }
            },
            onOptionHover: function(e) {
                this.ignoreHover || this.setActiveOption(e.currentTarget, !1)
            },
            onOptionSelect: function(t) {
                var n, i, r = this;
                t.preventDefault && (t.preventDefault(), t.stopPropagation()), i = e(t.currentTarget), i.hasClass("create") ? r.createItem(null, function() {
                    r.settings.closeAfterSelect && r.close()
                }) : void 0 !== (n = i.attr("data-value")) && (r.lastQuery = null, r.setTextboxValue(""), r.addItem(n), r.settings.closeAfterSelect ? r.close() : !r.settings.hideSelected && t.type && /mouse/.test(t.type) && r.setActiveOption(r.getOption(n)))
            },
            onItemSelect: function(e) {
                var t = this;
                t.isLocked || "multi" === t.settings.mode && (e.preventDefault(), t.setActiveItem(e.currentTarget, e))
            },
            load: function(e) {
                var t = this,
                    n = t.$wrapper.addClass(t.settings.loadingClass);
                t.loading++, e.apply(t, [function(e) {
                    t.loading = Math.max(t.loading - 1, 0), e && e.length && (t.addOption(e), t.refreshOptions(t.isFocused && !t.isInputHidden)), t.loading || n.removeClass(t.settings.loadingClass), t.trigger("load", e)
                }])
            },
            setTextboxValue: function(e) {
                var t = this.$control_input;
                t.val() !== e && (t.val(e).triggerHandler("update"), this.lastValue = e)
            },
            getValue: function() {
                return 1 === this.tagType && this.$input.attr("multiple") ? this.items : this.items.join(this.settings.delimiter)
            },
            setValue: function(e, t) {
                g(this, t ? [] : ["change"], function() {
                    this.clear(t), this.addItems(e, t)
                })
            },
            setActiveItem: function(t, n) {
                var i, r, o, s, a, l, u, c, d = this;
                if ("single" !== d.settings.mode) {
                    if (t = e(t), !t.length) return e(d.$activeItems).removeClass("active"), d.$activeItems = [], void(d.isFocused && d.showInput());
                    if ("mousedown" === (i = n && n.type.toLowerCase()) && d.isShiftDown && d.$activeItems.length) {
                        for (c = d.$control.children(".active:last"), s = Array.prototype.indexOf.apply(d.$control[0].childNodes, [c[0]]), a = Array.prototype.indexOf.apply(d.$control[0].childNodes, [t[0]]), s > a && (u = s, s = a, a = u), r = s; r <= a; r++) l = d.$control[0].childNodes[r], -1 === d.$activeItems.indexOf(l) && (e(l).addClass("active"), d.$activeItems.push(l));
                        n.preventDefault()
                    } else "mousedown" === i && d.isCtrlDown || "keydown" === i && this.isShiftDown ? t.hasClass("active") ? (o = d.$activeItems.indexOf(t[0]), d.$activeItems.splice(o, 1), t.removeClass("active")) : d.$activeItems.push(t.addClass("active")[0]) : (e(d.$activeItems).removeClass("active"), d.$activeItems = [t.addClass("active")[0]]);
                    d.hideInput(), this.isFocused || d.focus()
                }
            },
            setActiveOption: function(t, n, i) {
                var r, o, s, a, l, c = this;
                c.$activeOption && c.$activeOption.removeClass("active"), c.$activeOption = null, t = e(t), t.length && (c.$activeOption = t.addClass("active"), !n && u(n) || (r = c.$dropdown_content.height(), o = c.$activeOption.outerHeight(!0), n = c.$dropdown_content.scrollTop() || 0, s = c.$activeOption.offset().top - c.$dropdown_content.offset().top + n, a = s, l = s - r + o, s + o > r + n ? c.$dropdown_content.stop().animate({
                    scrollTop: l
                }, i ? c.settings.scrollDuration : 0) : s < n && c.$dropdown_content.stop().animate({
                    scrollTop: a
                }, i ? c.settings.scrollDuration : 0)))
            },
            selectAll: function() {
                var e = this;
                "single" !== e.settings.mode && (e.$activeItems = Array.prototype.slice.apply(e.$control.children(":not(input)").addClass("active")), e.$activeItems.length && (e.hideInput(), e.close()), e.focus())
            },
            hideInput: function() {
                var e = this;
                e.setTextboxValue(""), e.$control_input.css({
                    opacity: 0,
                    position: "absolute",
                    left: e.rtl ? 1e4 : -1e4
                }), e.isInputHidden = !0
            },
            showInput: function() {
                this.$control_input.css({
                    opacity: 1,
                    position: "relative",
                    left: 0
                }), this.isInputHidden = !1
            },
            focus: function() {
                var e = this;
                e.isDisabled || (e.ignoreFocus = !0, e.$control_input[0].focus(), window.setTimeout(function() {
                    e.ignoreFocus = !1, e.onFocus()
                }, 0))
            },
            blur: function(e) {
                this.$control_input[0].blur(), this.onBlur(null, e)
            },
            getScoreFunction: function(e) {
                return this.sifter.getScoreFunction(e, this.getSearchOptions())
            },
            getSearchOptions: function() {
                var e = this.settings,
                    t = e.sortField;
                return "string" == typeof t && (t = [{
                    field: t
                }]), {
                    fields: e.searchField,
                    conjunction: e.searchConjunction,
                    sort: t,
                    nesting: e.nesting
                }
            },
            search: function(t) {
                var n, i, r, o = this,
                    s = o.settings,
                    a = this.getSearchOptions();
                if (s.score && "function" != typeof(r = o.settings.score.apply(this, [t]))) throw new Error('Selectize "score" setting must be a function that returns a function');
                if (t !== o.lastQuery ? (o.lastQuery = t, i = o.sifter.search(t, e.extend(a, {
                        score: r
                    })), o.currentResults = i) : i = e.extend(!0, {}, o.currentResults), s.hideSelected)
                    for (n = i.items.length - 1; n >= 0; n--) - 1 !== o.items.indexOf(c(i.items[n].id)) && i.items.splice(n, 1);
                return i
            },
            refreshOptions: function(t) {
                var n, r, o, s, a, l, u, d, p, h, f, g, m, v, y, b;
                void 0 === t && (t = !0);
                var w = this,
                    C = e.trim(w.$control_input.val()),
                    S = w.search(C),
                    _ = w.$dropdown_content,
                    T = w.$activeOption && c(w.$activeOption.attr("data-value"));
                for (s = S.items.length, "number" == typeof w.settings.maxOptions && (s = Math.min(s, w.settings.maxOptions)), a = {}, l = [], n = 0; n < s; n++)
                    for (u = w.options[S.items[n].id], d = w.render("option", u), p = u[w.settings.optgroupField] || "", h = e.isArray(p) ? p : [p], r = 0, o = h && h.length; r < o; r++) p = h[r], w.optgroups.hasOwnProperty(p) || (p = ""), a.hasOwnProperty(p) || (a[p] = document.createDocumentFragment(), l.push(p)), a[p].appendChild(d);
                for (this.settings.lockOptgroupOrder && l.sort(function(e, t) {
                        return (w.optgroups[e].$order || 0) - (w.optgroups[t].$order || 0)
                    }), f = document.createDocumentFragment(), n = 0, s = l.length; n < s; n++) p = l[n], w.optgroups.hasOwnProperty(p) && a[p].childNodes.length ? (g = document.createDocumentFragment(), g.appendChild(w.render("optgroup_header", w.optgroups[p])), g.appendChild(a[p]), f.appendChild(w.render("optgroup", e.extend({}, w.optgroups[p], {
                    html: x(g),
                    dom: g
                })))) : f.appendChild(a[p]);
                if (_.html(f), w.settings.highlight && (_.removeHighlight(), S.query.length && S.tokens.length))
                    for (n = 0, s = S.tokens.length; n < s; n++) i(_, S.tokens[n].regex);
                if (!w.settings.hideSelected)
                    for (n = 0, s = w.items.length; n < s; n++) w.getOption(w.items[n]).addClass("selected");
                m = w.canCreate(C), m && (_.prepend(w.render("option_create", {
                    input: C
                })), b = e(_[0].childNodes[0])), w.hasOptions = S.items.length > 0 || m, w.hasOptions ? (S.items.length > 0 ? (y = T && w.getOption(T), y && y.length ? v = y : "single" === w.settings.mode && w.items.length && (v = w.getOption(w.items[0])), v && v.length || (v = b && !w.settings.addPrecedence ? w.getAdjacentOption(b, 1) : _.find("[data-selectable]:first"))) : v = b, w.setActiveOption(v), t && !w.isOpen && w.open()) : (w.setActiveOption(null), t && w.isOpen && w.close())
            },
            addOption: function(t) {
                var n, i, r, o = this;
                if (e.isArray(t))
                    for (n = 0, i = t.length; n < i; n++) o.addOption(t[n]);
                else(r = o.registerOption(t)) && (o.userOptions[r] = !0, o.lastQuery = null, o.trigger("option_add", r, t))
            },
            registerOption: function(e) {
                var t = c(e[this.settings.valueField]);
                return void 0 !== t && null !== t && !this.options.hasOwnProperty(t) && (e.$order = e.$order || ++this.order, this.options[t] = e, t)
            },
            registerOptionGroup: function(e) {
                var t = c(e[this.settings.optgroupValueField]);
                return !!t && (e.$order = e.$order || ++this.order, this.optgroups[t] = e, t)
            },
            addOptionGroup: function(e, t) {
                t[this.settings.optgroupValueField] = e, (e = this.registerOptionGroup(t)) && this.trigger("optgroup_add", e, t)
            },
            removeOptionGroup: function(e) {
                this.optgroups.hasOwnProperty(e) && (delete this.optgroups[e], this.renderCache = {}, this.trigger("optgroup_remove", e))
            },
            clearOptionGroups: function() {
                this.optgroups = {}, this.renderCache = {}, this.trigger("optgroup_clear")
            },
            updateOption: function(t, n) {
                var i, r, o, s, a, l, u, d = this;
                if (t = c(t), o = c(n[d.settings.valueField]), null !== t && d.options.hasOwnProperty(t)) {
                    if ("string" != typeof o) throw new Error("Value must be set in option data");
                    u = d.options[t].$order, o !== t && (delete d.options[t], -1 !== (s = d.items.indexOf(t)) && d.items.splice(s, 1, o)), n.$order = n.$order || u, d.options[o] = n, a = d.renderCache.item, l = d.renderCache.option, a && (delete a[t], delete a[o]), l && (delete l[t], delete l[o]), -1 !== d.items.indexOf(o) && (i = d.getItem(t), r = e(d.render("item", n)), i.hasClass("active") && r.addClass("active"), i.replaceWith(r)), d.lastQuery = null, d.isOpen && d.refreshOptions(!1)
                }
            },
            removeOption: function(e, t) {
                var n = this;
                e = c(e);
                var i = n.renderCache.item,
                    r = n.renderCache.option;
                i && delete i[e], r && delete r[e], delete n.userOptions[e], delete n.options[e], n.lastQuery = null, n.trigger("option_remove", e), n.removeItem(e, t)
            },
            clearOptions: function() {
                var t = this;
                t.loadedSearches = {}, t.userOptions = {}, t.renderCache = {};
                var n = t.options;
                e.each(t.options, function(e, i) {
                    -1 == t.items.indexOf(e) && delete n[e]
                }), t.options = t.sifter.items = n, t.lastQuery = null, t.trigger("option_clear")
            },
            getOption: function(e) {
                return this.getElementWithValue(e, this.$dropdown_content.find("[data-selectable]"))
            },
            getAdjacentOption: function(t, n) {
                var i = this.$dropdown.find("[data-selectable]"),
                    r = i.index(t) + n;
                return r >= 0 && r < i.length ? i.eq(r) : e()
            },
            getElementWithValue: function(t, n) {
                if (void 0 !== (t = c(t)) && null !== t)
                    for (var i = 0, r = n.length; i < r; i++)
                        if (n[i].getAttribute("data-value") === t) return e(n[i]);
                return e()
            },
            getItem: function(e) {
                return this.getElementWithValue(e, this.$control.children())
            },
            addItems: function(t, n) {
                this.buffer = document.createDocumentFragment();
                for (var i = this.$control[0].childNodes, r = 0; r < i.length; r++) this.buffer.appendChild(i[r]);
                for (var o = e.isArray(t) ? t : [t], r = 0, s = o.length; r < s; r++) this.isPending = r < s - 1, this.addItem(o[r], n);
                var a = this.$control[0];
                a.insertBefore(this.buffer, a.firstChild), this.buffer = null
            },
            addItem: function(t, n) {
                g(this, n ? [] : ["change"], function() {
                    var i, r, o, s, a, l = this,
                        u = l.settings.mode;
                    return t = c(t), -1 !== l.items.indexOf(t) ? void("single" === u && l.close()) : void(l.options.hasOwnProperty(t) && ("single" === u && l.clear(n), "multi" === u && l.isFull() || (i = e(l.render("item", l.options[t])), a = l.isFull(), l.items.splice(l.caretPos, 0, t), l.insertAtCaret(i), (!l.isPending || !a && l.isFull()) && l.refreshState(), l.isSetup && (o = l.$dropdown_content.find("[data-selectable]"), l.isPending || (r = l.getOption(t), s = l.getAdjacentOption(r, 1).attr("data-value"), l.refreshOptions(l.isFocused && "single" !== u), s && l.setActiveOption(l.getOption(s))), !o.length || l.isFull() ? l.close() : l.isPending || l.positionDropdown(), l.updatePlaceholder(), l.trigger("item_add", t, i), l.isPending || l.updateOriginalInput({
                        silent: n
                    })))))
                })
            },
            removeItem: function(t, n) {
                var i, r, o, s = this;
                i = t instanceof e ? t : s.getItem(t), t = c(i.attr("data-value")), -1 !== (r = s.items.indexOf(t)) && (i.remove(), i.hasClass("active") && (o = s.$activeItems.indexOf(i[0]), s.$activeItems.splice(o, 1)), s.items.splice(r, 1), s.lastQuery = null, !s.settings.persist && s.userOptions.hasOwnProperty(t) && s.removeOption(t, n), r < s.caretPos && s.setCaret(s.caretPos - 1), s.refreshState(), s.updatePlaceholder(), s.updateOriginalInput({
                    silent: n
                }), s.positionDropdown(), s.trigger("item_remove", t, i))
            },
            createItem: function(t, n) {
                var i = this,
                    r = i.caretPos;
                t = t || e.trim(i.$control_input.val() || "");
                var o = arguments[arguments.length - 1];
                if ("function" != typeof o && (o = function() {}), "boolean" != typeof n && (n = !0), !i.canCreate(t)) return o(), !1;
                i.lock();
                var s = "function" == typeof i.settings.create ? this.settings.create : function(e) {
                        var t = {};
                        return t[i.settings.labelField] = e, t[i.settings.valueField] = e, t
                    },
                    a = h(function(e) {
                        if (i.unlock(), !e || "object" != typeof e) return o();
                        var t = c(e[i.settings.valueField]);
                        return "string" != typeof t ? o() : (i.setTextboxValue(""), i.addOption(e), i.setCaret(r), i.addItem(t), i.refreshOptions(n && "single" !== i.settings.mode), o(e), void 0)
                    }),
                    l = s.apply(this, [t, a]);
                return void 0 !== l && a(l), !0
            },
            refreshItems: function() {
                this.lastQuery = null, this.isSetup && this.addItem(this.items), this.refreshState(), this.updateOriginalInput()
            },
            refreshState: function() {
                this.refreshValidityState(), this.refreshClasses()
            },
            refreshValidityState: function() {
                if (!this.isRequired) return !1;
                var e = !this.items.length;
                this.isInvalid = e, this.$control_input.prop("required", e), this.$input.prop("required", !e)
            },
            refreshClasses: function() {
                var t = this,
                    n = t.isFull(),
                    i = t.isLocked;
                t.$wrapper.toggleClass("rtl", t.rtl), t.$control.toggleClass("focus", t.isFocused).toggleClass("disabled", t.isDisabled).toggleClass("required", t.isRequired).toggleClass("invalid", t.isInvalid).toggleClass("locked", i).toggleClass("full", n).toggleClass("not-full", !n).toggleClass("input-active", t.isFocused && !t.isInputHidden).toggleClass("dropdown-active", t.isOpen).toggleClass("has-options", !e.isEmptyObject(t.options)).toggleClass("has-items", t.items.length > 0), t.$control_input.data("grow", !n && !i)
            },
            isFull: function() {
                return null !== this.settings.maxItems && this.items.length >= this.settings.maxItems;
            },
            updateOriginalInput: function(e) {
                var t, n, i, r, o = this;
                if (e = e || {}, 1 === o.tagType) {
                    for (i = [], t = 0, n = o.items.length; t < n; t++) r = o.options[o.items[t]][o.settings.labelField] || "", i.push('<option value="' + d(o.items[t]) + '" selected="selected">' + d(r) + "</option>");
                    i.length || this.$input.attr("multiple") || i.push('<option value="" selected="selected"></option>'), o.$input.html(i.join(""))
                } else o.$input.val(o.getValue()), o.$input.attr("value", o.$input.val());
                o.isSetup && (e.silent || o.trigger("change", o.$input.val()))
            },
            updatePlaceholder: function() {
                if (this.settings.placeholder) {
                    var e = this.$control_input;
                    this.items.length ? e.removeAttr("placeholder") : e.attr("placeholder", this.settings.placeholder), e.triggerHandler("update", {
                        force: !0
                    })
                }
            },
            open: function() {
                var e = this;
                e.isLocked || e.isOpen || "multi" === e.settings.mode && e.isFull() || (e.focus(), e.isOpen = !0, e.refreshState(), e.$dropdown.css({
                    visibility: "hidden",
                    display: "block"
                }), e.positionDropdown(), e.$dropdown.css({
                    visibility: "visible"
                }), e.trigger("dropdown_open", e.$dropdown))
            },
            close: function() {
                var e = this,
                    t = e.isOpen;
                "single" === e.settings.mode && e.items.length && (e.hideInput(), e.isBlurring || e.$control_input.blur()), e.isOpen = !1, e.$dropdown.hide(), e.setActiveOption(null), e.refreshState(), t && e.trigger("dropdown_close", e.$dropdown)
            },
            positionDropdown: function() {
                var e = this.$control,
                    t = "body" === this.settings.dropdownParent ? e.offset() : e.position();
                t.top += e.outerHeight(!0), this.$dropdown.css({
                    width: e[0].getBoundingClientRect().width,
                    top: t.top,
                    left: t.left
                })
            },
            clear: function(e) {
                var t = this;
                t.items.length && (t.$control.children(":not(input)").remove(), t.items = [], t.lastQuery = null, t.setCaret(0), t.setActiveItem(null), t.updatePlaceholder(), t.updateOriginalInput({
                    silent: e
                }), t.refreshState(), t.showInput(), t.trigger("clear"))
            },
            insertAtCaret: function(e) {
                var t = Math.min(this.caretPos, this.items.length),
                    n = e[0],
                    i = this.buffer || this.$control[0];
                0 === t ? i.insertBefore(n, i.firstChild) : i.insertBefore(n, i.childNodes[t]), this.setCaret(t + 1)
            },
            deleteSelection: function(t) {
                var n, i, r, o, s, a, l, u, c, d = this;
                if (r = t && 8 === t.keyCode ? -1 : 1, o = v(d.$control_input[0]), d.$activeOption && !d.settings.hideSelected && (l = d.getAdjacentOption(d.$activeOption, -1).attr("data-value")), s = [], d.$activeItems.length) {
                    for (c = d.$control.children(".active:" + (r > 0 ? "last" : "first")), a = d.$control.children(":not(input)").index(c), r > 0 && a++, n = 0, i = d.$activeItems.length; n < i; n++) s.push(e(d.$activeItems[n]).attr("data-value"));
                    t && (t.preventDefault(), t.stopPropagation())
                } else(d.isFocused || "single" === d.settings.mode) && d.items.length && (r < 0 && 0 === o.start && 0 === o.length ? s.push(d.items[d.caretPos - 1]) : r > 0 && o.start === d.$control_input.val().length && s.push(d.items[d.caretPos]));
                if (!s.length || "function" == typeof d.settings.onDelete && !1 === d.settings.onDelete.apply(d, [s])) return !1;
                for (void 0 !== a && d.setCaret(a); s.length;) d.removeItem(s.pop());
                return d.showInput(), d.positionDropdown(), d.refreshOptions(!0), l && (u = d.getOption(l), u.length && d.setActiveOption(u)), !0
            },
            advanceSelection: function(e, t) {
                var n, i, r, o, s, a = this;
                0 !== e && (a.rtl && (e *= -1), n = e > 0 ? "last" : "first", i = v(a.$control_input[0]), a.isFocused && !a.isInputHidden ? (o = a.$control_input.val().length, (e < 0 ? 0 === i.start && 0 === i.length : i.start === o) && !o && a.advanceCaret(e, t)) : (s = a.$control.children(".active:" + n), s.length && (r = a.$control.children(":not(input)").index(s), a.setActiveItem(null), a.setCaret(e > 0 ? r + 1 : r))))
            },
            advanceCaret: function(e, t) {
                var n, i, r = this;
                0 !== e && (n = e > 0 ? "next" : "prev", r.isShiftDown ? (i = r.$control_input[n](), i.length && (r.hideInput(), r.setActiveItem(i), t && t.preventDefault())) : r.setCaret(r.caretPos + e))
            },
            setCaret: function(t) {
                var n = this;
                if (t = "single" === n.settings.mode ? n.items.length : Math.max(0, Math.min(n.items.length, t)), !n.isPending) {
                    var i, r, o, s;
                    for (o = n.$control.children(":not(input)"), i = 0, r = o.length; i < r; i++) s = e(o[i]).detach(), i < t ? n.$control_input.before(s) : n.$control.append(s)
                }
                n.caretPos = t
            },
            lock: function() {
                this.close(), this.isLocked = !0, this.refreshState()
            },
            unlock: function() {
                this.isLocked = !1, this.refreshState()
            },
            disable: function() {
                var e = this;
                e.$input.prop("disabled", !0), e.$control_input.prop("disabled", !0).prop("tabindex", -1), e.isDisabled = !0, e.lock()
            },
            enable: function() {
                var e = this;
                e.$input.prop("disabled", !1), e.$control_input.prop("disabled", !1).prop("tabindex", e.tabIndex), e.isDisabled = !1, e.unlock()
            },
            destroy: function() {
                var t = this,
                    n = t.eventNS,
                    i = t.revertSettings;
                t.trigger("destroy"), t.off(), t.$wrapper.remove(), t.$dropdown.remove(), t.$input.html("").append(i.$children).removeAttr("tabindex").removeClass("selectized").attr({
                    tabindex: i.tabindex
                }).show(), t.$control_input.removeData("grow"), t.$input.removeData("selectize"), 0 == --C.count && C.$testInput && (C.$testInput.remove(), C.$testInput = void 0), e(window).off(n), e(document).off(n), e(document.body).off(n), delete t.$input[0].selectize
            },
            render: function(t, n) {
                var i, r, o = "",
                    s = !1,
                    a = this;
                return "option" !== t && "item" !== t || (i = c(n[a.settings.valueField]), s = !!i), s && (u(a.renderCache[t]) || (a.renderCache[t] = {}), a.renderCache[t].hasOwnProperty(i)) ? a.renderCache[t][i] : (o = e(a.settings.render[t].apply(this, [n, d])), "option" === t || "option_create" === t ? n[a.settings.disabledField] || o.attr("data-selectable", "") : "optgroup" === t && (r = n[a.settings.optgroupValueField] || "", o.attr("data-group", r), n[a.settings.disabledField] && o.attr("data-disabled", "")), "option" !== t && "item" !== t || o.attr("data-value", i || ""), s && (a.renderCache[t][i] = o[0]), o[0])
            },
            clearCache: function(e) {
                var t = this;
                void 0 === e ? t.renderCache = {} : delete t.renderCache[e]
            },
            canCreate: function(e) {
                var t = this;
                if (!t.settings.create) return !1;
                var n = t.settings.createFilter;
                return e.length && ("function" != typeof n || n.apply(t, [e])) && ("string" != typeof n || new RegExp(n).test(e)) && (!(n instanceof RegExp) || n.test(e))
            }
        }), C.count = 0, C.defaults = {
            options: [],
            optgroups: [],
            plugins: [],
            delimiter: ",",
            splitOn: null,
            persist: !0,
            diacritics: !0,
            create: !1,
            createOnBlur: !1,
            createFilter: null,
            highlight: !0,
            openOnFocus: !0,
            maxOptions: 1e3,
            maxItems: null,
            hideSelected: null,
            addPrecedence: !1,
            selectOnTab: !1,
            preload: !1,
            allowEmptyOption: !1,
            closeAfterSelect: !1,
            scrollDuration: 60,
            loadThrottle: 300,
            loadingClass: "loading",
            dataAttr: "data-data",
            optgroupField: "optgroup",
            valueField: "value",
            labelField: "text",
            disabledField: "disabled",
            optgroupLabelField: "label",
            optgroupValueField: "value",
            lockOptgroupOrder: !1,
            sortField: "$order",
            searchField: ["text"],
            searchConjunction: "and",
            mode: null,
            wrapperClass: "selectize-control",
            inputClass: "selectize-input",
            dropdownClass: "selectize-dropdown",
            dropdownContentClass: "selectize-dropdown-content",
            dropdownParent: null,
            copyClassesToDropdown: !0,
            render: {}
        }, e.fn.selectize = function(t) {
            var n = e.fn.selectize.defaults,
                i = e.extend({}, n, t),
                r = i.dataAttr,
                o = i.labelField,
                s = i.valueField,
                a = i.disabledField,
                l = i.optgroupField,
                u = i.optgroupLabelField,
                d = i.optgroupValueField,
                p = function(t, n) {
                    var a, l, u, c, d = t.attr(r);
                    if (d)
                        for (n.options = JSON.parse(d), a = 0, l = n.options.length; a < l; a++) n.items.push(n.options[a][s]);
                    else {
                        var p = e.trim(t.val() || "");
                        if (!i.allowEmptyOption && !p.length) return;
                        for (u = p.split(i.delimiter), a = 0, l = u.length; a < l; a++) c = {}, c[o] = u[a], c[s] = u[a], n.options.push(c);
                        n.items = u
                    }
                },
                h = function(t, n) {
                    var p, h, f, g, m = n.options,
                        v = {},
                        y = function(e) {
                            var t = r && e.attr(r);
                            return "string" == typeof t && t.length ? JSON.parse(t) : null
                        },
                        b = function(t, r) {
                            t = e(t);
                            var u = c(t.val());
                            if (u || i.allowEmptyOption)
                                if (v.hasOwnProperty(u)) {
                                    if (r) {
                                        var d = v[u][l];
                                        d ? e.isArray(d) ? d.push(r) : v[u][l] = [d, r] : v[u][l] = r
                                    }
                                } else {
                                    var p = y(t) || {};
                                    p[o] = p[o] || t.text(), p[s] = p[s] || u, p[a] = p[a] || t.prop("disabled"), p[l] = p[l] || r, v[u] = p, m.push(p), t.is(":selected") && n.items.push(u)
                                }
                        };
                    for (n.maxItems = t.attr("multiple") ? null : 1, g = t.children(), p = 0, h = g.length; p < h; p++) f = g[p].tagName.toLowerCase(), "optgroup" === f ? function(t) {
                        var i, r, o, s, l;
                        for (t = e(t), o = t.attr("label"), o && (s = y(t) || {}, s[u] = o, s[d] = o, s[a] = t.prop("disabled"), n.optgroups.push(s)), l = e("option", t), i = 0, r = l.length; i < r; i++) b(l[i], o)
                    }(g[p]) : "option" === f && b(g[p])
                };
            return this.each(function() {
                if (!this.selectize) {
                    var r = e(this),
                        o = this.tagName.toLowerCase(),
                        s = r.attr("placeholder") || r.attr("data-placeholder");
                    s || i.allowEmptyOption || (s = r.children('option[value=""]').text());
                    var a = {
                        placeholder: s,
                        options: [],
                        optgroups: [],
                        items: []
                    };
                    "select" === o ? h(r, a) : p(r, a), new C(r, e.extend(!0, {}, n, a, t))
                }
            })
        }, e.fn.selectize.defaults = C.defaults, e.fn.selectize.support = {
            validity: l
        }, C.define("drag_drop", function(t) {
            if (!e.fn.sortable) throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');
            if ("multi" === this.settings.mode) {
                var n = this;
                n.lock = function() {
                    var e = n.lock;
                    return function() {
                        var t = n.$control.data("sortable");
                        return t && t.disable(), e.apply(n, arguments)
                    }
                }(), n.unlock = function() {
                    var e = n.unlock;
                    return function() {
                        var t = n.$control.data("sortable");
                        return t && t.enable(), e.apply(n, arguments)
                    }
                }(), n.setup = function() {
                    var t = n.setup;
                    return function() {
                        t.apply(this, arguments);
                        var i = n.$control.sortable({
                            items: "[data-value]",
                            forcePlaceholderSize: !0,
                            disabled: n.isLocked,
                            start: function(e, t) {
                                t.placeholder.css("width", t.helper.css("width")), i.css({
                                    overflow: "visible"
                                })
                            },
                            stop: function() {
                                i.css({
                                    overflow: "hidden"
                                });
                                var t = n.$activeItems ? n.$activeItems.slice() : null,
                                    r = [];
                                i.children("[data-value]").each(function() {
                                    r.push(e(this).attr("data-value"))
                                }), n.setValue(r), n.setActiveItem(t)
                            }
                        })
                    }
                }()
            }
        }), C.define("dropdown_header", function(t) {
            var n = this;
            t = e.extend({
                title: "Untitled",
                headerClass: "selectize-dropdown-header",
                titleRowClass: "selectize-dropdown-header-title",
                labelClass: "selectize-dropdown-header-label",
                closeClass: "selectize-dropdown-header-close",
                html: function(e) {
                    return '<div class="' + e.headerClass + '"><div class="' + e.titleRowClass + '"><span class="' + e.labelClass + '">' + e.title + '</span><a href="javascript:void(0)" class="' + e.closeClass + '">&times;</a></div></div>'
                }
            }, t), n.setup = function() {
                var i = n.setup;
                return function() {
                    i.apply(n, arguments), n.$dropdown_header = e(t.html(t)), n.$dropdown.prepend(n.$dropdown_header)
                }
            }()
        }), C.define("optgroup_columns", function(t) {
            var n = this;
            t = e.extend({
                equalizeWidth: !0,
                equalizeHeight: !0
            }, t), this.getAdjacentOption = function(t, n) {
                var i = t.closest("[data-group]").find("[data-selectable]"),
                    r = i.index(t) + n;
                return r >= 0 && r < i.length ? i.eq(r) : e()
            }, this.onKeyDown = function() {
                var e = n.onKeyDown;
                return function(t) {
                    var i, r, o, s;
                    return !this.isOpen || 37 !== t.keyCode && 39 !== t.keyCode ? e.apply(this, arguments) : (n.ignoreHover = !0, s = this.$activeOption.closest("[data-group]"), i = s.find("[data-selectable]").index(this.$activeOption), s = 37 === t.keyCode ? s.prev("[data-group]") : s.next("[data-group]"), o = s.find("[data-selectable]"), r = o.eq(Math.min(o.length - 1, i)), void(r.length && this.setActiveOption(r)))
                }
            }();
            var i = function() {
                    var e, t = i.width,
                        n = document;
                    return void 0 === t && (e = n.createElement("div"), e.innerHTML = '<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>', e = e.firstChild, n.body.appendChild(e), t = i.width = e.offsetWidth - e.clientWidth, n.body.removeChild(e)), t
                },
                r = function() {
                    var r, o, s, a, l, u, c;
                    if (c = e("[data-group]", n.$dropdown_content), (o = c.length) && n.$dropdown_content.width()) {
                        if (t.equalizeHeight) {
                            for (s = 0, r = 0; r < o; r++) s = Math.max(s, c.eq(r).height());
                            c.css({
                                height: s
                            })
                        }
                        t.equalizeWidth && (u = n.$dropdown_content.innerWidth() - i(), a = Math.round(u / o), c.css({
                            width: a
                        }), o > 1 && (l = u - a * (o - 1), c.eq(o - 1).css({
                            width: l
                        })))
                    }
                };
            (t.equalizeHeight || t.equalizeWidth) && (p.after(this, "positionDropdown", r), p.after(this, "refreshOptions", r))
        }), C.define("remove_button", function(t) {
            return t = e.extend({
                label: "&times;",
                title: "Remove",
                className: "remove",
                append: !0
            }, t), "single" === this.settings.mode ? void
            function(t, n) {
                n.className = "remove-single";
                var i = t,
                    r = '<a href="javascript:void(0)" class="' + n.className + '" tabindex="-1" title="' + d(n.title) + '">' + n.label + "</a>",
                    o = function(t, n) {
                        return e("<span>").append(t).append(n)
                    };
                t.setup = function() {
                    var s = i.setup;
                    return function() {
                        if (n.append) {
                            var a = e(i.$input.context).attr("id"),
                                l = (e("#" + a), i.settings.render.item);
                            i.settings.render.item = function(e) {
                                return o(l.apply(t, arguments), r)
                            }
                        }
                        s.apply(t, arguments), t.$control.on("click", "." + n.className, function(e) {
                            e.preventDefault(), i.isLocked || i.clear()
                        })
                    }
                }()
            }(this, t): void! function(t, n) {
                var i = t,
                    r = '<a href="javascript:void(0)" class="' + n.className + '" tabindex="-1" title="' + d(n.title) + '">' + n.label + "</a>",
                    o = function(e, t) {
                        var n = e.search(/(<\/[^>]+>\s*)$/);
                        return e.substring(0, n) + t + e.substring(n)
                    };
                t.setup = function() {
                    var s = i.setup;
                    return function() {
                        if (n.append) {
                            var a = i.settings.render.item;
                            i.settings.render.item = function(e) {
                                return o(a.apply(t, arguments), r)
                            }
                        }
                        s.apply(t, arguments), t.$control.on("click", "." + n.className, function(t) {
                            if (t.preventDefault(), !i.isLocked) {
                                var n = e(t.currentTarget).parent();
                                i.setActiveItem(n), i.deleteSelection() && i.setCaret(i.items.length)
                            }
                        })
                    }
                }()
            }(this, t)
        }), C.define("restore_on_backspace", function(e) {
            var t = this;
            e.text = e.text || function(e) {
                return e[this.settings.labelField]
            }, this.onKeyDown = function() {
                var n = t.onKeyDown;
                return function(t) {
                    var i, r;
                    return 8 === t.keyCode && "" === this.$control_input.val() && !this.$activeItems.length && (i = this.caretPos - 1) >= 0 && i < this.items.length ? (r = this.options[this.items[i]], this.deleteSelection(t) && (this.setTextboxValue(e.text.apply(this, [r])), this.refreshOptions(!0)), void t.preventDefault()) : n.apply(this, arguments)
                }
            }()
        }), C
    });